// Translations.js
const translations = {
  en: {
    buAccountNumbers: "Account Numbers",
    buAccountNo: "Account No",
    buTypeAccountPlaceholder: "Type account number and press Enter",
    buTypeAndEnterHint: "Type and press Enter, or paste a list of accounts.",
    buDetected: "{n} detected",
    buAssignmentPriority: "Assignment & Priority",
    buAssignment: "Assignment",
    buCreateTasks: "Create Tasks",
    buUpdatePriority: "Update Priority",
    buUpdatePriorityAndAssign: "Update Priority and Assign",
    buUpdatingPriority: "Updating priority...",
    buUpdatePriorityTooltip: "Update priority of the entered accounts",
    buUpdatePriorityAssignTooltip: "Update priority and assign to the selected field agents",
    buCloseDialog: "Close the dialog box",
    buTotalAccountsHint: "Total account numbers added above.",
    buCreatingTask: "Creating the task...",
    buDuplicatesIgnored: "{n} duplicate account number(s) ignored.",
    buPriorityUpdated: "Priority updated for {n} account(s).",
    buPriorityUpdateFailed: "Priority update failed.",
    buLookupFailed: "Lookup failed.",
    buUnexpectedError: "An unexpected error occurred.",
    buSelectPriority: "Please select a priority.",
    columnContainsHelp: "Case-insensitive match across every task in the workflow.",
    selectDateRangeHint: "Select date range (YYYY-MM-DD to YYYY-MM-DD)",
    dragToReorderColumn: "Drag to reorder column",
    dragToResize: "Drag to resize",
    viewFieldAgents: "View Field Agents",
    noAssigneesOrGroupForUnassign: "No assignees or group selected for unassigning.",
    taskOnHoldSuccess: "Task on hold",
    selectTaskBeforeProceeding: "Please select a task before proceeding!",
    noFieldsMatch: "No fields match",
    clearSelectionAria: "Clear selection",
    createTaskSubtitle: "Add a single task manually, upload many at once, or import a sheet.",
    singleTaskUpload: "Single Task Upload",
    bulkTaskUpload: "Bulk Task Upload",
    selectOnMap: "Select on Map",
    categoryName: "Category name",
    arabicNameOptional: "Arabic name (optional)",
    enterNewCategory: "Enter new category",
    enterArabicNameOptional: "Enter Arabic name (optional)",
    selectAZone: "Select a Zone",
    selectPriorityLabel: "Select Priority",
    activitySelection: "Activity Selection",
    page: "Page",
    refreshBtn: "Refresh",
    accHistoryTabTooltip: "View the history of an account",
    exportReportTabTooltip: "Request and download reports",
    dragFieldToCanvas: "Drag a field onto the canvas",
    searchField: "Search fields...",
    dragElementsFromLeftPanel: "Drag your elements from the left panel",
    otherFieldSettings: "Other Field Settings",
    requiredField: "Field is required",
    validation: "Validation",
    validationupdated: "Validation updated successfully",
    workflowEmptyTitle: "Create a workflow to see them here",
    workflowEmptyDesc: "Build your first workflow template to configure task forms faster and consistently.",
    workflowEmptyNoProjectTitle: "Select a project to get started",
    workflowEmptyNoProjectDesc: "Please select a project to view and manage workflows.",
    workflowEmptySearchTitle: "No workflows found",
    wfEnterYourInput: "Enter your input",
    wfNoRadioOptions: "No radio options available",
    wfAddFieldsForReport: "Add Fields For Report",
    wfSelectMandatoryField: "Select Mandatory Field",
    wfEnterPdfName: "Enter PDF Name...",
    wfType_text: "Text",
    wfType_number: "Number",
    wfType_email: "Email",
    wfType_date: "Date",
    wfType_time: "Time",
    wfType_radio: "Radio",
    wfType_checkbox: "Checkbox",
    wfType_select: "Dropdown",
    wfType_textarea: "Long Text",
    wfType_file: "File",
    wfType_multi_image: "Multiple Images",
    wfType_scan: "Scan",
    wfType_ocr: "OCR",
    wfType_gps: "GPS",
    wfType_signal_quality: "Signal Quality",
    OCR: "OCR",
    GPS: "GPS",
    CaptureSignalQuality: "Capture Signal Quality",
    editDepartment: "Edit Department",
    accHistProjects: "Projects",
    accHistTasks: "Tasks",
    accHistWorkflowHistory: "Workflow History",
    accHistNoProjectDetails: "No account details in this project.",
    accHistNoteAll: "As a Super Admin, account history is displayed for all departments and projects.",
    accHistNoteScoped: "Account history is displayed only for the departments, projects and activities assigned to you.",
    taskLocationColumn: "Location",
    taskLocationTooltip: "View task location on map",
    taskLocationTitle: "Selected Task Location",
    orgDcrcSubscription: "DCRC Subscription",
    orgAutoRc: "Auto RC",
    orgPoleDc: "Pole DC",
    orgInstallmentPlan: "Installment plan",
    orgMinPaymentPercent: "Min payment %",
    orgMinOutstandingAmount: "Min outstanding amount",
    orgSvMaxIterations: "SV max iterations",
    orgDcrcWorkflowConfig: "DCRC Workflow Config (Activity required for each step)",
    orgDcrcWorkflowConfigPoleDc: "DCRC Workflow Config (Activity required for each step, including POLE_DC)",
    orgLoadingActivities: "Loading activities…",
    orgActivityWorkflow: "Activity (Workflow)",
    orgSelectActivity: "Select activity",
    orgDelayDays: "Delay (days)",
    orgEndCycleField: "End cycle field",
    orgEndCycleValues: "End cycle values",
    orgSelectActivityFirst: "Select an activity first",
    orgLoading: "Loading…",
    orgLoadingOptions: "Loading options…",
    orgNoFieldsInWorkflow: "No fields in workflow",
    orgSelectField: "Select field",
    orgSelectValues: "Select values",
    orgNextStepSuccess: "Next step (success)",
    orgNextStepFailure: "Next step (failure)",
    orgNone: "None",
    orgField: "Field",
    orgValues: "Values",
    orgNoValuesForField: "No values for this field",
    orgSelectFieldFirst: "Select field first",
    orgLoadActivityFirst: "Load activity first",
    orgShowProject: "Show project",
    orgHideProject: "Hide project",
    orgShowing: "Showing…",
    orgLoadingProject: "Loading project…",
    orgShowProjectTitle: "Show project?",
    orgHideProjectTitle: "Hide project?",
    orgShowProjectDesc: "Show \"{name}\" again? It will be visible in the list.",
    orgHideProjectDesc: "Hide \"{name}\" from the list? You can show it again later from the same place.",
    orgProjectVisible: "Project visible again",
    orgProjectHidden: "Project hidden",
    orgFailedShowProject: "Failed to show project",
    orgFailedUpdateStatus: "Failed to update status",
    orgFailedDeleteOrg: "Failed to delete organization",
    orgDeleteOrgSuccess: "Organization deleted successfully",
    orgInvalidEmails: "Please enter valid email addresses.",
    orgSelectActivityAllSteps: "Please select Activity (workflow) for all DCRC steps ({steps}).",
    completionSubmissionNoteTitle: "Define at least one rule for a task to be completed successfully.",
    completionSubmissionRuleRequired: "Required field: shows the message when the field is left empty.",
    completionSubmissionRuleMismatch: "Number mismatch: shows the message when the submitted number does not match the number.",
    mapTipMapView: "Map view",
    mapTipListView: "List view",
    mapTipShowAll: "Show all tasks",
    mapTipShowOnly: "Show only {status} tasks",
    mapTipSatellite: "Satellite view",
    mapTipZoomIn: "Zoom in",
    mapTipZoomOut: "Zoom out",
    mapTipExport: "Export Task Report",
    mapTipPrevWeek: "Previous Week",
    mapTipNextWeek: "Next Week",
    mapTipHideDates: "Hide date navigation",
    mapTipCloseCalendar: "Close calendar panel",
    mapSelectFromDate: "Select from date",
    mapSelectToDate: "Select to date",
    failedToFetchTaskStatus: "Failed to fetch task status. Please try again.",
    failedToFetchUserCount: "Failed to fetch user count. Please try again.",
    noDataAvailableForWorkflow: "No task status data available for this workflow.",
    selectOrganizationPrompt: "Please select an organization.",
    selectWorkflowPrompt: "Please select a workflow.",
    numberOfUsers: "Number of Users",
    numberOfTasks: "Number of Tasks",
    taskPriorityAxis: "Task Priority",
    completedTaskAxis: "Completed Task",
    taskCount: "Task Count",
    priorityCount: "Priority Count",
    totalCompletedTasks: "Completed Tasks",
    totalTasks: "Total Tasks",
    totalUsers: "Total Users",
    userCount: "User Count",
    unknownUser: "Unknown User",
    totalEntries: "Total Entries",
    numberOfEntries: "Number of Entries",
    entryCount: "Entry Count",
    totalWorked: "Total Worked",
    averageDaily: "Average Daily",
    tasksCountLabel: "{n} tasks",
    usersCountLabel: "{n} users",
    dateCannotBeFuture: "{field} cannot be in the future.",
    userFormLeaveBlank: "Leave blank to keep current",
    userFormCreateGroup: "Create group",
    userFormNewGroupName: "New group name",
    userFormCloseAria: "Close user form",
    userFormSignatureReady: "Signature image ready",
    userFormChooseSignature: "Choose Signature",
    userFormReplaceSignature: "Replace Signature",
    userFormSignatureFormats: "JPG, PNG supported",
    userFormUploadSignature: "Upload signature",
    userFormEditUser: "Edit User",
    userFilterNone: "None",
    userFilterAll: "All",
    userFilterNoMatches: "No matches",
    userFilterSearch: "Search…",
    userViewAll: "View all",
    userColEmployeeId: "Employee ID",
    userColWorkflows: "Workflows",
    userColRoles: "Roles",
    userListNoProjectTitle: "No project selected",
    userListNoProjectHint: "Select a department and project at the top of the page to see users.",
    userFilterLimitReached: "You can apply at most 15 column filters at once. Remove one to add another.",
    userContainsHelp: "Case-insensitive match across all users.",
    timeAgoMonths: "{n}mo ago",
    timeAgoDays: "{n}d ago",
    timeAgoHours: "{n}h ago",
    timeAgoMinutes: "{n}m ago",
    loginLocation: "Location",
    noUsersMatchSearch: "No users match your search",
    never: "Never",
    justNow: "Just now",
    groupMembers: "Group Members",
    groupListInfo: "Select the groups this user can access within the selected department(s).",
    groupInfo: "Assign the field agent to a group in the selected department. Type a new name and click create to add one.",
    groupCreated: "Group created",
    getStartedAddingUser: "Get started by adding your first user.",
    inventoryAssignmentFileRequired: "Choose an Excel file (.xlsx or .xls).",
    inventoryAssignmentInput: "Assignment source",
    inventoryAssignmentProjectRequired: "Choose one project for this assignment.",
    inventoryClearCustody: "Clear custody",
    inventoryClearCustodyHint: "Remove all store and group assignments for these items.",
    inventoryMeterNumbers: "Serial numbers",
    inventoryMeterNumbersHint: "Enter serial numbers (meter, modem, SIM or seal range) separated by spaces, commas, or new lines.",
    inventoryMeterNumbersRequired: "Enter valid serial numbers for every selected item.",

    inventoryMissingMeterNumbers: "One or more selected meters have no meter number.",
    inventoryAssignmentSameProject: "Select meters from one project.",
    inventoryAssignmentPending: "Assignment accepted and is processing.",
    inventoryAssignmentExcel: "Assign from Excel",
    inventoryAssignmentExcelHint: "Upload an Excel file to assign its meters to the selected store or group. The file replaces the row selection.",

    accountreportcenter: " Account & Reports Center",
    accountreportcentersub: "Track account history and manage report exports.",
    PDF: "PDF",
    viewdetails: " View Details",
    addnewvehicale: " Add a new vehicle to your asset list.",
    cancelandstay: "Cancel and stay on the page",
    confirmandlogout: "Confirm and logout",
    welcome: "Welcome",
    welcomeback: "Welcome back",
    editandudateasset: " Edit and update asset details ",
    assigntheselected: "Assign the selected assets to the field staff",
    updatetherule: " Update the rule",
    submitherule: " Submit the rule",
    addassignmentrule: " Add assignment rule",
    savetherule: " Save the rule",
    addcompletionrule: " Add completion rule",
    addcustomrule: " Add custom rule",
    assignallactiverules: "Assign all active rules",
    addnewspecialassingmentrule: " Add new special assignment rule",
    updatetherulewitjselectedpara: " Update the rule with selected parameters",
    createneweulwwithselected: " Create new rule with selected parameters",
    cancelandclose: " Cancel and close dialog box",
    addnewdashboardtooltip:
      " Add a new dashboard (You can create the dashboard based on workflow)",
    processthenextstep: " Process the next step",
    deletethedashboard: " Delete the dashboard",
    createdashboardtooltip: " Create a dashboard ",
    canceltheselectedchart: "Create  the selected chart",
    applytheselecteddaterange: "Apply the selected date range filter",
    downloadfilterdate: " Download with filtered date",
    proceedwiththeaction: " Proceed with the action",
    addnewproject: " Add new project",
    addnewdepartment: " Add new department",
    addneworgnization: " Add new organization",
    updateorgnizations: " Update organizations",
    savethechangesmadetomarkers: " Save the changes made to the marker colors",
    updatethechangesmade: " Update the changes made to the marker colors",
    cancelanddiscardchanges: " Cancel and discard changes",
    requestthereport: " Request the report",
    savetheprotectedaccount: " Save the protected account",
    submitthereportrequest: " Submit the report request",
    cancelandgoback: " Cancel and go back",
    exportthexcelfilebasedon: " Export the excel file based on the filter",
    createaprotectedaccountwithpermanent:
      " Create a protected account with permanent protection or for specified duration",
    downloadthereportfortheselecte:
      " Download the report for the selected date range",
    uploadtheinventorysheet: "Upload The Inventory Excel Sheet",
    downloadincentoryreport: "Download the inventory report",
    applythesleectedfilters: "Apply the selected filters ",
    uploadtheselectedexcelfile: "Upload the selected Excel file",
    createinstallmentplan: " Create installment plan",
    generatepreviewfiter: "(Generate preview first)",
    emiamount: "(EMI amounts do not match the outstanding amount)",
    finisheditinisntall: " (Finish editing installment) ",
    savechangesbeforesubmiting: " (Save changes before submitting )",
    totalemaiamount: "(Total EMI amount cannot be negative)",
    userscancreateup: "(Users can create up to 6 installments only)",
    accountTwoActivePlans: "This account already has 2 active installment plans. You cannot create another one.",
    maxTwoActivePlans: " (Max 2 active plans allowed per account)",
    maxInstalmentsExceeded: "Number of instalments cannot be more than",
    instalmentsGreaterThanZero: "Number of instalments must be greater than zero",
    printpreviewtable: "Print preview table",
    generatepreview: "Generate preview",
    clearpreviewdata: " Clear preview data",
    submitforRccreation: " Submit for RC creation",
    savethechagesmadeto: " Save the changes made to the payment amount",
    editthepaymentamount: " Edit the payment amount",
    submitspecialRc: " Submit special RC",
    printinstallmentdetails: " Print installment details",
    proceedwithdeleaction: "Proceed with delete action",
    proceedwithrecallaction: "Proceed with recall action",
    deletetheselectedtask: " Delete the selected task",
    unassignntheseledtask: " Unassign the selected tasks",
    reassigntheselectedtask: " Reassign the selected tasks",
    assigntheselectedtask: " Assign the selected tasks",
    multiselecte: "Muti-select",
    addemailenablrnotifi:
      "Add emails, enable notifications, and configure other settings",
    donwloadthetaskrecordin:
      "Download the task record in Excel based on the selected activity or for all activities",
    createtaskbulk:
      "Create a new task, create and assign, or perform a bulk task upload",
    uploadthetasksheet: "Upload the task sheet",
    assingtaskbasedonselectedrules: "Assign tasks based on selected rules",
    reassigningprocess: "Reassigning in progress",
    reassingselectedtasktochosen:
      "Reassign selected tasks to chosen field agents",
    assingtaskbasedonselectedrule: "Assign tasks based on selected rules",
    reassinginginprocess: "Reassigning in progress",
    reassignselectedtasktochosenfield:
      "Reassign selected tasks to chosen field agents",
    unassignselectedassingeesfromtask: "Unassign selected assignees from tasks",
    savetheupdateddatacompleted: "Save the updated data for completed tasks",
    gobacktheprivious: "Go back to the previous screen without saving",
    resetthecompletiondata: "Reset the task completion data",
    closewithoutsavingchnages: "Close without saving changes",
    savechangesmadetothefield: "Save changes made to the field",
    viewworkflowguidlines: "View workflow guidelines",
    createnewworkflows: "Create a new workflow",
    selectorgtocreateaworkflow: "Select an organization to create a workflow",
    scheduleemail: "Schedule email",
    exporttheexcelfilebasedonfilters: "Export the Excel file based on filters",
    exportpdfbasedonfilters: "Export the PDF file based on filters",
    downloadpdfbasedonfilters: "Download PDF based on filters",
    savechangesforprofile: "Save changes for profile",
    requestonewreport: "Request a new report",
    createamanualtask: "Create a manual task",
    createandassingtasktofield: "Create and assign a task to a field agent",
    closethedialogbox: "Close the dialog box",
    gobacktomapmandotoryfield: "Go back to map mandatory fields",
    submitmappeddataandstartupload:
      "Submit the mapped data and start the upload",
    procestomapnonmdaotry: "Proceed to map non-mandatory fields",
    gobacktotaskpriority: "Go back to task priority selection",
    proceestomapmadatory: "Proceed to map mandatory fields",
    gobackprivousscren: "Go back to the previous screen without saving",
    addmultipleaccount:
      "Add multiple account numbers and assign tasks to field agents",
    selectatleast: "Select at least one field agent to assign",
    assingmentinprocess: "Assignment in progress",
    assingselectedtasktochosen: "Assign selected tasks to chosen field agents",
    recallassingedtask: "Recall assigned tasks from users",
    deleterecordfrom: "Delete records from the uploaded file",
    donwloastheuplodedexcel: "Download the uploaded Excel file",
    uploasthexcelfile: "Upload the Excel file for the selected activity",
    savethechanges: "Save the changes",
    diacardchanges: "Discard the changes",
    proceedtomapnonmdfield: "Proceed to map non-mandatory fields",
    submitthemapedcol: "Submit the mapped columns and upload the data",
    uploadtheslectedfile: "Upload the selected file",
    uploadtheaccountexcel:
      "Upload the accounts Excel sheet to the master database",
    clearalldata: "Clear all data",
    fetchtheaccounthistory:
      "Fetch the account history for the entered account number",
    donwlaodthetaskreportinpdfformat: "Download the task report in PDF format",
    editandupdateuserdetail: "Edit and update user details",
    saveandcreateuser: "Save and create user",
    donotsavechangesgoback: "Don’t save changes and go back",
    addauserassingroles: "Add a user and assign roles or privileges",
    previewcurrentworkflowlayout:
      "Preview the current workflow layout and fields",
    submitworkflow: "Submit the workflow",
    pleaseselectatleastonefild: "Please select at least one field as a report",
    plzmakesuretosetauique:
      "Please make sure to set a unique workflow name before cloning",
    updatetheworkflowiwth: "Update the workflow with the latest changes",
    addnewvalidation: "Add a new validation",
    closewithoutsavingchanges: "Close without saving changes",
    viewwxistinfcalidation: "View existing validations",
    savechangesmadetovalidation: "Save changes made to validations",
    discarchangesandexit: "Discard changes and exit",
    savetheupdateddata: "Save the updated data for completed tasks",
    addselectefield: "Add selected fields to the report",
    gotonextpage: "Go to the next page",
    gotopreviouspage: "Go to the previous page",
    refeshreportlist: "Refresh report list",
    reportsGenerationNote: "Reports can take a few minutes to generate. If yours isn't ready yet, please allow some time and click the refresh button to check again. Reports will expire after 6 hours once generated.",
    gobackpreviouspage: "Go back to the previous page",
    requestreporbasedonfilter: "Request report based on filters",
    filteredReports: "Filtered Reports",

    failedtoloadruledata:
      " Failed to load rule data.Please contact help@blufield.net",
    pleaseSelectLeastAssetBeforeAssigning:
      "Please select at least one asset before assigning.",
    plzselectfieldagent: "Please select field agent",
    assetsucassigned: "Assets were assigned successfully.",
    assetsfailedassigned: "Failed to assign assets",
    logout: "Logged out successfully",
    rulecreated: "Rule created successfully.",
    unexpectederroroccured: "",
    plzselworkflow: "Please select a workflow before adding criteria.",
    ruledeleted: "Rule deleted successfully.",
    failedelrule: "Failed to delete the rule.",
    PleaseSelectWorkflowBeforeAddingRule:
      "Please select a workflow before adding a rule.",
    plzfillallfield: "Please fill in all mandatory fields to submit.",
    failtoloadasign:
      "Failed to load assignment rules. Please contact help@blufield.net",
    failedtoassign:
      "Failed to assign all rules. Please contact help@blufield.net .",
    OnClickTheOldAssignmentRuleDisabled:
      "When clicked, the previous assignment rule will be disabled.",
    invalideruleid: "Invalid rule ID.",
    plzselfield: "Please select a field agent.",
    nopermission:
      "You don’t have the necessary permissions to view this page.Please contact help@blufield.net ",
    nocreatetaskaccess: "You do not have access to create tasks.",
    plzselectorg: "Please select an organization.",
    somthingwentwrong: "",
    excelisdownloading: "The Excel file is downloading…",
    norecordfound: "No records found.",
    anerroroccurred: "",
    orgaddedsuc: "Organization added successfully.",
    errorcreatingorg:
      "Error creating organization. Please contact help@blufield.net",
    failstofetchorg: "Failed to fetch organization data.",
    orgupdated: "Organization updated successfully.",
    allfieldarerequired: "All fields are required.",
    reportreqsuc: "Report requested successfully.",
    errorequestreport: "Error requesting report.",
    addremark: "Add a remark!",
    protectedAcccreated: "Protected account created .",
    protectedAccUpdated: "Protected account updated.",
    errorcreatingprotacc: "Error creating protected account.",
    skippedAccountsDownloaded:
      "account(s) were skipped. The details have been downloaded.",
    partialProtectionSummary:
      "{created} account(s) protected, {skipped} skipped. The details have been downloaded.",
    updatedBy: "Updated By",
    previousRemarks: "Previous Remarks",
    pleaseSelectOrganizationCreatingAccount:
      "Please select an organization before creating an account.",
    pleaseSelectProjectIdFirst: "Please select a project first.",
    norecordareavailbles: "No records are available.",
    downloadlinkmissing: "The download link is missing.",
    invalidresponse: "Invalid response format.",
    failedFetchReports: "Failed to fetch reports.",
    reportgeneratedsuccc: "Report generated successfully!",
    pleaseSelectRecordProceed: "Please select a record to proceed!",
    errorOccurredWhileDeletingRecord:
      "An error occurred while deleting the record.",
    failedtofetchmeter: "Failed to fetch meter inventory details.",
    userStatusupdatesuc: "User status updated successfully.",
    failedtoupdateuserstatus: "Failed to update user status.",
    fileuploadedsucc: "File uploaded successfully.",
    failedtouploadfiles:
      "Failed to upload the file. Please contact help@blufield.net",
    pleasegeneratepreview:
      "Please generate the preview before creating the installment.",
    failedtogeneratepdf:
      "Failed to generate the PDF. Please try again or contact us at help@blufield.net",
    installmentupdated: "Installment plan updated successfully!",
    installmentplancretsuc: "Installment Plan Created Successfully!",
    errorgeneratingpdf:
      "Error generating the PDF or submitting the installment plan!",
    failedtoconnectserver: "",
    youcannotpaythefullamount:
      "You cannot pay the full amount in one installment. Please distribute it across all installments.",
    eachinstallmentmusthave:
      "Each installment must have at least the minimum amount.",
    changesavedsuc: "Changes saved successfully!",
    plzwentervalidacc: "Please enter a valid account number.",
    fieldagentassinged: "Field agent assigned.",
    NoasssingData: "No assignee data available",
    assigneeCompleted: "Completed",
    assigneeCompletedBy: "Completed by",
    unAssignTaskSuccessMeg:
      "Your request has been received and is being processed in the background. You’ll be notified once it’s complete.",
    pleaseselect: "Select a workflow first.",
    plzenteracommentbeforedel:
      "Please enter a comment before deleting the task.",
    taskdelsuccessfully: "Task deleted successfully.",
    erroccureduringtask: "",
    failedtoassignbyarea: "Failed to assign tasks by area.",
    plzselectactivity: "Please select an activity.",
    noassigneselectedfor: "No assignees selected for unassigning.",
    delteallrecord: "All records have been deleted.",
    taskprioriyupdated: "Task priority updated.",
    pdfnotavailable: "PDF is not available.",
    datafetchedsuccessfully: "Data fetched successfully.",
    anerroroccuredtaskhistory: "",
    taskupdatedcussfully: "Task Updated Successfully.",
    erroruploadingfileplztry:
      "Error uploading the file. Please try again or contact us at help@blufield.net ",
    orgismissingnotdrag: "Organization ID is missing, cannot drag!",
    nochangwsmadetothe: "No changes were made to the field type.",
    selectOrgWarning: "Select organization first.",
    pleaseselectdayreport: "Please select the day for the report.",
    reportprocesucc: "Report processed successfully!",
    nofileselc: "No file selected.",
    filesizeexceeds: "File size exceeds 5MB.",
    invalidfiletypeplimg: "Invalid file type. Please upload an image",
    invalidfiletypedouc: "Invalid file type. Please upload a document",
    unsupportedfile: "Unsupported file type.",
    plzfillallfieldbeforeadd: "Please fill in all fields before adding asset.",
    assetaddedscucceffuly: "Asset Added Successfully.",
    fillFieldbeforeAddVehical:
      "Please fill in all fields before adding a vehicle.",
    assetupdatedsuc: "Asset updated successfully.",
    vehicalupdatedsuc: "Vehicle updated successfully",
    emailidorpass: "Email or password is incorrect.",
    accessdenied: "Access Denied !",
    otpverifiedsuc: "OTP verified successfully.",
    failedtoverifyotp: "Failed to verify OTP.",
    noworkflowinorg: "No workflows are available for this organization.",
    plzuploadpdffileonly: "Please upload PDF or video files only.",
    guidlineuplodsucc: "Guideline uploaded successfully.",
    invalidfiletype: "Invalid file type. Please upload a JPG, PNG, or GIF",
    emailnotavailble:
      "Email not available. Please ensure your profile is loaded",
    youcanotmodify:
      "You cannot modify the existing password unless cleared first",
    youcanowenter: "You can now enter a new password",
    passowrdmust:
      "Password must be at least 8 characters,include an uppercase letter,lowercase letter,number,and special character",
    profileupdated: "Profile Updated",
    failedtofetchemails: "Failed to fetch emails",
    enteremailfirst:
      "Enter your email first, then you can enable email notifications.",
    statusupdatedsucc: "Status updated successfully.",
    failedtoupdatednotifcation: "Failed to update notification setting",
    errorfiledownloaded: "Error: File Downloaded",
    fileuploadedaborteddue: "File upload aborted due to an error.",
    plxselectanoption: "Please select an option.",
    pleasefillallmandtoryfield:
      "Please fill in all mandatory fields to proceed.",
    uploadcanceled: "Upload canceled",
    nodatavailvle: "No data available",
    nofieldavailable: "No fields available.",
    categoriyaddedsucc: "Category added successfully.",
    plzselectdeltype: "Please select a deletion type.",
    failedtodelfile: "Failed to delete the file.",
    uploadedtasksheet: "The uploaded task sheet list is shown in the table!",
    nomoredatatoload: "No more data to load.",
    taskdetailupdatedsuc: "Task details updated successfully!",
    norecordavbforthisacc:
      "No record available for this account number, please try another account number",
    userupdatedsuc: "User updated successfully",
    usercreatedSuc: "User created successfully",
    failedtofetchusers: "Failed to fetch users.",
    nofieldabuplodtasksheet:
      "No fields available, Upload task sheet first to get additional fields",
    nomoreuniqueversion: "No more unique versions available",
    nomoreversionavailble: "No more versions available ",
    createworkflowdiagram: "Create Workflow.",
    updatepdfnamefirst: "Update the pdf name first ",
    pdfnameupdate: "PDF name updated successfully.",
    updatereportname: "Update report name first",
    excelnameupdate: "Excel name updated succssfully ",
    inputvlueadded: "Input value added!",
    warningthis:
      "Warning: This option is already included in the workflow. Removal is restricted",
    linkedWorkflowConditionConflict:
      'This option already has a linked workflow. Remove the linked workflow before adding a parent-option condition for "{option}".',
    conditionLinkedWorkflowConflict:
      'This option already has a parent-option condition. Remove it before linking a workflow to "{option}".',
    linkedWorkflowConditionSaveConflict:
      '{field} option "{option}" already has a linked workflow and a parent-option condition. Remove one before saving.',
    fieldremoved: "Field Removed",
    fieldcloned: "Field Cloned",
    clonedsuc: "Cloned Successfully",
    pleaseentername: "Please enter a name for the cloned workflow.",
    inputfield: "Input field cannot be empty!",
    warningalready:
      "Warning: This option is already included in the workflow. Removal is restricted. You can only edit the name of this option",
    validationremoved: "Validation removed. Update the workflow for Deletion",
    validationnotapplicable:
      "Validation is not applicable for this field type.",
    updatetheworkflow: "Update the workflow to save these additional fields.",
    failedtoupdatefield: "Failed to update fields. Please try again.",
    pleaseSelectLeastActivity: "Please select at least one activity.",
    failedSubmitReportRequest: "Failed to submit report request.",
    urlnotprovided: "URL not provided in the response",
    failedtoaddasset: "Failed to add asset ",
    vehicleaddedsuc: "Vehical added successfully",
    failToAddVehical: "Failed to add vehicle.",
    ruleupdatedsuc: "Rule updated successfully!",
    filesdeleted: "File deleted",
    plzselectatleatone: "Please select at least one task to assign",
    plzselectedforilfagrntoasing: "Please select a field agent to assign tasks",
    selectedtasknotassinged: "Selected tasks are not assigned.",
    completedTaskReassignNotAllowed: "Only unsuccessful completed tasks can be reassigned.",
    completedTasksCannotBeOnHold: "Completed tasks cannot be put on hold.",
    taskAlreadyOnHold: "Task is already on hold.",
    pendingTasksCannotBeOnHold: "Pending tasks cannot be put on hold.",
    taskAssignNotAllowed: "Only Active, Pending or On Hold tasks can be assigned.",
    taskReassignNotAllowed: "Only Assigned, In Progress, Pending or On Hold tasks can be reassigned.",
    taskUnassignNotAllowed: "Only Assigned, Pending or On Hold tasks can be unassigned.",
    invalidworkflow: "Invalid workflow. Please try again",
    softdeletedsucc: "Soft delete successful!",
    softdelfailed: "Soft delete failed!",
    erroduringsoftdel: "Error during soft delete!",
    permamatdelsuc: "Permanent delete successful!",
    permantdelfailed: "Permanent delete failed!",
    errorduringperdel: "Error during permanent delete!",
    taskrecallcompletesuc: "Task recall completed successfully!",
    taskrecallfailed: "Task recall failed!",
    erroduringtaskrecall: "Error during task recall!",
    attachmentismand: "Attachment is mandatory!",
    onlypdfimgallowed: "Only PDF and Image files are allowed.",
    workflowmodule:
      "The workflow module is not available on mobile devices. Please use a desktop or tablet to continue.",

    Attachment: "Attachment ",
    viewattachment: "View Attachment",
    Inactive: "Inactive ",
    aresurewantodeleterule: "Are you sure you want to delete Rule?",
    Assigning: "Assigning ",
    taskcreatesuc: "Task Created Successfully",
    Requesting: "Requesting ",
    enterextendeddate: "Enter Extended Date",
    targetoutstandingamtbyextdate: "Target Outstanding Amount by Extended Date",
    Comments: "Comments ",
    No: "No",
    aresurewanttodeleterecord: "Are you sure you want to delete record?",
    downladreport: "Download Report",
    transferto: "Transfreed To",
    nometerdetailfound: "No meter details found for barcode",
    Saving: "Saving ",
    loadingmeterdetail: "Loading meter detail",
    Print: "Print ",
    ucantaddmorethan6: `You can't add more than 6 installments`,
    Proceed: "Proceed ",
    taskdetails: "Task Details",
    viewexistingfile: "View Existing File",
    nofileuploaded: "No file uploaded",
    nooptionavailable: "No options available",
    fetchingaccdetails: "Fetching account details",
    workflowid: "Workflow ID",
    pdflink: "PDF Link",
    selectefieldpreiview: "Selected fields for preview",
    fieldname: "Field Name",
    fieldtype: "Field Type",
    selectfield: "Select Field",
    selectinputtype: "Select Input Type",
    updateinputype: "Update Input Type",
    uploadnewphoto: "Upload New Photo",
    Open: "Open ",
    uploadnewdoc: "Upload New Document",
    viewpdf: "View PDF",
    dragandroptoupload: "Drag and drop to upload",
    aresurewantodeletefile: "Are sure want to delete file ?",
    generatereport: "Generate Report ",
    Reject: "Reject ",
    Approve: "Approve ",
    loadingmorenotification: "Loading more notifications",
    nomorenotification: "No more notifications to load",
    Pending: "Pending ",
    Task: "Task ",
    Mandatory: "Mandatory ",
    Fields: "Fields ",
    Other: "Other ",
    Back: "Back ",
    thisactivitydoesnothavefield: "This activity does not have fields",
    subcategory: "Sub Category",
    selectsubcategory: "Select Sub Category",
    addcategory: "Add Category +",
    deletetask: "Delete Tasks",
    deleteTaskTitle: "Delete Task",
    dosoftdeletions: "Do soft deletion",
    depermanatdeletions: "Do permanent deletion",
    permanentdeletedisabled: "Currently this option is disabled",
    confirmdeletion: "Confirm Deletion",
    areusurewanttoallassinged:
      "Are you sure you want to make all assigned , progress and on-hold tasks active ?",
    selectlocationmap: "Select Location on Map",
    Loading: "Loading",
    nowuserfound: "No users found",
    userActivity: "User Activity",
    loginHistoryTitle: "Login History",
    viewLoginHistory: "View login history",
    loadingLoginHistory: "Loading login history...",
    noLoginActivityYet: "No login activity yet",
    loginHistoryWillAppearWhenSignIn:
      "Login history will appear here when this user signs in.",
    mostRecentLogin: "Most Recent Login",
    loginTime: "Login Time",
    systemId: "System ID",
    map: "Map",
    openInMap: "Open in map",
    open: "Open",
    locationUnavailable: "Location unavailable",
    failedToFetchLoginHistory: "Failed to fetch login history.",
    notAvailable: "N/A",
    addfield: "Add fields",
    updatefield: "Update Fields",
    enterworkflowname: "Enter Workflow Name",
    Elements: "Elements ",
    Report: "Report ",
    editinputvalues: "Edit Input Values",
    addedvalidation: "Added Validations",
    deletefield: "Delete Field",
    deletevalidation: "Delete Validation",
    validationcode: "Validation Code",
    novalidationavailable: "No validation available",
    rusurewanttodeleteworkflow:
      "Are you sure you want to delete this workflow?",
    noversionavb: "No versions available",
    noreportdataavb: "No Report Data available",
    goback: "Go Back →",
    aresurewantodeleteemail: "Are you sure you want to delete this email?",
    nofieldagentfound: "No field agents found",
    Selected: "Selected",
    updatedon: "Updated on",
    tariff: "Tariff",
    Office: "Office",
    cancelupload: "Cancel Upload",
    Recall: "Recall ",
    notaskavbtounasign: "No Task Available to Un-Assign",
    unassigntask: " Unassign Task",
    selectassigntounassign:
      "Select assignees to unassign from the selected tasks",
    allassign: "All Assignees",
    confirmaction: "Confirm Action",
    areusure:
      " Are you sure you want to delete this task? This action cannot be undone",
    totalcount: "Total Count",
    Processing: "Processing",
    currenOs: "Current OS ",
    updatedat: "Updated At",
    curros: "Current Outstanding",
    lastupdateddate: "Last Updated Date",
    lastupdatedtime: "Last Updated Time ",
    assingename: "Assignee Name",
    finisheddate: "Finished Date",
    fnishedtime: "Finished Time",
    uploadeddate: "Uploaded Date",
    uploadedtime: "Uploaded Time",
    uploadedLabel: "Uploaded",
    finishedLabel: "Finished",
    Unsuccessful: "Unsuccessful ",
    Success: "Success ",
    fileprocessingcancle: "File processing canceled",
    pleaseenteraccnumber: "Please enter account number ",
    projmissingplzelc: "Project is missing. Please select a project",
    addleastonelementto:
      "Add at least one element to the current page before moving to the next page",
    checkuremailotp: "Check your email for OTP",
    taskcreatedsuc: "Tasks Created Successfully",
    taskunassingedsucc: "Task unassigned successfully!",
    norecordareavailable: "No Records are Available ",
    failtoupdaterule: "Failed to update rule",
    startdateerror: "Start date cannot be after end date",
    anerror: "",
    errorsubmiting: "Error submitting form",
    ruleupdated: "Rule updated successfully",
    failupdaterule: "Failed to update rule",
    plzselectworkflow: "Please select workflow before adding rule",
    basicinfo: "Basic Info",
    changeprofile: "Change Profile",
    updateRule: "Update Rule",
    newRule: "New Rule",
    assignedAll: "Assigned All",
    notAssignedAll: "Not Assigned All",
    LoadingGeo: "Loading Geo Codes...",
    selectgeocode: "Select Geo Codes",
    All: "All",
    loadingtyoecodes: "Loading Type Codes...",
    selecttypecodes: "Select Type Codes",
    selectamount: "Select Amount Range",
    ok: "Ok",
    gobacktopreviousstep: "Go back to the previous step",
    continuetonextstep: "Continue to the next step",
    selectsheettoupload: "Select or drop the sheet you want to import",
    uploadlimitexceeded: "Upload limit exceeded",
    sheetrecordlimitmsg:
      "This sheet contains {count} records. A maximum of {limit} records can be uploaded at a time. Please split the file and upload again.",
    fileuploadedtitle: "File uploaded",
    largedataprocessingmsg:
      "Your file has been uploaded successfully. If it contains a large number of records, processing may take some time. Please wait a while and check the status in the list below.",
    invalidfiletitle: "Invalid file",
    unabletoreadsheet:
      "We could not read this file. Please make sure it is a valid CSV or Excel sheet and try again.",
    importtaskusingsheet: "Import task using sheet / csv",
    mapyourfilecolumns: "Map your file columns and upload tasks",
    importprogress: "Import progress",
    columnmappingsteps: "Column mapping steps",
    uploadfilelabel: "Upload File",
    uploadtasksheetdesc:
      "Upload the task sheet you want to import (.csv or .xlsx). We'll map its columns next.",
    draganddroptasksheet: "Drag & drop your task sheet here",
    orclicktobrowse: "or click to browse · CSV or Excel",
    clicktochooseanotherfile: "click to choose another file",
    selectavalue: "Select a value",
    selecttaskpriority: "Choose default priority for imported tasks",
    existingaccountsquestion: "What Do You Want To Do With Existing Accounts?",
    updateexistingaccountentries: "Update Already Existing Account Entries?",
    createnewaccountentries: "Create New Account Entries?",
    mandatoryfield: "Mandatory Field",
    primarykeyvalue: "primary key / value",
    pleaseselectanactivity: "Please select an activity",
    findAField: "Find a field...",
    wfFieldGroupBasic: "Basic Fields",
    wfFieldGroupSelection: "Selection Fields",
    wfFieldGroupMedia: "Media & Special Fields",
    uploadandreviewtasksheets: "Upload and review imported task sheets.",
    cycle: "Cycle",
    daterange: "Date Range",
    reportscope: "Report scope",
    selectcycle: "Select Cycle",
    selectcycleoptional: "Cycle (optional)",
    nocyclesavailable: "No cycles uploaded yet",
    pleaseselectacycle: "Please select a cycle",
    pleaseselectonecycle: "Select exactly one cycle for the data report",
    performancereport: "Performance Report",
    cycleperformancereport: "Cycle Performance Report",
    performancereportready: "Cycle performance reports generated.",
    performancereporttooltip: "Generate performance reports for the selected activity and cycles",
    performancereportrequirements: "Select one of this activity's cycles to generate the performance report",
    cyclesingleactivityonly: "Cycle reports cover one activity at a time. Select a single activity to use cycle scope.",
    cycleselectactivityfirst: "Select an activity to use cycle scope",
    gobacklabel: "Go back",
    inProgress: "In Progress",
    uploadedCount: "Uploaded Count",
    movedCount: "Moved Count",
    updatedCount: "Updated Count",
    notUploadedCount: "Not Uploaded Count",
    notUploadedLog: "Not Uploaded Log",
    movedLog: "Moved Log",
    downloadnotuploadedlog: "Download not uploaded log",
    downloadnotmovedlog: "Download not moved log",
    failedtorecalltask: "Failed to recall the task.",
    previousPage: "Previous page",
    nextPage: "Next page",
    previousyear: "Previous year",
    nextyear: "Next year",
    addRule: "Add Rule",
    addproject: "Add Project",
    departmentname: "Department Name",
    projectname: "Project Name",
    adddepartment: "Add Department",
    seeData: "See Data",
    enterrecipt: "Enter recipients, separated by commas",
    enterbcc: "Enter Bcc, separated by commas",
    entercc: "Enter Cc, separated by commas",
    assignbyrule: "Assign by Rules",
    searchfieldAgent: "Search Field Agents",
    selectAll: "Select All",
    deselectAll: "Deselect All",
    selectAllAgentsTooltip: "Select all visible agents",
    deselectAllAgentsTooltip: "Deselect all visible agents",
    loadingtask: "Loading task details",
    fieldagentAvgwork: "Field Agent Avg Work Time",
    selectDash: "Select Dashboard",
    selecttask: "Select Task Status",
    selectStatus: "Select Status",
    SelectDateTime: "Select Date and Time Range",
    startdatetime: "Start Date and Time",
    enddatetime: "End Date and Time",
    selectDateRange: "Select Date Range",
    fieldAgentCLock: "Field Agent Clock In/Out",
    selectusertpye: "Select User Type",
    isClockin: "Is ClockIn",
    selectvehicle: "Select Vehicle",
    vehicalid: "Vehicle Id ",
    OrganizationId: "Organization Id",
    inuse: "In Use",
    id: "ID",
    selectAsset: "Select Asset ",
    showLatLog: "Show Lat/Long Missing Tasks",
    hidelatlog: "Show Tasks Without Location (Lat/Long)",
    createdatetime: "Created Date-Time",
    taskCategory: "Task Category",
    mobileno: "Mobile No",
    discardMessage:
      "Do you really want to leave? This action will you save or discard",
    viewinstallmentmsg: "Enter the account number to view installment plans",
    optionalSelectedfield: "Optional Selection Fields",
    emailnotification: "Email Notifications",
    recievemeial: "Receive email notifications for task updates and reminders",
    taskmangement: "Task Management",
    autoAssign: "Auto Assign",
    autoAssignTask: "Auto Assign Tasks",
    autoasigntaskto: "Automatically assign tasks to available team members ",
    failedToLoadAutoAssign: "Failed to load auto-assign status.",
    failedToUpdateAutoAssign: "Failed to update auto-assign status.",
    protectioninWorkflow: "Protection in Workflow",
    preventtaskprotected: "Prevent changes to tasks once they are in progress",
    othersetting: "Other Settings",
    choselang: "Choose the default language for the application",
    addmeail: "Add Email",
    email: "Email",
    noFieldsAvailable: "No Fields Available",
    notchartYet: "No data available to display for this chart yet.",
    chartWaitingForResponses: "This chart will update automatically once responses come in.",
    priorityLevel: "Priority Level",
    entername: "Enter Name",
    Activities: "Activities",
    basicField: "Basic  Fields",
    recent: "Recent",
    selectionfield: "Selection field",
    mediafield: "Media and Special Fields",
    items: "items",
    Enable: "Enable",
    disable: "Disable",
    comapletedDate: "Completed Date",
    taskId: "Task Id",
    noproject: "No Project",
    nodepartment: "No Department",
    noactivity: "No Activity",
    splaignrule: "Special Assignment Rule",
    specialAssignmentRuleSubheading: "Route tasks by geo location, type, or amount range.",
    urgentTaskAssignment: "Urgent Task Assignment",
    urgentTaskAssignmentTooltip: "Assign urgent tasks to selected field agents",
    urgentTaskAssignmentSubtitle: "Choose the workflows, area codes and field agents for urgent task assignment.",
    urgentAreaCodes: "Area Codes",
    urgentSelectAreaCodes: "Select area codes",
    urgentFieldAgents: "Field Agents",
    urgentSelectFieldAgents: "Select field agents",
    urgentSelectWorkflowRequired: "Please select at least one workflow",
    urgentSelectAreaCodeRequired: "Please select at least one area code",
    urgentSelectAgentRequired: "Please select at least one field agent",
    urgentWorkflowHelp: "Urgent tasks from these workflows will be assigned.",
    urgentAreaCodeHelp: "Only tasks located in these area codes are included.",
    urgentAgentHelp: "These agents are added to every open task that matches.",
    urgentSummary: "Assignment summary",
    urgentStepsComplete: "steps complete",
    urgentAssignNow: "Assign Urgent Tasks",
    urgentAssigning: "Assigning...",
    urgentPleaseWait: "Assigning urgent tasks, please wait...",
    urgentNoPermission: "You don't have permission to assign urgent tasks",
    urgentAssignSuccess: "Urgent assignment is being processed in the background. You'll be notified once it's complete.",
    urgentAssignFailed: "Failed to assign urgent tasks",
    urgentConfirmTitle: "Confirm urgent assignment",
    urgentConfirmMessage: "Add {count} agent(s) to all open tasks in the selected activities and areas? Existing assignees are kept.",
    urgentConfirmBack: "Back",
    urgentConfirm: "Yes, assign",
    urgentHowItWorks: "How it works",
    urgentHelpKeepAssignees: "Existing assignees are kept; the agents are added on top.",
    urgentHelpSkipCompleted: "Completed and Finished tasks are skipped.",
    urgentHelpOneTime: "It's one-time: new uploads won't go to these agents automatically.",
    urgentHelpInProgress: "In-Progress tasks also get the agents, and the task list shows them alongside the existing assignees.",
    searchByAssignTo: "Search by assign to...",
    myprofile: "My Profile",
    sidebarNotifications: "Notifications",
    sidebarSettings: "Settings",
    sidebarUnreadCount: "{count} unread",
    barChart: "Bar Chart",
    Piechart: "Pie chart",
    Radarchart: "Radar chart",
    Linechart: "Line chart",
    Areachart: "Area chart",
    OrganizationLogo: "Organization Logo",
    OrganizationName: "Organization Name",

    Organizations: "Organizations",
    ReportType: "Report Type",
    ForInstallmentPlan: "For Installment Plan",
    WorkflowNames: "Workflow Names",
    ReportLink: "Report Link",
    RequestedAt: "Requested At",
    Noguidelines: "No guidelines available",
    Deleteworkflowmsg:
      "Do you really want to leave? This action will delete your created workflow structure",
    MandatoryFields: "Mandatory Field",
    NonMandatoryFields: "Non-Mandatory Fields",
    BulkUpload: "Bulk Upload",
    CreateandAssigne: "Create and Assign",
    AssetName: "Asset Name",
    UserId: "User Id",
    FieldStaffList: "Field Staff List",
    SUBMISSION: "SUBMISSION",
    NOT_COMPLETED: "NOT_COMPLETED",
    HideCriteria: "Hide Criteria",
    NewCriteria: "Add New Criteria",
    ActivityQuestions: "Select Activity Questions",
    FieldQuestion: "Select Field Question",
    Select: "Select",
    AddChart: "Add Chart",
    DeleteDash: "Are you sure you want to delete this dashboard?",
    DeleteGraph: "Are you sure you want to delete this graph metric?",
    CreateDash: "Create Activity Dashboard",
    Role: "Role",
    Activity: "Activity",
    selectWorkflow: "Select Workflow",
    sarWorkflow: "Workflow",
    allWorkflows: "All workflows",
    sarWorkflowRequired: "Please select a workflow",
    sarWorkflowChangeHint: "Changing the workflow unassigns the tasks this rule assigned in the old workflow and assigns matching tasks in the new workflow.",
    ActivityName: "Activity Name",
    SelectChart: "Select Chart",

    // --- Tasks by Governorate card ---
    tasksByGovernorate: "Tasks by Governorate",
    governorate: "Governorate",
    notSpecified: "Not specified",
    selectFieldAgent: "Select field agent",
    selectView: "Select view",
    barChartView: "Bar chart",
    barChartViewHint: "Bar length is the task count",
    shareView: "Share",
    shareViewHint: "Every bar full width, to compare the status mix",
    tableView: "Table",
    tableViewHint: "Exact numbers for all six statuses",
    statusAssigned: "Assigned",
    statusInProgress: "In Progress",
    statusOnHold: "On Hold",
    statusPending: "Pending",
    statusCompleted: "Completed",
    statusFinished: "Finished",
    total: "Total",
    doneLabel: "Done",
    openLabel: "Open",
    blockedLabel: "Blocked",
    totalAcrossGovernorates: "All tasks across governorates that have tasks",
    completedPlusFinished: "Completed + Finished",
    assignedPlusInProgress: "Assigned + In Progress",
    onHoldPlusPending: "On Hold + Pending",
    selectWorkflowToSeeData: "Select a workflow to see data.",
    workflowPickerHint: "Choose a workflow from the picker at the top of the page.",
    noFieldAgentsForWorkflow: "No field agents on this workflow.",
    noFieldAgentsHint: "Assign a field agent to this workflow to see their coverage.",
    selectFieldAgentToSeeData: "Pick a field agent",
    selectFieldAgentHint: "Their tasks will be broken down by governorate and status.",
    loadingData: "Loading...",
    somethingWentWrong: "Could not load governorate data.",
    tryAgainHint: "Try selecting the field agent again.",
    noTasksForAgent: "No tasks for this field agent",
    noTasksForAgentHint: "Nothing has been assigned to them in this workflow yet.",
    allStatusesHidden: "All statuses hidden - click one below to show it again.",
    governorateWithNoTask: "governorate with no task",
    governoratesWithNoTask: "governorate(s) with no task",
    ViewChart: "View Chart",
    RangeFilter: "Date Range Filter",
    selecrOrg: "Please select an organization",
    Page: "Page",
    FieldId: "Field Agent ID",
    FieldAgentName: "Field Agent Name",
    Action: "Action",
    RemarkReq: "Remarks are required.",
    adCustSupport: "Add customer Support",
    Clone: "Clone",
    SpecialRc: "Special RC",
    InteractiveRc: "Interactive RC",
    Viewinstallment: "View installment",
    createInstallment: "Create installment plan",
    CustomerId: "Customer Id",
    NoOfinstallment: "Number of installments ",
    advancepayamt: "Advance Payment Amount",
    advDate: "Advance Date",
    custDetail: "Customer Details",
    instalDetail: "Installment Details ",
    firstInstDate: "First Installment Date ",
    clrPreview: "Clear Preview",
    prevPlan: "Preview Plan ",
    submitRc: "Submit for RC",
    AfterAdv: "Outstanding After Advance",
    currentOut: "Current outstanding",

    Amount: "Amount ",
    Notes: "Notes ",
    Latitude: "Latitude ",
    Longitude: "Longitude ",
    selectFieldAget: "Select Field Agent ",
    planId: "Plan Id",
    planActive: "Plan Active ",
    planCreated: "Plan Created",
    outstaningAmt: "Outstanding Amount",
    Advamt: "Advance Amount",
    AdvDate: "Advance Payment Date",
    firstInsDate: "First Installment Date",
    noOfInst: "No of Installments",
    activeInst: "Active Installments",
    DetailId: "Detail Id ",
    PaymentId: "Payment Id,",
    PayAmt: "Payment Amount ",
    payDate: "Payment date ",
    dueDate: "Due date",
    paymentStatusUpdatedAt: "Payment status updated at",
    outstandingForInstalmentPlan: "Outstanding",
    Status: "Status ",
    PayPrev: "Payment Preview",
    OutAfteAdv: "Outstanding After Advance",
    CurrentOut: "Current outstanding ",
    NoinstAvlble: "No installment available ",
    title: "Blufield Utilities Tasks management solutions",
    userEmail: "Username/Email address ",
    remember: "Remember me",
    forgetpass: "Forget password",
    Login: "Login ",
    pressEnter: "Press Enter to add multiple account numbers",
    typeEnter: "Type a number and press Enter",
    protectedAccountLimitReached: "You can add a maximum of {limit} accounts per request.",
    protectedAccountCount: "Added {count} of a maximum of {limit} accounts",

    payDetail: "Payment Details",
    cretDate: "Created Date",
    inactiveplane: "Inactive Installment Plans",
    instplanDetail: "Installment Plan Details",
    loogoutMsg: "Are you sure you want to logout?",
    Logout: "Logout",
    support: "Customer Support",
    supportSubtitle: "Manage RC requests, installment plans, and account updates.",
    interactiveRcTabTooltip: "Submit an interactive RC request",
    createInstallmentTabTooltip: "Create a new installment plan for an account",
    viewInstallmentTabTooltip: "Browse existing installment plans",
    specialRcTabTooltip: "Submit a special/exception RC request",
    interactiveRcSubtitle: "Submit an interactive RC request.",
    createInstallmentSubtitle: "Set up a new installment plan for a customer account.",
    viewInstallmentSubtitle: "Look up an account to see its installment plan.",
    specialRcSubtitle: "Submit a special or exception RC request.",
    viewInstallmentEmptySub: "Search an account number above to view its installment plan.",
    noMatchingCustomerRecord: "No matching customer record.",
    noInactiveInstallmentPlans: "No inactive installment plans.",
    noActiveInstallments: "No active installments.",
    supporttooltip: "RC Support System",
    powerbidashboard: "PowerBi Dashboard",
    installment: "Installment Plan",
    password: "Password",
    noDatavb: "No Data available",
    noFilteredData: "No tasks match the selected filters. Try adjusting or clearing your filters.",
    viewValidation: "view Validation",
    completedTaskCount: "Completed Task Count",
    taskpriority: " Task Priority",
    taskstatus: "Task Status",
    previous: "Prev",
    next: "Next",
    datefilterforchart: " Date for Completed Task",
    date: "Date",
    from: "From",
    to: "To",
    apply: "Apply",
    unassignn: "Unassign",
    dashboard: "Dashboard",
    dashboardtolltip: "Dashboard,View and manage your dashboard overview",
    usertooltip: "Users, Manage user accounts and roles",
    setting: "Settings",
    asset: "Asset Management",
    assettooltip: "Asset, View and manage your assets",
    config: "Configuration",
    configtooltip:
      "Configuration, Manage Assignment rules, custom rules and completion rules",
    task: "Task Manage",
    tasktooltip: "Task Manage, Manage your tasks and assignments, deletion",
    acchistory: "Account History",
    accReportsCenter: "Account & Reports Center",
    historytooltip: "Account History, View the history of completed tasks",
    accReportsCentertooltip:
      "Account & Report Center, View account history and export reports",
    callCenter: "Call Center",
    callCentertooltip:
      "Call Center, Manage inbox, tickets, campaigns, and agent workspace",
    workflowe: "Workflow",
    workflowtooltip: "Workflow, Manage your workflows, Guidelines",
    workflowManagementSubtitle: "Create and manage the workflow templates used to configure task forms.",
    workflows: "Workflows",
    searchWorkflow: "Search workflow name...",
    sortBy: "Sort",
    sortNameAsc: "Name (A-Z)",
    sortNameDesc: "Name (Z-A)",
    sortUpdatedNewest: "Last updated (newest)",
    sortUpdatedOldest: "Last updated (oldest)",
    noWorkflowsMatchSearch: "No workflows match your search",
    workflowSettings: "Workflow settings",
    secondsUnit: "sec",
    pageWiseOff: "Page wise off",
    timerLabel: "Timer",
    addPage: "Add page",
    duplicatePage: "Duplicate page",
    deletePage: "Delete page",
    versionHistory: "Version history",
    confirmDeletePageText: "This page and all its fields will be permanently removed. This can't be undone.",
    workflowNeedsAtLeastOnePage: "A workflow needs at least one page",
    pageAdded: "Page added",
    pageDuplicated: "Page duplicated",
    pageDeleted: "Page deleted",
    moveToPage: "Move to Page",
    fieldMoved: "Field moved",
    worklog: "Worklog",
    worklogtooltip:
      "Worklog, View and manage your work logs, Export Excel Report, Export PDF",
    worklogSubtitle: "Schedule a recurring email report or export your work log as a PDF.",
    security: "Security",
    securitytooltip: "Security, Manage security settings",
    report: "Reports",
    reportooltip: "Reports, Request for report, Check status of the Reports",
    reportsSubtitle: "Request, track, and download reports for your organization.",
    dateRange: "Date Range",
    dateRangeTooltip: "Filter reports by date range",
    reportTypeTooltip: "Filter reports by report type",
    userTypeTooltip: "Filter reports by user type",
    statusTooltip: "Filter reports by status",
    roleManagement: "Role Based Management",
    roleManagementSubtitle: "Create and manage roles with custom permissions for your organization.",
    roleManagementtooltip: "Manage roles and permissions",
    createRole: "Create Role",
    updateRole: "Update Role",
    deleteRole: "Delete Role",
    roleName: "Role Name",
    confirmDeleteRole: "Are you sure you want to delete this role?",
    noRolesFound: "No roles found",
    permissions: "Permissions",
    permissionModalSubtitle: "Choose what this role can view, create, update or delete across your workspace.",
    granted: "granted",
    changesApplyOnceSaved: "Changes apply once you save.",
    noScreensAvailable: "No screens available",
    permGroupAccess: "Access & Roles",
    permGroupOperations: "Operations",
    permGroupAssets: "Assets",
    permGroupInsights: "Insights",
    permGroupSystem: "System & Account",
    permGroupOther: "Other",
    org: "Organization",
    organizationPageTitle: "Organization",
    recordName: "Name",
    recordType: "Type",
    logo: "Logo",
    orgHierarchyHint:
      "Expand an organization to view its departments and projects.",
    organizationPageHierarchyHint:
      "Expand an organization to view its departments and projects.",
    organizationPageSearchPlaceholder: "Search Organization...",
    orgtooltip: "Organization, Manage Organization",
    deleteOrganizationTitle: "Delete organization?",
    deleteOrganizationCascadeMessage:
      "Are you sure you want to delete this organization? All dependent data linked to it will also be removed.",
    stock: "Stock Management",
    stocktoooltip:
      "Stock Management, Update inventory Details, Download Report",
    inventoryManagement: "Inventory Management",
    inventoryManagementTooltip:
      "Inventory Management, Manage meter inventory, transfers, and assignments",
    meterInventoryTitle: "Meter Inventory",
    meterInventorySubtitle:
      "Manage meter inventory, store locations, transfers, and group assignments.",
    inventoryMeterHistoryTitle: "Meter History & Traceability",
    inventoryMeterHistorySubtitle: "Complete lifecycle log for {identifier}",
    inventoryDetailsTitle: "Inventory Details",
    inventoryDetailsSection: "Details",
    inventoryViewHistory: "View History →",
    inventoryEditItem: "Edit Details",
    inventoryEditStatus: "Status",
    inventoryEditStore: "Store",
    inventoryEditGroup: "Group",
    inventoryEditSelectGroup: "Select a group",
    inventoryEditSave: "Save Changes",
    inventoryEditSuccess: "Inventory item updated successfully.",
    inventoryBackToDetails: "Back to Details",
    inventoryMovementTimeline: "Movement & Event Timeline",
    inventoryUpdated: "Updated",
    inventoryBy: "By",
    inventoryNote: "Note",
    inventoryIdentifier: "Identifier",
    inventoryItemType: "Item Type",
    inventoryColItemType: "Item Type",
    inventoryColIdentifier: "Identifier",
    inventoryColStatus: "Status",
    inventoryColComponents: "Components",
    inventoryColGroupAssignment: "Group Assignment",
    inventoryColConditionNote: "Condition Note",
    inventoryColCreatedBy: "Created By",
    inventoryColCreatedAt: "Created At",
    inventoryColUpdatedBy: "Updated By",
    inventoryColUpdatedAt: "Updated At",
    inventoryColStore: "Store",
    inventoryColSource: "Source",
    inventoryColLocation: "Location",
    inventoryColLatitude: "Latitude",
    inventoryColLongitude: "Longitude",
    inventoryColTransferFrom: "Transfer From",
    inventoryColTransferTo: "Transfer To",
    inventoryTypeNewMeter: "New Meter",
    inventoryTypeOldMeter: "Old Meter",
    inventoryTypeModem: "Modem",
    inventoryTypeSimCard: "SIM Card",
    inventoryTypeSeal: "Seal",
    inventorySealPrefix: "Seal Prefix",
    inventorySealFrom: "Seal From",
    inventorySealTo: "Seal To",
    inventorySealPrefixPlaceholder: "e.g. SL",
    inventorySealFromPlaceholder: "e.g. 1001",
    inventorySealToPlaceholder: "e.g. 2000",
    inventorySealRangeRequired: "Enter the seal from and to numbers.",
    inventorySealRangeInvalid: "Seal From and Seal To must be whole numbers, and To cannot be lower than From.",
    inventorySealRangePreview: "Creates {first} – {last} ({count} seals)",
    inventorySealRange: "Seal Range",
    inventorySealCount: "Seal Count",
    inventorySealNumbers: "Seal Numbers",
    inventorySealsFitted: "Seals fitted",
    inventorySealRangeHistoryTitle: "Seal Range History & Traceability",
    inventorySealTotal: "Total seals",
    inventorySealFittedCount: "Fitted",
    inventorySealRemaining: "Remaining",
    inventorySealRemainingOfTotal: "{available} of {total} left",
    inventorySealNoneFitted: "No seals fitted yet",
    inventorySealColSeal: "Seal",
    inventorySealColMeter: "Meter",
    inventorySealColFittedBy: "Fitted by",
    inventorySealColDate: "Date",
    inventoryHistorySealUsedEvent: "Seal {seal} fitted",
    inventorySealOpenMeterHistory: "Open this meter's history",
    inventorySealBackToRange: "Back to seal range",
    inventorySealNumbersInfoTitle: "Seals fitted on this meter",
    inventorySealNumbersInfo: "These seal numbers were fitted on the meter when it was installed by a field task.",
    inventorySealNumbersCellTooltip: "{count} seal(s) fitted on this installed meter",
    inventorySealRangeFittedInfoTitle: "Seals used from this range",
    inventorySealRangeFittedInfo: "Seals from this range that have already been fitted on installed meters. They are no longer available.",
    inventoryImportSealColumns: "Seal sheets need From and To columns, plus an optional Prefix column (Seal From / Seal To / Seal Prefix also work). No serial column is needed.",
    inventoryImportSealColumnsFound: "Detected: {found}",
    inventoryImportSealColumnsMissing: "Not found yet: {missing} (you can pick them in the column mapping)",
    inventoryImportDownloadSealTemplate: "Download seal template",
    inventoryStatus: "Status",
    inventoryStoreId: "Store ID",
    inventoryAssignedToId: "Assigned To (User ID)",
    inventoryGroupAssignment: "Group Assignment",
    inventoryAction: "Action",
    rowsPerPage: "Rows per page",
    inventoryApply: "Apply",
    inventorySelectAll: "Select all",
    inventorySelectNone: "Select none",
    inventoryFilterSearchValues: "Search values...",
    inventoryFilterNoValues: "No values",
    inventoryFilterOk: "OK",
    inventoryFilterLoadingValues: "Loading values...",
    inventoryFilterBlanks: "(Blanks)",
    inventoryFilterContainsPlaceholder: "Contains...",
    inventoryFilterContainsHelp: "Case-insensitive match.",
    inventoryRowNumber: "No.", 
    inventoryStoreLocation: "Location",
    inventoryMeterNumber: "Meter Number",
    inventoryMeterType: "Meter Type",
    inventoryGroup: "Group",
    inventoryAssignment: "Assignment",
    inventorySimNo: "SIM No.",
    inventoryModemNo: "Modem No.",
    inventoryInstallationDate: "Installation Date",
    inventoryCreatedAt: "Created At",
    inventoryComponentType: "Component Type",
    inventoryComponentId: "Component ID",
    inventoryCurrentLocation: "Current Location",
    inventoryAssignedGroup: "Assigned Group",
    inventoryGroupMembers: "Group Members",
    inventoryCurrentAssignment: "Current Assignment",
    inventoryMeterBarcode: "Meter Barcode",
    inventoryMeterSerialNumber: "Meter Serial Number",
    inventoryMeterMake: "Meter Make",
    inventoryManufacturingYear: "Manufacturing Year",
    inventoryBatchNumber: "Batch Number",
    inventoryActivationDate: "Activation Date",
    inventoryReplacementSection: "Replacement & Connected Components",
    inventoryComponents: "Components",
    inventoryApn: "APN",
    inventoryIpAddress: "IP Address",
    inventoryInstallationStatus: "Installation Status",
    inventoryTransferredFrom: "Transferred From",
    inventoryTransferredTo: "Transferred To",
    inventoryConditionNote: "Condition Note",
    inventorySource: "Source",
    inventoryUploadId: "Upload ID",
    inventoryCreatedBy: "Created By",
    inventoryUpdatedAt: "Updated At",
    inventoryBalance: "Balance",
    inventoryOrganizationId: "Organization ID",
    inventoryProjectId: "Project ID",
    inventoryOp: "OP",
    inventorySimDetailUpdatedAt: "SIM Detail Updated At",
    inventoryDeleted: "Deleted",
    inventoryDeletedAt: "Deleted At",
    inventoryDeletedBy: "Deleted By",
    inventoryDeleteReason: "Delete Reason",
    inventoryValueNewMeter: "New Meter",
    inventoryValueOldMeter: "Old Meter",
    inventoryValueModem: "Modem",
    inventoryValueSimCard: "SIM Card",
    inventoryValueSmartMeter: "Smart Meter",
    inventoryStatusAvailable: "Available",
    inventoryStatusTipAvailable: "Available in inventory and ready to be assigned.",
    inventoryStatusAssigned: "Assigned",
    inventoryStatusTipAssigned: "Assigned to a subcontractor.",
    inventoryStatusReassigned: "Reassigned",
    inventoryStatusTipReassigned: "Assigned again to the same or another subcontractor.",
    inventoryStatusActive: "Active",
    inventoryStatusInTransit: "In Transit",
    inventoryStatusTipInTransit: "Being moved between locations or subcontractors.",
    inventoryStatusInstalled: "Installed",
    inventoryStatusTipInstalled: "Installed at a customer's premises.",
    inventoryStatusRemoved: "Removed",
    inventoryStatusTipRemoved: "Taken out of a customer's premises.",
    inventoryStatusReturned: "Returned",
    inventoryStatusTipReturned: "Handed back to a store.",
    inventoryStatusDamaged: "Damaged",
    inventoryStatusTipDamaged: "Damaged and not fit for use.",
    inventoryStatusQuarantined: "Quarantined",
    inventoryStatusTipQuarantined: "Set aside until it is checked.",
    inventoryStatusLost: "Lost",
    inventoryStatusTipLost: "Lost. Cannot be assigned or transferred.",
    inventoryStatusRetired: "Retired",
    inventoryStatusTipRetired: "Withdrawn from use. Cannot be assigned or transferred.",
    inventoryAssigned: "Assigned",
    inventoryAvailable: "Available",
    inventoryViewDetailsAria: "View inventory details",
    inventoryViewHistoryAria: "View inventory history",
    inventoryClosePanel: "Close inventory panel",
    noHistoryFound: "No history available yet.",
    inventoryHistoryFilterAll: "All",
    inventoryHistoryFilterTransactions: "Transactions",
    inventoryHistoryFilterAuditLog: "Audit Log",
    inventoryHistoryEventsCount: "{count} event(s)",
    inventoryHistoryNoEventsForFilter: "No events for this filter.",
    inventoryHistoryLoadFailed: "Failed to load inventory history.",
    inventoryHistoryRecordCreated: "Record Created",
    inventoryHistoryReceivedEvent: "Received into Inventory",
    inventoryHistoryAuditEvent: "Audit Event",
    inventoryHistoryTagAccount: "Account",
    inventoryHistoryTagTask: "Task",
    inventoryHistoryTagReplacement: "Replacement ID",
    inventoryHistoryTagReference: "Ref",
    inventoryHistoryUnknownUser: "User #{id}",
    inventoryImportTitle: "Import Meter Inventory",
    inventoryImportSubtitle:
      "Upload an Excel or CSV sheet to create or update meter inventory.",
    inventoryImportTabNew: "New Import",
    inventoryImportTabHistory: "Upload History",
    inventoryImportProgressAria: "Inventory import progress",
    inventoryImportStepUpload: "Upload File",
    inventoryImportStepDestination: "Destination",
    inventoryImportStepReview: "Validate & Import",
    inventoryImportUploadDesc: "Select the sheet that holds your inventory rows.",
    inventoryImportDropTitle: "Drag & drop your Excel or CSV file",
    inventoryImportDropHint: "or click to browse (.xlsx, .xls, .csv)",
    inventoryImportChooseAnother: "Click to choose another file",
    inventoryImportInvalidType: "Only .xlsx, .xls and .csv files can be imported.",
    inventoryImportDestinationDesc:
      "Choose where the rows land and how they should be applied.",
    inventoryImportSelectStore: "Store",
    inventoryImportSelectStorePlaceholder: "Select a store",
    inventoryImportStoresEmpty: "No stores available for this project.",
    inventoryImportStoreLoadFailed: "Could not load stores.",
    inventoryImportItemType: "Item Type",
    inventoryImportItemTypePlaceholder: "Select item type",
    inventoryImportMode: "Import Mode",
    inventoryImportModeCreate: "Create new or update existing",
    inventoryImportModeCreateHint:
      "New rows are created and matching rows are updated.",
    inventoryImportModeUpdate: "Update existing only",
    inventoryImportModeUpdateHint:
      "Only existing rows are updated, nothing new is inserted.",
    inventoryImportSelectFileFirst: "Select a file to continue.",
    inventoryImportSelectStoreFirst: "Select a store to continue.",
    inventoryImportValidating: "Validating your sheet...",
    inventoryImportValidationDesc: "Every row was checked. Nothing has been saved yet.",
    inventoryImportValidationPassed: "Validation passed",
    inventoryImportValidationFailed: "Validation found issues",
    inventoryImportValidationError: "Could not validate the sheet.",
    inventoryImportRevalidate: "Re-validate",
    inventoryImportSummary: "Summary",
    inventoryImportTotalRows: "Total rows",
    inventoryImportValidRows: "Valid rows",
    inventoryImportInvalidRows: "Invalid rows",
    inventoryImportCreatedRows: "Created",
    inventoryImportUpdatedRows: "Updated",
    inventoryImportSkippedRows: "Skipped",
    inventoryImportErrorsTitle: "Row issues",
    inventoryImportRow: "Row",
    inventoryImportMoreIssues: "{count} more issue(s) not shown.",
    inventoryImportConfirm: "Import",
    inventoryImportUploading: "Importing...",
    inventoryImportSuccess: "Inventory sheet imported successfully.",
    inventoryImportFailed: "Inventory import failed.",
    inventoryImportHistoryEmpty: "No uploads yet.",
    inventoryImportHistoryFile: "File",
    inventoryImportHistoryStore: "Store",
    inventoryImportHistoryMode: "Mode",
    inventoryImportHistoryStatus: "Status",
    inventoryImportHistoryTotal: "Total",
    inventoryImportHistorySuccess: "Success",
    inventoryImportHistoryFailed: "Failed",
    inventoryImportHistoryUploadedBy: "Uploaded By",
    inventoryImportHistoryUploadedAt: "Uploaded At",
    inventoryImportHistoryLoadFailed: "Could not load upload history.",
    inventoryImportRunning: "Import running in the background...",
    inventoryImportValidationRunning: "Validation running in the background...",
    inventoryImportBackgroundNote:
      "You can keep working — this run continues in the background and stays in the upload history.",
    inventoryImportStatusLabel: "Status",
    inventoryImportStatusQueued: "Queued",
    inventoryImportStatusInProgress: "In progress",
    inventoryImportStatusCompleted: "Completed",
    inventoryImportStatusFailedLabel: "Failed",
    inventoryImportPollFailed: "Could not read the upload status.",
    inventoryImportUploadIdLabel: "Upload",
    inventoryImportRejectedTitle: "Rows not uploaded",
    inventoryImportRejectedTruncated: "Showing the first {count} rejected rows.",
    inventoryImportLoadAllRejected: "Load all rejected rows",
    inventoryImportDownloadFailureLog: "Download failure log",
    inventoryImportDownloadNotUploaded: "Download not uploaded rows (Excel)",
    inventoryImportNotUploadedExportEmpty: "There are no rejected rows to download.",
    inventoryImportNotUploadedExportPartial:
      "Only the rows already loaded could be downloaded.",
    inventoryImportNotUploadedExportFailed: "Could not download the rejected rows.",
    inventoryImportReason: "Reason",
    inventoryImportNotUploadedCount: "Not uploaded",
    inventoryImportShowValidationRuns: "Show validation runs",
    inventoryImportShowValidationRunsInfo:
      "A validation run is the dry-run check the upload wizard does first: it reports what would be created, updated or rejected without saving anything.",
    inventoryImportUploadSheet: "Upload Sheet",
    inventoryNoAccessTooltip: "You do not have access to this action",
    inventoryNoCreateAccessTooltip: "You do not have create access for inventory",
    inventoryNoUpdateAccessTooltip: "You do not have update access for inventory",
    inventoryImportTooltip: "Upload a sheet to create or update inventory",
    inventoryTransferTooltip: "Transfer the selected items to a store or group",
    inventoryAddTooltip: "Add inventory manually or in bulk",
    inventoryCreateStoreTooltip: "Create a new store",
    inventorySuperAdminOnlyTooltip: "Only a super admin can create a store",
    inventoryFiltersTooltip: "Show or hide the column filters",
    inventoryResetTooltip: "Clear every applied filter",
    inventoryImportHistoryHeading: "Upload history",
    inventoryImportHistorySubtitle: "Every sheet uploaded into meter inventory, newest first.",
    inventoryExport: "Export",
    inventoryExportTooltip: "Export all inventory items to Excel",
    inventoryExportFilteredTooltip: "Export items filtered by: {columns}",
    inventoryExportStarted: "Inventory export started.",
    inventoryExportStartFailed: "Unable to start the inventory export.",
    inventoryExportHistoryLoadFailed: "Unable to load export history.",
    inventoryExportHistoryEmpty: "No exports yet",
    inventoryExportNoRecordsTooltip: "No inventory items matched the selected filters, so there is no data to export.",
    inventoryExportPreparing: "Preparing…",
    inventoryExportProgress: "{completed} / {total} items, {remaining} remaining",
    inventoryExportRetry: "Retry",
    inventoryExportRetryTooltip: "Start this export again with the same project and filters",
    inventoryExportRetrying: "Starting the export again…",
    inventoryExportView: "View export",
    inventoryExportTitle: "Export inventory",
    inventoryExportDescription: "This report exports inventory for the selected project(s).",
    inventoryDashboard: "Inventory Dashboard",
    inventoryDashboardSubtitle: "Status of every item in the inventory, and what each group holds.",
    inventoryDashboardStatusTitle: "Items by status",
    inventoryDashboardTotal: "Total items",
    inventoryDashboardGroupTitle: "Items assigned to groups",
    inventoryDashboardGroupSubtitle: "Total items assigned to each group, broken down by status.",
    inventoryDashboardGroup: "Group",
    inventoryDashboardGroupTotal: "Total assigned",
    inventoryDashboardBreakdown: "Breakdown",
    inventoryDashboardNoGroups: "No items are assigned to a group yet.",
    inventoryDashboardLoadFailed: "Unable to load the inventory dashboard.",
    inventoryDashboardAllItemTypes: "All item types",
    inventoryDashboardSelectOrganization: "Select an organization in the header to see its inventory.",
    inventoryDashboardOther: "Other statuses",
    inventoryDashboardGroups: "Groups",
    inventoryDashboardItems: "items",
    inventoryDashboardNoItems: "No items in the inventory yet.",
    inventoryDashboardDonutHint: "Each slice is a status's share of all items",
    inventoryDashboardStatusBarHint: "Bar length is the item count",
    inventoryDashboardGroupBarHint: "Bar length is the group's item count",
    inventoryDashboardTableHint: "Exact numbers for every group",
    inventoryDashboardShowAllGroups: "Show all {count} groups",
    inventoryDashboardShowTopGroups: "Show top {count} groups",
    inventoryDashboardStoreTitle: "Items by store",
    inventoryDashboardStoreSubtitle: "Items held in each store, broken down by status.",
    inventoryDashboardStores: "Stores",
    inventoryDashboardItemsInStores: "Items in stores",
    inventoryDashboardNeedsAttention: "Damaged / Quarantined / Lost",
    inventoryDashboardNoStores: "No stores found for this selection.",
    inventoryDashboardStoreInactive: "Inactive",
    inventoryDashboardIncoming: "Incoming in transit",
    inventoryDashboardOutgoing: "Outgoing in transit",
    inventoryDashboardItemsWithoutStore: "{count} items are not in any store.",
    inventoryDashboardStoreBarHint: "Bar length is the store's item count",
    inventoryDashboardStoreTableHint: "Exact numbers for every store",
    inventoryDashboardShowAllStores: "Show all {count} stores",
    inventoryDashboardShowTopStores: "Show top {count} stores",
    inventoryExportRecent: "Recent exports",
    inventoryExportNote: "Exports are built in the background. The file appears here when it is ready, and you also get a notification.",
    inventoryImportValidationRunBadge: "Validation only",
    inventoryImportFailedRows: "Failed",
    inventoryAddTitle: "Add Inventory",
    inventoryAddSubtitle: "Create a single inventory item manually or add many at once.",
    inventoryAddTabManual: "Manual Entry",
    inventoryAddTabBulk: "Bulk Entry",
    inventoryAddTabImport: "Excel Upload",
    inventoryUpdateActionLabel: "When the meter already exists",
    inventoryUpdateActionHint:
      "Updating details no longer moves stock — choose the return option to change custody.",
    inventoryUpdateActionDetails: "Update existing meter details",
    inventoryUpdateActionDetailsHint:
      "Refresh the meter's details and leave its current store and holder unchanged.",
    inventoryUpdateActionReturn: "Return existing meter to selected store",
    inventoryUpdateActionReturnHint:
      "Move the meter back into the selected store. Lost or retired meters cannot be returned.",
    inventoryGroupDisabledReturnTooltip: "Group assignment isn't available when returning a meter to the store.",
    inventoryUploadFieldModemSerial: "Modem Serial Number",
    inventoryUploadFieldSimSerial: "SIM Serial Number",
    inventoryImportNoHeaders: "The sheet has no header row to map. Add column names in the first row.",
    inventoryImportHeadersReadFailed: "Could not read the sheet. Check the file and try again.",
    inventoryImportColumnsFound: "columns",
    inventoryImportMapTitle: "Map Sheet Columns",
    inventoryImportUnmappedCount: "{count} sheet column(s) not mapped",
    inventoryImportMainColumns: "Main columns to map",
    inventoryImportMapHint: "You'll match your sheet's columns to these fields in the next step.",
    inventoryImportMapAndImport: "Map Columns & Import",
    inventoryImportSerialDetected: "Detected automatically from the column \"{header}\" — no mapping needed.",
    inventoryImportSerialNotFound: "No recognised serial column found in this sheet — map it in the next step.",
    inventoryImportSerialAccepted: "Recognised headers: {names}",
    inventoryImportMapConflict: "Columns '{a}' and '{b}' both map to '{target}'. Map only one of them.",
    inventoryImportKeepColumnName: "Keep as \"{header}\"",
    inventoryImportColumnsMappedCount: "{mapped} of {total} mapped to inventory fields",
    inventoryImportOtherColumnsHint:
      "Every other column in your sheet is listed below. Pick the inventory field it fills, or keep it under its own name.",
    inventoryImportExcelColumn: "Excel column",
    inventoryImportInventoryField: "Inventory field",
    inventoryAddSectionDestination: "Destination & Mode",
    inventoryAddSectionDetails: "Item Details",
    inventoryAddSectionMetadata: "Additional Details",
    inventoryAddSectionItems: "Items",
    inventoryAddIdentifierPlaceholder: "e.g. MTR-000123",
    inventoryAddStatus: "Status",
    inventoryAddMode: "Save Mode",
    inventoryAddModeCreateOnly: "Create only",
    inventoryAddModeCreateOnlyHint: "Fails when the identifier already exists.",
    inventoryAddModeUpdateOnly: "Update only",
    inventoryAddModeUpdateOnlyHint: "Only identifiers that already exist are updated.",
    inventoryAddModeCreateOrUpdate: "Create or update",
    inventoryAddModeCreateOrUpdateHint: "Creates new identifiers and updates existing ones.",
    inventoryAddGroupAssignment: "Group Assignment",
    inventoryAddConditionNote: "Condition Note",
    inventoryAddNote: "Note",
    inventoryAddMeterMake: "Meter Make",
    inventoryAddMeterType: "Meter Type",
    inventoryAddComponents: "Components",
    inventoryAddManufacturingYear: "Manufacturing Year",
    inventoryAddSelectYear: "Select year",
    inventoryAddBatchNo: "Batch No.",
    inventoryAddOrganizationName: "Organization",
    inventoryAddSimNo: "SIM No.",
    inventoryAddIccid: "ICCID",
    inventoryAddModemMake: "Modem Make",
    inventoryAddBulkHint:
      "Every row uses the store, item type and mode selected above unless the row overrides it.",
    inventoryAddAddRow: "Add Row",
    inventoryAddRemoveRow: "Remove row",
    inventoryAddRowLabel: "Row",
    inventoryAddIdentifierRequired: "Meter number is required.",
    inventoryAddStoreRequired: "Select a store.",
    inventoryAddItemsRequired: "Add at least one item with a meter number.",
    inventoryAddDuplicateIdentifier: "Duplicate identifiers in this batch: {values}",
    inventoryAddSuccess: "Inventory item saved.",
    inventoryAddBulkSuccess: "Inventory items saved.",
    inventoryAddFailed: "Could not save inventory.",
    inventoryAddSave: "Save",
    inventoryAddSaving: "Saving...",
    inventoryAddResultsTitle: "Results",
    inventoryTransferTitle: "Transfer Inventory",
    inventoryTransferSubtitle:
      "Move the selected inventory items to another store or hand them to a subcontractor group.",
    inventoryTransferSelectedCount: "{count} item(s) selected",
    inventoryTransferNoSelection: "Select at least one inventory item to transfer.",
    inventoryTransferSelectedItems: "Selected items",
    inventoryTransferTargetTitle: "Transfer To",
    inventoryTransferTargetStore: "Another store",
    inventoryTransferTargetStoreHint: "Move the items into a different store location.",
    inventoryTransferTargetGroup: "Subcontractor (group)",
    inventoryTransferTargetGroupHint:
      "Hand the items to a field group; its members are listed for reference.",
    inventoryTransferSearchGroup: "Search group or member...",
    inventoryTransferNoGroups: "No group found",
    inventoryTransferSelectGroupFirst: "Select a group to continue.",
    inventoryAssignmentInput: "Assignment source",
    inventoryMeterNumbers: "Serial numbers",
    inventoryAssignmentExcel: "Assign from Excel",
    inventoryMeterNumbersHint: "Enter serial numbers (meter, modem, SIM or seal range) separated by spaces, commas, or new lines.",
    inventoryMeterNumbersRequired: "Enter valid serial numbers for every selected item.",
    inventoryAssignmentFileRequired: "Choose an Excel file (.xlsx or .xls).",
    inventoryAssignmentProjectRequired: "Choose one project for this assignment.",
    inventoryClearCustody: "Clear custody",
    inventoryClearCustodyHint: "Remove all store and group assignments for these items.",
    inventoryReassign: "Reassign",
    inventoryDeleteUnavailable: "Delete API configuration is required.",
    inventoryTransferSameSourceStore: "Select meters from the same source store before assigning them to a group.",
    inventoryTransferSameSourceOrg: "Select meters from the same organization before assigning them to a group.",
    inventoryTransferOrgMismatch: "Item '{item}' belongs to another organization.",
    inventoryTransferAssignmentResult: "{assigned} assigned, {failed} failed.",
    inventoryMeterTransferSummary: "{success} successful, {skipped} skipped.",
    inventorySkippedMetersDownloaded: "The skipped serial numbers have been downloaded.",
    inventoryTransferSelectStoreFirst: "Select a store to continue.",
    inventoryTransferNote: "Note",
    inventoryTransferNotePlaceholder: "Optional note for this transfer",
    inventoryTransferConfirm: "Transfer",
    inventoryTransferring: "Transferring...",
    inventoryTransferInProgressHint: "This can take a while. Please keep this window open until it finishes.",
    inventoryTransferSuccess: "Inventory transferred successfully.",
    inventoryTransferFailed: "Inventory transfer could not be completed.",
    inventoryTransferCurrentStore: "Current store",
    inventoryTransferNewStore: "New store",
    inventoryTransferUnassignedStore: "No store assigned",
    inventoryTransferCurrentStoreUnknown: "Available for selected items",
    inventoryTransferGroupLoadFailed: "Could not load groups.",
    inventorySampleComponentId: "INV-MTR-20451",
    inventorySampleLocation: "Site 102",
    inventorySampleGroup: "Group A",
    inventorySampleAssignment: "Field Team 04",
    inventorySampleBarcode: "23239722299",
    inventorySampleSerial: "SN-2026-88231",
    inventorySampleMake: "L&T",
    inventorySampleYear: "2026",
    inventorySampleBatch: "BATCH-2026-14",
    inventorySampleActivationDate: "25 Sep 2026",
    inventorySampleInstallationDate: "2026-09-25",
    inventorySampleOldMeterId: "INV-MTR-10021",
    inventorySampleModemId: "INV-MOD-00421",
    inventorySampleSimId: "INV-SIM-00891",
    notAvailable: "—",
    transferMeter: "Transfer Inventory",
    addInventory: "Add Inventory",
    //USER
    addUser: "Add User",
    searchusername: "Search by username...",
    searchAllFields: "Search by username, email, or phone...",
    searchByEmail: "Search by email...",
    searchByPhone: "Search by phone...",
    searchareacode: "Search by areacode...",
    userType: "User Type",
    user: "User",
    edit: "Edit",
    editOrganizationTooltip: "Edit organization",
    deleteOrganizationTooltip: "Delete organization",
    userlist: "User Management",
    userManagementSubtitle: "Add, edit, and manage user access across your organization.",
    userdetail: "User Details",
    previllage: "Previleges",
    cancle: "Cancel",
    updateuser: "Update User",
    add: "Add User",
    username: "User Name",

    selectOrg: "Select Organization",
    areCode: "Area Code",
    addeditActivity: "Add/edit Activity",
    addnewlabel: "Add/Edit Configuration",
    addEdituser: "Add/edit User",
    canasset: "Can access asset Management",
    uservisibility: " User Visibility",
    modifyguidline: "Modifying Guidelines",
    createDashboar: "Create Dashboard",
    addeditleader: "Add/edit Leader-board",
    canTaskManage: "Can access Task Manage",
    canAddEditProtectedAccount: "Can Add /Edit Protected account",
    canAddEditInventory: "Can add/Edit Inventory Management",
    //SETTINGS
    general: "General",
    save: "Save Changes",
    langSetting: "Language Settings",
    colormode: "Color Mode",
    light: "Light",
    dark: "Dark",
    highcontrast: "High Contrast",
    lang: "Language",
    toursetting: "Tour Setting",
    stoptour: "Stop Tour",
    starttour: "Start Tour",
    custommarker: "Custom Marker",
    all: "All",
    none: "None",
    assigned: "Assigned",
    active: "Active",
    progress: "In Progress",
    completed: "Completed",
    onhold: "On Hold",
    //ASSET
    vehical: "Vehical",
    Inventory: "Inventory",
    exportreport: "Export Report",
    addVehical: "Add New Vehical",
    addAsset: " Add New Asset",
    search: "Search",
    vehicalType: "Vehicle type",
    vehicalAssign: "Vehicle Assignee",
    searchbyId: "Search By Id...",
    assetType: "Asset type",
    assetAssign: "Asset Assignee",
    addnewasset: "Add New Asset",
    assetId: "Asset ID",
    agentAssigned: "Agent Assigned",
    assetStatus: "Asset Status",
    updateAsset: "Update Asset",
    Update: "Update",
    updateVehical: "Update Vehical",
    //CONFIGURATION
    complitionrule: "Completion Rules",
    completionRuleSubheading: "Control how tasks behave when a status is selected.",
    searchStatusOrExpression: "Search by status or expression...",
    editRule: "Edit Rule",
    deleteRule: "Delete Rule",
    completionRuleColumn: "Completion Rule",
    ruleLabel: "Rule",
    step: "STEP",
    statusStepDescription: "Choose the task status that will trigger this rule.",
    ruleActive: "Rule active",
    ruleActiveDescription: "When enabled, this rule is evaluated. Disabled rules are kept but ignored.",
    taskMovement: "Task movement",
    taskMovementDescription: "When enabled, the task automatically moves to another workflow once this rule is met.",
    destinationTask: "Destination task",
    completionRuleDescPrefix: "Define the condition that must evaluate to",
    completionRuleDescSuffix: "before the task can be completed.",
    expressionEditor: "expression editor",
    fullscreen: "Fullscreen",
    exitFullscreen: "Exit fullscreen",
    criteriaPlaceholder: 'e.g. submission["field_id"] == option-1',
    whatThisScreenDoes: "What this screen does",
    completionRuleInfo: "Each rule configures one condition: which status it watches, whether it's active, whether the task should move automatically, and the exact expression that must be true. Click a rule -- or Add New Rule -- to edit it.",
    assignmentRuleInfo: "Each rule matches a criteria expression to a specific field agent or group. Auto assign applies these automatically as new tasks come in.",
    specialAssignmentRuleInfo: "Use this when routing needs to be more specific than a simple assignment rule -- for example, sending certain geo codes, type codes, or amount ranges to a dedicated user or group.",
    customVariableInfo: "Define an expression once and reference it across completion, assignment, and special assignment rules for this workflow.",
    customVariableSubheading: "Reusable expressions for your workflow rules.",
    completionRuleTabTooltip: "Control what happens when a task's status changes",
    assignmentRuleTabTooltip: "Assign tasks to a user or group by criteria match",
    specialAssignmentRuleTabTooltip: "Route specific tasks to a dedicated assignee",
    customVariableTabTooltip: "Reusable expressions for your rules",
    assignment: "Assignment Rules",
    assignmentRuleSubheading: "Decide which user or group a task is assigned to based on a criteria match.",
    searchByNameTargetCriteria: "Search by name, target, or criteria...",
    searchByCriteria: "Search by criteria...",
    editCriteria: "Edit Criteria",
    assignmentCriteriaPlaceholder: "e.g. 'Area Code' == 123, 456",
    customerule: "Custom Variables",
    rulename: "Rule Name",
    assignTo: "Assign To",
    assingTask: "Assign Tasks",
    activedeactive: "Active / Deactive",
    criteria: "Criteria",
    submit: "Submit",
    update: "Update",
    norule: "No more rules to load",
    noSearchResults: "No matches found",
    tryAdjustingSearch: "Try adjusting your search terms to find what you're looking for.",
    clearSearch: "Clear search",
    getStartedAddingRule: "Get started by adding your first rule.",
    getStartedAddingCustomVariable: "Get started by adding your first custom variable.",
    icon: "Icon",
    createrule: "Create new rule",
    addNewRule: "Add New Rule",
    multiSelect: "Multi Select",
    smartAssign: "Smart Assign",
    FieldStaff: "Field Staff",
    Location: "Location",
    MapStatus: "Map Status",
    fieldAgent: "Field Agent",
    selectFieldAgent: "Select Field Agent",
    allFieldAgents: "All Field Agents",
    createNewTask: " Create new task",
    importCSV: "Upload Task",
    mapview: "Mapview",
    createTask: "Create new task",
    listvbiew: "Task List View",
    download: "Download",
    downloadPdf: "Download PDF",
    downloadAll: "Download All",
    downloadSelected: "Download Selected",
    downloadAllPdfsTooltip: "Download all PDFs",
    downloadSelectedPdfsTooltip: "Download selected PDFs",
    downloadingAllPdfs: "Downloading all PDFs...",
    downloadingSelectedPdfs: "Downloading {count} PDF(s)...",
    // Bulk PDF export (BLF-2171)
    bulkExportTitle: "Bulk PDF export",
    bulkExportSubtitle: "Prepared in the background, delivered as one ZIP.",
    bulkExportIdLabel: "Export ID",
    // Singular: labels one export's workflow, unlike the plural `Activities`
    // used for the filter dropdown that spans all of them.
    bulkExportActivityLabel: "Activity",
    bulkExportClose: "Close",
    bulkExportActionColumn: "Action",
    bulkExportStart: "Start export",
    bulkExportStartTooltip: "Prepare the PDFs in the background",
    bulkExportRetry: "Try again",
    bulkExportIdleHelp:
      "The PDFs are zipped in the background, so you can keep working while it runs. We'll notify you when the ZIP is ready.",
    bulkExportRequesting: "Queueing your export...",
    bulkExportQueuedHeading: "Queued — waiting for a worker to pick it up",
    bulkExportQueuedHelp: "Your export is in the queue and will start shortly.",
    bulkExportInProgressHeading: "Preparing PDFs",
    bulkExportProcessedOfTotal: "{processed} of {total} PDFs",
    bulkExportKeepRunningHint:
      "You can close this window — the export keeps running and the ZIP stays in Export History.",
    bulkExportRunInBackground: "Run in background",
    bulkExportRunInBackgroundTooltip: "Close this window and keep the export running",
    bulkExportCompletedHeading: "Your ZIP is ready",
    bulkExportCompletedHelp: "Download it below or from Export History.",
    bulkExportDownloadZip: "Download ZIP",
    bulkExportDownloadZipTooltip: "Download the prepared ZIP",
    bulkExportTotalLabel: "Total",
    bulkExportSuccessLabel: "Succeeded",
    bulkExportFailedLabel: "Failed",
    bulkExportNoFile: "This export finished without a file. Please try again.",
    bulkExportNoFileShort: "No file",
    bulkExportFailedHeading: "Export failed",
    bulkExportFailedHelp: "The export could not be completed. Please try again.",
    bulkExportErrorHeading: "Could not reach the export service",
    bulkExportErrorHelp:
      "Progress updates stopped. The export may still be running — check Export History.",
    // Title for every header.code 601 -- it covers a too-wide date range, too
    // many account numbers, too many matched PDFs and too many exports already
    // running, so it stays neutral and lets the backend message do the work.
    bulkExportLimitHeading: "Export could not be started",
    bulkExportLimitFallback:
      "This export could not be started. Please narrow your selection and try again.",
    bulkExportEmptyHeading: "Nothing matched this selection",
    bulkExportEmptyHelp: "Try a different date range, activity, or account selection.",
    bulkExportFailedAccountsTitle: "{count} account(s) could not be exported",
    bulkExportFailedAccountsColumn: "Failed Accounts",
    bulkExportFailedAccountsCount: "{count} failed",
    bulkExportNoFailedAccounts: "None",
    bulkExportDownloadFailedExcel: "Download Excel",
    bulkExportDownloadFailedExcelTooltip: "Download the failed account numbers as Excel",
    bulkExportRequestError: "Could not start the export. Please try again.",
    bulkExportDismiss: "Dismiss",
    bulkExportShowAccounts: "Show accounts",
    bulkExportHideAccounts: "Hide accounts",
    bulkExportCopyAccounts: "Copy account numbers",
    bulkExportCopied: "Copied",
    bulkExportSelectedAccounts: "{count} selected",
    bulkExportAllAccountsInRange: "All accounts in the date range",
    bulkExportMatchedLabel: "Matched PDFs",
    bulkExportStatusPending: "Queued",
    bulkExportStatusInProgress: "In progress",
    bulkExportStatusCompleted: "Completed",
    bulkExportStatusFailed: "Failed",
    bulkExportHistoryTitle: "Export History",
    bulkExportHistorySubtitle: "Every bulk PDF export you have requested, newest first.",
    bulkExportShowingRange: "Showing {start}-{end} of {total}",
    bulkExportHistoryTooltip: "View previous bulk PDF exports",
    bulkExportHistoryLoadError: "Could not load export history.",
    bulkExportAllActivities: "All activities",
    bulkExportRefresh: "Refresh",
    bulkExportRefreshTooltip: "Reload the export history",
    bulkExportBackToPdf: "Back to Export PDF",
    bulkExportRequestedAt: "Requested",
    bulkExportCompletedAt: "Completed",
    bulkExportFileSize: "Size",
    bulkExportNoHistory: "No exports yet",
    bulkExportNoHistoryHelp: "Bulk PDF exports you request will show up here.",
    bulkExportTrack: "Track",
    bulkExportTrackTooltip: "Watch this export's progress",
    bulkExportToggleDetails: "Show export details",
    bulkExportViewExport: "View export",
    bulkExportCheckSelectionTitle: "Check your selection",
    bulkExportSingleActivityWarning: "Select a single activity before exporting PDFs.",
    bulkExportDateRangeWarning: "Select a date range before exporting PDFs.",
    bulkExportRadioFilterNotice:
      "The radio-option filter is not applied to bulk exports — every completed task in this date range will be included. Tick specific rows to export only those.",
    bulkExportTableFilterNotice:
      "Column and user-name filters only narrow the table on this page, not the export. Tick specific rows to export only those.",
    selectRadioOption: "Select radio option",
    refresh: "Refresh Table",
    deleteAllRecord: " Delete All Record",
    assign: "Assign",
    reassign: "Reassign",
    usercount: "User Counts",
    alert: "Sent Alert",
    delete: "Delete",
    priority: "Priority",
    Cycle: "Cycle",
    status: "Status",
    searchbycode: "Search by Area Code..",
    selectAssign: "Select Assignee",
    downloadtask: " Download Task Report",
    seectallactivty: " Select All Activity",
    selectpartcular: " Selected Particular Activity",
    recentReports: "Recent Reports",
    noteLabel: "Note:",
    reportGeneratingNote: "Reports can take a few minutes to generate. If yours isn't ready yet, wait a bit and click the refresh button to check again.",
    viewAllReports: "View all reports",
    reportRequestQueued:
      "Report generation is in process. It will appear under Recent Reports once ready.",
    selectMsg: "Please select an activity to proceed.",
    createnewtask: "Create new task",
    cancel: "Cancel",
    create: "Create",
    bulkReAssign: "Bulk Re-Assign",
    bulkPriorityUpdate: "Bulk Priority Update",
    bulkUpload: "Bulk Upload",
    reassignTasks: "Reassign Tasks",
    newAccounts: "New Accounts",
    existingAccounts: "Existing Accounts",
    noNewAccounts: "No new accounts",
    noExistingAccounts: "No existing accounts",
    assignees: "assignees",
    noAssignees: "No assignees",
    DragDetail: "Drag and drop CSV containing all the task details",
    sizeMsg: "Max file size: 15MB",
    import: " Import CSV ",
    uploadfile: "Upload Task Sheet",
    uploadby: "Uploaded By",
    uploaddate: "Upload Date",
    uploadtime: "Upload Time (24hrs)",
    taskdetail: "Task Detail",
    taskhistory: " Task History",
    nohistory: "No task history available.",
    more: "Loading more task history...",
    enteraccno: " Enter Account Number",
    reset: " Reset",
    resetAllAppliedFiltersTooltip: "Clear all applied filters",
    filtersToggleTooltip: "Apply filters from the table header",
    protectedAccountsTitle: "Protected Accounts",
    protectionJobsTitle: "Protection History",
    protectionJobsSubtitle: "Track account protection requests and download the accounts that were skipped.",
    protectionJobsTooltip: "View the status and history of protection requests",
    protectionJobsBack: "Back to protected accounts",
    protectionJobsRefresh: "Refresh",
    protectionJobsAutoRefresh: "Protection is in progress and may take some time. The table updates automatically, or click Refresh.",
    protectionJobsEmpty: "No protection jobs yet",
    protectionJobsEmptyHint: "Jobs appear here after you create protected accounts.",
    protectionJobsLoadFailed: "Could not load protection jobs.",
    protectionJobCreated: "Created",
    protectionJobFinished: "Finished",
    protectionJobStatusQUEUED: "Queued",
    protectionJobStatusIN_PROGRESS: "In progress",
    protectionJobStatusCOMPLETED: "Completed",
    protectionJobStatusFAILED: "Failed",
    protectionJobColStatus: "Status",
    protectionJobColSrNo: "Sr No.",
    protectionJobColSkippedFile: "Skipped Accounts",
    protectionJobColActions: "Actions",
    protectionJobAddMasterDb: "Add to Master DB",
    protectionJobAddProtection: "Add Protection",
    protectionJobMasterDbTooltip: "Not in Master DB. Add them first.",
    masterDbModalTitle: "Add accounts to Master DB",
    masterDbModalSubtitle: "These accounts were skipped because they are not in the Master DB. Add them first so they can be protected.",
    masterDbAccountsLabel: "Accounts ({count})",
    masterDbNote: "{count} skipped accounts are not in the Master DB. They will be added at the default location ({lat}, {lon}).",
    masterDbProtectionTitle: "Protection details",
    masterDbProtectionHint: "Needed only for Add & Protect.",
    masterDbNoAccounts: "Select at least one account.",
    masterDbProtectNotice: "Once the accounts are added to the master DB, they will be protected again.",
    masterDbFieldsLoadFailed: "Could not load the Master DB fields. Close this window and try again.",
    masterDbSubmitAdd: "Add to Master DB",
    masterDbSubmitAddAndProtect: "Add & Protect",
    masterDbSubmitAddTooltip: "Add to Master DB only",
    masterDbSubmitAddAndProtectTooltip: "Add to Master DB and protect",
    masterDbAddedSuccess: "Added to the Master DB successfully.",
    masterDbAddedAndProtected: "Accounts added to the Master DB. The protection request runs in the background; its progress is shown here.",
    masterDbAddedProtectFailed: "The accounts were added to the Master DB, but the protection request failed. Protect them from Create Protected Account.",
    masterDbAddFailed: "Could not add the accounts to the Master DB.",
    protectionJobMasterDbAddedTooltip: "Already added to Master DB. Protect them.",
    protectionJobMasterDbDoneTooltip: "All accounts are already added to the Master DB and protected.",
    masterDbProtectModalTitle: "Protect accounts",
    masterDbProtectModalSubtitle: "These accounts are already added to the Master DB. Only protection can be added.",
    masterDbAlreadyAddedNote: "{count} accounts are already added to the Master DB. Only protection can be added now.",
    masterDbSubmitProtect: "Protect",
    masterDbSubmitProtectTooltip: "Protect these accounts",
    masterDbProtectStarted: "The protection request runs in the background; its progress is shown here.",
    masterDbProtectFailed: "The protection request failed.",
    protectionJobTotal: "Total",
    protectionJobProtected: "Protected",
    protectionJobSkipped: "Skipped",
    protectionJobDownloadSkipped: "Download skipped accounts",
    protectionJobDownloadSkippedTooltip: "Download Excel of skipped accounts",
    protectionJobFinishedSummary: "Protection finished: {protected} protected, {skipped} skipped.",
    protectionJobFailedToast: "Protection request failed.",
    protectionJobFailedTitle: "Protection request failed",
    protectionRequestReceived: "Protection request received. It runs in the background, so track its progress here.",
    protectedAccountsSubtitle: "Protects accounts from automatic write-offs and closures.",
    fromDateTooltip: "Select the report's start date",
    toDateTooltip: "Select the report's end date",
    exportProtectedAccountsReport: "Export protected accounts report",
    createProtectedAccountTooltip: "Create a protected account",
    searchProtectedAccounts: "Search protected accounts",
    editProtectedAccountTooltip: "Edit protected account",
    deleteProtectedAccountTooltip: "Delete protected account",
    totalUsersTooltip: "Total matching users",
    searchScopeTooltip: "Choose which field to search by",
    toggleDensity: "Toggle density",
    stockManagementSubtitle: "View, track, and manage your meter inventory stock.",
    totalItemsTooltip: "Total number of records matching the current filters.",
    exportDateRangeTooltip: "Select the date range for the export report",
    protectedAccountsEmptyHint: "No accounts are protected yet. Create one to protect it from automatic write-offs and closures.",
    dateRange: "Date Range",
    dateRangeTooltip: "Filter by activation date range",
    searchTooltip: "Search by the selected field. Press Enter to search.",
    clear: "Clear",
    clearFilters: "Clear filters",
    selected: "selected",
    noRecordsMatchSearch: "No records match your search",
    tryAdjustingFilters: "Try adjusting your filters or search terms to find what you're looking for.",
    noDataFound: "No data found",
    getStartedUploadingSheet: "Get started by uploading your inventory sheet.",
    inventoryLoadError: "Couldn't load inventory. Please try again.",
    uploadinventorysheetlabel: "Upload Inventory Sheet (XLSX/XLS)",
    onlyexcelallowed: "Only .xlsx and .xls files are allowed.",
    exportCsvTooltip: "Export the current page as a CSV file.",
    minVisibleColumnsTooltip: "At least 2 columns must stay visible",
    submitting: "Submitting..",
    accDetail: " Account Details",
    accnumber: "Account Number",
    searchByAccountNumber: "Search by Account number",
    activityFilterTooltip: "Filter by activity or workflow",
    workflowInputTooltip: "Filter by additional criteria",
    area: "Area",
    areacode: "Area Code",
    latitude: "Latitude",
    longitude: "Longitude",
    importdb: "Import Master DB",
    exportData: " Export Report",
    downloading: "Downloading...",
    viewGuideline: "View Guideline",
    createWorkflow: "Create new Workflow",
    guidline: "Guidlines",
    guidelinesSubtitle: "Upload and manage PDF or video guidelines for each activity.",
    guidelinesLabel: "Guidelines",
    selectOrgForGuidelines: "Select an organization to view guidelines.",
    dropzoneHint: "PDF or video files only",
    noworkflow: "No workflows available",

    Scheduleemail: "  Schedule email report",
    export: "Export Report",
    pdf: "Export PDF",
    todo: "To do",
    loading: "Loading more worklog...",
    nomore: "No more worklog to load",
    name: "Protected Account",
    createacc: "Create new account",

    editacc: "Edit Protected Account",
    createproacc: "Create Protected Account",
    permanent: "Permanent Protection",
    protectionValid: "Protection Valid to",
    createdBy: "createdBy",
    accProtection: "Account Protection for All Activity",
    accno: "Account No",
    remark: "Remarks",
    enterremark: "Enter your remarks here",
    updatemeterDEtail: "Update Meter Details",
    downloadsheet: "Download Sheet",
    uploadinventory: "Upload Inventory Sheet",
    reportType: "Report Type",

    form: "Request Report",
    uploadSheet: "Upload Sheet",
    createStore: "Create Store",
    storeManagement: "Store Management",
    storeManagementTooltip: "Manage stores and inventory locations",
    selectStoreLocation: "Select a point on the map or enter its coordinates below.",
    selectStoreAddress: "Select a point on the map or search for an address below.",
    storeLocationMethod: "Location method",
    storeAddress: "Address",
    storeGovernorate: "Governorate",
    storeWilayat: "Wilayat",
    storeCity: "City / Locality",
    storeArea: "Area / Neighborhood",
    storeStreet: "Street name",
    storeBuilding: "Building name / number",
    storeUnit: "Unit / Floor (optional)",
    storePostalCode: "Postal code (optional)",
    storeCountry: "Country",
    storeCoordinates: "Coordinates",
    storeAddressPlaceholder: "Enter an address in Oman",
    storeAddressSearchPlaceholder: "Search for a place",
    omanCountry: "Oman",
    searchStoreAddress: "Search address",
    searchingStoreAddress: "Searching...",
    storeAddressResults: "Oman address results",
    storeAddressSearchFailed: "Could not search addresses. Please try again.",
    noOmanAddressesFound: "No matching addresses found.",
    storeLatitude: "Latitude",
    storeLongitude: "Longitude",
    storeMapView: "Map view",
    storeDefaultView: "Default",
    storeSatelliteView: "Satellite",
    storeZoomIn: "Zoom in",
    storeZoomOut: "Zoom out",
    createStoreDescription: "Create and organize locations for your inventory stock.",
    existingStores: "Existing Stores",
    existingStoresDescription: "Search, filter, and update your store details.",
    searchStores: "Search stores or locations...",
    filterStoresByStatus: "Filter stores by status",
    allStatuses: "All statuses",
    storeName: "Store Name",
    storeLocation: "Location",
    storeStatus: "Status",
    storeAction: "Action",
    storeActive: "Active",
    storeInactive: "Inactive",
    updateStore: "Update",
    updateStoreTitle: "Update Store",
    viewStore: "View",
    storeDetails: "Store Details",
    storeCreatedSuccess: "Store created successfully.",
    storeUpdatedSuccess: "Store updated successfully.",
    storeDeletedSuccess: "Store deleted successfully.",
    deleteStore: "Delete",
    failedToLoadStores: "Failed to load stores.",
    noStoresYet: "No stores available yet.",
    noMatchingStores: "No stores match your filters.",
    storesCount: "stores",
    storeNameRequired: "Store name is required.",
    storeNameMaxLength: "Store name must not exceed 255 characters.",
    storeNameNote: "Note: Maximum 255 characters allowed.",
    storeAddressRequired: "Please enter an address or search for a location.",
    storeAddressNotFound: "Could not find coordinates for this address. Please refine address or select on map.",
    storeCoordinatesRequired: "Valid coordinates (latitude and longitude) are required.",
    autoDetectedCoordinates: "Coordinates automatically detected",
    detectingCoordinates: "Detecting coordinates...",
    fetchingAddressFromMap: "Fetching address from map...",
    addressFilledFromMap: "Address filled from map",
    startDate: "Start Date",
    endDate: " End Date",
    request: "Request",

    orglist: " Orgnizations List",
    createOrg: " Create Orgnization",
    noOrg: " No organization data available.",
    rows: "Rows per page",
    showing: "Showing",
    of: "of",
    allFields: "All Fields",
    group: "Group",
    assignedGroups: "Assigned Groups",
    agentGroup: "Agent Group",
    lastLogin: "Last Login",
    loginCount: "Logins",
    users: "users",
    filters: "Filters",
    columns: "Columns",
    orgname: "Organization Name",
    img: "  Upload Logo",

    creating: "Creating...",
    updateOrg: "Update Organization",

    Updating: "Updating...",
    nolog: "No Logo",
    number: "No.",
    geoCodes: "Selected Geo Codes",
    geoCodeLabel: "Geo Code",
    typeCodes: "Selected Type Codes",
    amountRange: "Selected Amount Range",
    assignAll: "Assign All",
    default: "Default",
    //dashbord
    userdashboard: "User Dashboard",
    activitydashboard: "Activity Dashboard",
    admin: "Admin",
    supervisor: "Supervisor",
    office_user: "Office Users",
    field_agent: "Field Agents",
    dashboardName: "Dashboard Name",
    dashboardManagement: "Dashboard Management",
    addnewDashboard: "Add New Dashboard",
    chartMessage: " Select the Dashboard to view charts",
    noChartsTitle: "No charts yet",
    noChartsSubtitle: "Add your first chart to start visualizing this dashboard's data.",
    addChartCardSubtitle: "Add another chart to this dashboard",
    deletDashbord: "Delete Dashboard",
    //notifucation
    notification: "Notification",
    allnotification: "All Notification",
    profile: "Profile",
    select: " Select Activity",
    selecteOrgName: "Select Organization",
    selectsubactivty: "Select Subactivity",

    emailreport: "Schedule Email Report",
    selectactivity: "Select the activity:",
    recipients: "Recipients",
    bcc: "Bcc",
    cc: "Cc",
    sendreport: "Send scheduled report",
    senddashboard: "Send Dashboard:",
    shedulesend: "Schedule send:",
    daily: "Daily",
    weekly: "Weekly",
    monthly: "Monthly",

    send: "Send",
    sendScheduleReportTooltip: "Send this scheduled email report",
    updateScheduleReportTooltip: "Update this scheduled email report",
    reportbtn: "Request Report",

    stockmanag: "Stock Management",
    fromdate: "From Date",
    todate: "To Date",
    metercode: "Meter Bar Code",
    location: "To Location",
    filter: "Apply Filters",
    filtersLabel: "Filters",
    columnFiltersLabel: "Column Filters",
    maxFiltersReachedTitle: "Filter limit reached",
    maxFiltersReachedMsg:
      "You can apply up to {limit} filters at a time. Clear one of the applied filters before adding another.",
    filterByColumn: "Filter by",
    addbtn: "Add",
    updatetaskdetail: "Update Task Details",
    discard: "Discard",
    Confirm: "Confirm",
    visitTime: "Visit Time",
    visitDate: "Visit Date",
    nopdfavb: "PDF is not available.",
    noPdfEntriesHelp: "Try adjusting the date range, activity, or account number filters.",
    pdfReportsSubtitle: "Search, filter, and download visit PDF reports for a date range.",

    // login
    loginEnterEmailPassword: "Sign in to manage your field operations",
    loginManageTeamOperations: "Effortlessly manage your team and operations",
    loginDashboardAccess:
      "Log in to access your dashboard and manage everything in one place.",
    Utilities: "Utilities &",
    TasksManagementSolutions: "Tasks Management Solutions",
    UsernameEmailAddress: "Username / Email Address",
    loginEmailPlaceholder: "Enter your username or email",
    loginPasswordPlaceholder: "Enter your password",
    loginNoAccountText: "Don't have an account?",
    loginContactAdminText: "Contact your administrator",
    loginPoweredByText: "Powered by Outbox",
    loginMadeWithLoveText: "Engineered in the Sultanate of OMAN",
    loginOtpTitle: "Verify your identity",
    loginOtpDescription:
      "We sent a 6-digit code via SMS to {phone}. Enter it below to continue.",
    loginOtpDidntGetCode: "Didn't get the code?",
    loginOtpVerify: "Verify and continue",
    loginOtpVerifying: "Verifying...",
    loginOtpResend: "Resend code",
    loginOtpResendIn: "Resend in",
    loginOtpResendSuccess: "A new verification code was sent.",
    loginOtpIncomplete: "Please enter the complete verification code.",
    loginOtpBack: "Back to login",
    loginOtpSecureTitle: "Secure access to Blufield",
    loginOtpSecureDescription:
      "Your verification code helps keep your field operations protected.",
    loginOtpDigitLabel: "Verification digit",
    loginOtpRegisteredNumber: "your registered number",
    loginHeroSlide1Title: "Expert Technicians",
    loginHeroSlide1Description:
      "Empower your field technicians with mobile-first tools for inspections, reporting, and maintenance.",
    loginHeroSlide1Stat1Label: "Technicians",
    loginHeroSlide1Stat2Label: "Satisfaction",
    loginHeroSlide2Title: "Safety & Compliance",
    loginHeroSlide2Description:
      "Ensure safety protocols and compliance standards with integrated documentation and reporting systems.",
    loginHeroSlide2Stat1Label: "Compliant",
    loginHeroSlide2Stat2Label: "Incidents",
    loginHeroSlide3Title: "Power Grid Infrastructure",
    loginHeroSlide3Description:
      "Monitor and maintain critical infrastructure with advanced scheduling and resource allocation tools.",
    loginHeroSlide3Stat1Label: "Efficiency Rate",
    loginHeroSlide3Stat2Label: "Teams",
    loginHeroSlide4Title: "Field Operations Management",
    loginHeroSlide4Description:
      "Streamline your electrical maintenance operations with real-time tracking and comprehensive field management.",
    loginHeroSlide4Stat1Label: "Active Jobs",
    loginHeroSlide4Stat2Label: "Support",
    RememberMe: "Remember Me",
    ForgotPassword: "Forgot Password?",
    assetBarCode: "Asset Response Code (Barcode)",
    assetBarCodeMain: "Asset Response Code",
    assetBarCodeParen: "Barcode",
    dragAndDropDocuments: "Drag and drop Documents",
    viewDocuments: "View Documents",
    uploadedDocument: "Uploaded Document",
    maxFileSize5MB: "Max file size: 5MB",
    browse: "Browse",
    description: "Description",
    kilometer: "Kilometer",
    noAccountDetialsAvailable: "No account details available",
    enterAccSubmitViewDetails:
      "Enter an account number and submit to view details",
    uploading: "Uploading",
    upload: "Upload",
    addOrganization: "Add Organization",
    addDepartment: "Add Department",
    uploadOrganizationLogo: "Upload Organization Logo",
    successMessage:
      "Please wait! The file is being uploaded. It may take some time, and once successfully uploaded, you will receive a success message.",
    fullName: "Full Name",
    fullNameInfo: "Enter the user's full name (as it should appear).",
    userEmailInfo: "Use a valid email address for this user.",
    phoneInfo: "Enter a contact number. Country code is +968.",
    userTypeInfo:
      "Choose the user's access type: Admin, Office user, or Field agent.",
    orgInfo: "Select the organization this user belongs to.",
    rolesInfo: "Select roles to grant the user permissions.",
    departmentInfo: "Select departments the user should have access to.",
    projectInfo: "Select projects the user should have access to.",
    clockInInfo:
      "Enable clock-in/out and choose the project (Field agent only).",
    activityInfo: "Select workflows/activities the field agent can access.",
    employeeIdInfo: "Employee ID is required for field agents.",
    subContractInfo: "Enter sub-contract details for field agents.",
    passwordInfo:
      "New users require a password. Leave blank when editing to keep the current password.",
    signatureInfo: "Upload a clear signature image for field-agent documents.",
    department: "Department",
    project: "Project",
    profileImage: "Profile Image",
    vehicleId: "Vehicle ID",
    vehicleKM: "Vehicle (KM)",
    vehicleAssinged: "Vehicle Assigned",
    editPrivileges: "Edit Privileges",
    source: "Source",
    thecustomcodewarningmessage:
      "The custom marker color not added, select from below !!",
    selectWorkflowFirst: "Select workflow first",
    makerColor: "Marker colors saved successfully!",
    failedtoSaveMakerColor: "Failed to save marker color!",
    permanentProtection: "Permanent protection stays active until you remove it manually, so no end date is needed.",
    noRecordAvailable: "No record Available",
    reportGenerating: "Report is Generating...",
    reportFailed: "Failed",
    reportGenerationFailed: "Report generation failed",
    reportFailedTooltip: "Click to view error details",
    reportNoRecords: "No records found",
    reportNoRecordsTooltip: "No records found for the selected filters",
    mediumPriority: "Medium Priority",
    highPriority: "High Priority",
    lowPriority: "Low Priority",

    accountProtection: "Account Protection",
    clockIn: "clock in",
    clockOut: "clock out",
    isPageWise: "Page Wise",
    isReviewEnabled: "Review Enabled",
    isShowDistance: "Show Coordinate Distance",
    isShowDistanceTooltip:
      "When enabled, the report and PDF export display the distance between the uploaded task coordinates and the coordinates captured at field submission.",
    safetyComplianceRequired: "Needs Safety Checklist",
    safetyComplianceRequiredTooltip:
      "When enabled, a safety-compliance sub-workflow is built under this workflow. Barcode, OCR, GPS and Capture Signal Quality fields are not available in it.",
    safetyChecklistName: "Safety Checklist Name",
    enterSafetyChecklistName: "Enter a name for the safety checklist",
    safetyChecklistNeedsField:
      "Add at least one field to the safety checklist",
    mainWorkflowTab: "Main workflow",
    safetyChecklistTab: "Safety checklist",
    safetyPaletteRestricted:
      "Barcode, OCR, GPS and Capture Signal Quality aren't available in a safety checklist.",
    fieldNotAllowedInSafetyChecklist:
      "This field can't be used in a safety checklist.",
    createSafetyChecklist: "Create Safety Checklist",
    createSafetyChecklistTooltip:
      "Create the safety checklist under this workflow",
    updateSafetyChecklist: "Update Safety Checklist",
    updateSafetyChecklistTooltip: "Save changes to the safety checklist only",
    deleteSafetyChecklist: "Delete Safety Checklist",
    deleteSafetyChecklistTooltip:
      "Disable safety compliance and save the workflow before deleting",
    confirmDeleteSafetyChecklist:
      "This safety checklist and all its fields will be permanently removed. Disable safety compliance and save the workflow first.",
    safetyChecklistCreated: "Safety checklist created",
    createSafetyChecklistFirst:
      "Create the safety checklist first, then enable safety compliance",
    safetyChecklistSavedWithWorkflow: "Saved together with the workflow",
    savedLabel: "Saved",
    notCreatedLabel: "Not created",
    companyStamp: "Company Stamp",
    companyStampDescription:
      "Upload a clean company stamp image for field agent documents.",
    uploadCompanyStamp: "Upload Company Stamp",
    changeCompanyStamp: "Change Company Stamp",
    companyStampSupported: "JPG, PNG, SVG supported",
    companyStampMaxSize: "Max file size: 5MB",
    chooseCompanyStamp: "Choose Stamp",
    editCompanyStamp: "Change",
    removeCompanyStamp: "Remove",
    companyStampInvalidType: "Please upload a JPG, PNG or SVG image.",
    userAssign: "User Assign",
    groupAssign: "Group Assign",
    searchGroup: "Search Groups",
    nogroupfound: "No group found",
    nomembers: "No members",
    selectGroup: "Select Group",
    selectgrouptoassign: "Select group(s) to assign.",
    selectgrouptounassign: "Select group(s) to unassign.",
    memberNoWorkflowAccess: "No access to this workflow",
    groupNotInProject: "Not part of selected project",
    groupNotInProjectTooltip: "This group does not belong to the selected project",
    groupDisabledNoMembers: "This group has no members",
    assignWorkflowAccessNote:
      "Only group members who have access to this workflow will be assigned the task.",
    showAsFilter: "Show as filter",
    allowGallery: "Allow Gallery",
    allowGalleryTooltip:
      "Allow field agents to pick images from the gallery instead of only using the camera.",
    photoDimensions: "Photo Dimensions",
    photoDimensionsTooltip:
      "Optionally require captured photos to match a width, height and/or aspect ratio.",
    widthPx: "Width (px)",
    heightPx: "Height (px)",
    aspectRatio: "Aspect Ratio (optional)",
    aspectRatioSelect: "Select aspect ratio",
    customAspectRatio: "Custom",
    configuredDimensions: "Configured dimensions",
    linkedWorkflow: "Linked Workflow",
    linkedWorkflowTooltip:
      "Pick the workflow to link to each option. The link only affects report / PDF output.",
    linkedWorkflowSelect: "Select workflow",
    linkedWorkflowNoOptions: "Add at least one option to link a workflow.",
    linkedWorkflowNoWorkflows:
      "No other active workflow is available in this project.",
    linkedWorkflowLoading: "Loading workflows...",
    linkedWorkflowAdvancedRules: "Rules set outside this panel (kept on save)",
    linkedWorkflowLinkedTo: "Linked workflow",
    linkedWorkflowLoadFailed: "Couldn't load this linked workflow.",
    linkedWorkflowNoFields: "This workflow has no fields to preview.",
    linkedWorkflowDepthLimit:
      "Nested linked workflows aren't expanded any further in the preview.",
    English: "English",
    Urdu: "Urdu",
    Arabic: "Arabic",
    History: "History",
    Heading: "Heading",
    Name: "Name",
    Email: "Email",
    Phone: "Phone",
    Address: "Address",
    DatePicker: "Date Picker",
    TakePhoto: "Take Photo",
    MultipleImages: "Multiple Images",
    Signature: "Signature",
    RadioButton: "Radio Button",
    Checkbox: "Checkbox",
    Dropdown: "Dropdown",
    Number: "Number",
    Time: "Time",
    LongText: "Long Text",
    Barcode: "Barcode",
    wfElTooltipHeading: "Use this to add a heading.",
    wfElTooltipName: "Enter the name for the field.",
    wfElTooltipEmail: "Enter a valid email address.",
    wfElTooltipPhone: "Enter a phone number.",
    wfElTooltipAddress: "Enter the address.",
    wfElTooltipDate: "Select a date from the calendar.",
    wfElTooltipPhoto: "Upload a photo.",
    wfElTooltipMultiImage: "Upload multiple images.",
    wfElTooltipSignature: "Add a signature.",
    wfElTooltipRadio: "Choose one option from multiple choices.",
    wfElTooltipCheckbox: "Select multiple options if applicable.",
    wfElTooltipDropdown: "Select an option from the dropdown list.",
    wfElTooltipNumber: "Enter a numerical value.",
    wfElTooltipTime: "Pick a specific time.",
    wfElTooltipLongText: "Enter detailed text or descriptions.",
    wfElTooltipBarcode: "Scan a barcode for input.",
    wfElTooltipOcr: "Optical Character Recognition.",
    wfElTooltipGps: "Global Positioning System.",
    wfElTooltipSignalQuality: "Automatically captures the device's network signal quality.",
    workflowModalPreviewOptionsEmpty:
      "Add choices in the form builder to see them here.",
    NotificationSound: "Notification Sound",
    TestSound: "Test Sound",
    Configurations: "Configurations",
    TermsAndConditions: "Terms and Conditions",
    DragDropTermsConditionFile: "Drag and drop Terms and Condition file",
    PrivacyAcceptance: "Privacy Acceptance",
    DragDropPrivacyAcceptanceFile: "Drag and drop Privacy Acceptance file",
    TermsandConditionPdf: "TermsandCondition.pdf",
    view: "view",
    NoReportDataavailble: "No Report Data availble",
    getStartedRequestingReport: "Get started by requesting your first report.",
    noRecordsMatchSearch: "No records match your search",
    tryAdjustingFilters: "Try adjusting your filters or search terms to find what you're looking for.",
    clearFilters: "Clear filters",
    UnexpectedResponseFormat: "Unexpected response format. Please try again.",
    chooseFile: "Choose File",
    noFile: "No file chosen",
    UsernameRequired: "Username is required",
    PasswordRequired: "Password is required",
    PasswordMustBeAtLeast8Characters: "Password must be at least 8 characters",
    IncludeDeletedRecords: "Include Deleted Records",
    includedeletedrecordstooltip: "Include deleted workflows and tasks in the report",
    selectdurationtooltip: "Select the date range for the report",
    selectduration: "Select Duration",
    /* Export Report summary line. Whole-sentence templates, not fragments --
       see formatTemplate in ExportData.js. reportsummarysuffix is the trailing
       verb slot verb-final languages need; leave it empty where unused. */
    reportsummaryprefix: "I need a report for",
    reportsummarycovering: "covering",
    reportsummarysuffix: "",
    selectactivities: "Select activities",
    activitiesjoinand: "{first} and {second}",
    activitieslistheader: "Activities ({count})",
    reportrangedates: "from {from} to {to}",
    reportrangecycles: "for {cycles}",
    requestreporttooltip: "Generate a report for the selected activities and duration",
    downloadreporttooltip: "Download the generated report file",

    pleaseFillAllFieldsBeforeSaving: "Please fill all fields before saving",
    ruleCreatedSuccessfully: "Rule Created Successfully",
    pleaseSelectFromDateToDate: "Please select both From Date and To Date.",
    exportBtn: "Export",
    // {count} is substituted at the call site (TaskListToolbar) -- the button
    // shows how many filters the export payload carries.
    exportOneFilter: "1 filter",
    exportManyFilters: "{count} filters",
    deleteAllFilteredMessage: "{filters} applied. Only the tasks matching the applied filters will be deleted.",
    deleteAllUnfilteredMessage: "No filters applied. All tasks in this activity will be deleted.",
    deleteAllFilteredTooltip: "Delete only the tasks that match the applied filters",
    deleteAllUnfilteredTooltip: "Delete all tasks in this activity",
    exportNoFiltersWarning:
      "No filters are applied, so this exports every task in the selection. On a large workflow the file can take a long time to build.",
    selectProjectForFullExport: "Select a project before exporting all activities.",
    importBtn: "Import",
    addTaskBtn: "Add Task",
    attachProof: "Attach Proof (PDF/Image)",
    attachProofNote:
      "Note: The uploaded document is stored against this account and will be available to view later.",
    currentAttachment: "Current document attached",
    viewAttachment: "View attached document",
    removeAttachment: "Remove attachment",
    maxAttachmentsExceeded: "You can upload a maximum of {count} attachments",
    attachmentTooLarge: "File exceeds the maximum allowed size of {size} MB",
    filesSelected: "files selected",
    attachmentUnavailable: "Attachment is not available",
    viewLabel: "View",
    attachmentSourceRc: "RC",
    attachmentSourceTask: "Task",
    attachmentSourceInstalment: "Instalment Plan",
    activityAnalytics: "Activity Analytics",
    analyticsLabel: "Analytics",
    analyticsStatusLabel: "Status",
    chartSelectFiltersHint: "Select activity, status and dates to view chart",
    chartLoading: "Loading...",
    taskActions: "Task Details",
    selectedCountLabel: "selected",
    selectedLocation: "Selected Location",
    drawnArea: "Drawn Area",
    clearSelection: "Clear",
    clickMarkerForLocationDetails:
      "Click a marker on the map to see location details",
    taskDetailsSection: "Task Details",
    loadingTaskDetails: "Loading task details...",
    clickMarkerLoadTaskDetails: "Click a marker to load task details.",
    taskStatusSection: "Task Status",
    allStatusLabel: "All",
    availableAgents: "Available Agents",
    searchFieldAgentsPlaceholder: "Search field agents...",
    noAgentsMatchSearch: "No agents match your search",
    noAgentsAvailable: "No agents available",
    loadingAgentsLabel: "Loading agents...",
    statusActiveLabel: "Active",
    statusInProgressLabel: "In Progress",
    statusCompletedLabel: "Completed",
    statusAssignedLabel: "Assigned",
    statusOnHoldLabel: "On Hold",
    unassignedLabel: "Unassigned",
    taskIdLabel: "Task ID",
    assigneeLabel: "Assignee",
    completedCountSuffix: "Completed",
    tasksInDrawnAreaTitle: "Tasks in drawn area",
    tasksListTitle: "Tasks",
    centerApproxLabel: "CENTER (APPROX.)",
    latLongUpperLabel: "LAT/LONG",
    agentUpperLabel: "AGENT",
    activeTasksUpperLabel: "ACTIVE TASKS",
    taskWord: "Task",
    tasksWord: "Tasks",
    assignTaskCountVerb: "Assign",
    taskSingular: "task",
    tasksPlural: "tasks",
    onlineLabel: "Online",
    offlineLabel: "Offline",
    showOnlineAgentsTitle: "Show online agents",
    showOfflineAgentsTitle: "Show offline agents",
    onlyActiveTasksAssignableTitle: "Only Active tasks can be assigned",
    consNameEnglish: "Consumer name (English)",
    consNameArabic: "Consumer name (Arabic)",
    meterNoLabel: "Meter No.",
    consumerTypeLabel: "Consumer Type",
    phoneLabel: "Phone",
    lastReadTypeLabel: "Last reading type",
    lastReadingLabel: "Last reading",
    lastReadingDateLabel: "Last reading date",
    averageLabel: "Average",
    instalmentPlanNotExisting:
      "Instalment plan not existing for the given account number",
    remarksError: "Remarks field is required",
    previewPlanError: "",
    selectActivityAndMap: "Select Activity and Map",
    selectActivityLabel: "Select Activity",
    selectMapLabel: "Select Map",
    indoorMap: "Indoor Map",
    drawOnMap: "Draw on Map",
    calendarLabel: "Calendar",
    activityPanel: "Activity Panel",
    fullScreenLabel: "Full Screen",
    detailPanel: "Detail Panel",
    columnsModalMinThreeRequired: "At least 3 columns are required.",
    columnsLabel: "Columns",
    toggleColumns: "Toggle Columns",
    columnsTooltip: "Choose which columns appear in the table.",
    columnsModalTitle: "Customize Columns",
    columnsModalSubtitle: "Choose visible columns and set display order",
    columnsModalShowHide: "Show / Hide Columns",
    columnsModalSearchPlaceholder: "Search columns...",
    columnsModalSelectAll: "Select All",
    columnsModalClearAll: "Clear All",
    columnsModalOrderTitle: "Column Order",
    columnsModalOrderHint: "Top appears first in table",
    columnsModalAtLeastOne: "Select at least one column.",
    columnsModalCountOf: "of",
    columnsModalCountVisible: "columns visible",
    columnsModalApply: "Apply Changes",
    columnsModalCloseAria: "Close columns modal",
    columnsModalMoveUp: "Move up",
    columnsModalMoveDown: "Move down",
    columnsManageTitle: "Manage columns",
    columnsResetDefault: "Reset to default",
    columnsModalResetDefault: "Reset to default",
    super_admin: "Super Admin",
    roles: "Roles",
    appliedFiltersAria: "applied filters",
    reportEmailsOptional: "Report emails (optional)",
    reportEmailsDescription:
      "Add one or more email addresses to receive reports.",
    addAnotherEmail: "Add another email",
    removeEmail: "Remove email",

    meterBarCode: "Meter Bar Code",
    components: "components",
    meterType: "meter Type",
    manufacturingYear: "manufacturing Year",
    meterMake: "Meter Make",
    activationDate: "activation Date",
    batchNo: "batch No",
    installationStatus: "installation Status",
    createBy: "Created By",
    createdAt: "Created At",
    simNo: "sim No",
    ipAddress: "ip Address",
    iccid: "iccid",
    apn: "apn",
    op: "op",
    balance: "balance",
    simDetailUpdatedAt: "sim Detail Updated At",
    transferredFrom: "transferred From",
    transferredTo: "transferred To",
    DragYourElementsToSecondPageFromLeftPanel:
      "Drag your elements to second page from left panel",
    Deactive: "Deactive",
    Yes: "Yes",

    WhatDoYouWantExistingAccounts:
      "What do you want to do with Existing Accounts?",
    updateAlreadyExistingAccountEntries:
      "Update already Existing Account Entries ?",
    createNewAccountEntries: "Create new Account Entries ?",
    customerDetails: "Installment Creation Detail",
    created_By: "Created By",
    accountNo: "Account No.",
    mapAccountSearchPlaceholder: "Search account number",
    mapAccountNotFound: "Account not found",
    mapAccountLocationUnavailable: "Location not available for this account",
    civilId: "Customer Id",
    phoneNo: "Phone No.",
    comment: "comment",
    attachments: "Attachments",
    employee: "Employee", // employed id added by harshit vachhani
    employeeIdLabel: "Employee Id",
    subContract: "SubContract", // subContract added by harshit vachhani
    subContractIdLabel: "SubContract Id",
    // App Update Config
    appUpdateConfig: "App Update Config",
    appUpdateConfigTooltip: "App Update Config, Manage App Update Config",
    appUpdateConfigTitle: "App Update Config",
    appUpdateConfigDescription: "Manage App Update Config",
    appUpdatePlatform: "Platform",
    iosConfigComingSoonTooltip: "iOS configuration is not available yet",
    appUpdateLatestVersion: "Latest Version",
    appUpdateLatestBuildNumber: "Latest Build Number",
    appUpdateMinBuildNumber: "Minimum Supported Build Number",
    appUpdateTitleLabel: "Title",
    appUpdateMessageLabel: "Message",
    appUpdateForceUpdate: "Force Update",
    appUpdateUrlLabel: "App URL",
    appUpdateReleaseNotes: "Release Notes",
    appUpdateReleaseNotesPlaceholder: "One note per line",
    appUpdateFieldRequired: "This field is required",
    appUpdateReleaseNotesRequired: "At least one release note is required",
    appUpdateNumberInvalid: "Must be a valid number",
    appUpdateNumberNegative: "Must be a positive number",
    appUpdateUpdatedAt: "Updated At",
    editAppUpdateConfigTooltip: "Edit configuration",
    updateAppUpdateConfigTooltip: "Update configuration",
    cancelAppUpdateConfigTooltip: "Discard changes",
    savingAppUpdateConfigTooltip: "Saving...",
    switchPlatformDisabledTooltip:
      "Save or cancel your changes before switching platform",
    appUpdateConfigUpdateSuccess: "Configuration updated successfully",
    appUpdateConfigLoadError: "Failed to load configuration",
    appUpdateConfigUpdateError: "Failed to update configuration",
    taskRoadmap: "Task Roadmap",
    taskRoadmapTooltip: "Click to view the task roadmap",
    roadmapTimeline: "Timeline",
    roadmapDetails: "Task Details",
    roadmapLoading: "Loading task roadmap...",
    roadmapLoadFailed: "Failed to load the task roadmap",
    roadmapNoData: "No roadmap available for this task",
    roadmapNoTimeline: "No timeline events recorded for this task",
    roadmapWorkflow: "Workflow",
    roadmapAccountNo: "Account No.",
    roadmapArea: "Area",
    roadmapCompletedBy: "Completed By",
    roadmapCreatedAt: "Created At",
    roadmapFinishedAt: "Finished At",
    roadmapTaskNote: "Task Note",
    roadmapRemarks: "Remarks",
    roadmapReading: "Reading",
    roadmapAssignedTo: "Assigned to",
    roadmapBy: "By",
    roadmapLocation: "Location",
    roadmapSource: "Source",
    roadmapDeleted: "Deleted",
    roadmapPhotos: "Photos",
    roadmapPhotoField: "Field",
    roadmapPhotoLink: "Photo Link",
    roadmapCompletionInfo: "Task Completion Info",
    roadmapFieldValue: "Value",
    roadmapQueNo: "Que No",
    // Column Access Management
    columnAccessManagementTitle: "Column Access Management",
    columnAccessManagementSubtitle: "Control which columns each user type can see, per workflow",
    accessManagementBtn: "Access Control",
    selectWorkflowLabel: "Select workflow",
    selectUserTypeLabel: "Select user type",
    selectWorkflowPlaceholder: "Select workflow",
    selectUserTypePlaceholder: "Select user type",
    currentlyAccessible: "Currently Accessible",
    currentlyAccessibleCountLabel: "{label} - {userType} ({count})",
    manageAccessLabel: "Manage Access",
    manageAccessCountLabel: "{label} - {selected} {of} {total} {selectedLabel}",
    selected: "selected",
    clear: "Clear",
    noResults: "No results found",
    noWorkflowSelectedTitle: "No workflow selected",
    selectWorkflowAndUserTypePrompt: "Pick a workflow, then a user type, to view and manage column access.",
    detailsGroupLabel: "Dynamic Columns",
    standardGroupLabel: "Static Columns",
    columnAccessExportNote:
      "These grants apply to dynamic columns only. The Excel export follows dynamic-column access, but static system columns are always included in the exported file and cannot be granted or revoked here.",
    newBadge: "New",
    removingBadge: "Removing",
    deleteAccessBtn: "Delete Access",
    saveChangesBtn: "Save Changes",
    confirmDeleteColumnAccess: "Delete the saved column access for",
    columnAccessSaved: "Column access saved",
    columnAccessDeleted: "Column access removed",
    noColumnAccessTitle: "No column access",
    noColumnAccessMessage: "You do not have access to any columns for this workflow. Please contact your super admin.",
    assignedTo: "Assigned To",
    compareValidationTitle: "Compare Validation",
    compareValidationSubtitle:
      "Check this field against another field on the workflow instead of a fixed value.",
    compareValidationButton: "Comparison Validation",
    compareValidationCount: "comparison rules",
    compareValidationFirstField: "Field 1 (this field)",
    compareValidationSecondField: "Field 2",
    compareValidationSelectSecondField: "Select a field to compare with",
    compareValidationCondition: "Condition",
    compareValidationEqual: "Must Be Equal",
    compareValidationNotEqual: "Must Not Be Equal",
    compareValidationErrorMessage: "Error Message",
    compareValidationErrorMessagePlaceholder:
      "Shown when the comparison fails",
    compareValidationAdd: "Add",
    compareValidationUpdate: "Update",
    compareValidationCancel: "Cancel",
    compareValidationAdded: "Added Comparisons",
    compareValidationEmpty: "No comparison rules yet.",
    compareValidationNoFields:
      "Add at least one more field to the canvas to compare against.",
    compareValidationEligibleTypes:
      "Comparison works with Text, Long Text, Number, Email, Date and Time fields.",
    compareValidationSelectFieldFirst: "Select the field to compare with.",
    compareValidationDuplicate:
      "This field is already compared with the selected field.",
    compareValidationSaved: "Comparison validation saved.",
    compareValidationRemoved: "Comparison validation removed.",
    compareValidationDeletedField: "Deleted field",
    compareValidationDefaultEqualError: "This field must match {field}.",
    compareValidationDefaultNotEqualError: "This field must not match {field}.",
    validationTabLabel: "Validation",
    comparisonTabLabel: "Comparison",
    addValidationButton: "Add Validation",
    validationEmpty: "No validation rules yet.",
    validationCount: "validation rules",
    addValidationTooltipDesc:
      "Check this field's own value against a validation code, and set the error message shown when it doesn't match.",
    viewValidationTooltipDesc:
      "Review, edit or delete the validation rules already added to this field.",
    compareValidationTooltipDesc:
      "Compare this field's value with another field on the workflow and require the two to be equal or not equal.",
  },
  ar: {
    buAccountNumbers: "أرقام الحسابات",
    buAccountNo: "رقم الحساب",
    buTypeAccountPlaceholder: "اكتب رقم الحساب واضغط Enter",
    buTypeAndEnterHint: "اكتب واضغط Enter، أو الصق قائمة بالحسابات.",
    buDetected: "تم اكتشاف {n}",
    buAssignmentPriority: "التعيين والأولوية",
    buAssignment: "التعيين",
    buCreateTasks: "إنشاء المهام",
    buUpdatePriority: "تحديث الأولوية",
    buUpdatePriorityAndAssign: "تحديث الأولوية والتعيين",
    buUpdatingPriority: "جارٍ تحديث الأولوية...",
    buUpdatePriorityTooltip: "تحديث أولوية الحسابات المدخلة",
    buUpdatePriorityAssignTooltip: "تحديث الأولوية والتعيين للموظفين الميدانيين المحددين",
    buCloseDialog: "إغلاق مربع الحوار",
    buTotalAccountsHint: "إجمالي أرقام الحسابات المضافة أعلاه.",
    buCreatingTask: "جارٍ إنشاء المهمة...",
    buDuplicatesIgnored: "تم تجاهل {n} من أرقام الحسابات المكررة.",
    buPriorityUpdated: "تم تحديث الأولوية لـ {n} حساب.",
    buPriorityUpdateFailed: "فشل تحديث الأولوية.",
    buLookupFailed: "فشل البحث.",
    buUnexpectedError: "حدث خطأ غير متوقع.",
    buSelectPriority: "يرجى اختيار أولوية.",
    columnContainsHelp: "مطابقة بدون حساسية لحالة الأحرف عبر كل المهام في سير العمل.",
    selectDateRangeHint: "اختر نطاق التاريخ (YYYY-MM-DD إلى YYYY-MM-DD)",
    dragToReorderColumn: "اسحب لإعادة ترتيب العمود",
    dragToResize: "اسحب لتغيير الحجم",
    viewFieldAgents: "عرض الموظفين الميدانيين",
    noAssigneesOrGroupForUnassign: "لم يتم اختيار مسنَد إليهم أو مجموعة لإلغاء الإسناد.",
    taskOnHoldSuccess: "المهمة معلّقة",
    selectTaskBeforeProceeding: "يرجى تحديد مهمة قبل المتابعة!",
    noFieldsMatch: "لا توجد حقول مطابقة",
    clearSelectionAria: "مسح التحديد",
    createTaskSubtitle: "أضف مهمة واحدة يدويًا، أو ارفع عدة مهام دفعة واحدة، أو استورد ورقة.",
    singleTaskUpload: "رفع مهمة واحدة",
    bulkTaskUpload: "رفع مهام جماعي",
    selectOnMap: "تحديد على الخريطة",
    categoryName: "اسم الفئة",
    arabicNameOptional: "الاسم بالعربية (اختياري)",
    enterNewCategory: "أدخل فئة جديدة",
    enterArabicNameOptional: "أدخل الاسم بالعربية (اختياري)",
    selectAZone: "اختر منطقة",
    selectPriorityLabel: "اختر الأولوية",
    activitySelection: "اختيار النشاط",
    accessDenied: "ليس لديك صلاحية الوصول إلى هذه المهام.",
    back: "رجوع",
    createNewAccountsHint: "سجّل حسابًا جديدًا إلى جانب هذه المهمة",
    enter: "أدخل",
    fieldAgents: "الموظفون الميدانيون",
    high: "عالية",
    medium: "متوسطة",
    low: "منخفضة",
    history: "السجل",
    listView: "عرض القائمة",
    mapView: "عرض الخريطة",
    loadingTasks: "جارٍ تحميل المهام...",
    moreActions: "المزيد من الإجراءات",
    nofieldagent: "لا يوجد موظفون متاحون",
    noFieldsAvailable: "لا توجد حقول متاحة",
    nonMandatoryFieldsHint: "تفاصيل إضافية، املأ ما ينطبق فقط",
    reassignOnlyExisting: "إعادة تعيين الحالية فقط",
    sessionExpired: "انتهت الجلسة. يرجى تسجيل الدخول مرة أخرى.",
    taskManagement: "إدارة المهام",
    taskManagementSubtitle: "تتبّع مهام الخدمة الميدانية وعيّنها وصدّرها لفريقك.",
    taskSelected: "مهمة محددة",
    tasksSelected: "مهام محددة",
    tasksLabel: "مهام",
    updateExistingAccountsHint: "اربط هذه المهمة بسجلات حسابات موجودة في النظام",
    allActivity: "كل الأنشطة",
    page: "صفحة",
    refreshBtn: "تحديث",
    accHistoryTabTooltip: "عرض سجل الحساب",
    exportReportTabTooltip: "طلب التقارير وتنزيلها",
    dragFieldToCanvas: "اسحب حقلاً إلى لوحة التصميم",
    searchField: "ابحث في الحقول...",
    dragElementsFromLeftPanel: "اسحب العناصر من اللوحة اليسرى",
    otherFieldSettings: "إعدادات الحقل الأخرى",
    requiredField: "الحقل مطلوب",
    validation: "التحقق",
    validationupdated: "تم تحديث التحقق بنجاح",
    workflowEmptyTitle: "أنشئ سير عمل ليظهر هنا",
    workflowEmptyDesc: "أنشئ أول قالب لسير العمل لإعداد نماذج المهام بشكل أسرع وأكثر اتساقاً.",
    workflowEmptyNoProjectTitle: "اختر مشروعاً للبدء",
    workflowEmptyNoProjectDesc: "يرجى اختيار مشروع لعرض سير العمل وإدارته.",
    workflowEmptySearchTitle: "لم يتم العثور على سير عمل",
    wfEnterYourInput: "أدخل المدخلات",
    wfNoRadioOptions: "لا توجد خيارات اختيار متاحة",
    wfAddFieldsForReport: "إضافة حقول للتقرير",
    wfSelectMandatoryField: "تحديد الحقل الإلزامي",
    wfEnterPdfName: "أدخل اسم PDF...",
    wfType_text: "نص",
    wfType_number: "رقم",
    wfType_email: "بريد إلكتروني",
    wfType_date: "تاريخ",
    wfType_time: "وقت",
    wfType_radio: "اختيار واحد",
    wfType_checkbox: "خانة اختيار",
    wfType_select: "قائمة منسدلة",
    wfType_textarea: "نص طويل",
    wfType_file: "ملف",
    wfType_multi_image: "صور متعددة",
    wfType_scan: "مسح",
    wfType_ocr: "التعرف الضوئي على الحروف",
    wfType_gps: "نظام تحديد المواقع",
    wfType_signal_quality: "جودة الإشارة",
    OCR: "التعرف الضوئي على الحروف",
    GPS: "تحديد الموقع (GPS)",
    CaptureSignalQuality: "التقاط جودة الإشارة",
    editDepartment: "تعديل القسم",
    accHistProjects: "المشاريع",
    accHistTasks: "المهام",
    accHistWorkflowHistory: "سجل سير العمل",
    accHistNoProjectDetails: "لا توجد تفاصيل حساب في هذا المشروع.",
    accHistNoteAll: "بصفتك مسؤولاً عاماً، يتم عرض سجل الحساب لجميع الأقسام والمشاريع.",
    accHistNoteScoped: "يتم عرض سجل الحساب فقط للأقسام والمشاريع والأنشطة المعيّنة لك.",
    taskLocationColumn: "الموقع",
    taskLocationTooltip: "عرض موقع المهمة على الخريطة",
    taskLocationTitle: "موقع المهمة المحددة",
    orgDcrcSubscription: "اشتراك DCRC",
    orgAutoRc: "RC تلقائي",
    orgPoleDc: "DC العمود",
    orgInstallmentPlan: "خطة التقسيط",
    orgMinPaymentPercent: "الحد الأدنى للدفع %",
    orgMinOutstandingAmount: "الحد الأدنى للمبلغ المستحق",
    orgSvMaxIterations: "الحد الأقصى لتكرارات SV",
    orgDcrcWorkflowConfig: "إعداد سير عمل DCRC (النشاط مطلوب لكل خطوة)",
    orgDcrcWorkflowConfigPoleDc: "إعداد سير عمل DCRC (النشاط مطلوب لكل خطوة، بما في ذلك POLE_DC)",
    orgLoadingActivities: "جارٍ تحميل الأنشطة…",
    orgActivityWorkflow: "النشاط (سير العمل)",
    orgSelectActivity: "اختر النشاط",
    orgDelayDays: "التأخير (بالأيام)",
    orgEndCycleField: "حقل نهاية الدورة",
    orgEndCycleValues: "قيم نهاية الدورة",
    orgSelectActivityFirst: "اختر نشاطاً أولاً",
    orgLoading: "جارٍ التحميل…",
    orgLoadingOptions: "جارٍ تحميل الخيارات…",
    orgNoFieldsInWorkflow: "لا توجد حقول في سير العمل",
    orgSelectField: "اختر الحقل",
    orgSelectValues: "اختر القيم",
    orgNextStepSuccess: "الخطوة التالية (نجاح)",
    orgNextStepFailure: "الخطوة التالية (فشل)",
    orgNone: "لا شيء",
    orgField: "الحقل",
    orgValues: "القيم",
    orgNoValuesForField: "لا توجد قيم لهذا الحقل",
    orgSelectFieldFirst: "اختر الحقل أولاً",
    orgLoadActivityFirst: "حمّل النشاط أولاً",
    orgShowProject: "إظهار المشروع",
    orgHideProject: "إخفاء المشروع",
    orgShowing: "جارٍ الإظهار…",
    orgLoadingProject: "جارٍ تحميل المشروع…",
    orgShowProjectTitle: "إظهار المشروع؟",
    orgHideProjectTitle: "إخفاء المشروع؟",
    orgShowProjectDesc: "إظهار \"{name}\" مرة أخرى؟ سيظهر في القائمة.",
    orgHideProjectDesc: "إخفاء \"{name}\" من القائمة؟ يمكنك إظهاره مرة أخرى لاحقاً من نفس المكان.",
    orgProjectVisible: "أصبح المشروع مرئياً مرة أخرى",
    orgProjectHidden: "تم إخفاء المشروع",
    orgFailedShowProject: "فشل إظهار المشروع",
    orgFailedUpdateStatus: "فشل تحديث الحالة",
    orgFailedDeleteOrg: "فشل حذف المؤسسة",
    orgDeleteOrgSuccess: "تم حذف المؤسسة بنجاح",
    orgInvalidEmails: "يرجى إدخال عناوين بريد إلكتروني صحيحة.",
    orgSelectActivityAllSteps: "يرجى اختيار النشاط (سير العمل) لجميع خطوات DCRC ({steps}).",
    completionSubmissionNoteTitle: "حدّد قاعدة واحدة على الأقل ليتم إكمال المهمة بنجاح.",
    completionSubmissionRuleRequired: "حقل مطلوب: تظهر الرسالة عند ترك الحقل فارغًا.",
    completionSubmissionRuleMismatch: "عدم تطابق الرقم: تظهر الرسالة عندما لا يتطابق الرقم المُرسل مع الرقم.",
    mapTipMapView: "عرض الخريطة",
    mapTipListView: "عرض القائمة",
    mapTipShowAll: "عرض جميع المهام",
    mapTipShowOnly: "عرض مهام {status} فقط",
    mapTipSatellite: "عرض الأقمار الصناعية",
    mapTipZoomIn: "تكبير",
    mapTipZoomOut: "تصغير",
    mapTipExport: "تصدير تقرير المهام",
    mapTipPrevWeek: "الأسبوع السابق",
    mapTipNextWeek: "الأسبوع التالي",
    mapTipHideDates: "إخفاء التنقل بين التواريخ",
    mapTipCloseCalendar: "إغلاق لوحة التقويم",
    mapSelectFromDate: "اختر تاريخ البدء",
    mapSelectToDate: "اختر تاريخ الانتهاء",
    failedToFetchTaskStatus: "تعذّر جلب حالة المهام. يرجى المحاولة مرة أخرى.",
    failedToFetchUserCount: "تعذّر جلب عدد المستخدمين. يرجى المحاولة مرة أخرى.",
    noDataAvailableForWorkflow: "لا تتوفر بيانات حالة المهام لسير العمل هذا.",
    selectOrganizationPrompt: "يرجى اختيار منظمة.",
    selectWorkflowPrompt: "يرجى اختيار سير عمل.",
    numberOfUsers: "عدد المستخدمين",
    numberOfTasks: "عدد المهام",
    taskPriorityAxis: "أولوية المهمة",
    completedTaskAxis: "المهام المكتملة",
    taskCount: "عدد المهام",
    priorityCount: "عدد الأولويات",
    totalCompletedTasks: "المهام المكتملة",
    totalTasks: "إجمالي المهام",
    totalUsers: "إجمالي المستخدمين",
    userCount: "عدد المستخدمين",
    unknownUser: "مستخدم غير معروف",
    totalEntries: "إجمالي الإدخالات",
    numberOfEntries: "عدد الإدخالات",
    entryCount: "عدد الإدخالات",
    totalWorked: "إجمالي ساعات العمل",
    averageDaily: "المتوسط اليومي",
    tasksCountLabel: "{n} مهام",
    usersCountLabel: "{n} مستخدمين",
    dateCannotBeFuture: "لا يمكن أن يكون {field} في المستقبل.",
    userFormLeaveBlank: "اتركه فارغًا للإبقاء على الحالية",
    userFormCreateGroup: "إنشاء مجموعة",
    userFormNewGroupName: "اسم المجموعة الجديدة",
    userFormCloseAria: "إغلاق نموذج المستخدم",
    userFormSignatureReady: "صورة التوقيع جاهزة",
    userFormChooseSignature: "اختيار التوقيع",
    userFormReplaceSignature: "استبدال التوقيع",
    userFormSignatureFormats: "صيغ JPG وPNG مدعومة",
    userFormUploadSignature: "رفع التوقيع",
    userFormEditUser: "تعديل المستخدم",
    userFormTokenMissing: "رمز المصادقة غير موجود",
    userFormPwSpecial: "رمز خاص واحد",
    userFormPwNumber: "رقم واحد",
    userFormPwLower: "حرف صغير واحد",
    userFormPwUpper: "حرف كبير واحد",
    userFormPwMin: "8 أحرف على الأقل",
    userFormPasswordSpecial: "يجب أن تحتوي كلمة المرور على رمز خاص واحد على الأقل",
    userFormPasswordNumber: "يجب أن تحتوي كلمة المرور على رقم واحد على الأقل",
    userFormPasswordLower: "يجب أن تحتوي كلمة المرور على حرف صغير واحد على الأقل",
    userFormPasswordUpper: "يجب أن تحتوي كلمة المرور على حرف كبير واحد على الأقل",
    userFormPasswordMin: "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل",
    userFormPasswordRequired: "كلمة المرور مطلوبة",
    userFormFieldMustBeNumber: "يجب أن يكون {field} رقمًا",
    userFormFieldRequired: "{field} مطلوب",
    userFormClockInRequired: "تسجيل الحضور مطلوب",
    userFormActivityRequired: "النشاط مطلوب",
    userFormProjectRequired: "المشروع مطلوب",
    userFormDepartmentRequired: "القسم مطلوب",
    userFormOrgRequired: "المنظمة مطلوبة",
    userFormUserTypeRequired: "نوع المستخدم مطلوب",
    userFormPhoneRequired: "رقم الهاتف مطلوب",
    userFormEmailRequired: "البريد الإلكتروني مطلوب",
    userFormNameRequired: "الاسم الكامل مطلوب",
    userFilterNone: "لا شيء",
    userFilterAll: "الكل",
    userFilterNoMatches: "لا توجد نتائج مطابقة",
    userFilterSearch: "بحث…",
    userViewAll: "عرض الكل",
    userColEmployeeId: "رقم الموظف",
    userColWorkflows: "سير العمل",
    userColRoles: "الأدوار",
    userListNoProjectTitle: "لم يتم اختيار مشروع",
    userListNoProjectHint: "اختر قسمًا ومشروعًا في أعلى الصفحة لعرض المستخدمين.",
    userFilterLimitReached: "يمكنك تطبيق 15 عامل تصفية للأعمدة كحد أقصى في المرة الواحدة. أزل واحدًا لإضافة آخر.",
    userContainsHelp: "مطابقة غير حساسة لحالة الأحرف عبر جميع المستخدمين.",
    timeAgoMonths: "منذ {n} شهر",
    timeAgoDays: "منذ {n} يوم",
    timeAgoHours: "منذ {n} ساعة",
    timeAgoMinutes: "منذ {n} دقيقة",
    loginLocation: "الموقع",
    noUsersMatchSearch: "لا يوجد مستخدمون يطابقون بحثك",
    never: "أبدًا",
    justNow: "الآن",
    groupMembers: "أعضاء المجموعة",
    groupListInfo: "اختر المجموعات التي يمكن لهذا المستخدم الوصول إليها ضمن القسم أو الأقسام المحددة.",
    groupInfo: "عيّن الموظف الميداني إلى مجموعة في القسم المحدد. اكتب اسمًا جديدًا وانقر على إنشاء لإضافة مجموعة.",
    groupCreated: "تم إنشاء المجموعة",
    getStartedAddingUser: "ابدأ بإضافة أول مستخدم لك.",
    inventoryAssignmentFileRequired: "اختر ملف Excel (.xlsx أو .xls).",
    inventoryAssignmentInput: "مصدر الإسناد",
    inventoryAssignmentProjectRequired: "اختر مشروعاً واحداً لهذا الإسناد.",
    inventoryClearCustody: "إزالة العهدة",
    inventoryClearCustodyHint: "إزالة جميع إسنادات المخازن والمجموعات لهذه العناصر.",
    inventoryMeterNumbers: "الأرقام التسلسلية",
    inventoryMeterNumbersHint: "أدخل الأرقام التسلسلية (عداد أو مودم أو شريحة أو نطاق أختام) مفصولة بمسافات أو فواصل أو أسطر جديدة.",
    inventoryMeterNumbersRequired: "أدخل أرقاماً تسلسلية صالحة لكل عنصر محدد.",

    inventoryMissingMeterNumbers: "بعض العدادات المحددة لا تحتوي على رقم عداد.",
    inventoryAssignmentSameProject: "اختر عدادات من مشروع واحد.",
    inventoryAssignmentPending: "تم قبول الإسناد وجارٍ معالجته.",
    inventoryAssignmentExcel: "إسناد من Excel",
    inventoryAssignmentExcelHint: "ارفع ملف Excel لإسناد عداداته إلى المخزن أو المجموعة المحددة. يحل الملف محل الصفوف المحددة.",

    accountreportcenter: "مركز الحسابات والتقارير",
    accountreportcentersub: "تتبع سجل الحساب وإدارة تصدير التقارير.",
    PDF: "PDF",
    viewdetails: " عرض التفاصيل",
    addnewvehicale: "أضف مركبة جديدة إلى قائمة الأصول الخاصة بك.",
    cancelandstay: "إلغاء والبقاء على الصفحة",
    confirmandlogout: "تأكيد وتسجيل الخروج",
    welcome: "مرحباً",
    welcomeback: "مرحبًا بعودتك",
    editandudateasset: "تحرير وتحديث تفاصيل الأصل",
    assigntheselected: "تعيين المركبة المحددة إلى موظف ميداني",
    updatetherule: " تحديث القاعدة",
    submitherule: " إرسال القاعدة",
    addassignmentrule: " إضافة قاعدة تعيين",
    savetherule: "حفظ القاعدة",
    addcompletionrule: "  إضافة قاعدة إتمام",
    addcustomrule: " إضافة قاعدة مخصصة",
    assignallactiverules: " تعيين جميع القواعد النشطة",
    addnewspecialassingmentrule: "  إضافة قاعدة تعيين خاصة جديدة",
    updatetherulewitjselectedpara: " تحديث القاعدة بالمعايير المحددة",
    createneweulwwithselected: "  إنشاء قاعدة جديدة بالمعايير المحددة",
    cancelandclose: " إلغاء وإغلاق النافذة",
    addnewdashboardtooltip:
      "إضافة لوحة معلومات جديدة (يمكنك إنشاء لوحة المعلومات بناءً على سير العمل)",
    processthenextstep: " متابعة إلى الخطوة التالية",
    deletethedashboard: " حذف لوحة المعلومات",
    createdashboardtooltip: " إنشاء لوحة المعلومات ",
    canceltheselectedchart: "إنشاء المخطط المحدد",
    applytheselecteddaterange: " تطبيق نطاق التاريخ المحدد",
    downloadfilterdate: "  تنزيل البيانات بعد تطبيق الفلتر",
    proceedwiththeaction: "  المتابعة في تنفيذ الإجراء",
    addnewproject: " إضافة مشروع جديد",
    addnewdepartment: " إضافة قسم جديد",
    addneworgnization: "  إضافة مؤسسة جديدة",
    updateorgnizations: " تحديث بيانات المؤسسة",
    savethechangesmadetomarkers: " حفظ التغييرات التي تمت على ألوان العلامات",
    updatethechangesmade: " تحديث التغييرات التي تمت على ألوان العلامات",
    cancelanddiscardchanges: " إلغاء وتجاهل التغييرات",
    requestthereport: " طلب التقرير",
    savetheprotectedaccount: " حفظ الحساب المحمي",
    submitthereportrequest: " إرسال طلب التقرير",
    cancelandgoback: " إلغاء والعودة للخلف",
    exportthexcelfilebasedon: " تصدير ملف ‎Excel‎ بناءً على عوامل التصفية",
    createaprotectedaccountwithpermanent:
      "  إنشاء حساب محمي بحماية دائمة أو لمدة محددة",
    downloadthereportfortheselecte: " تنزيل التقرير للفترة الزمنية المحددة",
    uploadtheinventorysheet: " رفع ملف ‎Excel‎ للمخزون",
    downloadincentoryreport: "تنزيل تقرير المخزون",
    applythesleectedfilters: "تطبيق عوامل التصفية المحددة ",
    uploadtheselectedexcelfile: " رفع ملف ‎Excel‎ المحدد",
    createinstallmentplan: "إنشاء خطة أقساط",
    generatepreviewfiter: "(إنشاء المعاينة أولًا)",
    emiamount: "(مبالغ الأقساط ‎EMI‎ لا تطابق المبلغ المستحق)",
    finisheditinisntall: "  (إنهاء تعديل الأقساط) ",
    savechangesbeforesubmiting: " (احفظ التغييرات قبل الإرسال)",
    totalemaiamount: " (إجمالي مبلغ الأقساط ‎EMI‎ لا يمكن أن يكون سالبًا)",
    userscancreateup: " (يمكن للمستخدم إنشاء ما يصل إلى 6 أقساط فقط)",
    accountTwoActivePlans: "يوجد بالفعل خطتا أقساط نشطتان لهذا الحساب. لا يمكنك إنشاء خطة أخرى.",
    maxTwoActivePlans: " (يُسمح بحد أقصى خطتين نشطتين لكل حساب)",
    maxInstalmentsExceeded: "لا يمكن أن يتجاوز عدد الأقساط",
    instalmentsGreaterThanZero: "يجب أن يكون عدد الأقساط أكبر من صفر",
    printpreviewtable: "طباعة جدول المعاينة",
    generatepreview: " إنشاء المعاينة",
    clearpreviewdata: " مسح بيانات المعاينة",
    submitforRccreation: " إرسال لإنشاء ‎RC‎",
    savethechagesmadeto: " حفظ التغييرات على مبالغ الدفعات",
    editthepaymentamount: " تعديل مبالغ الدفعات",
    submitspecialRc: "  إرسال ‎RC‎ خاص",
    printinstallmentdetails: " طباعة تفاصيل الأقساط",
    proceedwithdeleaction: " المتابعة في إجراء الحذف",
    proceedwithrecallaction: "المتابعة في إجراء الاسترجاع",
    deletetheselectedtask: " حذف المهمة المحددة",
    unassignntheseledtask: " إلغاء تعيين المهمة المحددة",
    reassigntheselectedtask: " إعادة تعيين المهمة المحددة",
    assigntheselectedtask: "تعيين المهمة المحددة",
    multiselecte: " تحديد متعدد",
    addemailenablrnotifi:
      " إضافة عناوين البريد الإلكتروني، وتفعيل الإشعارات، وضبط الإعدادات الأخرى",
    donwloadthetaskrecordin:
      " تنزيل سجل المهام بصيغة ‎Excel‎ بناءً على النشاط المحدد أو لجميع الأنشطة",
    createtaskbulk:
      " إنشاء مهمة جديدة، أو إنشاؤها وتعيينها، أو رفع المهام دفعة واحدة",
    uploadthetasksheet: "رفع ملف المهام",
    assingtaskbasedonselectedrules: "تعيين المهام بناءً على القواعد المحددة",
    reassigningprocess: "إعادة التعيين قيد التنفيذ",
    reassingselectedtasktochosen:
      " إعادة تعيين المهام المحددة إلى الموظفين الميدانيين المختارين",
    assingtaskbasedonselectedrule: "— تعيين المهام بناءً على القواعد المحددة",
    reassinginginprocess: "إعادة التعيين قيد التنفيذ",
    reassignselectedtasktochosenfield:
      "إعادة تعيين المهام المحددة إلى الموظفين الميدانيين المختارين",
    unassignselectedassingeesfromtask:
      "إلغاء تعيين المكلّفين المحددين من المهام",
    savetheupdateddatacompleted: "حفظ البيانات المحدّثة للمهام المكتملة",
    gobacktheprivious: " العودة إلى الشاشة السابقة دون حفظ",
    resetthecompletiondata: " إعادة تعيين بيانات إتمام المهمة",
    closewithoutsavingchnages: " إغلاق دون حفظ التغييرات",
    savechangesmadetothefield: " حفظ التغييرات التي تمت على الحقل",
    viewworkflowguidlines: "عرض إرشادات سير العمل",
    createnewworkflows: "إنشاء سير عمل جديد",
    selectorgtocreateaworkflow: "اختيار مؤسسة لإنشاء سير العمل",
    scheduleemail: " جدولة بريد إلكتروني",
    exporttheexcelfilebasedonfilters:
      " تصدير ملف ‎Excel‎ بناءً على عوامل التصفية",
    exportpdfbasedonfilters: " تصدير ملف ‎PDF‎ بناءً على عوامل التصفية",
    downloadpdfbasedonfilters: " تنزيل ملف ‎PDF‎ بناءً على عوامل التصفية",
    savechangesforprofile: " حفظ التغييرات في الملف الشخصي",
    requestonewreport: "طلب تقرير جديد",
    createamanualtask: " إنشاء مهمة يدوية",
    createandassingtasktofield: " إنشاء وتعيين مهمة لموظف ميداني",
    closethedialogbox: "إغلاق نافذة الحوار",
    gobacktomapmandotoryfield: " العودة لتعيين الحقول الإلزامية",
    submitmappeddataandstartupload:
      " إرسال البيانات المعيَّنة وبدء عملية الرفع",
    procestomapnonmdaotry: " المتابعة لتعيين الحقول غير الإلزامية",
    gobacktotaskpriority: " العودة إلى اختيار أولوية المهام",
    proceestomapmadatory: " المتابعة لتعيين الحقول الإلزامية",
    gobackprivousscren: " العودة إلى الشاشة السابقة دون حفظ",
    addmultipleaccount:
      " إضافة أرقام حسابات متعددة وتعيين المهام للموظفين الميدانيين",
    selectatleast: "يرجى اختيار موظف ميداني واحد على الأقل للتعيين",
    assingmentinprocess: " التعيين قيد التنفيذ",
    assingselectedtasktochosen:
      "تعيين المهام المحددة إلى الموظفين الميدانيين المختارين",
    recallassingedtask: " استرجاع المهام المعيّنة من المستخدمين",
    deleterecordfrom: " حذف السجلات من الملف المرفوع",
    donwloastheuplodedexcel: "تنزيل ملف ‎Excel‎ الذي تم رفعه",
    uploasthexcelfile: " رفع ملف ‎Excel‎ للنشاط المحدد",
    savethechanges: " حفظ التغييرات",
    diacardchanges: " تجاهل التغييرات",
    proceedtomapnonmdfield: " المتابعة لتعيين الحقول غير الإلزامية",
    submitthemapedcol: " إرسال الأعمدة المعيّنة ورفع البيانات",
    uploadtheslectedfile: " رفع الملف المحدد",
    uploadtheaccountexcel:
      " رفع ملف حسابات ‎Excel‎ إلى قاعدة البيانات الرئيسية",
    clearalldata: "مسح جميع البيانات",
    fetchtheaccounthistory: " جلب سجل الحساب للرقم المُدخل",
    donwlaodthetaskreportinpdfformat: "تنزيل تقرير المهام بصيغة ‎PDF‎",
    editandupdateuserdetail: "تحرير وتحديث تفاصيل المستخدم",
    saveandcreateuser: " حفظ وإنشاء مستخدم",
    donotsavechangesgoback: "عدم حفظ التغييرات والعودة",
    addauserassingroles: " إضافة مستخدم وتعيين الأدوار أو الصلاحيات",
    previewcurrentworkflowlayout: " معاينة تخطيط سير العمل الحالي والحقول",
    submitworkflow: " إرسال سير العمل",
    pleaseselectatleastonefild: "يرجى اختيار حقل واحد على الأقل للتقرير",
    plzmakesuretosetauique:
      " يرجى التأكد من تعيين اسم فريد لسير العمل قبل الاستنساخ",
    updatetheworkflowiwth: " تحديث سير العمل بأحدث التغييرات",
    addnewvalidation: "إضافة تحقق جديد",
    closewithoutsavingchanges: " إغلاق دون حفظ التغييرات",
    viewwxistinfcalidation: "عرض عمليات التحقق الحالية",
    savechangesmadetovalidation: " حفظ التغييرات التي تمت على عمليات التحقق",
    discarchangesandexit: " تجاهل التغييرات والخروج",
    savetheupdateddata: "حفظ البيانات المحدّثة للمهام المكتملة",
    addselectefield: " إضافة الحقول المحددة إلى التقرير",
    gotonextpage: " الانتقال إلى الصفحة التالية",
    gotopreviouspage: " الانتقال إلى الصفحة السابقة",
    refeshreportlist: " تحديث قائمة التقارير",
    reportsGenerationNote: "قد يستغرق إنشاء التقارير بضع دقائق. إذا لم يكن تقريرك جاهزًا بعد، يرجى الانتظار قليلاً والنقر على زر التحديث للتحقق مرة أخرى. ستنتهي صلاحية التقارير بعد 6 ساعات من إنشائها.",
    gobackpreviouspage: " العودة إلى الصفحة السابقة",
    requestreporbasedonfilter: "طلب تقرير بناءً على عوامل التصفية",
    filteredReports: "التقارير المفلترة",
    pleaseSelectLeastAssetBeforeAssigning:
      "يرجى اختيار أصل واحد على الأقل قبل الإسناد.",
    plzselectfieldagent: "يرجى اختيار فني ميداني.",
    assetsucassigned: "تم إسناد الأصول بنجاح.",
    assetsfailedassigned: "تعذّر إسناد الأصول",
    logout: "تم تسجيل الخروج بنجاح.",
    rulecreated: "تم إنشاء القاعدة بنجاح.",
    unexpectederroroccured: "",
    plzselworkflow: "يرجى اختيار سير العمل قبل إضافة المعايير.",
    ruledeleted: "تم حذف القاعدة بنجاح.",
    failedelrule: "تعذّر حذف القاعدة.",
    PleaseSelectWorkflowBeforeAddingRule:
      " يرجى اختيار سير العمل قبل إضافة قاعدة",
    failtoloadasign:
      "تعذّر تحميل قواعد الإسناد. يرجى التواصل على help@blufield.net.",
    plzfillallfield: "يرجى تعبئة جميع الحقول الإلزامية للإرسال.",
    failedtoassign:
      "تعذّر إسناد جميع القواعد. يرجى التواصل على help@blufield.net.",
    OnClickTheOldAssignmentRuleDisabled:
      " عند النقر، سيتم تعطيل قاعدة الإسناد السابقة.",
    invalideruleid: "معرّف القاعدة غير صالح.",
    plzselfield: "يرجى اختيار فني ميداني.",
    failedtoloadruledata:
      "تعذّر تحميل بيانات القاعدة. يرجى التواصل على help@blufield.net.",
    nopermission:
      "لا تملك الأذونات اللازمة لعرض هذه الصفحة. يرجى التواصل على help@blufield.net. ",
    nocreatetaskaccess: "ليس لديك صلاحية إنشاء المهام.",
    plzselectorg: "يرجى اختيار منظمة.",
    somthingwentwrong: "",
    excelisdownloading: "يتم تنزيل ملف Excel…",
    norecordfound: "لا توجد سجلات.",
    anerroroccurred: "",
    orgaddedsuc: "تمت إضافة المنظمة بنجاح.",
    errorcreatingorg:
      "حدث خطأ أثناء إنشاء المنظمة. يرجى التواصل على help@blufield.net.",
    failstofetchorg: "تعذّر جلب بيانات المنظمة.",
    orgupdated: "تم تحديث المنظمة بنجاح.",
    allfieldarerequired: "كل الحقول مطلوبة.",
    reportreqsuc: "تم إرسال طلب التقرير بنجاح.",
    errorequestreport: "حدث خطأ أثناء طلب التقرير.",
    addremark: "أضف ملاحظة!",
    protectedAcccreated: " تم إنشاء حساب محمي.",
    protectedAccUpdated: "تم تحديث الحساب المحمي.",
    errorcreatingprotacc: "حدث خطأ أثناء إنشاء الحساب المحمي.",
    skippedAccountsDownloaded: "حساب تم تخطيه. تم تنزيل التفاصيل.",
    partialProtectionSummary:
      "تمت حماية {created} حساب، وتم تخطي {skipped}. تم تنزيل التفاصيل.",
    updatedBy: "تم التحديث بواسطة",
    previousRemarks: "الملاحظات السابقة",
    pleaseSelectOrganizationCreatingAccount:
      "يرجى اختيار منظمة قبل إنشاء حساب.",
    pleaseSelectProjectIdFirst: "يرجى اختيار مشروع أولًا.",
    norecordareavailbles: "لا توجد سجلات متاحة.",
    downloadlinkmissing: "رابط التنزيل غير موجود.",
    invalidresponse: "تنسيق الاستجابة غير صالح.",
    failedFetchReports: "تعذّر جلب التقرير.",
    reportgeneratedsuccc: "تم إنشاء التقرير بنجاح!",
    pleaseSelectRecordProceed: "يرجى اختيار سجل للمتابعة!",
    errorOccurredWhileDeletingRecord: "حدث خطأ أثناء حذف السجل.",
    failedtofetchmeter: "تعذّر جلب تفاصيل مخزون العدادات.",
    userStatusupdatesuc: "تم تحديث حالة المستخدم بنجاح.",
    failedtoupdateuserstatus: "تعذّر تحديث حالة المستخدم.",
    fileuploadedsucc: "تم رفع الملف بنجاح.",
    failedtouploadfiles: "تعذّر رفع الملف. يرجى التواصل على help@blufield.net.",
    pleasegeneratepreview: "يرجى إنشاء المعاينة قبل إنشاء القسط.",
    failedtogeneratepdf:
      " تعذّر إنشاء ملف PDF. يرجى المحاولة مرة أخرى أو التواصل معنا على help@blufield.net.",
    installmentupdated: "تم تحديث خطة الأقساط بنجاح!",
    installmentplancretsuc: "تم إنشاء خطة الأقساط بنجاح!",
    errorgeneratingpdf: " حدث خطأ أثناء إنشاء ملف PDF أو إرسال خطة الأقساط!",
    failedtoconnectserver: "",
    youcannotpaythefullamount:
      "لا يمكنك دفع المبلغ كاملًا في قسط واحد. يرجى توزيعه على جميع الأقساط.",
    eachinstallmentmusthave: " يجب أن يحتوي كل قسط على الحد الأدنى على الأقل.",
    changesavedsuc: "تم حفظ التغييرات بنجاح!",
    plzwentervalidacc: "يرجى إدخال رقم حساب صالح.",
    fieldagentassinged: "تم تعيين الفني الميداني.",
    NoasssingData: "لا تتوفر بيانات للمسنَد إليهم.",
    assigneeCompleted: "مكتملة",
    assigneeCompletedBy: "أُنجزت بواسطة",
    unAssignTaskSuccessMeg:
      "تم استلام طلبك ويجري معالجته في الخلفية. ستتلقى إشعارًا عند اكتماله.",
    pleaseselect: "اختر سير العمل أولًا.",
    plzenteracommentbeforedel: "يرجى إدخال تعليق قبل حذف المهمة.",
    taskdelsuccessfully: "تم حذف المهمة بنجاح.",
    erroccureduringtask: "",
    failedtoassignbyarea: "تعذّر إسناد المهام حسب المنطقة.",
    plzselectactivity: "يرجى اختيار نشاط.",
    noassigneselectedfor: "لم يتم اختيار مسنَد إليهم لإلغاء الإسناد.",
    delteallrecord: "تم حذف جميع السجلات.",
    taskprioriyupdated: "تم تحديث أولوية المهمة.",
    pdfnotavailable: " ملف PDF غير متاح.",
    datafetchedsuccessfully: "تم جلب البيانات بنجاح.",
    anerroroccuredtaskhistory: "",
    taskupdatedcussfully: "تم تحديث المهمة بنجاح.",
    erroruploadingfileplztry:
      " تعذّر رفع الملفات. يرجى التواصل على help@blufield.net.",
    orgismissingnotdrag: "معرّف المنظمة مفقود؛ لا يمكن السحب!",
    nochangwsmadetothe: "لم تُجرَ أي تغييرات على نوع الحقل.",
    selectOrgWarning: "اختر المنظمة أولًا.",
    pleaseselectdayreport: "يرجى اختيار يوم التقرير.",
    reportprocesucc: "تمت معالجة التقرير بنجاح!",
    nofileselc: "لم يتم اختيار أي ملف.",
    filesizeexceeds: "حجم الملف يتجاوز 5 MB.",
    invalidfiletypeplimg: "وع الملف غير صالح. يرجى رفع صورة.",
    invalidfiletypedouc: "نوع الملف غير صالح. يرجى رفع مستند.",
    unsupportedfile: "نوع ملف غير مدعوم.",
    plzfillallfieldbeforeadd: "يرجى تعبئة جميع الحقول قبل إضافة أصل.",
    assetaddedscucceffuly: "تمت إضافة الأصل بنجاح.",
    fillFieldbeforeAddVehical: "يرجى تعبئة جميع الحقول قبل إضافة مركبة.",
    assetupdatedsuc: " تم تحديث الأصل بنجاح.",
    vehicalupdatedsuc: "تم تحديث المركبة بنجاح.",
    emailidorpass: "البريد الإلكتروني أو كلمة المرور غير صحيحة.",
    accessdenied: "تم رفض الوصول!",
    otpverifiedsuc: "تم التحقق من رمز التحقق (OTP) بنجاح.",
    failedtoverifyotp: "تعذّر التحقق من رمز التحقق (OTP).",
    noworkflowinorg: "لا تتوفر سير عمل لهذه المنظمة.",
    plzuploadpdffileonly: " يرجى رفع ملفات PDF أو الفيديو فقط.",
    guidlineuplodsucc: "تم رفع الدليل بنجاح.",
    invalidfiletype: " نوع الملف غير صالح. يرجى رفع JPG أو PNG أو GIF.",
    emailnotavailble:
      "البريد الإلكتروني غير متاح. يرجى التأكد من تحميل ملفك الشخصي.",
    youcanotmodify: "لا يمكنك تعديل كلمة المرور الحالية ما لم يتم مسحها أولًا.",
    youcanowenter: "يمكنك الآن إدخال كلمة مرور جديدة.",
    passowrdmust:
      "يجب أن تتكون كلمات المرور من 8 أحرف على الأقل وأن تتضمن حرفًا كبيرًا وحرفًا صغيرًا ورقمًا ورمزًا خاصًا.",
    profileupdated: "تم تحديث الملف الشخصي.",
    failedtofetchemails: "تعذّر جلب الرسائل الإلكترونية.",
    enteremailfirst:
      "أدخل بريدك الإلكتروني أولًا، ثم يمكنك تفعيل إشعارات البريد الإلكتروني.",
    statusupdatedsucc: "تم تحديث الحالة بنجاح.",
    failedtoupdatednotifcation: "تعذّر تحديث إعدادات الإشعارات.",
    errorfiledownloaded: "خطأ: تم تنزيل الملف.",
    fileuploadedaborteddue: "تم إلغاء رفع الملف بسبب خطأ.",
    plxselectanoption: "يرجى اختيار خيار.",
    pleasefillallmandtoryfield: "يرجى تعبئة جميع الحقول الإلزامية للمتابعة.",
    uploadcanceled: "تم إلغاء الرفع.",
    nodatavailvle: "لا توجد بيانات متاحة.",
    nofieldavailable: "لا توجد حقول متاحة.",
    categoriyaddedsucc: "تمت إضافة الفئة بنجاح.",
    plzselectdeltype: "يرجى اختيار نوع الحذف.",
    failedtodelfile: "تعذّر حذف الملف.",
    uploadedtasksheet: "تم عرض قائمة ملفات المهام المرفوعة في الجدول!",
    nomoredatatoload: "لا توجد بيانات إضافية للتحميل.",
    taskdetailupdatedsuc: "تم تحديث تفاصيل المهمة بنجاح!",
    norecordavbforthisacc:
      "لا يوجد سجل لرقم الحساب هذا. يرجى تجربة رقم حساب آخر.",
    userupdatedsuc: "تم تحديث المستخدم بنجاح.",
    usercreatedSuc: "تم إنشاء المستخدم بنجاح.",
    failedtofetchusers: "تعذّر جلب المستخدمين.",
    nofieldabuplodtasksheet:
      "لا توجد حقول متاحة. يرجى رفع ملف المهام أولًا للحصول على حقول إضافية.",
    nomoreuniqueversion: "لا مزيد من الإصدارات الفريدة المتاحة.",
    nomoreversionavailble: "لا مزيد من الإصدارات المتاحة.",
    createworkflowdiagram: "إنشاء سير عمل.",
    updatepdfnamefirst: "حدّث اسم ملف PDF أولًا.",
    pdfnameupdate: "تم تحديث اسم ملف PDF بنجاح.",
    updatereportname: "حدّث اسم التقرير أولًا.",
    excelnameupdate: "تم تحديث اسم ملف Excel بنجاح. ",
    inputvlueadded: "تمت إضافة قيمة الإدخال!",
    warningthis:
      "تحذير: هذا الخيار مُدرج بالفعل في سير العمل. الإزالة مُقيّدة.",
    linkedWorkflowConditionConflict:
      'هذا الخيار مرتبط بالفعل بسير عمل. أزل سير العمل المرتبط قبل إضافة شرط خيار الأصل لـ "{option}".',
    conditionLinkedWorkflowConflict:
      'هذا الخيار لديه بالفعل شرط خيار أصل. أزل الشرط قبل ربط سير عمل بـ "{option}".',
    linkedWorkflowConditionSaveConflict:
      'الخيار "{option}" في الحقل "{field}" لديه بالفعل سير عمل مرتبط وشرط خيار أصل. أزل أحدهما قبل الحفظ.',
    fieldremoved: "تمت إزالة الحقل.",
    fieldcloned: "تم استنساخ الحقل.",
    clonedsuc: "تم الاستنساخ بنجاح.",
    pleaseentername: "يرجى إدخال اسم لسير العمل المستنسخ.",
    inputfield: "لا يمكن أن يكون حقل الإدخال فارغًا!",
    warningalready:
      "تحذير: هذا الخيار مضاف بالفعل في تدفق العمل. الإزالة مقيدة. يمكنك فقط تعديل اسم هذا الخيار.",
    validationremoved: "تمت إزالة التحقق، حدث تدفق العمل للحذف.",
    validationnotapplicable: "لا ينطبق التحقق على هذا النوع من الحقول.",
    updatetheworkflow: "حدّث سير العمل لحفظ هذه الحقول الإضافية.",
    failedtoupdatefield: "تعذّر تحديث الحقول. يرجى المحاولة مرة أخرى.",
    pleaseSelectLeastActivity: "يرجى اختيار نشاط واحد على الأقل.",
    failedSubmitReportRequest: "تعذّر إرسال طلب التقرير.",
    urlnotprovided: "لم يتم توفير عنوان URL في الاستجابة.",
    failedtoaddasset: " تعذّر إضافة الأصل.",
    vehicleaddedsuc: "تمت إضافة المركبة بنجاح.",
    failToAddVehical: "تعذّر إضافة المركبة.",
    ruleupdatedsuc: "تم تحديث القاعدة بنجاح!",
    filesdeleted: " تم حذف الملف.",
    plzselectatleatone: "يرجى اختيار مهمة واحدة على الأقل للإسناد.",
    plzselectedforilfagrntoasing: "يرجى اختيار فني ميداني لإسناد المهام.",
    invalidworkflow: "سير العمل غير صالح. يرجى المحاولة مرة أخرى.",
    softdeletedsucc: "تم الحذف المنطقي بنجاح!",
    softdelfailed: "فشل الحذف المنطقي!",
    erroduringsoftdel: "خطأ أثناء الحذف المنطقي!",
    permamatdelsuc: "تم الحذف النهائي بنجاح!",
    permantdelfailed: "فشل الحذف النهائي!",
    errorduringperdel: "خطأ أثناء الحذف النهائي!",
    taskrecallcompletesuc: "تم استرجاع المهمة بنجاح!",
    taskrecallfailed: "فشل استرجاع المهمة!",
    erroduringtaskrecall: "خطأ أثناء استرجاع المهمة!",
    attachmentismand: "المرفق إلزامي!",
    onlypdfimgallowed: " يُسمح فقط بملفات PDF والصور.",
    workflowmodule:
      "وحدة سير العمل غير متاحة على الأجهزة المحمولة. يرجى استخدام جهاز كمبيوتر مكتبي أو جهاز لوحي للمتابعة.",
    Attachment: "المرفق ",
    viewattachment: " عرض المرفق",
    selectedtasknotassinged: "المهام المحددة غير مخصصة ",
    completedTaskReassignNotAllowed: "يمكن إعادة تعيين المهام المكتملة غير الناجحة فقط.",
    completedTasksCannotBeOnHold: "لا يمكن تعليق المهام المكتملة.",
    taskAlreadyOnHold: "المهمة معلّقة بالفعل.",
    pendingTasksCannotBeOnHold: "لا يمكن تعليق المهام قيد الانتظار.",
    taskAssignNotAllowed: "يمكن تعيين المهام النشطة أو قيد الانتظار أو المعلّقة فقط.",
    taskReassignNotAllowed: "يمكن إعادة تعيين المهام المعيّنة أو قيد التنفيذ أو قيد الانتظار أو المعلّقة فقط.",
    taskUnassignNotAllowed: "يمكن إلغاء تعيين المهام المعيّنة أو قيد الانتظار أو المعلّقة فقط.",
    Inactive: "غير نشط ",
    aresurewantodeleterule: "هل أنت متأكد أنك تريد حذف القاعدة؟",
    Assigning: "جاري التعيين ",
    Saving: "جاري الحفظ",
    Requesting: "جاري الطلب ",
    enterextendeddate: "أدخل التاريخ الممتد",
    targetoutstandingamtbyextdate: "المبلغ المستحق المستهدف حسب التاريخ الممتد",
    Comments: "تعليقات ",
    No: "لا ",
    aresurewanttodeleterecord: "هل أنت متأكد أنك تريد حذف السجل؟",
    downladreport: "تنزيل التقرير",
    transferto: "تم التحويل إلى",
    nometerdetailfound: "لم يتم العثور على تفاصيل العداد للرمز الشريطي",

    loadingmeterdetail: "جاري تحميل تفاصيل العداد",
    Print: "طباعة ",
    ucantaddmorethan6: `لا يمكنك إضافة أكثر من 6 أقساط`,
    Proceed: "متابعة ",
    taskdetails: "تفاصيل المهمة",
    viewexistingfile: "عرض الملف الموجود",
    nofileuploaded: "لم يتم تحميل أي ملف.",
    nooptionavailable: "لا توجد خيارات متاحة",

    fetchingaccdetails: "جاري جلب تفاصيل الحساب",
    workflowid: "معرف سير العمل",
    pdflink: "رابط PDF",
    selectefieldpreiview: " معاينة الحقل المحدد",
    fieldname: "اسم الحقل",
    fieldtype: "نوع الحقل:",
    selectfield: "ختر الحقل",
    selectinputtype: "اختر نوع الإدخال",
    updateinputype: "تحديث نوع الإدخال",
    uploadnewphoto: "تحميل صورة جديدة",
    Open: "فتح ",
    uploadnewdoc: "تحميل مستند جديد",
    viewpdf: "عرض PDF",
    dragandroptoupload: "اسحب وأسقط للتحميل",
    aresurewantodeletefile: "هل أنت متأكد أنك تريد حذف الملف؟",
    generatereport: "إنشاء تقرير ",
    Reject: "رفض ",
    Approve: " موافقة ",
    loadingmorenotification: "جاري تحميل المزيد من الإشعارات",
    nomorenotification: "لا توجد إشعارات إضافية للتحميل",
    Pending: "قيد الانتظار ",
    Task: "مهمة ",
    Mandatory: "إلزامي ",
    Fields: " حقول ",
    Other: "أخرى ",
    Back: " رجوع ",
    thisactivitydoesnothavefield: "لا تحتوي هذه النشاطات على حقول",
    subcategory: "الفئة الفرعية",
    selectsubcategory: "اختر الفئة الفرعية",
    addcategory: "إضافة فئة +",
    deletetask: "حذف المهام",
    deleteTaskTitle: "حذف المهمة",
    dosoftdeletions: "تنفيذ الحذف المؤقت",
    depermanatdeletions: "تنفيذ الحذف الدائم  ",
    permanentdeletedisabled: "هذا الخيار معطل حاليًا",
    confirmdeletion: "تأكيد الحذف",
    areusurewanttoallassinged:
      "هل أنت متأكد أنك تريد جعل جميع المهام المعينة، قيد التقدم، والمعلقة نشطة؟",
    selectlocationmap: "اختر الموقع على الخريطة",
    Loading: "جاري التحميل",
    nowuserfound: "لم يتم العثور على مستخدمين",
    userActivity: "نشاط المستخدم",
    loginHistoryTitle: "سجل تسجيل الدخول",
    viewLoginHistory: "عرض سجل تسجيل الدخول",
    loadingLoginHistory: "جارٍ تحميل سجل تسجيل الدخول...",
    noLoginActivityYet: "لا يوجد نشاط تسجيل دخول حتى الآن",
    loginHistoryWillAppearWhenSignIn: "سيظهر سجل تسجيل الدخول هنا عندما يسجّل هذا المستخدم الدخول.",
    mostRecentLogin: "آخر تسجيل دخول",
    loginTime: "وقت تسجيل الدخول",
    systemId: "معرّف النظام",
    map: "الخريطة",
    openInMap: "فتح في الخريطة",
    open: "فتح",
    locationUnavailable: "الموقع غير متاح",
    failedToFetchLoginHistory: "تعذّر جلب سجل تسجيل الدخول.",
    notAvailable: "N/A",
    addfield: "إضافة حقول",
    updatefield: "تحديث الحقول",
    enterworkflowname: "أدخل اسم سير العمل",
    Elements: "العناصر ",

    Report: "تقرير ",
    editinputvalues: "تعديل قيم الإدخال",
    addedvalidation: "تم إضافة التحققات",

    deletefield: "حذف الحقل",
    deletevalidation: "حذف التحقق",
    validationcode: "رمز التحقق",
    novalidationavailable: "لا توجد تحققات متاحة",
    rusurewanttodeleteworkflow: "هل أنت متأكد أنك تريد حذف سير العمل هذا؟",
    noversionavb: "لا توجد نسخ متاحة",
    noreportdataavb: "لا توجد بيانات تقرير متاحة",
    goback: "العودة ",
    aresurewantodeleteemail: "هل أنت متأكد أنك تريد حذف هذا البريد الإلكتروني؟",
    nofieldagentfound: "لم يتم العثور على أي عملاء ميدانيين",
    Selected: "تم التحديد",
    updatedon: "تم التحديث في",
    tariff: "التعرفة",
    Office: "مكتب ",
    cancelupload: "إلغاء الرفع ",
    Recall: "أسترجاع ",
    notaskavbtounasign: " لا توجد مهام متاحة لإلغاء التعيين",
    unassigntask: "إلغاء تعيين المهمة",
    selectassigntounassign:
      "اختر الأشخاص المراد إلغاء تعيينهم من المهام المحددة",
    allassign: "جميع المعينين",

    confirmaction: "تأكيد الأجراء ",
    areusure: "هل تريد بالتأكيد حذف هذه المهمة؟ هذا الإجراء غير قابل للاسترجاع",
    totalcount: "العدد الإجمالي",
    Processing: " جارٍ المعالجة",
    currenOs: " نظام التشغيل الحالي",
    updatedat: "تم التحديث في",
    curros: "الحالي غير المكتمل / الحالي المعلّق",
    lastupdateddate: "تاريخ آخر تحديث",
    lastupdatedtime: "وقت آخر تحديث",
    assingename: "اسم المُكلّف / المُعيّن",
    finisheddate: "تاريخ الانتهاء",
    fnishedtime: "وقت الانتهاء",
    uploadeddate: "تاريخ الرفع",
    uploadedtime: "وقت الرفع",
    uploadedLabel: "تم الرفع",
    finishedLabel: "منتهي",
    Unsuccessful: "غير ناجح ",
    Success: " ناجح  ",
    fileprocessingcancle: "تم إلغاء معالجة الملف.",
    pleaseenteraccnumber: "الرجاء إدخال رقم الحساب.",
    projmissingplzelc: "المشروع مفقود. الرجاء اختيار مشروع.",
    addleastonelementto:
      "أضف عنصرًا واحدًا على الأقل إلى الصفحة الحالية قبل الانتقال للصفحة التالية.",

    checkuremailotp: " تحقق من بريدك الإلكتروني للحصول على رمز التحقق",
    taskcreatedsuc: "تم إنشاء المهام بنجاح",
    taskunassingedsucc: "تم إلغاء تعيين المهمة بنجاح!",
    norecordareavailable: "لا توجد سجلات متاحة",
    failedtouploadfile: "فشل رفع الملف",
    failtoupdaterule: " فشل في تحديث القاعدة",
    startdateerror: "لا يمكن أن يكون تاريخ البدء بعد تاريخ الانتهاء",
    anerror: "",
    errorsubmiting: "خطأ في إرسال النموذج",
    ruleupdated: " تم تحديث القاعدة بنجاح",
    failupdaterule: "فشل في تحديث القاعدة",
    plzselectworkflow: "الرجاء اختيار سير عمل قبل إضافة قاعدة",
    basicinfo: " معلومات أساسية",
    changeprofile: " تغيير الملف الشخصي",
    updateRule: "تحديث القاعدة",
    newRule: " قاعدة جديدة",
    assignedAll: " الكل مُعيَّن",
    notAssignedAll: "الكل غير مُعيَّن",
    LoadingGeo: " جارٍ تحميل الأكواد الجغرافية",
    selectgeocode: " اختر الكود الجغرافي",
    All: "الكل",
    loadingtyoecodes: "جارٍ تحميل أكواد الأنواع",
    selecttypecodes: "ختر كود النوع",
    selectamount: "اختر نطاق المبلغ",
    ok: "موافق",
    gobacktopreviousstep: "الرجوع إلى الخطوة السابقة",
    continuetonextstep: "المتابعة إلى الخطوة التالية",
    selectsheettoupload: "اختر أو أفلت الملف الذي تريد استيراده",
    uploadlimitexceeded: "تم تجاوز حد التحميل",
    sheetrecordlimitmsg:
      "يحتوي هذا الملف على {count} سجل. يمكن تحميل {limit} سجل كحد أقصى في المرة الواحدة. يُرجى تقسيم الملف وإعادة التحميل.",
    fileuploadedtitle: "تم تحميل الملف",
    largedataprocessingmsg:
      "تم تحميل ملفك بنجاح. إذا كان يحتوي على عدد كبير من السجلات، فقد تستغرق المعالجة بعض الوقت. يُرجى الانتظار قليلاً والتحقق من الحالة في القائمة أدناه.",
    invalidfiletitle: "ملف غير صالح",
    unabletoreadsheet:
      "لم نتمكن من قراءة هذا الملف. يُرجى التأكد من أنه ملف CSV أو Excel صالح والمحاولة مرة أخرى.",
    importtaskusingsheet: "استيراد المهام باستخدام ملف Excel / CSV",
    mapyourfilecolumns: "قم بمطابقة أعمدة الملف وتحميل المهام",
    importprogress: "تقدّم الاستيراد",
    columnmappingsteps: "خطوات مطابقة الأعمدة",
    uploadfilelabel: "تحميل الملف",
    uploadtasksheetdesc:
      "قم بتحميل ملف المهام الذي تريد استيراده (.csv أو .xlsx). سنقوم بمطابقة أعمدته في الخطوة التالية.",
    draganddroptasksheet: "اسحب ملف المهام وأفلته هنا",
    orclicktobrowse: "أو انقر للاستعراض · CSV أو Excel",
    clicktochooseanotherfile: "انقر لاختيار ملف آخر",
    selectavalue: "اختر قيمة",
    selecttaskpriority: "اختر الأولوية الافتراضية للمهام المستوردة",
    existingaccountsquestion: "ماذا تريد أن تفعل بالحسابات الحالية؟",
    updateexistingaccountentries: "تحديث إدخالات الحسابات الموجودة بالفعل؟",
    createnewaccountentries: "إنشاء إدخالات حسابات جديدة؟",
    mandatoryfield: "حقل إلزامي",
    primarykeyvalue: "المفتاح الأساسي / القيمة",
    pleaseselectanactivity: "يُرجى اختيار النشاط",
    findAField: "ابحث عن حقل...",
    wfFieldGroupBasic: "الحقول الأساسية",
    wfFieldGroupSelection: "حقول الاختيار",
    wfFieldGroupMedia: "الوسائط والحقول الخاصة",
    uploadandreviewtasksheets: "قم بتحميل ملفات المهام المستوردة ومراجعتها.",
    cycle: "الدورة",
    daterange: "النطاق الزمني",
    reportscope: "نطاق التقرير",
    selectcycle: "اختر الدورة",
    selectcycleoptional: "الدورة (اختياري)",
    nocyclesavailable: "لا توجد دورات محمّلة بعد",
    pleaseselectacycle: "يُرجى اختيار الدورة",
    pleaseselectonecycle: "اختر دورة واحدة فقط لتقرير البيانات",
    performancereport: "تقرير الأداء",
    cycleperformancereport: "تقرير أداء الدورة",
    performancereportready: "تم إنشاء تقارير أداء الدورات.",
    performancereporttooltip: "إنشاء تقارير الأداء للنشاط والدورات المحددة",
    performancereportrequirements: "اختر إحدى دورات هذا النشاط لإنشاء تقرير الأداء",
    cyclesingleactivityonly: "تغطي تقارير الدورات نشاطًا واحدًا في كل مرة. اختر نشاطًا واحدًا لاستخدام نطاق الدورة.",
    cycleselectactivityfirst: "اختر نشاطًا لاستخدام نطاق الدورة",
    gobacklabel: "رجوع",
    inProgress: "قيد التنفيذ",
    uploadedCount: "عدد السجلات المحمّلة",
    movedCount: "عدد السجلات المنقولة",
    updatedCount: "عدد السجلات المحدّثة",
    notUploadedCount: "عدد السجلات غير المحمّلة",
    notUploadedLog: "سجل السجلات غير المحمّلة",
    movedLog: "سجل السجلات المنقولة",
    downloadnotuploadedlog: "تنزيل سجل السجلات غير المحمّلة",
    downloadnotmovedlog: "تنزيل سجل السجلات غير المنقولة",
    failedtorecalltask: "فشل استرجاع المهمة.",
    previousPage: "الصفحة السابقة",
    nextPage: "الصفحة التالية",
    previousyear: "السنة السابقة",
    nextyear: "السنة التالية",
    addRule: " إضافة قاعدة",
    addproject: "إضافة مشروع",
    departmentname: "اسم القسم",
    projectname: "  اسم المشروع",
    adddepartment: " إضافة قسم",
    seeData: " عرض البيانات",
    enterrecipt: "أدخل المستلمين ",
    enterbcc: "أدخل العناوين في خانة النسخة المخفية (Bcc)",
    entercc: " خل العناوين في خانة النسخة الكربونية (Cc)",
    assignbyrule: " التوزيع حسب القواعد",
    searchfieldAgent: " البحث عن الموظفين الميدانيين",
    selectAll: "تحديد الكل",
    deselectAll: "إلغاء تحديد الكل",
    selectAllAgentsTooltip: "تحديد كل الموظفين الظاهرين",
    deselectAllAgentsTooltip: "إلغاء تحديد كل الموظفين الظاهرين",
    loadingtask: "جاري تحميل تفاصيل المهمة",
    fieldagentAvgwork: "متوسط وقت عمل الموظف الميداني",
    selectDash: "ختر لوحة التحكم",
    selecttask: "اختر حالة المهمة",
    selectStatus: "  اختر الحالة",
    SelectDateTime: "اختر نطاق التاريخ والوقت",
    startdatetime: " تاريخ ووقت البداية ",
    enddatetime: "تاريخ ووقت النهاية",
    selectDateRange: " اختر نطاق التاريخ",
    fieldAgentCLock: "تسجيل دخول /خروج الموظف الميداني",
    selectusertpye: " أختر نوع المستخدم",
    isClockin: "هل  تم تسجيل الدخول",
    selectvehicle: "أختر المركبة",
    vehicalid: " رقم المركبة   ",
    OrganizationId: " رقم المؤسسة",
    inuse: "قيد الاستخدام ",
    id: " رقم التعريف",
    selectAsset: "أختر المورد ",
    showLatLog: "إظهار المهام التي تفتقد خطوط الطول/العرض",
    hidelatlog: "إظهار المهام التي لا تحتوي على موقع (خط الطول/العرض)",
    createdatetime: "تاريخ ووقت الإنشاء ",
    taskCategory: " فئة المهمة ",
    mobileno: " رقم الهاتف",
    discardMessage:
      " هل تريد حقاً المغادرة ؟ هذا الإجراء سيؤدي إلى الحفظ أو الإلغاء",
    viewinstallmentmsg: "دخل رقم الحساب لعرض خطط الأقساط",
    optionalSelectedfield: " حقول اختيارية",
    emailnotification: "إشعارات البريد الإلكتروني",
    recievemeial:
      " استلام إشعارات البريد الإلكتروني لتحديثات المهام والتذكيرات ",
    taskmangement: " إدارة المهام",
    autoAssign: "التعيين التلقائي",
    autoAssignTask: " إسناد المهام تلقائياً",
    autoasigntaskto: "إسناد المهام تلقائياً لأعضاء الفريق المتاحين",
    failedToLoadAutoAssign: "تعذّر تحميل حالة التعيين التلقائي.",
    failedToUpdateAutoAssign: "تعذّر تحديث حالة التعيين التلقائي.",
    protectioninWorkflow: "الحماية في سير العمل ",
    preventtaskprotected: " منع التغييرات على المهام بعد أن تكون قيد التنفيذ",
    othersetting: " إعدادات أخرى ",
    choselang: "أختر اللغة الافتراضية للتطبيق",
    addmeail: " إضافة بريد إلكتروني",
    email: " البريد الإلكتروني",
    notchartYet: "لا تتوفر بيانات لعرضها في هذا المخطط بعد ",
    chartWaitingForResponses: "سيتم تحديث هذا المخطط تلقائيًا بمجرد ورود الردود.",
    priorityLevel: "مستوى الأولوية ",
    entername: "أدخل الأسم",
    Activities: "الأنشطة",
    basicField: "الحقول الأساسية",
    recent: "مؤخرًا",
    selectionfield: "حقل الاختيار",
    mediafield: "وسائل الاعلام والمجالات الخاصه ",
    items: "العناصر",
    Enable: "تمكين",
    disable: "تعطيل",
    comapletedDate: "تاريخ الإكمال",
    taskId: "معرف المهمة",
    noproject: "لا توجد مشاريع",
    nodepartment: " لا توجد أقسام",
    noactivity: " لا توجد أنشطة",
    splaignrule: "قاعدة المهام الخاصة",
    specialAssignmentRuleSubheading: "توجيه المهام حسب الموقع الجغرافي أو النوع أو نطاق المبلغ.",
    urgentTaskAssignment: "تعيين المهام العاجلة",
    urgentTaskAssignmentTooltip: "تعيين المهام العاجلة للموظفين الميدانيين المحددين",
    urgentTaskAssignmentSubtitle: "اختر سير العمل ورموز المناطق والموظفين الميدانيين لتعيين المهام العاجلة.",
    urgentAreaCodes: "رموز المناطق",
    urgentSelectAreaCodes: "اختر رموز المناطق",
    urgentFieldAgents: "الموظفون الميدانيون",
    urgentSelectFieldAgents: "اختر الموظفين الميدانيين",
    urgentSelectWorkflowRequired: "يرجى اختيار سير عمل واحد على الأقل",
    urgentSelectAreaCodeRequired: "يرجى اختيار رمز منطقة واحد على الأقل",
    urgentSelectAgentRequired: "يرجى اختيار موظف ميداني واحد على الأقل",
    urgentWorkflowHelp: "سيتم تعيين المهام العاجلة من سير العمل هذه.",
    urgentAreaCodeHelp: "يتم تضمين المهام الموجودة في رموز المناطق هذه فقط.",
    urgentAgentHelp: "تتم إضافة هؤلاء الموظفين إلى كل مهمة مفتوحة مطابقة.",
    urgentSummary: "ملخص التعيين",
    urgentStepsComplete: "خطوات مكتملة",
    urgentAssignNow: "تعيين المهام العاجلة",
    urgentAssigning: "جارٍ التعيين...",
    urgentPleaseWait: "جارٍ تعيين المهام العاجلة، يرجى الانتظار...",
    urgentNoPermission: "ليس لديك صلاحية لتعيين المهام العاجلة",
    urgentAssignSuccess: "تتم معالجة التعيين العاجل في الخلفية، وسيتم إشعارك عند اكتماله.",
    urgentAssignFailed: "فشل تعيين المهام العاجلة",
    urgentConfirmTitle: "تأكيد التعيين العاجل",
    urgentConfirmMessage: "إضافة {count} موظف/موظفين إلى جميع المهام المفتوحة في الأنشطة والمناطق المحددة؟ سيتم الإبقاء على المعيّنين الحاليين.",
    urgentConfirmBack: "رجوع",
    urgentConfirm: "نعم، عيّن",
    urgentHowItWorks: "كيف يعمل",
    urgentHelpKeepAssignees: "يتم الإبقاء على المعيّنين الحاليين، وتتم إضافة الموظفين إليهم.",
    urgentHelpSkipCompleted: "يتم تخطي المهام المكتملة والمنتهية.",
    urgentHelpOneTime: "يتم مرة واحدة فقط: لن تُسند المهام المرفوعة لاحقًا إلى هؤلاء الموظفين تلقائيًا.",
    urgentHelpInProgress: "يُضاف الموظفون أيضاً إلى المهام قيد التنفيذ، وتعرضهم قائمة المهام إلى جانب المكلفين الحاليين.",
    searchByAssignTo: "البحث حسب المعين إلى...",
    myprofile: "ملفي الشخصي",
    sidebarNotifications: "الإشعارات",
    sidebarSettings: "الإعدادات",
    sidebarUnreadCount: "{count} غير مقروء",
    barChart: "مخطط شريطي",
    Piechart: " مخطط دائري",
    Radarchart: " مخطط الرادار",
    Linechart: "مخطط خطي",
    Areachart: "مخطط مساحي",
    OrganizationLogo: "شعار المنظمة",
    OrganizationName: "اسم المنظمة",

    Organizations: "المنظمات",
    ReportType: " نوع التقرير",
    ForInstallmentPlan: " لخطة التقسيط",
    WorkflowNames: " أسماء سير العمل",
    ReportLink: "رابط التقرير",
    RequestedAt: " تم الطلب في",
    Noguidelines: "لا توجد إرشادات متاحة",
    Deleteworkflowmsg:
      " هل تريد المغادرة حقًا؟ هذا الإجراء سيؤدي إلى حذف هيكل سير العمل الذي أنشأته",
    MandatoryFields: "لحقول الإلزامية",
    NonMandatoryFields: " الحقول غير الإلزامية",
    BulkUpload: "رفع جماعي",
    CreateandAssigne: "إنشاء وتعيين",
    AssetName: "اسم الأصل",
    UserId: "معرف المستخدم",
    FieldStaffList: "قائمة موظفي الميدان",
    SUBMISSION: "إرسال",
    NOT_COMPLETED: "غير مكتمل",
    HideCriteria: "إخفاء المعايير",
    NewCriteria: "إضافة معيار جديد",
    ActivityQuestions: "اختر أسئلة النشاط",
    FieldQuestion: "اختر سؤال الحقل",
    Select: "اختر",
    AddChart: "إضافة مخطط",
    DeleteDash: "هل أنت متأكد أنك تريد حذف لوحة المعلومات هذه؟",
    DeleteGraph: "هل أنت متأكد أنك تريد حذف هذا المقياس البياني؟",
    CreateDash: "إنشاء لوحة معلومات للنشاط",
    Role: "الدور",
    Activity: "النشاط",
    selectWorkflow: "اختر سير العمل",
    sarWorkflow: "سير العمل",
    allWorkflows: "جميع مسارات العمل",
    sarWorkflowRequired: "يرجى اختيار سير العمل",
    sarWorkflowChangeHint: "سيؤدي تغيير سير العمل إلى إلغاء إسناد المهام التي أسندتها هذه القاعدة في سير العمل القديم، وإسناد المهام المطابقة في سير العمل الجديد.",
    ActivityName: "اسم النشاط",
    SelectChart: "اختر مخطط",

    // --- بطاقة المهام حسب المحافظة ---
    tasksByGovernorate: "المهام حسب المحافظة",
    governorate: "المحافظة",
    notSpecified: "غير محدد",
    selectFieldAgent: "اختر موظفًا ميدانيًا",
    selectView: "اختر طريقة العرض",
    barChartView: "مخطط شريطي",
    barChartViewHint: "طول الشريط يمثل عدد المهام",
    shareView: "النسبة",
    shareViewHint: "كل شريط بعرض كامل لمقارنة توزيع الحالات",
    tableView: "جدول",
    tableViewHint: "الأرقام الدقيقة لجميع الحالات الست",
    statusAssigned: "مُسندة",
    statusInProgress: "قيد التنفيذ",
    statusOnHold: "معلّقة",
    statusPending: "قيد الانتظار",
    statusCompleted: "مكتملة",
    statusFinished: "منتهية",
    total: "الإجمالي",
    doneLabel: "منجزة",
    openLabel: "مفتوحة",
    blockedLabel: "متوقفة",
    totalAcrossGovernorates: "جميع المهام في المحافظات التي تحتوي على مهام",
    completedPlusFinished: "مكتملة + منتهية",
    assignedPlusInProgress: "مُسندة + قيد التنفيذ",
    onHoldPlusPending: "معلّقة + قيد الانتظار",
    selectWorkflowToSeeData: "اختر سير عمل لعرض البيانات.",
    workflowPickerHint: "اختر سير العمل من القائمة أعلى الصفحة.",
    noFieldAgentsForWorkflow: "لا يوجد موظفون ميدانيون في سير العمل هذا.",
    noFieldAgentsHint: "قم بإسناد موظف ميداني إلى سير العمل هذا لعرض تغطيته.",
    selectFieldAgentToSeeData: "اختر موظفًا ميدانيًا",
    selectFieldAgentHint: "سيتم تصنيف مهامه حسب المحافظة والحالة.",
    loadingData: "جارٍ التحميل...",
    somethingWentWrong: "تعذّر تحميل بيانات المحافظات.",
    tryAgainHint: "حاول اختيار الموظف الميداني مرة أخرى.",
    noTasksForAgent: "لا توجد مهام لهذا الموظف الميداني",
    noTasksForAgentHint: "لم يتم إسناد أي مهمة له في سير العمل هذا بعد.",
    allStatusesHidden: "جميع الحالات مخفية - اضغط على إحداها بالأسفل لإظهارها.",
    governorateWithNoTask: "محافظة بدون مهام",
    governoratesWithNoTask: "محافظات بدون مهام",
    ViewChart: "عرض المخطط",
    RangeFilter: "مرشح نطاق التاريخ",
    selecrOrg: " يرجى اختيار منظمة",
    Page: "الصفحة",
    FieldId: "رقم تعريف موظف الميدان",
    FieldAgentName: "اسم موظف الميدان",
    Action: "إجراء",
    RemarkReq: "الملاحظات مطلوبة",

    adCustSupport: "إضافة دعم العملاء",
    Clone: "نسخ",
    SpecialRc: "خاص RC",
    InteractiveRc: "تفاعلي RC",
    Viewinstallment: "عرض القسط ",
    createInstallment: "إنشاء خطة تقسيط",
    CustomerId: "معرف العميل",
    NoOfinstallment: "عدد الأقساط",
    advancepayamt: "مبلغ الدفع المقدم",
    advDate: " تاريخ الدفع المقدم",
    custDetail: "تفاصيل العميل",
    instalDetail: "تفاصيل القسط",
    firstInstDate: "تاريخ أول قسط",
    clrPreview: "مسح المعاينة",
    prevPlan: " معاينة الخطة",
    submitRc: "RC إرسال  ",
    AfterAdv: "المستحقات بعد دفع المقدم",
    currentOut: "المستحقات الحالية",

    Amount: "المبلغ ",
    Notes: "الملاحظات ",
    Latitude: "خط العرض  ",
    Longitude: " خط الطول ",
    selectFieldAget: " اختيار الموظف ميداني",
    planId: "رقم الخطة",
    planActive: "الخطة نشطة",
    planCreated: "تم إنشاء الخطة",
    outstaningAmt: "المبلغ المستحق",
    Advamt: "مبلغ المقدم",
    AdvDate: " تاريخ دفع المقدم",
    firstInsDate: "تاريخ أول قسط",
    noOfInst: " عدد الأقساط",
    activeInst: "الأقساط النشطة",
    DetailId: "رمز التفاصيل",
    PaymentId: "رمز الدفع",
    PayAmt: "مبلغ الدفع",
    payDate: "تاريخ الدفع",
    dueDate: "تاريخ الاستحقاق",
    paymentStatusUpdatedAt: "تاريخ تحديث حالة الدفع",
    outstandingForInstalmentPlan: "المبلغ المستحق",
    Status: "الحالة ",
    PayPrev: "معاينة الدفع",
    OutAfteAdv: "المبلغ المستحق بعد دفع المقدم ",
    CurrentOut: "المبلغ المستحق الحالي ",
    NoinstAvlble: "لا توجد أقساط متاحة",
    title: "حلول إدارة المهام من بلوفيلد ",
    userEmail: "اسم المستخدم / عنوان البريد الإلكتروني",
    remember: "تذكرني",
    forgetpass: "نسيت كلمة المرور",
    Login: "تسجيل الدخول ",
    pressEnter: "اضغط إدخال لإضافة أرقام حسابات متعددة",
    typeEnter: "اكتب رقمًا واضغط إدخال",
    protectedAccountLimitReached: "يمكنك إضافة ما يصل إلى {limit} حسابًا لكل طلب.",
    protectedAccountCount: "تمت إضافة {count} من أصل حد أقصى قدره {limit} حسابًا",

    payDetail: "تفاصيل الدفع",
    cretDate: "تاريخ الإنشاء",
    inactiveplane: "خطط التقسيط غير النشطة",
    instplanDetail: "تفاصيل خطة التقسيط",
    loogoutMsg: "هل أنت متأكد أنك تريد تسجيل الخروج؟",
    Logout: " تسجيل الخروج",
    support: "دعم العملاء",
    supportSubtitle: "إدارة طلبات RC وخطط التقسيط وتحديثات الحسابات.",
    interactiveRcTabTooltip: "إرسال طلب RC تفاعلي",
    createInstallmentTabTooltip: "إنشاء خطة تقسيط جديدة لحساب",
    viewInstallmentTabTooltip: "تصفح خطط التقسيط الحالية",
    specialRcTabTooltip: "إرسال طلب RC خاص/استثنائي",
    interactiveRcSubtitle: "إرسال طلب RC تفاعلي.",
    createInstallmentSubtitle: "إعداد خطة تقسيط جديدة لحساب عميل.",
    viewInstallmentSubtitle: "ابحث عن حساب لعرض خطة تقسيطه.",
    specialRcSubtitle: "إرسال طلب RC خاص أو استثنائي.",
    viewInstallmentEmptySub: "ابحث عن رقم حساب أعلاه لعرض خطة تقسيطه.",
    noMatchingCustomerRecord: "لا يوجد سجل عميل مطابق.",
    noInactiveInstallmentPlans: "لا توجد خطط تقسيط غير نشطة.",
    noActiveInstallments: "لا توجد أقساط نشطة.",
    supporttooltip: "نظام الدعم  RC",
    powerbidashboard: "لوحة معلومات PowerBI",
    installment: "خطة التقسيط",
    password: "كلمة المرور",
    downloadPdf: "تحميل PDF",
    noDatavb: "لا تتوفر بيانات",
    noFilteredData: "لا توجد مهام مطابقة للمرشحات المحددة. حاول تعديل المرشحات أو مسحها.",
    viewValidation: "عرض التحقق من الصحة",
    refresh: " تحديث الجدول",
    discard: "إلغاء",
    Confirm: "تأكيد",
    datefilterforchart: "مرشح التاريخ للمهام المكتملة",
    updatetaskdetail: "تحديث تفاصيل المهمة",
    completedTaskCount: "عدد المهام المكتملة  ",
    taskpriority: "أولوية ",
    taskstatus: "حالة المهمة",
    request: "طلب",
    usercount: "أعداد المستخدمين",
    listvbiew: "عرض قائمة المهام",
    addbtn: "يضيف",
    unassignn: "إلغاء التعيين",
    assingTask: "تعيين المهام",
    date: "التاريخ",
    from: "من",
    to: "إلى",
    apply: "تطبيق",
    previous: "السابق",
    next: "التالي",
    profile: "حساب تعريفي",
    uploadSheet: " تحميل الورقة",
    createStore: "إنشاء متجر",
    storeManagement: "إدارة المخازن",
    storeManagementTooltip: "إدارة المخازن ومواقع المخزون",
    selectStoreLocation: "اختر نقطة على الخريطة أو أدخل إحداثياتها أدناه.",
    selectStoreAddress: "اختر نقطة على الخريطة أو ابحث عن عنوان أدناه.",
    storeLocationMethod: "طريقة تحديد الموقع",
    storeAddress: "العنوان",
    storeGovernorate: "المحافظة",
    storeWilayat: "الولاية",
    storeCity: "المدينة / البلدة",
    storeArea: "المنطقة / الحي",
    storeStreet: "اسم الشارع",
    storeBuilding: "اسم / رقم المبنى",
    storeUnit: "الوحدة / الطابق (اختياري)",
    storePostalCode: "الرمز البريدي (اختياري)",
    storeCountry: "البلد",
    storeCoordinates: "الإحداثيات",
    storeAddressPlaceholder: "أدخل عنوانًا في عُمان",
    storeAddressSearchPlaceholder: "ابحث عن مكان",
    omanCountry: "عُمان",
    searchStoreAddress: "ابحث عن عنوان",
    searchingStoreAddress: "جارٍ البحث...",
    storeAddressResults: "نتائج العناوين",
    storeAddressSearchFailed: "تعذّر البحث عن عناوين. حاول مرة أخرى.",
    noOmanAddressesFound: "لم يتم العثور على عناوين مطابقة.",
    storeLatitude: "خط العرض",
    storeLongitude: "خط الطول",
    storeMapView: "عرض الخريطة",
    storeDefaultView: "افتراضي",
    storeSatelliteView: "قمر صناعي",
    storeZoomIn: "تكبير",
    storeZoomOut: "تصغير",
    createStoreDescription: "أنشئ مواقع مخزونك ونظّمها.",
    existingStores: "المتاجر الحالية",
    existingStoresDescription: "ابحث عن تفاصيل المتاجر وصفّها وحدّثها.",
    searchStores: "ابحث عن المتاجر أو المواقع...",
    filterStoresByStatus: "تصفية المتاجر حسب الحالة",
    allStatuses: "كل الحالات",
    storeName: "اسم المتجر",
    storeLocation: "الموقع",
    storeStatus: "الحالة",
    storeAction: "الإجراء",
    storeActive: "نشط",
    storeInactive: "غير نشط",
    updateStore: "تحديث",
    updateStoreTitle: "تحديث المتجر",
    viewStore: "عرض",
    storeDetails: "تفاصيل المتجر",
    storeCreatedSuccess: "تم إنشاء المتجر بنجاح.",
    storeUpdatedSuccess: "تم تحديث المتجر بنجاح.",
    storeDeletedSuccess: "تم حذف المتجر بنجاح.",
    deleteStore: "حذف",
    failedToLoadStores: "فشل تحميل المتاجر.",
    noStoresYet: "لا توجد متاجر حتى الآن.",
    noMatchingStores: "لا توجد متاجر تطابق عوامل التصفية.",
    storesCount: "متاجر",
    storeNameRequired: "اسم المتجر مطلوب.",
    storeNameMaxLength: "يجب ألا يتجاوز اسم المخزن 255 حرفًا.",
    storeNameNote: "ملاحظة: الحد الأقصى 255 حرفًا مسموح به.",
    storeAddressRequired: "يرجى إدخال العنوان أو البحث عن موقع.",
    storeAddressNotFound: "تعذر العثور على إحداثيات هذا العنوان. يرجى تعديل العنوان أو التحديد على الخريطة.",
    storeCoordinatesRequired: "الإحداثيات الصحيحة مطلوبة (خط العرض وخط الطول).",
    autoDetectedCoordinates: "تم تحديد الإحداثيات تلقائيًا",
    detectingCoordinates: "جارٍ تحديد الإحداثيات...",
    fetchingAddressFromMap: "جارٍ جلب العنوان من الخريطة...",
    addressFilledFromMap: "تم ملء العنوان من الخريطة",

    //notification
    notification: "إشعار",
    allnotification: "كل الإخطار",
    //dashbord
    deletDashbord: "حذف لوحة المعلومات",
    workflow: "سير العمل",
    dashboard: "لوحة القيادة",
    userdashboard: "لوحة تحكم المستخدم",
    activitydashboard: "لوحة معلومات النشاط",
    admin: "مسؤول ",
    supervisor: "مشرف",
    office_user: "مستخدمي المكتب",
    field_agent: "موظفين الميدان",
    dashboardName: "اسم لوحة المعلومات",
    dashboardManagement: "إدارة لوحة المعلومات",
    addnewDashboard: "إضافة لوحة تحكم جديدة",
    chartMessage: "حدد لوحة المعلومات لعرض المخططات",
    noChartsTitle: "لا توجد مخططات بعد",
    noChartsSubtitle: "أضف أول مخطط للبدء في عرض بيانات لوحة المعلومات هذه.",
    addChartCardSubtitle: "أضف مخططًا آخر إلى لوحة المعلومات هذه",

    dashboardtolltip:
      "لوحة المعلومات، عرض وإدارة نظرة عامة على لوحة المعلومات الخاصة بك",
    usertooltip: "المستخدمون، إدارة حسابات المستخدمين والأدوار",
    asset: "إدارة الأصول",
    assettooltip: "الأصول وعرض وإدارة الأصول الخاصة بك",
    config: "قواعد التعيين",
    configtooltip:
      "التكوين وإدارة قواعد التعيين والقواعد المخصصة وقواعد الإكمال",
    task: "إدارة المهام",
    tasktooltip: "إدارة المهام، إدارة المهام والواجبات الخاصة بك، والحذف",
    acchistory: "سجل الحساب",
    accReportsCenter: "مركز الحسابات والتقارير",
    historytooltip: "سجل الحساب، عرض تاريخ المهام المكتملة",
    accReportsCentertooltip:
      "مركز الحسابات والتقارير، عرض سجل الحساب وتصدير التقارير",
    callCenter: "مركز الاتصال",
    callCentertooltip:
      "مركز الاتصال، إدارة البريد الوارد والتذاكر والحملات ومساحة عمل الوكيل",
    workflowe: "سير العمل",
    workflowtooltip: "سير العمل، إدارة سير العمل الخاص بك، المبادئ التوجيهية",
    workflowManagementSubtitle: "إنشاء وإدارة قوالب سير العمل المستخدمة لتكوين نماذج المهام.",
    workflows: "سير العمل",
    searchWorkflow: "ابحث باسم سير العمل...",
    sortBy: "فرز",
    sortNameAsc: "الاسم (أ-ي)",
    sortNameDesc: "الاسم (ي-أ)",
    sortUpdatedNewest: "آخر تحديث (الأحدث)",
    sortUpdatedOldest: "آخر تحديث (الأقدم)",
    noWorkflowsMatchSearch: "لا توجد سير عمل مطابقة لبحثك",
    workflowSettings: "إعدادات سير العمل",
    secondsUnit: "ث",
    pageWiseOff: "غير مقسم بصفحات",
    timerLabel: "المؤقت",
    addPage: "إضافة صفحة",
    duplicatePage: "تكرار الصفحة",
    deletePage: "حذف الصفحة",
    versionHistory: "سجل الإصدارات",
    confirmDeletePageText: "سيتم حذف هذه الصفحة وجميع حقولها نهائيًا. لا يمكن التراجع عن هذا الإجراء.",
    workflowNeedsAtLeastOnePage: "يجب أن يحتوي سير العمل على صفحة واحدة على الأقل",
    pageAdded: "تمت إضافة الصفحة",
    pageDuplicated: "تم تكرار الصفحة",
    pageDeleted: "تم حذف الصفحة",
    moveToPage: "نقل إلى الصفحة",
    fieldMoved: "تم نقل الحقل",
    worklog: "سجل العمل",
    worklogtooltip:
      "سجل العمل، عرض وإدارة سجلات العمل الخاصة بك، تصدير تقرير Excel، تصدير PDF",
    worklogSubtitle: "جدولة تقرير بريد إلكتروني متكرر أو تصدير سجل العمل بصيغة PDF.",

    security: "حماية",
    securitytooltip: "الأمان، إدارة إعدادات الأمان",
    report: "التقارير",
    reportooltip: "التقارير، طلب التقرير، التحقق من حالة التقارير",
    reportsSubtitle: "اطلب تقارير منظمتك وتتبعها وقم بتنزيلها.",
    dateRange: "النطاق الزمني",
    dateRangeTooltip: "تصفية التقارير حسب النطاق الزمني",
    reportTypeTooltip: "تصفية التقارير حسب نوع التقرير",
    userTypeTooltip: "تصفية التقارير حسب نوع المستخدم",
    statusTooltip: "تصفية التقارير حسب الحالة",
    roleManagement: "إدارة الأدوار",
    roleManagementSubtitle: "إنشاء وإدارة الأدوار بصلاحيات مخصصة لمؤسستك.",
    roleManagementtooltip: "إدارة الأدوار والصلاحيات",
    createRole: "إنشاء دور",
    updateRole: "تحديث الدور",
    deleteRole: "حذف الدور",
    roleName: "اسم الدور",
    confirmDeleteRole: "هل أنت متأكد أنك تريد حذف هذا الدور؟",
    noRolesFound: "لا توجد أدوار",
    permissions: "الصلاحيات",
    permissionModalSubtitle: "اختر ما يمكن لهذا الدور عرضه أو إنشاؤه أو تحديثه أو حذفه.",
    granted: "ممنوحة",
    changesApplyOnceSaved: "يتم تطبيق التغييرات بمجرد الحفظ.",
    noScreensAvailable: "لا توجد شاشات متاحة",
    permGroupAccess: "الوصول والأدوار",
    permGroupOperations: "العمليات",
    permGroupAssets: "الأصول",
    permGroupInsights: "الرؤى",
    permGroupSystem: "النظام والحساب",
    permGroupOther: "أخرى",
    org: "منظمة",
    organizationPageTitle: "المؤسسة",
    recordName: "الاسم",
    recordType: "النوع",
    logo: "الشعار",
    orgHierarchyHint: "وسّع المنظمة لعرض الأقسام والمشاريع .",
    organizationPageHierarchyHint: "قم بتوسيع المؤسسة لعرض أقسامها ومشاريعها.",
    organizationPageSearchPlaceholder: "بحث المؤسسة",
    orgtooltip: "التنظيم، إدارة المنظمة",
    deleteOrganizationTitle: "حذف المنظمة؟",
    deleteOrganizationCascadeMessage:
      "هل أنت متأكد أنك تريد حذف هذه المنظمة؟ سيتم أيضًا إزالة جميع البيانات التابعة المرتبطة بها.",
    stock: "إدارة المخزون",
    stocktoooltip: "إدارة المخزون، تحديث تفاصيل المخزون، تنزيل التقرير",
    inventoryManagement: "انویٹری مینجمنٹ",
    inventoryManagementTooltip:
      "انویٹری مینجمنٹ، میٹر انویٹری، منتقلیاں اور اسائنمنٹس منظم کریں",
    meterInventoryTitle: "میٹر انویٹری",
    meterInventorySubtitle:
      "میٹر انویٹری، اسٹور مقامات، منتقلیاں اور گروپ اسائنمنٹس منظم کریں۔",
    inventoryManagement: "إدارة المخزون",
    inventoryManagementTooltip:
      "إدارة المخزون، إدارة مخزون العدادات والتحويلات والتعيينات",
    meterInventoryTitle: "مخزون العدادات",
    meterInventorySubtitle:
      "إدارة مخزون العدادات ومواقع التخزين والتحويلات وتعيين المجموعات.",
    inventoryMeterHistoryTitle: "سجل العداد والتتبع",
    inventoryMeterHistorySubtitle: "السجل الكامل لدورة حياة {identifier}",
    inventoryDetailsTitle: "تفاصيل المخزون",
    inventoryDetailsSection: "التفاصيل",
    inventoryViewHistory: "عرض السجل →",
    inventoryEditItem: "تعديل التفاصيل",
    inventoryEditStatus: "الحالة",
    inventoryEditStore: "المخزن",
    inventoryEditGroup: "المجموعة",
    inventoryEditSelectGroup: "اختر مجموعة",
    inventoryEditSave: "حفظ التغييرات",
    inventoryEditSuccess: "تم تحديث عنصر المخزون بنجاح.",
    inventoryBackToDetails: "العودة إلى التفاصيل",
    inventoryMovementTimeline: "التحركات والأحداث",
    inventoryUpdated: "تم التحديث",
    inventoryBy: "بواسطة",
    inventoryNote: "ملاحظة",
    inventoryIdentifier: "المعرّف",
    inventoryItemType: "نوع العنصر",
    inventoryColItemType: "نوع العنصر",
    inventoryColIdentifier: "المعرّف",
    inventoryColStatus: "الحالة",
    inventoryColComponents: "المكونات",
    inventoryColGroupAssignment: "تعيين المجموعة",
    inventoryColConditionNote: "ملاحظة الحالة",
    inventoryColCreatedBy: "أنشئ بواسطة",
    inventoryColCreatedAt: "تاريخ الإنشاء",
    inventoryColUpdatedBy: "حُدّث بواسطة",
    inventoryColUpdatedAt: "تاريخ التحديث",
    inventoryColStore: "المخزن",
    inventoryColSource: "المصدر",
    inventoryColLocation: "الموقع",
    inventoryColLatitude: "خط العرض",
    inventoryColLongitude: "خط الطول",
    inventoryColTransferFrom: "نُقل من",
    inventoryColTransferTo: "نُقل إلى",
    inventoryTypeNewMeter: "عداد جديد",
    inventoryTypeOldMeter: "عداد قديم",
    inventoryTypeModem: "مودم",
    inventoryTypeSimCard: "شريحة SIM",
    inventoryTypeSeal: "ختم",
    inventorySealPrefix: "بادئة الختم",
    inventorySealFrom: "الختم من",
    inventorySealTo: "الختم إلى",
    inventorySealPrefixPlaceholder: "مثال: SL",
    inventorySealFromPlaceholder: "مثال: 1001",
    inventorySealToPlaceholder: "مثال: 2000",
    inventorySealRangeRequired: "أدخل رقمي بداية ونهاية الأختام.",
    inventorySealRangeInvalid: "يجب أن يكون رقما البداية والنهاية أعداداً صحيحة، ولا يمكن أن تكون النهاية أقل من البداية.",
    inventorySealRangePreview: "سيتم إنشاء {first} – {last} ({count} ختم)",
    inventorySealRange: "نطاق الأختام",
    inventorySealCount: "عدد الأختام",
    inventorySealNumbers: "أرقام الأختام",
    inventorySealsFitted: "الأختام المركبة",
    inventorySealRangeHistoryTitle: "سجل نطاق الأختام والتتبع",
    inventorySealTotal: "إجمالي الأختام",
    inventorySealFittedCount: "المركبة",
    inventorySealRemaining: "المتبقية",
    inventorySealRemainingOfTotal: "متبقٍ {available} من {total}",
    inventorySealNoneFitted: "لم يتم تركيب أي ختم بعد",
    inventorySealColSeal: "الختم",
    inventorySealColMeter: "العداد",
    inventorySealColFittedBy: "ركّبه",
    inventorySealColDate: "التاريخ",
    inventoryHistorySealUsedEvent: "تم تركيب الختم {seal}",
    inventorySealOpenMeterHistory: "فتح سجل هذا العداد",
    inventorySealBackToRange: "العودة إلى نطاق الأختام",
    inventorySealNumbersInfoTitle: "الأختام المركبة على هذا العداد",
    inventorySealNumbersInfo: "تم تركيب أرقام الأختام هذه على العداد عند تركيبه من خلال مهمة ميدانية.",
    inventorySealNumbersCellTooltip: "{count} ختم مركب على هذا العداد المركّب",
    inventorySealRangeFittedInfoTitle: "الأختام المستخدمة من هذا النطاق",
    inventorySealRangeFittedInfo: "أختام من هذا النطاق تم تركيبها بالفعل على عدادات مركبة، ولم تعد متاحة.",
    inventoryImportSealColumns: "تحتاج ملفات الأختام إلى عمودي From وTo، وعمود Prefix اختياري (تعمل أيضاً Seal From / Seal To / Seal Prefix). لا حاجة لعمود الرقم التسلسلي.",
    inventoryImportSealColumnsFound: "تم اكتشاف: {found}",
    inventoryImportSealColumnsMissing: "غير موجود بعد: {missing} (يمكنك اختيارها في ربط الأعمدة)",
    inventoryImportDownloadSealTemplate: "تنزيل نموذج الأختام",
    inventoryStatus: "الحالة",
    inventoryStoreId: "معرّف المتجر",
    inventoryAssignedToId: "مُسند إلى (معرّف المستخدم)",
    inventoryGroupAssignment: "تعيين المجموعة",
    inventoryAction: "الإجراء",
    rowsPerPage: "الصفوف لكل صفحة",
    inventoryApply: "تطبيق",
    inventorySelectAll: "تحديد الكل",
    inventorySelectNone: "إلغاء التحديد",
    inventoryFilterSearchValues: "ابحث في القيم...",
    inventoryFilterNoValues: "لا توجد قيم",
    inventoryFilterOk: "موافق",
    inventoryFilterLoadingValues: "جارٍ تحميل القيم...",
    inventoryFilterBlanks: "(فارغ)",
    inventoryFilterContainsPlaceholder: "يحتوي على...",
    inventoryFilterContainsHelp: "مطابقة بدون حساسية لحالة الأحرف.",
    inventoryRowNumber: "الرقم",
    inventoryStoreLocation: "الموقع",
    inventoryMeterNumber: "رقم العداد",
    inventoryMeterType: "نوع العداد",
    inventoryGroup: "المجموعة",
    inventoryAssignment: "التعيين",
    inventorySimNo: "رقم الشريحة",
    inventoryModemNo: "رقم المودم",
    inventoryInstallationDate: "تاريخ التركيب",
    inventoryCreatedAt: "تاريخ الإنشاء",
    inventoryComponentType: "نوع المكوّن",
    inventoryComponentId: "معرّف المكوّن",
    inventoryCurrentLocation: "الموقع الحالي",
    inventoryAssignedGroup: "المجموعة المعيّنة",
    inventoryGroupMembers: "أعضاء المجموعة",
    inventoryCurrentAssignment: "التعيين الحالي",
    inventoryMeterBarcode: "باركود العداد",
    inventoryMeterSerialNumber: "الرقم التسلسلي للعداد",
    inventoryMeterMake: "شركة العداد",
    inventoryManufacturingYear: "سنة التصنيع",
    inventoryBatchNumber: "رقم الدفعة",
    inventoryActivationDate: "تاريخ التفعيل",
    inventoryReplacementSection: "الاستبدال والمكوّنات المرتبطة",
    inventoryComponents: "المكوّنات",
    inventoryApn: "APN",
    inventoryIpAddress: "عنوان IP",
    inventoryInstallationStatus: "حالة التركيب",
    inventoryTransferredFrom: "تم النقل من",
    inventoryTransferredTo: "تم النقل إلى",
    inventoryConditionNote: "ملاحظة الحالة",
    inventorySource: "المصدر",
    inventoryUploadId: "معرّف الرفع",
    inventoryCreatedBy: "أُنشئ بواسطة",
    inventoryUpdatedAt: "تاريخ التحديث",
    inventoryBalance: "الرصيد",
    inventoryOrganizationId: "معرّف المؤسسة",
    inventoryProjectId: "معرّف المشروع",
    inventoryOp: "OP",
    inventorySimDetailUpdatedAt: "تاريخ تحديث الشريحة",
    inventoryDeleted: "محذوف",
    inventoryDeletedAt: "تاريخ الحذف",
    inventoryDeletedBy: "تم الحذف بواسطة",
    inventoryDeleteReason: "سبب الحذف",
    inventoryValueNewMeter: "عداد جديد",
    inventoryValueOldMeter: "عداد قديم",
    inventoryValueModem: "مودم",
    inventoryValueSimCard: "شريحة SIM",
    inventoryValueSmartMeter: "عداد ذكي",
    inventoryStatusAvailable: "متاح",
    inventoryStatusTipAvailable: "متاح في المخزون وجاهز للتعيين.",
    inventoryStatusAssigned: "مُعيّن",
    inventoryStatusTipAssigned: "تم تعيينه لمقاول فرعي.",
    inventoryStatusReassigned: "أُعيد تعيينه",
    inventoryStatusTipReassigned: "أُعيد تعيينه لنفس المقاول الفرعي أو لمقاول آخر.",
    inventoryStatusActive: "نشط",
    inventoryStatusInTransit: "قيد النقل",
    inventoryStatusTipInTransit: "قيد النقل بين المواقع أو المقاولين الفرعيين.",
    inventoryStatusInstalled: "مركّب",
    inventoryStatusTipInstalled: "مُركّب في موقع العميل.",
    inventoryStatusRemoved: "مُزال",
    inventoryStatusTipRemoved: "تمت إزالته من موقع العميل.",
    inventoryStatusReturned: "مُعاد",
    inventoryStatusTipReturned: "أُعيد إلى المخزن.",
    inventoryStatusDamaged: "تالف",
    inventoryStatusTipDamaged: "تالف وغير صالح للاستخدام.",
    inventoryStatusQuarantined: "محجور",
    inventoryStatusTipQuarantined: "مُبعد حتى يتم فحصه.",
    inventoryStatusLost: "مفقود",
    inventoryStatusTipLost: "مفقود. لا يمكن تعيينه أو نقله.",
    inventoryStatusRetired: "متقاعد",
    inventoryStatusTipRetired: "مسحوب من الاستخدام. لا يمكن تعيينه أو نقله.",
    inventoryAssigned: "مُعيّن",
    inventoryAvailable: "متاح",
    inventoryViewDetailsAria: "عرض تفاصيل المخزون",
    inventoryViewHistoryAria: "عرض سجل المخزون",
    inventoryClosePanel: "إغلاق لوحة المخزون",
    noHistoryFound: "لا يوجد سجل بعد.",
    inventoryHistoryFilterAll: "الكل",
    inventoryHistoryFilterTransactions: "المعاملات",
    inventoryHistoryFilterAuditLog: "سجل التدقيق",
    inventoryHistoryEventsCount: "{count} حدث",
    inventoryHistoryNoEventsForFilter: "لا توجد أحداث لهذا الفلتر.",
    inventoryHistoryLoadFailed: "فشل تحميل سجل المخزون.",
    inventoryHistoryRecordCreated: "تم إنشاء السجل",
    inventoryHistoryReceivedEvent: "استُلم في المخزون",
    inventoryHistoryAuditEvent: "حدث تدقيق",
    inventoryHistoryTagAccount: "الحساب",
    inventoryHistoryTagTask: "المهمة",
    inventoryHistoryTagReplacement: "معرّف الاستبدال",
    inventoryHistoryTagReference: "مرجع",
    inventoryHistoryUnknownUser: "المستخدم #{id}",
    inventoryImportTitle: "استيراد مخزون العدادات",
    inventoryImportSubtitle:
      "ارفع ملف Excel أو CSV لإنشاء مخزون العدادات أو تحديثه.",
    inventoryImportTabNew: "استيراد جديد",
    inventoryImportTabHistory: "سجل الرفع",
    inventoryImportProgressAria: "تقدم استيراد المخزون",
    inventoryImportStepUpload: "رفع الملف",
    inventoryImportStepDestination: "الوجهة",
    inventoryImportStepReview: "التحقق والاستيراد",
    inventoryImportUploadDesc: "اختر الملف الذي يحتوي على صفوف المخزون.",
    inventoryImportDropTitle: "اسحب وأفلت ملف Excel أو CSV",
    inventoryImportDropHint: "أو انقر للاختيار (.xlsx أو .xls أو .csv)",
    inventoryImportChooseAnother: "انقر لاختيار ملف آخر",
    inventoryImportInvalidType: "يمكن استيراد ملفات .xlsx و .xls و .csv فقط.",
    inventoryImportDestinationDesc: "حدد وجهة الصفوف وطريقة تطبيقها.",
    inventoryImportSelectStore: "المخزن",
    inventoryImportSelectStorePlaceholder: "اختر مخزنًا",
    inventoryImportStoresEmpty: "لا توجد مخازن متاحة لهذا المشروع.",
    inventoryImportStoreLoadFailed: "تعذر تحميل المخازن.",
    inventoryImportItemType: "نوع العنصر",
    inventoryImportItemTypePlaceholder: "اختر نوع العنصر",
    inventoryImportMode: "وضع الاستيراد",
    inventoryImportModeCreate: "إنشاء جديد أو تحديث الموجود",
    inventoryImportModeCreateHint: "يتم إنشاء الصفوف الجديدة وتحديث الصفوف المطابقة.",
    inventoryImportModeUpdate: "تحديث الموجود فقط",
    inventoryImportModeUpdateHint: "يتم تحديث الصفوف الموجودة فقط دون إضافة أي صف جديد.",
    inventoryImportSelectFileFirst: "اختر ملفًا للمتابعة.",
    inventoryImportSelectStoreFirst: "اختر مخزنًا للمتابعة.",
    inventoryImportValidating: "جارٍ التحقق من الملف...",
    inventoryImportValidationDesc: "تم فحص جميع الصفوف. لم يتم حفظ أي شيء بعد.",
    inventoryImportValidationPassed: "نجح التحقق",
    inventoryImportValidationFailed: "تم العثور على مشكلات في التحقق",
    inventoryImportValidationError: "تعذر التحقق من الملف.",
    inventoryImportRevalidate: "إعادة التحقق",
    inventoryImportSummary: "الملخص",
    inventoryImportTotalRows: "إجمالي الصفوف",
    inventoryImportValidRows: "الصفوف الصالحة",
    inventoryImportInvalidRows: "الصفوف غير الصالحة",
    inventoryImportCreatedRows: "تم الإنشاء",
    inventoryImportUpdatedRows: "تم التحديث",
    inventoryImportSkippedRows: "تم التخطي",
    inventoryImportErrorsTitle: "مشكلات الصفوف",
    inventoryImportRow: "الصف",
    inventoryImportMoreIssues: "{count} مشكلة إضافية غير معروضة.",
    inventoryImportConfirm: "استيراد",
    inventoryImportUploading: "جارٍ الاستيراد...",
    inventoryImportSuccess: "تم استيراد ملف المخزون بنجاح.",
    inventoryImportFailed: "فشل استيراد المخزون.",
    inventoryImportHistoryEmpty: "لا توجد عمليات رفع بعد.",
    inventoryImportHistoryFile: "الملف",
    inventoryImportHistoryStore: "المخزن",
    inventoryImportHistoryMode: "الوضع",
    inventoryImportHistoryStatus: "الحالة",
    inventoryImportHistoryTotal: "الإجمالي",
    inventoryImportHistorySuccess: "ناجح",
    inventoryImportHistoryFailed: "فاشل",
    inventoryImportHistoryUploadedBy: "تم الرفع بواسطة",
    inventoryImportHistoryUploadedAt: "تاريخ الرفع",
    inventoryImportHistoryLoadFailed: "تعذر تحميل سجل الرفع.",
    inventoryImportRunning: "جارٍ تنفيذ الاستيراد في الخلفية...",
    inventoryImportValidationRunning: "جارٍ تنفيذ التحقق في الخلفية...",
    inventoryImportBackgroundNote:
      "يمكنك متابعة عملك — تستمر هذه العملية في الخلفية وتبقى في سجل الرفع.",
    inventoryImportStatusLabel: "الحالة",
    inventoryImportStatusQueued: "في قائمة الانتظار",
    inventoryImportStatusInProgress: "قيد التنفيذ",
    inventoryImportStatusCompleted: "مكتمل",
    inventoryImportStatusFailedLabel: "فشل",
    inventoryImportPollFailed: "تعذرت قراءة حالة الرفع.",
    inventoryImportUploadIdLabel: "الرفع",
    inventoryImportRejectedTitle: "صفوف لم يتم رفعها",
    inventoryImportRejectedTruncated: "يتم عرض أول {count} صف مرفوض.",
    inventoryImportLoadAllRejected: "تحميل جميع الصفوف المرفوضة",
    inventoryImportDownloadFailureLog: "تنزيل سجل الأخطاء",
    inventoryImportDownloadNotUploaded: "تنزيل الصفوف غير المرفوعة (Excel)",
    inventoryImportNotUploadedExportEmpty: "لا توجد صفوف مرفوضة لتنزيلها.",
    inventoryImportNotUploadedExportPartial: "تم تنزيل الصفوف المحمّلة بالفعل فقط.",
    inventoryImportNotUploadedExportFailed: "تعذر تنزيل الصفوف المرفوضة.",
    inventoryImportReason: "السبب",
    inventoryImportNotUploadedCount: "لم يتم رفعها",
    inventoryImportShowValidationRuns: "إظهار عمليات التحقق",
    inventoryImportShowValidationRunsInfo:
      "عملية التحقق هي فحص تجريبي يجريه معالج الرفع أولاً: يوضح ما سيتم إنشاؤه أو تحديثه أو رفضه دون حفظ أي بيانات.",
    inventoryImportUploadSheet: "رفع ملف",
    inventoryNoAccessTooltip: "ليس لديك صلاحية لهذا الإجراء",
    inventoryNoCreateAccessTooltip: "ليس لديك صلاحية الإنشاء في المخزون",
    inventoryNoUpdateAccessTooltip: "ليس لديك صلاحية التحديث في المخزون",
    inventoryImportTooltip: "ارفع ملفًا لإنشاء المخزون أو تحديثه",
    inventoryTransferTooltip: "نقل العناصر المحددة إلى مخزن أو مجموعة",
    inventoryAddTooltip: "إضافة مخزون يدويًا أو بشكل جماعي",
    inventoryCreateStoreTooltip: "إنشاء مخزن جديد",
    inventorySuperAdminOnlyTooltip: "يمكن للمشرف العام فقط إنشاء مخزن",
    inventoryFiltersTooltip: "إظهار أو إخفاء مرشحات الأعمدة",
    inventoryResetTooltip: "مسح جميع المرشحات المطبقة",
    inventoryImportHistoryHeading: "سجل الرفع",
    inventoryImportHistorySubtitle: "كل ملف تم رفعه إلى مخزون العدادات، الأحدث أولًا.",
    inventoryExport: "تصدير",
    inventoryExportTooltip: "تصدير جميع عناصر المخزون إلى Excel",
    inventoryExportFilteredTooltip: "تصدير العناصر المصفاة حسب: {columns}",
    inventoryExportStarted: "بدأ تصدير المخزون.",
    inventoryExportStartFailed: "تعذر بدء تصدير المخزون.",
    inventoryExportHistoryLoadFailed: "تعذر تحميل سجل التصدير.",
    inventoryExportHistoryEmpty: "لا توجد عمليات تصدير بعد",
    inventoryExportNoRecordsTooltip: "لم تتطابق أي عناصر مخزون مع الفلاتر المحددة، لذلك لا توجد بيانات للتصدير.",
    inventoryExportPreparing: "جارٍ التحضير…",
    inventoryExportProgress: "{completed} / {total} عنصر، المتبقي {remaining}",
    inventoryExportRetry: "إعادة المحاولة",
    inventoryExportRetryTooltip: "إعادة بدء هذا التصدير بنفس المشروع والمرشحات",
    inventoryExportRetrying: "جارٍ إعادة بدء التصدير…",
    inventoryExportView: "عرض التصدير",
    inventoryExportTitle: "تصدير المخزون",
    inventoryExportDescription: "يقوم هذا التقرير بتصدير المخزون للمشروع (المشاريع) المحدد.",
    inventoryDashboard: "لوحة تحكم المخزون",
    inventoryDashboardSubtitle: "حالة كل عنصر في المخزون، وما تحتفظ به كل مجموعة.",
    inventoryDashboardStatusTitle: "العناصر حسب الحالة",
    inventoryDashboardTotal: "إجمالي العناصر",
    inventoryDashboardGroupTitle: "العناصر المخصصة للمجموعات",
    inventoryDashboardGroupSubtitle: "إجمالي العناصر المخصصة لكل مجموعة، موزعة حسب الحالة.",
    inventoryDashboardGroup: "المجموعة",
    inventoryDashboardGroupTotal: "إجمالي المخصص",
    inventoryDashboardBreakdown: "التوزيع",
    inventoryDashboardNoGroups: "لم يتم تخصيص أي عناصر لمجموعة بعد.",
    inventoryDashboardLoadFailed: "تعذر تحميل لوحة تحكم المخزون.",
    inventoryDashboardAllItemTypes: "جميع أنواع العناصر",
    inventoryDashboardSelectOrganization: "اختر مؤسسة من الشريط العلوي لعرض مخزونها.",
    inventoryDashboardOther: "حالات أخرى",
    inventoryDashboardGroups: "المجموعات",
    inventoryDashboardItems: "عنصر",
    inventoryDashboardNoItems: "لا توجد عناصر في المخزون بعد.",
    inventoryDashboardDonutHint: "كل شريحة تمثل نسبة الحالة من جميع العناصر",
    inventoryDashboardStatusBarHint: "طول الشريط يمثل عدد العناصر",
    inventoryDashboardGroupBarHint: "طول الشريط يمثل عدد عناصر المجموعة",
    inventoryDashboardTableHint: "الأرقام الدقيقة لكل مجموعة",
    inventoryDashboardShowAllGroups: "عرض جميع المجموعات ({count})",
    inventoryDashboardShowTopGroups: "عرض أعلى {count} مجموعات",
    inventoryDashboardStoreTitle: "العناصر حسب المستودع",
    inventoryDashboardStoreSubtitle: "العناصر الموجودة في كل مستودع، موزعة حسب الحالة.",
    inventoryDashboardStores: "المستودعات",
    inventoryDashboardItemsInStores: "العناصر في المستودعات",
    inventoryDashboardNeedsAttention: "تالف / معزول / مفقود",
    inventoryDashboardNoStores: "لم يتم العثور على مستودعات لهذا الاختيار.",
    inventoryDashboardStoreInactive: "غير نشط",
    inventoryDashboardIncoming: "وارد قيد النقل",
    inventoryDashboardOutgoing: "صادر قيد النقل",
    inventoryDashboardItemsWithoutStore: "{count} عنصر غير موجود في أي مستودع.",
    inventoryDashboardStoreBarHint: "طول الشريط يمثل عدد عناصر المستودع",
    inventoryDashboardStoreTableHint: "الأرقام الدقيقة لكل مستودع",
    inventoryDashboardShowAllStores: "عرض جميع المستودعات ({count})",
    inventoryDashboardShowTopStores: "عرض أعلى {count} مستودعات",
    inventoryExportRecent: "عمليات التصدير الأخيرة",
    inventoryExportNote: "يتم إنشاء ملفات التصدير في الخلفية. يظهر الملف هنا عندما يصبح جاهزًا، وستصلك أيضًا إشعار.",
    inventoryImportValidationRunBadge: "تحقق فقط",
    inventoryImportFailedRows: "فشل",
    inventoryAddTitle: "إضافة مخزون",
    inventoryAddSubtitle: "أنشئ عنصر مخزون واحدًا يدويًا أو أضف عدة عناصر دفعة واحدة.",
    inventoryAddTabManual: "إدخال يدوي",
    inventoryAddTabBulk: "إدخال جماعي",
    inventoryAddTabImport: "رفع ملف Excel",
    inventoryUpdateActionLabel: "عندما يكون العداد موجوداً بالفعل",
    inventoryUpdateActionHint:
      "تحديث البيانات لم يعد ينقل المخزون — اختر خيار الإرجاع لتغيير العهدة.",
    inventoryUpdateActionDetails: "تحديث بيانات العداد الحالي",
    inventoryUpdateActionDetailsHint:
      "حدّث بيانات العداد مع إبقاء مخزنه وحائزه الحاليين دون تغيير.",
    inventoryUpdateActionReturn: "إرجاع العداد الحالي إلى المخزن المحدد",
    inventoryUpdateActionReturnHint:
      "أعد العداد إلى المخزن المحدد. لا يمكن إرجاع العدادات المفقودة أو المسحوبة.",
    inventoryGroupDisabledReturnTooltip: "تعيين المجموعة غير متاح عند إرجاع العداد إلى المخزن.",
    inventoryUploadFieldModemSerial: "الرقم التسلسلي للمودم",
    inventoryUploadFieldSimSerial: "الرقم التسلسلي لشريحة SIM",
    inventoryImportNoHeaders: "لا يحتوي الملف على صف عناوين للربط. أضف أسماء الأعمدة في الصف الأول.",
    inventoryImportHeadersReadFailed: "تعذرت قراءة الملف. تحقق من الملف وحاول مرة أخرى.",
    inventoryImportColumnsFound: "أعمدة",
    inventoryImportMapTitle: "ربط أعمدة الملف",
    inventoryImportUnmappedCount: "{count} عمود/أعمدة غير مربوطة",
    inventoryImportMainColumns: "الأعمدة الرئيسية للربط",
    inventoryImportMapHint: "ستقوم بربط أعمدة الملف بهذه الحقول في الخطوة التالية.",
    inventoryImportMapAndImport: "ربط الأعمدة والاستيراد",
    inventoryImportSerialDetected: "تم اكتشافه تلقائياً من العمود \"{header}\" — لا حاجة للربط.",
    inventoryImportSerialNotFound: "لم يتم العثور على عمود رقم تسلسلي معروف في هذا الملف — اربطه في الخطوة التالية.",
    inventoryImportSerialAccepted: "العناوين المعروفة: {names}",
    inventoryImportMapConflict: "العمودان '{a}' و'{b}' مربوطان بنفس الحقل '{target}'. اربط واحداً منهما فقط.",
    inventoryImportKeepColumnName: "الإبقاء باسم \"{header}\"",
    inventoryImportColumnsMappedCount: "{mapped} من {total} مربوطة بحقول المخزون",
    inventoryImportOtherColumnsHint:
      "جميع الأعمدة الأخرى في ملفك مدرجة أدناه. اختر حقل المخزون الذي يملؤه كل عمود، أو أبقه باسمه.",
    inventoryImportExcelColumn: "عمود Excel",
    inventoryImportInventoryField: "حقل المخزون",
    inventoryAddSectionDestination: "الوجهة والوضع",
    inventoryAddSectionDetails: "تفاصيل العنصر",
    inventoryAddSectionMetadata: "تفاصيل إضافية",
    inventoryAddSectionItems: "العناصر",
    inventoryAddIdentifierPlaceholder: "مثال: MTR-000123",
    inventoryAddStatus: "الحالة",
    inventoryAddMode: "وضع الحفظ",
    inventoryAddModeCreateOnly: "إنشاء فقط",
    inventoryAddModeCreateOnlyHint: "يفشل إذا كان المعرّف موجودًا بالفعل.",
    inventoryAddModeUpdateOnly: "تحديث فقط",
    inventoryAddModeUpdateOnlyHint: "يتم تحديث المعرّفات الموجودة فقط.",
    inventoryAddModeCreateOrUpdate: "إنشاء أو تحديث",
    inventoryAddModeCreateOrUpdateHint: "ينشئ المعرّفات الجديدة ويحدّث الموجودة.",
    inventoryAddGroupAssignment: "تعيين المجموعة",
    inventoryAddConditionNote: "ملاحظة الحالة",
    inventoryAddNote: "ملاحظة",
    inventoryAddMeterMake: "ماركة العداد",
    inventoryAddMeterType: "نوع العداد",
    inventoryAddComponents: "المكونات",
    inventoryAddManufacturingYear: "سنة التصنيع",
    inventoryAddSelectYear: "اختر السنة",
    inventoryAddBatchNo: "رقم الدفعة",
    inventoryAddOrganizationName: "المؤسسة",
    inventoryAddSimNo: "رقم الشريحة",
    inventoryAddIccid: "رقم تعريف الشريحة (ICCID)",
    inventoryAddModemMake: "ماركة المودم",
    inventoryAddBulkHint:
      "يستخدم كل صف المخزن ونوع العنصر والوضع المحدد أعلاه ما لم يتم تجاوزه في الصف.",
    inventoryAddAddRow: "إضافة صف",
    inventoryAddRemoveRow: "حذف الصف",
    inventoryAddRowLabel: "الصف",
    inventoryAddIdentifierRequired: "رقم العداد مطلوب.",
    inventoryAddStoreRequired: "اختر مخزنًا.",
    inventoryAddItemsRequired: "أضف عنصرًا واحدًا على الأقل مع معرّف.",
    inventoryAddDuplicateIdentifier: "معرّفات مكررة في هذه الدفعة: {values}",
    inventoryAddSuccess: "تم حفظ عنصر المخزون.",
    inventoryAddBulkSuccess: "تم حفظ عناصر المخزون.",
    inventoryAddFailed: "تعذر حفظ المخزون.",
    inventoryAddSave: "حفظ",
    inventoryAddSaving: "جارٍ الحفظ...",
    inventoryAddResultsTitle: "النتائج",
    inventoryTransferTitle: "نقل المخزون",
    inventoryTransferSubtitle:
      "انقل عناصر المخزون المحددة إلى مخزن آخر أو سلّمها إلى مجموعة مقاول من الباطن.",
    inventoryTransferSelectedCount: "تم تحديد {count} عنصر",
    inventoryTransferNoSelection: "حدد عنصر مخزون واحدًا على الأقل للنقل.",
    inventoryTransferSelectedItems: "العناصر المحددة",
    inventoryTransferTargetTitle: "النقل إلى",
    inventoryTransferTargetStore: "مخزن آخر",
    inventoryTransferTargetStoreHint: "نقل العناصر إلى موقع مخزن مختلف.",
    inventoryTransferTargetGroup: "مقاول من الباطن (مجموعة)",
    inventoryTransferTargetGroupHint:
      "سلّم العناصر إلى مجموعة ميدانية؛ يتم عرض أعضائها للاطلاع فقط.",
    inventoryTransferSearchGroup: "ابحث عن مجموعة أو عضو...",
    inventoryTransferNoGroups: "لا توجد مجموعة",
    inventoryTransferSelectGroupFirst: "اختر مجموعة للمتابعة.",
    inventoryAssignmentInput: "مصدر الإسناد",
    inventoryMeterNumbers: "الأرقام التسلسلية",
    inventoryAssignmentExcel: "إسناد من Excel",
    inventoryMeterNumbersHint: "أدخل الأرقام التسلسلية (عداد أو مودم أو شريحة أو نطاق أختام) مفصولة بمسافات أو فواصل أو أسطر جديدة.",
    inventoryMeterNumbersRequired: "أدخل أرقاماً تسلسلية صالحة لكل عنصر محدد.",
    inventoryAssignmentFileRequired: "اختر ملف Excel (.xlsx أو .xls).",
    inventoryAssignmentProjectRequired: "اختر مشروعاً واحداً لهذا الإسناد.",
    inventoryClearCustody: "إزالة العهدة",
    inventoryClearCustodyHint: "إزالة جميع إسنادات المخازن والمجموعات لهذه العناصر.",
    inventoryReassign: "إعادة الإسناد",
    inventoryDeleteUnavailable: "يلزم إعداد واجهة الحذف.",
    inventoryTransferSameSourceStore: "اختر العدادات من نفس المخزن المصدر قبل إسنادها إلى مجموعة.",
    inventoryTransferSameSourceOrg: "اختر العدادات من نفس المؤسسة قبل إسنادها إلى مجموعة.",
    inventoryTransferOrgMismatch: "العنصر '{item}' ينتمي إلى مؤسسة أخرى.",
    inventoryTransferAssignmentResult: "تم إسناد {assigned}، وفشل {failed}.",
    inventoryMeterTransferSummary: "نجح {success}، وتم تخطي {skipped}.",
    inventorySkippedMetersDownloaded: "تم تنزيل الأرقام التسلسلية التي تم تخطيها.",
    inventoryTransferSelectStoreFirst: "اختر مخزنًا للمتابعة.",
    inventoryTransferNote: "ملاحظة",
    inventoryTransferNotePlaceholder: "ملاحظة اختيارية لعملية النقل",
    inventoryTransferConfirm: "نقل",
    inventoryTransferring: "جارٍ النقل...",
    inventoryTransferInProgressHint: "قد يستغرق ذلك بعض الوقت. يرجى إبقاء هذه النافذة مفتوحة حتى يكتمل.",
    inventoryTransferSuccess: "تم نقل المخزون بنجاح.",
    inventoryTransferFailed: "تعذر إتمام نقل المخزون.",
    inventoryTransferCurrentStore: "المخزن الحالي",
    inventoryTransferNewStore: "المخزن الجديد",
    inventoryTransferUnassignedStore: "لم يتم تعيين مخزن",
    inventoryTransferCurrentStoreUnknown: "متاح للعناصر المحددة",
    inventoryTransferGroupLoadFailed: "تعذر تحميل المجموعات.",
    inventorySampleComponentId: "INV-MTR-20451",
    inventorySampleLocation: "Site 102",
    inventorySampleGroup: "Group A",
    inventorySampleAssignment: "Field Team 04",
    inventorySampleBarcode: "23239722299",
    inventorySampleSerial: "SN-2026-88231",
    inventorySampleMake: "L&T",
    inventorySampleYear: "2026",
    inventorySampleBatch: "BATCH-2026-14",
    inventorySampleActivationDate: "25 Sep 2026",
    inventorySampleInstallationDate: "2026-09-25",
    inventorySampleOldMeterId: "INV-MTR-10021",
    inventorySampleModemId: "INV-MOD-00421",
    inventorySampleSimId: "INV-SIM-00891",
    notAvailable: "—",
    transferMeter: "نقل المخزون",
    addInventory: "إضافة مخزون",
    //USER
    addUser: "إضافة مستخدم",
    searchusername: "البحث حسب اسم المستخدم...",
    searchAllFields: "البحث حسب اسم المستخدم أو البريد الإلكتروني أو الهاتف...",
    searchByEmail: "البحث حسب البريد الإلكتروني...",
    searchByPhone: "البحث حسب رقم الهاتف...",
    searchareacode: "البحث عن طريق رمز المنطقة...",
    userType: "نوع المستخدم",
    user: "مستخدم",
    edit: "يحرر",
    editOrganizationTooltip: "تعديل المنظمة",
    deleteOrganizationTooltip: "حذف المنظمة",
    userlist: "إدارة المستخدمين ",
    userManagementSubtitle: "إضافة المستخدمين وتعديلهم وإدارة وصولهم عبر مؤسستك.",

    userdetail: "تفاصيل المستخدم",
    previllage: "الامتيازات",
    cancle: "إلغاء",
    updateuser: "تحديث المستخدم",
    add: "إضافة مستخدم",
    username: "اسم المستخدم",

    selectOrg: "حدد المنظمة",
    areCode: "كود المنطقة",
    addeditActivity: "إضافة/تعديل النشاط ",
    addnewlabel: "إضافة/تحرير التكوين     ",
    addEdituser: "إضافة/تحرير مستخدم",
    canasset: "يمكن الوصول إلى إدارة الأصول",
    uservisibility: "رؤية المستخدم",
    modifyguidline: "تعديل المبادئ التوجيهية",
    createDashboar: "إنشاء لوحة المعلومات",
    addeditleader: "إضافة/تحرير لوحة المتصدرين",

    canTaskManage: "يمكن الوصول إلى إدارة المهام",
    canAddEditProtectedAccount: "يمكن إضافة/تحرير الحساب المحمي",
    canAddEditInventory: "يمكن إضافة/تحرير إدارة المخزون",

    //SETTING
    general: "عام",
    save: "حفظ التغييرات",
    setting: "إعدادات",
    langSetting: "إعدادات اللغة",
    colormode: "وضع اللون",
    light: "ضوء",
    dark: "مظلم",
    highcontrast: "التباين العالي",
    lang: "لغة",
    toursetting: "إعداد الجولة",
    stoptour: "توقف الجولة",
    starttour: "ابدأ الجولة",
    custommarker: "علامة مخصصة",
    all: "الجميع",
    none: "بلا",
    assigned: "مهام",
    active: "نشيط ",
    progress: "قيد التنفيذ",
    completed: "مكتمل",
    onhold: "في الانتظار",

    //ASSET
    vehical: "مركبة",
    Inventory: "جرد",
    exportreport: "تصدير تقرير",
    addVehical: "أضف مركبة جديدة",
    addAsset: "إضافة أصول جديدة",
    search: "بحث",

    vehicalType: "نوع المركبة",
    vehicalAssign: "المكلف بالمركبة",
    searchbyId: "البحث بالمعرف...",
    assetType: "نوع الأصول",
    assetAssign: "المكلف بالأصول",
    addnewasset: "إضافة تأكيد جديد",
    assetId: "معرف الأصل",
    agentAssigned: "الوكيل المعين",
    assetStatus: "حالة الأصل",
    updateAsset: "تحديث الأصول",
    Update: "تحديث",
    updateVehical: "تحديث المركبة",

    //CONFIGURATION
    complitionrule: "قواعد الإكمال",
    completionRuleSubheading: "تحكم في سلوك المهام عند اختيار حالة معينة.",
    searchStatusOrExpression: "البحث حسب الحالة أو التعبير...",
    editRule: "تعديل القاعدة",
    deleteRule: "حذف القاعدة",
    completionRuleColumn: "قاعدة الإكمال",
    ruleLabel: "قاعدة",
    step: "خطوة",
    statusStepDescription: "اختر حالة المهمة التي ستؤدي إلى تفعيل هذه القاعدة.",
    ruleActive: "القاعدة نشطة",
    ruleActiveDescription: "عند التفعيل، يتم تقييم هذه القاعدة. القواعد المعطّلة تبقى محفوظة ولكن يتم تجاهلها.",
    taskMovement: "نقل المهمة",
    taskMovementDescription: "عند التفعيل، تنتقل المهمة تلقائيًا إلى سير عمل آخر بمجرد تحقق هذه القاعدة.",
    destinationTask: "مهمة الوجهة",
    completionRuleDescPrefix: "حدد الشرط الذي يجب أن يتحقق إلى",
    completionRuleDescSuffix: "قبل أن يتم إكمال المهمة.",
    expressionEditor: "محرر التعبيرات",
    fullscreen: "ملء الشاشة",
    exitFullscreen: "الخروج من ملء الشاشة",
    criteriaPlaceholder: 'مثال: submission["field_id"] == option-1',
    whatThisScreenDoes: "ما تقوم به هذه الشاشة",
    completionRuleInfo: "تحدد كل قاعدة شرطًا واحدًا: الحالة التي تراقبها، وما إذا كانت مفعّلة، وما إذا كانت المهمة ستنتقل تلقائيًا، والتعبير الدقيق الذي يجب أن يتحقق. انقر على قاعدة أو على إضافة قاعدة جديدة لتعديلها.",
    assignmentRuleInfo: "تربط كل قاعدة تعبير المعايير بمستخدم ميداني أو مجموعة محددة. يطبق التعيين التلقائي هذه القواعد تلقائيًا مع وصول المهام الجديدة.",
    specialAssignmentRuleInfo: "استخدم هذا عندما يحتاج التوجيه إلى تفصيل أكبر من قاعدة تعيين بسيطة -- مثل توجيه رموز جغرافية أو رموز نوع أو نطاقات مبالغ معينة إلى مستخدم أو مجموعة محددة.",
    customVariableInfo: "عرّف تعبيرًا مرة واحدة واستخدمه عبر قواعد الإكمال والتعيين والتعيين الخاص لهذا سير العمل.",
    customVariableSubheading: "تعبيرات قابلة لإعادة الاستخدام لقواعد سير عملك.",
    completionRuleTabTooltip: "تحكم في ما يحدث عند تغيير حالة المهمة",
    assignmentRuleTabTooltip: "تعيين المهام لمستخدم أو مجموعة حسب تطابق المعايير",
    specialAssignmentRuleTabTooltip: "توجيه مهام محددة إلى معين مخصص",
    customVariableTabTooltip: "تعبيرات قابلة لإعادة الاستخدام لقواعدك",
    assignment: "قواعد التعيين",
    assignmentRuleSubheading: "حدد المستخدم أو المجموعة التي سيتم تعيين المهمة إليها بناءً على تطابق المعايير.",
    searchByNameTargetCriteria: "البحث بالاسم أو الهدف أو المعايير...",
    searchByCriteria: "البحث بالمعايير...",
    editCriteria: "تعديل المعيار",
    assignmentCriteriaPlaceholder: "مثال: 'Area Code' == 123, 456",
    customerule: "المتغيرات المخصصة",
    rulename: "اسم القاعدة",
    assignTo: "تعيين ل",
    activedeactive: "نشط / غير نشط",
    criteria: "معايير",
    submit: "إرسال",
    update: "تحديث",
    norule: "لا مزيد من القواعد للتحميل",
    noSearchResults: "لم يتم العثور على نتائج",
    tryAdjustingSearch: "حاول تعديل مصطلحات البحث للعثور على ما تبحث عنه.",
    clearSearch: "مسح البحث",
    getStartedAddingRule: "ابدأ بإضافة القاعدة الأولى.",
    getStartedAddingCustomVariable: "ابدأ بإضافة أول متغير مخصص.",
    icon: "رمز",
    createrule: "إنشاء قاعدة جديدة",
    addNewRule: "إضافة قاعدة جديدة",

    multiSelect: "تحديد متعدد",
    smartAssign: "التعيين الذكي",
    FieldStaff: "الموظفين الميدانيين",
    Location: "موقع",
    MapStatus: "حالة الخريطة",
    fieldAgent: "الموظف الميداني",
    selectFieldAgent: "اختر الموظف الميداني",
    allFieldAgents: "جميع الموظفين الميدانيين",
    createNewTask: "إنشاء مهمة جديدة",
    importCSV: "  تحميل المهمة",
    mapview: "عرض الخريطة",
    createTask: "إنشاء مهمة جديدة",
    download: "تحميل",
    downloadAll: "تنزيل الكل",
    downloadSelected: "تنزيل المحدد",
    downloadAllPdfsTooltip: "تنزيل جميع ملفات PDF",
    downloadSelectedPdfsTooltip: "تنزيل ملفات PDF المحددة",
    downloadingAllPdfs: "جارٍ تنزيل جميع ملفات PDF...",
    downloadingSelectedPdfs: "جارٍ تنزيل {count} ملف PDF...",
    // Bulk PDF export (BLF-2171)
    bulkExportTitle: "تصدير PDF بالجملة",
    bulkExportSubtitle: "يتم التحضير في الخلفية ويُسلَّم كملف ZIP واحد.",
    bulkExportIdLabel: "رقم التصدير",
    bulkExportActivityLabel: "النشاط",
    bulkExportClose: "إغلاق",
    bulkExportActionColumn: "الإجراء",
    bulkExportStart: "بدء التصدير",
    bulkExportStartTooltip: "تحضير ملفات PDF في الخلفية",
    bulkExportRetry: "أعد المحاولة",
    bulkExportIdleHelp:
      "يتم ضغط ملفات PDF في الخلفية، فيمكنك متابعة عملك أثناء ذلك. سنخبرك عند جهوز ملف ZIP.",
    bulkExportRequesting: "جارٍ إضافة التصدير إلى قائمة الانتظار...",
    bulkExportQueuedHeading: "في قائمة الانتظار — بانتظار بدء المعالجة",
    bulkExportQueuedHelp: "التصدير في قائمة الانتظار وسيبدأ قريبًا.",
    bulkExportInProgressHeading: "جارٍ تحضير ملفات PDF",
    bulkExportProcessedOfTotal: "{processed} من {total} ملف PDF",
    bulkExportKeepRunningHint:
      "يمكنك إغلاق هذه النافذة — سيستمر التصدير وسيبقى ملف ZIP في سجل التصدير.",
    bulkExportRunInBackground: "المتابعة في الخلفية",
    bulkExportRunInBackgroundTooltip: "أغلق هذه النافذة مع استمرار التصدير",
    bulkExportCompletedHeading: "ملف ZIP جاهز",
    bulkExportCompletedHelp: "نزّله من الأسفل أو من سجل التصدير.",
    bulkExportDownloadZip: "تنزيل ZIP",
    bulkExportDownloadZipTooltip: "تنزيل ملف ZIP المُحضَّر",
    bulkExportTotalLabel: "الإجمالي",
    bulkExportSuccessLabel: "ناجح",
    bulkExportFailedLabel: "فاشل",
    bulkExportNoFile: "انتهى هذا التصدير بدون ملف. يُرجى المحاولة مرة أخرى.",
    bulkExportNoFileShort: "لا يوجد ملف",
    bulkExportFailedHeading: "فشل التصدير",
    bulkExportFailedHelp: "لم يكتمل التصدير. يُرجى المحاولة مرة أخرى.",
    bulkExportErrorHeading: "تعذّر الوصول إلى خدمة التصدير",
    bulkExportErrorHelp:
      "توقفت تحديثات التقدم. قد يكون التصدير ما زال قيد التنفيذ — راجع سجل التصدير.",
    bulkExportLimitHeading: "تعذّر بدء التصدير",
    bulkExportLimitFallback: "تعذّر بدء هذا التصدير. يُرجى تضييق التحديد والمحاولة مرة أخرى.",
    bulkExportEmptyHeading: "لا توجد نتائج مطابقة لهذا التحديد",
    bulkExportEmptyHelp: "جرّب نطاقًا زمنيًا أو نشاطًا أو حسابات مختلفة.",
    bulkExportFailedAccountsTitle: "تعذّر تصدير {count} حساب",
    bulkExportFailedAccountsColumn: "الحسابات الفاشلة",
    bulkExportFailedAccountsCount: "{count} فاشل",
    bulkExportNoFailedAccounts: "لا يوجد",
    bulkExportDownloadFailedExcel: "تنزيل Excel",
    bulkExportDownloadFailedExcelTooltip: "تنزيل أرقام الحسابات الفاشلة بصيغة Excel",
    bulkExportRequestError: "تعذّر بدء التصدير. يُرجى المحاولة مرة أخرى.",
    bulkExportDismiss: "إخفاء",
    bulkExportShowAccounts: "عرض الحسابات",
    bulkExportHideAccounts: "إخفاء الحسابات",
    bulkExportCopyAccounts: "نسخ أرقام الحسابات",
    bulkExportCopied: "تم النسخ",
    bulkExportSelectedAccounts: "{count} محدد",
    bulkExportAllAccountsInRange: "جميع الحسابات في النطاق الزمني",
    bulkExportMatchedLabel: "ملفات PDF المطابقة",
    bulkExportStatusPending: "في الانتظار",
    bulkExportStatusInProgress: "قيد التنفيذ",
    bulkExportStatusCompleted: "مكتمل",
    bulkExportStatusFailed: "فاشل",
    bulkExportHistoryTitle: "سجل التصدير",
    bulkExportHistorySubtitle: "جميع عمليات تصدير PDF بالجملة التي طلبتها، الأحدث أولًا.",
    bulkExportShowingRange: "عرض {start}-{end} من {total}",
    bulkExportHistoryTooltip: "عرض عمليات تصدير PDF السابقة",
    bulkExportHistoryLoadError: "تعذّر تحميل سجل التصدير.",
    bulkExportAllActivities: "جميع الأنشطة",
    bulkExportRefresh: "تحديث",
    bulkExportRefreshTooltip: "إعادة تحميل سجل التصدير",
    bulkExportBackToPdf: "العودة إلى تصدير PDF",
    bulkExportRequestedAt: "تاريخ الطلب",
    bulkExportCompletedAt: "تاريخ الاكتمال",
    bulkExportFileSize: "الحجم",
    bulkExportNoHistory: "لا توجد عمليات تصدير بعد",
    bulkExportNoHistoryHelp: "ستظهر هنا عمليات تصدير PDF بالجملة التي تطلبها.",
    bulkExportTrack: "تتبّع",
    bulkExportTrackTooltip: "متابعة تقدم هذا التصدير",
    bulkExportToggleDetails: "عرض تفاصيل التصدير",
    bulkExportViewExport: "عرض التصدير",
    bulkExportCheckSelectionTitle: "تحقق من اختيارك",
    bulkExportSingleActivityWarning: "اختر نشاطًا واحدًا قبل تصدير ملفات PDF.",
    bulkExportDateRangeWarning: "اختر نطاقًا زمنيًا قبل تصدير ملفات PDF.",
    bulkExportRadioFilterNotice:
      "لا يُطبَّق فلتر خيار الراديو على التصدير بالجملة — سيتم تضمين جميع المهام المكتملة في هذا النطاق الزمني. حدّد صفوفًا معيّنة لتصديرها وحدها.",
    bulkExportTableFilterNotice:
      "فلاتر الأعمدة واسم المستخدم تُضيّق الجدول في هذه الصفحة فقط، وليس التصدير. حدّد صفوفًا معيّنة لتصديرها وحدها.",
    selectRadioOption: "اختر خيار الراديو",
    deleteAllRecord: "حذف كافة السجلات",
    assign: "تعيين",

    reassign: "إعادة التعيين",
    alert: "تنبيه مرسل",
    delete: "حذف ",
    priority: "أولوية",
    Cycle: "دورة",
    status: "الحالة ",
    searchbycode: "البحث عن طريق رمز المنطقة..",
    selectAssign: "حدد المكلف",
    downloadtask: " تنزيل تقرير المهام",
    seectallactivty: "حدد كل الأنشطة",
    selectpartcular: " نشاط معين محدد",
    recentReports: "التقارير الأخيرة",
    noteLabel: "ملاحظة:",
    reportGeneratingNote: "قد يستغرق إنشاء التقارير بضع دقائق. إذا لم يكن تقريرك جاهزًا بعد، انتظر قليلاً ثم اضغط على زر التحديث للتحقق مرة أخرى.",
    viewAllReports: "عرض كل التقارير",
    reportRequestQueued:
      "جاري إنشاء التقرير. سيظهر ضمن التقارير الأخيرة بمجرد أن يصبح جاهزاً.",
    selectMsg: "الرجاء تحديد نشاط للمتابعة.",
    createnewtask: "إنشاء مهمة جديدة",
    cancel: "إلغاء",
    create: "إنشاء",
    bulkReAssign: "إعادة التعيين الجماعي",
    bulkPriorityUpdate: "تحديث الأولوية الجماعي",
    bulkUpload: "الرفع الجماعي",
    reassignTasks: "إعادة تعيين المهام",
    newAccounts: "حسابات جديدة",
    existingAccounts: "حسابات موجودة",
    noNewAccounts: "لا توجد حسابات جديدة",
    noExistingAccounts: "لا توجد حسابات موجودة",
    assignees: "المكلفون",
    noAssignees: "لا يوجد مكلفون",

    //import csv
    DragDetail: "قم بسحب وإسقاط ملف CSV الذي يحتوي على جميع تفاصيل المهمة",
    sizeMsg: "الحد الأقصى لحجم الملف: 15 ميجابايت",
    import: "CSV إستيراد ملف",
    uploadfile: "تحميل قائمة المهام",
    uploadby: "تم الرفع بواسطة",
    uploaddate: "تاريخ التحميل",
    uploadtime: "وقت التحميل (24 ساعة)",

    //taskd etail
    taskdetail: "تفاصيل المهمة",
    taskhistory: "سجل المهام",
    nohistory: "لا يوجد سجل مهام متاح.",
    more: "جارٍ تحميل المزيد من سجل المهام...",

    //task hisotry
    enteraccno: "أدخل رقم الحساب",
    reset: "إعادة تعيين",
    resetAllAppliedFiltersTooltip: "مسح جميع عوامل التصفية المطبقة",
    filtersToggleTooltip: "طبّق عوامل التصفية من رأس الجدول",
    protectedAccountsTitle: "الحسابات المحمية",
    protectionJobsTitle: "سجل الحماية",
    protectionJobsSubtitle: "تتبع طلبات حماية الحسابات وقم بتنزيل الحسابات التي تم تخطيها.",
    protectionJobsTooltip: "عرض حالة وسجل طلبات الحماية",
    protectionJobsBack: "العودة إلى الحسابات المحمية",
    protectionJobsRefresh: "تحديث",
    protectionJobsAutoRefresh: "الحماية قيد التنفيذ وقد تستغرق بعض الوقت. يتم تحديث الجدول تلقائياً، أو انقر على تحديث.",
    protectionJobsEmpty: "لا توجد مهام حماية بعد",
    protectionJobsEmptyHint: "تظهر المهام هنا بعد إنشاء حسابات محمية.",
    protectionJobsLoadFailed: "تعذر تحميل مهام الحماية.",
    protectionJobCreated: "تم الإنشاء",
    protectionJobFinished: "انتهت",
    protectionJobStatusQUEUED: "في الانتظار",
    protectionJobStatusIN_PROGRESS: "قيد التنفيذ",
    protectionJobStatusCOMPLETED: "مكتملة",
    protectionJobStatusFAILED: "فشلت",
    protectionJobColStatus: "الحالة",
    protectionJobColSrNo: "الرقم",
    protectionJobColSkippedFile: "الحسابات المتخطاة",
    protectionJobColActions: "الإجراءات",
    protectionJobAddMasterDb: "إضافة إلى قاعدة البيانات الرئيسية",
    protectionJobAddProtection: "إضافة الحماية",
    protectionJobMasterDbTooltip: "غير موجودة في قاعدة البيانات الرئيسية. أضفها أولاً.",
    masterDbModalTitle: "إضافة حسابات إلى قاعدة البيانات الرئيسية",
    masterDbModalSubtitle: "تم تخطي هذه الحسابات لأنها غير موجودة في قاعدة البيانات الرئيسية. أضفها أولاً ليمكن حمايتها.",
    masterDbAccountsLabel: "الحسابات ({count})",
    masterDbNote: "{count} حسابات متخطاة غير موجودة في قاعدة البيانات الرئيسية. ستتم إضافتها في الموقع الافتراضي ({lat}, {lon}).",
    masterDbProtectionTitle: "تفاصيل الحماية",
    masterDbProtectionHint: "مطلوبة فقط عند اختيار إضافة وحماية.",
    masterDbNoAccounts: "اختر حساباً واحداً على الأقل.",
    masterDbProtectNotice: "بمجرد إضافة الحسابات إلى قاعدة البيانات الرئيسية، ستتم حمايتها مرة أخرى.",
    masterDbFieldsLoadFailed: "تعذر تحميل حقول قاعدة البيانات الرئيسية. أغلق هذه النافذة وحاول مرة أخرى.",
    masterDbSubmitAdd: "إضافة إلى قاعدة البيانات الرئيسية",
    masterDbSubmitAddAndProtect: "إضافة وحماية",
    masterDbSubmitAddTooltip: "إضافة إلى قاعدة البيانات الرئيسية فقط",
    masterDbSubmitAddAndProtectTooltip: "إضافة إلى قاعدة البيانات الرئيسية والحماية",
    masterDbAddedSuccess: "تمت الإضافة إلى قاعدة البيانات الرئيسية بنجاح.",
    masterDbAddedAndProtected: "تمت إضافة الحسابات إلى قاعدة البيانات الرئيسية. يعمل طلب الحماية في الخلفية ويظهر تقدمه هنا.",
    masterDbAddedProtectFailed: "تمت إضافة الحسابات إلى قاعدة البيانات الرئيسية لكن طلب الحماية فشل. قم بحمايتها من إنشاء حساب محمي.",
    masterDbAddFailed: "تعذر إضافة الحسابات إلى قاعدة البيانات الرئيسية.",
    protectionJobMasterDbAddedTooltip: "الحسابات مضافة بالفعل إلى قاعدة البيانات الرئيسية. قم بحمايتها.",
    protectionJobMasterDbDoneTooltip: "جميع الحسابات مضافة بالفعل إلى قاعدة البيانات الرئيسية ومحمية.",
    masterDbProtectModalTitle: "حماية الحسابات",
    masterDbProtectModalSubtitle: "هذه الحسابات مضافة بالفعل إلى قاعدة البيانات الرئيسية. يمكن إضافة الحماية فقط.",
    masterDbAlreadyAddedNote: "{count} حسابات مضافة بالفعل إلى قاعدة البيانات الرئيسية. يمكن الآن إضافة الحماية فقط.",
    masterDbSubmitProtect: "حماية",
    masterDbSubmitProtectTooltip: "حماية هذه الحسابات",
    masterDbProtectStarted: "يتم تنفيذ طلب الحماية في الخلفية؛ ويظهر تقدمه هنا.",
    masterDbProtectFailed: "فشل طلب الحماية.",
    protectionJobTotal: "الإجمالي",
    protectionJobProtected: "محمية",
    protectionJobSkipped: "تم تخطيها",
    protectionJobDownloadSkipped: "تنزيل الحسابات التي تم تخطيها",
    protectionJobDownloadSkippedTooltip: "تنزيل ملف Excel للحسابات المتخطاة",
    protectionJobFinishedSummary: "انتهت الحماية: تمت حماية {protected} وتم تخطي {skipped}.",
    protectionJobFailedToast: "فشل طلب الحماية.",
    protectionJobFailedTitle: "فشل طلب الحماية",
    protectionRequestReceived: "تم استلام طلب الحماية. يتم تنفيذه في الخلفية، لذا يمكنك تتبع تقدمه هنا.",
    protectedAccountsSubtitle: "يحمي الحسابات من عمليات الشطب والإغلاق التلقائي.",
    fromDateTooltip: "اختر تاريخ بدء التقرير",
    toDateTooltip: "اختر تاريخ انتهاء التقرير",
    exportProtectedAccountsReport: "تصدير تقرير الحسابات المحمية",
    createProtectedAccountTooltip: "إنشاء حساب محمي",
    searchProtectedAccounts: "البحث في الحسابات المحمية",
    editProtectedAccountTooltip: "تعديل الحساب المحمي",
    deleteProtectedAccountTooltip: "حذف الحساب المحمي",
    totalUsersTooltip: "إجمالي المستخدمين المطابقين",
    searchScopeTooltip: "اختر الحقل الذي تريد البحث فيه",
    toggleDensity: "تبديل الكثافة",
    stockManagementSubtitle: "اعرض وتتبع وأدر مخزون عدادات المخزون الخاص بك.",
    totalItemsTooltip: "إجمالي عدد السجلات المطابقة لعوامل التصفية الحالية.",
    exportDateRangeTooltip: "اختر النطاق الزمني لتقرير التصدير",
    protectedAccountsEmptyHint: "لا توجد حسابات محمية بعد. أنشئ حسابًا لحمايته من الشطب والإغلاق التلقائي.",
    dateRange: "النطاق الزمني",
    dateRangeTooltip: "التصفية حسب نطاق تاريخ التفعيل",
    searchTooltip: "ابحث حسب الحقل المحدد. اضغط Enter للبحث.",
    clear: "مسح",
    clearFilters: "مسح عوامل التصفية",
    selected: "محدد",
    noRecordsMatchSearch: "لا توجد سجلات تطابق بحثك",
    tryAdjustingFilters: "حاول تعديل عوامل التصفية أو مصطلحات البحث للعثور على ما تبحث عنه.",
    noDataFound: "لا توجد بيانات",
    getStartedUploadingSheet: "ابدأ برفع ملف المخزون الخاص بك.",
    inventoryLoadError: "تعذر تحميل المخزون. يرجى المحاولة مرة أخرى.",
    uploadinventorysheetlabel: "رفع ملف المخزون (XLSX/XLS)",
    onlyexcelallowed: "يُسمح فقط بملفات .xlsx و .xls.",
    exportCsvTooltip: "تصدير الصفحة الحالية كملف CSV.",
    minVisibleColumnsTooltip: "يجب أن يبقى عمودان على الأقل مرئيين",
    submitting: "جارٍ التقديم..",
    accDetail: "تفاصيل الحساب :-",
    accnumber: "رقم الحساب",
    searchByAccountNumber: "البحث برقم الحساب",
    activityFilterTooltip: "التصفية حسب النشاط أو سير العمل",
    workflowInputTooltip: "التصفية حسب معايير إضافية",
    area: "المنطقة",
    areacode: "رمز المنطقة",
    latitude: "خط العرض",
    longitude: "خط الطول",
    importdb: "استيراد قاعدة البيانات الرئيسية",
    exportData: "إصدار البيانات",
    downloading: "جاري التحميل...",
    viewGuideline: "عرض الإرشادات",
    createWorkflow: "إنشاء سير عمل جديد",
    guidline: "المبادئ التوجيهية",
    guidelinesSubtitle: "تحميل وإدارة إرشادات PDF أو الفيديو لكل نشاط.",
    guidelinesLabel: "الإرشادات",
    selectOrgForGuidelines: "اختر مؤسسة لعرض الإرشادات.",
    dropzoneHint: "ملفات PDF أو الفيديو فقط",
    noworkflow: "لا توجد مسارات عمل متاحة",
    //worklog
    Scheduleemail: "جدولة تقرير البريد الإلكتروني",
    export: "إصدار التقارير",
    pdf: "إصدار الملفاتPDF",
    todo: "مهام",
    loading: "جاري تحميل المزيد من سجل العمل...",
    nomore: "لا مزيد من سجل العمل للتحميل",
    name: "الحساب المحمي",
    createacc: "إنشاء حساب جديد",
    editacc: "تحرير الحساب المحمي",
    createproacc: "إنشاء حساب محمي",
    permanent: "الحماية الدائمة",
    protectionValid: "صلاحية الحماية حتى",
    createdBy: "تم إنشاؤها بواسطة",
    accProtection: "حماية الحساب لجميع الأنشطة",
    accno: "رقم الحساب",
    remark: "ملاحظات",

    enterremark: "أدخل ملاحظاتك هنا",
    updatemeterDEtail: "تحديث تفاصيل العداد",
    downloadsheet: "تحميل الورقة",
    uploadinventory: "تحميل ورقة الجرد",
    reportType: "نوع التقرير",
    form: "طلب تقرير",
    startDate: "تاريخ البدء",
    endDate: "تاريخ الانتهاء",
    orglist: "قائمة المنظمات",
    createOrg: " إنشاء منظمة",
    noOrg: "لا توجد بيانات المنظمة المتاحة.",
    rows: "عدد الصفوف في كل صفحة ",
    showing: "عرض",
    of: "من",
    allFields: "جميع الحقول",
    group: "المجموعة",
    assignedGroups: "المجموعات المعينة",
    agentGroup: "مجموعة الوكيل",
    lastLogin: "آخر تسجيل دخول",
    loginCount: "مرات الدخول",
    users: "مستخدمين",
    filters: "الفلاتر",
    columns: "الأعمدة",
    orgname: "اسم المنظمة",
    img: "تحميل الشعار",
    creating: "جارٍ الإنشاء...",
    updateOrg: "تحديث المنظمة",
    Updating: "جارٍ التحديث...",
    nolog: "لا يوجد شعار",
    number: "رقم",
    geoCodes: "رموز جغرافية مختارة",
    geoCodeLabel: "رمز جغرافي",
    typeCodes: "رموز النوع المحددة",
    amountRange: "نطاق المبلغ المحدد",
    assignAll: "تعيين الكل",
    default: "تقصير",
    select: " حدد النشاط",
    selecteOrgName: " اختر المنظمة",
    selectsubactivty: " حدد النشاط الفرعي ",

    emailreport: "جدولة تقرير البريد الإلكتروني",
    selectactivity: "اختر النشاط:",
    recipients: "المستلمون",
    bcc: "نسخة مخفية الوجهة",
    cc: "نسخة",
    sendreport: "إرسال التقرير المقرر",
    senddashboard: "إرسال لوحة المعلومات:",
    shedulesend: "جدول الإرسال:",
    daily: "يوميًا",
    weekly: "أسبوعي",
    monthly: "شهريا",
    send: "يرسل",
    sendScheduleReportTooltip: "إرسال تقرير البريد الإلكتروني المجدول هذا",
    updateScheduleReportTooltip: "تحديث تقرير البريد الإلكتروني المجدول هذا",
    reportbtn: "طلب تقرير",

    stockmanag: "إدارة المخزون",
    fromdate: "من التاريخ",
    todate: "إلى التاريخ",
    metercode: "الباركود الخاص بالعداد",
    location: "إلى الموقع",
    filter: "تطبيق الفلترة",
    filtersLabel: "عوامل التصفية",
    columnFiltersLabel: "عوامل تصفية الأعمدة",
    maxFiltersReachedTitle: "تم بلوغ حد عوامل التصفية",
    maxFiltersReachedMsg:
      "يمكنك تطبيق {limit} عوامل تصفية كحد أقصى في المرة الواحدة. امسح أحد عوامل التصفية المطبقة قبل إضافة عامل آخر.",
    filterByColumn: "تصفية حسب",

    visitTime: "وقت الزيارة ",
    visitDate: "تاريخ الزيارة ",
    nopdfavb: "ملف PDF غير متاح",
    noPdfEntriesHelp: "حاول تعديل النطاق الزمني أو النشاط أو عامل تصفية رقم الحساب.",
    pdfReportsSubtitle: "ابحث في تقارير PDF للزيارات وقم بتصفيتها وتنزيلها لفترة زمنية محددة.",

    // login
    loginEnterEmailPassword:
      "أدخل بريدك الإلكتروني وكلمة المرور للوصول إلى حسابك",
    loginManageTeamOperations: "قم بإدارة فريقك وعملياتك بسهولة",
    loginDashboardAccess:
      "سجّل الدخول للوصول إلى لوحة التحكم وإدارة كل شيء من مكان واحد",
    Utilities: "المرافق و",
    TasksManagementSolutions: "حلول إدارة المهام",
    UsernameEmailAddress: "اسم المستخدم / عنوان البريد الإلكتروني",
    loginEmailPlaceholder: "أدخل اسم المستخدم أو البريد الإلكتروني",
    loginPasswordPlaceholder: "أدخل كلمة المرور",
    loginNoAccountText: "ليس لديك حساب؟",
    loginContactAdminText: "تواصل مع المسؤول",
    loginPoweredByText: "مشغل بواسطة Outbox",
    loginMadeWithLoveText: "تم تطويره في سلطنة عُمان",
    loginOtpTitle: "تحقق من هويتك",
    loginOtpDescription:
      "أرسلنا رمزًا مكونًا من 6 أرقام عبر رسالة نصية إلى {phone}. أدخله أدناه للمتابعة.",
    loginOtpDidntGetCode: "لم يصلك الرمز؟",
    loginOtpVerify: "تحقق وتابع",
    loginOtpVerifying: "جارٍ التحقق...",
    loginOtpResend: "إعادة إرسال الرمز",
    loginOtpResendIn: "إعادة الإرسال خلال",
    loginOtpResendSuccess: "تم إرسال رمز تحقق جديد.",
    loginOtpIncomplete: "يرجى إدخال رمز التحقق كاملًا.",
    loginOtpBack: "العودة إلى تسجيل الدخول",
    loginOtpSecureTitle: "وصول آمن إلى Blufield",
    loginOtpSecureDescription:
      "يساعد رمز التحقق على حماية عملياتك الميدانية.",
    loginOtpDigitLabel: "رقم التحقق",
    loginOtpRegisteredNumber: "رقمك المسجل",
    loginHeroSlide1Title: "فنيون خبراء",
    loginHeroSlide1Description:
      "مكّن فرقك الميدانية بأدوات موجهة للجوال للفحص والتقارير والصيانة.",
    loginHeroSlide1Stat1Label: "فنيون",
    loginHeroSlide1Stat2Label: "الرضا",
    loginHeroSlide2Title: "السلامة والامتثال",
    loginHeroSlide2Description:
      "اضمن بروتوكولات السلامة ومعايير الامتثال من خلال التوثيق والتقارير المتكاملة.",
    loginHeroSlide2Stat1Label: "امتثال",
    loginHeroSlide2Stat2Label: "حوادث",
    loginHeroSlide3Title: "البنية التحتية لشبكة الكهرباء",
    loginHeroSlide3Description:
      "راقب وحافظ على البنية التحتية الحيوية مع جدولة متقدمة وتخصيص للموارد.",
    loginHeroSlide3Stat1Label: "معدل الكفاءة",
    loginHeroSlide3Stat2Label: "فرق",
    loginHeroSlide4Title: "إدارة العمليات الميدانية",
    loginHeroSlide4Description:
      "بسّط عمليات الصيانة الكهربائية عبر التتبع الفوري وإدارة ميدانية شاملة.",
    loginHeroSlide4Stat1Label: "مهام نشطة",
    loginHeroSlide4Stat2Label: "دعم",
    RememberMe: "تذكرنى",
    ForgotPassword: "هل نسيت كلمة السر؟",
    assetBarCode: "رمز الاستجابة للأصول (الباركود)",
    assetBarCodeMain: "رمز الاستجابة للأصول",
    assetBarCodeParen: "الباركود",
    dragAndDropDocuments: "اسحب وأفلت المستندات",
    viewDocuments: "عرض المستندات",
    uploadedDocument: "المستند المُحمّل",
    maxFileSize5MB: "الحد الأقصى لحجم الملف: 5 ميغابايت",
    browse: "تصفح",
    description: "الوصف",
    kilometer: "كيلومتر",
    noAccountDetialsAvailable: "لا توجد تفاصيل حساب متاحة",
    enterAccSubmitViewDetails: "أدخل رقم الحساب واضغط إرسال لعرض التفاصيل",
    uploading: "جارٍ التحميل",
    upload: "تحميل",
    addOrganization: "إضافة مؤسسة",
    addDepartment: "إضافة قسم",
    uploadOrganizationLogo: "تحميل شعار المؤسسة",
    successMessage:
      ".يرجى الانتظار! يتم حالياً تحميل الملف. قد يستغرق ذلك بعض الوقت، وبمجرد اكتمال التحميل بنجاح، ستتلقى رسالة تأكيد",
    fullName: "الاسم الكامل",
    fullNameInfo: "أدخل الاسم الكامل للمستخدم كما يجب أن يظهر.",
    userEmailInfo: "استخدم عنوان بريد إلكتروني صالحًا لهذا المستخدم.",
    phoneInfo: "أدخل رقم الهاتف. رمز الدولة هو +968.",
    userTypeInfo: "اختر نوع المستخدم: مسؤول أو مستخدم مكتب أو موظف ميداني.",
    orgInfo: "اختر المؤسسة التي ينتمي إليها هذا المستخدم.",
    rolesInfo: "اختر الأدوار لمنح المستخدم الصلاحيات.",
    departmentInfo: "اختر الأقسام التي يحق لهذا المستخدم الوصول إليها.",
    projectInfo: "اختر المشاريع التي يحق لهذا المستخدم الوصول إليها.",
    clockInInfo:
      "فعّل تسجيل الحضور/الانصراف واختر المشروع (للموظف الميداني فقط).",
    activityInfo:
      "اختر سير العمل/الأنشطة التي يمكن للموظف الميداني الوصول إليها.",
    employeeIdInfo: "رقم الموظف مطلوب للموظفين الميدانيين.",
    subContractInfo: "أدخل تفاصيل التعاقد من الباطن للموظف الميداني.",
    passwordInfo:
      "يلزم إدخال كلمة مرور للمستخدمين الجدد. اتركه فارغًا عند التعديل للاحتفاظ بكلمة المرور الحالية.",
    signatureInfo: "ارفع صورة توقيع واضحة لوثائق الموظف الميداني.",
    department: "القسم",
    project: "المشروع",
    profileImage: "صورة الملف الشخصي",
    vehicleId: "معرف المركبة",
    vehicleKM: "(KM) ممشى المركبة",
    vehicleAssinged: "المركبة المعينة",
    editPrivileges: "صلاحيات التعديل",
    source: "المصدر",
    thecustomcodewarningmessage:
      "لم يتم إضافة لون العلامة المخصصة، الرجاء الاختيار من القائمة أدناه!!",
    selectWorkflowFirst: "يرجى اختيار سير العمل أولاً",
    makerColor: "تم حفظ ألوان العلامات بنجاح",
    failedtoSaveMakerColor: "فشل في حفظ ألوان العلامات",
    permanentProtection: "الحماية الدائمة لن تحتوي على تاريخ انتهاء",
    noRecordAvailable: "لا توجد سجلات متاحة",
    reportGenerating: "جاري توليد التقرير...",
    reportFailed: "فشل",
    reportGenerationFailed: "فشل إنشاء التقرير",
    reportFailedTooltip: "انقر لعرض تفاصيل الخطأ",
    reportNoRecords: "لا توجد سجلات",
    reportNoRecordsTooltip: "لا توجد سجلات للفلاتر المحددة",
    mediumPriority: "أولوية متوسطة",
    highPriority: "أولوية عالية",
    lowPriority: "أولوية منخفضة",
    accountProtection: "حماية الحساب",
    clockIn: "تسجيل الحضور",
    clockOut: "تسجيل الانصراف",
    isPageWise: "حسب الصفحة",
    isReviewEnabled: "المراجعة مفعّلة",
    isShowDistance: "إظهار المسافة بين الإحداثيات",
    isShowDistanceTooltip:
      "عند التفعيل، يعرض التقرير وملف PDF المسافة بين إحداثيات المهمة المرفوعة والإحداثيات المسجَّلة عند الإرسال من الميدان.",
    safetyComplianceRequired: "يتطلب قائمة تحقق السلامة",
    safetyComplianceRequiredTooltip:
      "عند التفعيل، يتم إنشاء سير عمل فرعي للامتثال للسلامة ضمن سير العمل هذا. حقول الباركود وOCR وGPS وجودة الإشارة غير متاحة فيه.",
    safetyChecklistName: "اسم قائمة تحقق السلامة",
    enterSafetyChecklistName: "أدخل اسمًا لقائمة تحقق السلامة",
    safetyChecklistNeedsField: "أضف حقلاً واحدًا على الأقل إلى قائمة تحقق السلامة",
    mainWorkflowTab: "سير العمل الرئيسي",
    safetyChecklistTab: "قائمة تحقق السلامة",
    safetyPaletteRestricted:
      "الباركود وOCR وGPS وجودة الإشارة غير متاحة في قائمة تحقق السلامة.",
    fieldNotAllowedInSafetyChecklist:
      "لا يمكن استخدام هذا الحقل في قائمة تحقق السلامة.",
    createSafetyChecklist: "إنشاء قائمة تحقق السلامة",
    createSafetyChecklistTooltip: "أنشئ قائمة تحقق السلامة ضمن سير العمل هذا",
    updateSafetyChecklist: "تحديث قائمة تحقق السلامة",
    updateSafetyChecklistTooltip: "حفظ التغييرات على قائمة تحقق السلامة فقط",
    deleteSafetyChecklist: "حذف قائمة تحقق السلامة",
    deleteSafetyChecklistTooltip:
      "عطّل الامتثال للسلامة واحفظ سير العمل قبل الحذف",
    confirmDeleteSafetyChecklist:
      "سيتم حذف قائمة تحقق السلامة وجميع حقولها نهائيًا. عطّل الامتثال للسلامة واحفظ سير العمل أولاً.",
    safetyChecklistCreated: "تم إنشاء قائمة تحقق السلامة",
    createSafetyChecklistFirst:
      "أنشئ قائمة تحقق السلامة أولاً، ثم فعّل الامتثال للسلامة",
    safetyChecklistSavedWithWorkflow: "يتم حفظها مع سير العمل",
    savedLabel: "محفوظة",
    notCreatedLabel: "غير منشأة",
    companyStamp: "ختم الشركة",
    companyStampDescription:
      "قم بتحميل صورة واضحة لختم الشركة لمستندات المندوب الميداني.",
    uploadCompanyStamp: "تحميل ختم الشركة",
    changeCompanyStamp: "تغيير ختم الشركة",
    companyStampSupported: "يدعم JPG وPNG وSVG",
    companyStampMaxSize: "الحد الأقصى لحجم الملف: 5 ميجابايت",
    chooseCompanyStamp: "اختر الختم",
    editCompanyStamp: "تغيير",
    removeCompanyStamp: "إزالة",
    companyStampInvalidType: "يرجى تحميل صورة بصيغة JPG أو PNG أو SVG.",
    userAssign: "تعيين مستخدم",
    groupAssign: "تعيين مجموعة",
    searchGroup: "البحث عن المجموعات",
    nogroupfound: "لا توجد مجموعة",
    nomembers: "لا يوجد أعضاء",
    selectGroup: "اختر المجموعة",
    selectgrouptoassign: "اختر مجموعة (مجموعات) للتعيين.",
    selectgrouptounassign: "اختر مجموعة (مجموعات) لإلغاء التعيين.",
    memberNoWorkflowAccess: "لا يملك صلاحية الوصول إلى سير العمل هذا",
    groupNotInProject: "لا تنتمي إلى المشروع المحدد",
    groupNotInProjectTooltip: "هذه المجموعة لا تنتمي إلى المشروع المحدد",
    groupDisabledNoMembers: "هذه المجموعة ليس بها أعضاء",
    assignWorkflowAccessNote:
      "لن يتم تعيين المهمة إلا لأعضاء المجموعة الذين لديهم صلاحية الوصول إلى سير العمل هذا.",
    showAsFilter: "إظهار كمرشح",
    allowGallery: "السماح بالمعرض",
    allowGalleryTooltip:
      "السماح لموظفي الميدان باختيار الصور من المعرض بدلاً من استخدام الكاميرا فقط.",
    photoDimensions: "أبعاد الصورة",
    photoDimensionsTooltip:
      "يمكنك اختياريًا اشتراط أن تطابق الصور الملتقطة عرضًا و/أو ارتفاعًا و/أو نسبة أبعاد معينة.",
    widthPx: "العرض (بكسل)",
    heightPx: "الارتفاع (بكسل)",
    aspectRatio: "نسبة العرض إلى الارتفاع (اختياري)",
    aspectRatioSelect: "اختر نسبة العرض إلى الارتفاع",
    customAspectRatio: "مخصص",
    configuredDimensions: "الأبعاد المحددة",
    linkedWorkflow: "سير العمل المرتبط",
    linkedWorkflowTooltip:
      "اختر سير العمل المراد ربطه بكل خيار. لا يؤثر الربط إلا على مخرجات التقارير و PDF.",
    linkedWorkflowSelect: "اختر سير العمل",
    linkedWorkflowNoOptions: "أضف خيارًا واحدًا على الأقل لربط سير عمل.",
    linkedWorkflowNoWorkflows: "لا يوجد سير عمل نشط آخر في هذا المشروع.",
    linkedWorkflowLoading: "جارٍ تحميل سير العمل...",
    linkedWorkflowAdvancedRules:
      "قواعد تم إعدادها خارج هذه اللوحة (يتم الاحتفاظ بها عند الحفظ)",
    linkedWorkflowLinkedTo: "سير العمل المرتبط",
    linkedWorkflowLoadFailed: "تعذر تحميل سير العمل المرتبط.",
    linkedWorkflowNoFields: "لا تحتوي سير العمل هذه على حقول للمعاينة.",
    linkedWorkflowDepthLimit:
      "لا يتم توسيع سير العمل المرتبطة المتداخلة أكثر من ذلك في المعاينة.",
    English: "إنجليزي",
    Urdu: "الأردية",
    Arabic: "عربي",
    History: "تاريخ",
    Heading: "رأس الموضوع",
    Name: "اسم",
    Email: "بريد إلكتروني",
    Phone: "الهاتف",
    Address: "عنوان",
    DatePicker: "منتقي التاريخ",
    TakePhoto: "التقط صورة",
    MultipleImages: "صور متعددة",
    Signature: "التوقيع",
    RadioButton: "زر الراديو",
    Checkbox: "خانة الاختيار",
    Dropdown: "اسقاط",
    Number: "رقم",
    Time: "وقت",
    LongText: "نص طويل",
    Barcode: "الباركود",
    wfElTooltipHeading: "استخدم هذا لإضافة عنوان.",
    wfElTooltipName: "أدخل الاسم للحقل.",
    wfElTooltipEmail: "أدخل عنوان بريد إلكتروني صالح.",
    wfElTooltipPhone: "أدخل رقم الهاتف.",
    wfElTooltipAddress: "أدخل العنوان.",
    wfElTooltipDate: "اختر تاريخاً من التقويم.",
    wfElTooltipPhoto: "ارفع صورة.",
    wfElTooltipMultiImage: "ارفع صوراً متعددة.",
    wfElTooltipSignature: "أضف توقيعاً.",
    wfElTooltipRadio: "اختر خياراً واحداً من بين عدة خيارات.",
    wfElTooltipCheckbox: "حدد خيارات متعددة إن أمكن.",
    wfElTooltipDropdown: "اختر خياراً من القائمة المنسدلة.",
    wfElTooltipNumber: "أدخل قيمة رقمية.",
    wfElTooltipTime: "اختر وقتاً محدداً.",
    wfElTooltipLongText: "أدخل نصاً تفصيلياً أو أوصافاً.",
    wfElTooltipBarcode: "امسح رمزاً شريطياً للإدخال.",
    wfElTooltipOcr: "التعرف الضوئي على الحروف.",
    wfElTooltipGps: "نظام تحديد المواقع العالمي.",
    wfElTooltipSignalQuality: "يلتقط تلقائيًا جودة إشارة شبكة الجهاز.",
    workflowModalPreviewOptionsEmpty:
      "أضف الخيارات في منشئ النموذج لعرضها هنا.",
    NotificationSound: "صوت الإخطار",
    TestSound: "اختبار الصوت",
    Configurations: "التكوينات",
    TermsAndConditions: "الشروط والأحكام",
    DragDropTermsConditionFile: "اسحب وأفلِت ملف الشروط والأحكام",
    PrivacyAcceptance: "قبول الخصوصية",
    DragDropPrivacyAcceptanceFile: "اسحب وأفلِت ملف قبول الخصوصية",
    TermsandConditionPdf: "الشروط والحالة.pdf",
    view: "منظر",
    NoReportDataavailble: "لا توجد بيانات تقرير متاحة",
    getStartedRequestingReport: "ابدأ بطلب تقريرك الأول.",
    noRecordsMatchSearch: "لا توجد سجلات تطابق بحثك",
    tryAdjustingFilters: "حاول تعديل عوامل التصفية أو مصطلحات البحث للعثور على ما تبحث عنه.",
    clearFilters: "مسح عوامل التصفية",
    UnexpectedResponseFormat: "تنسيق رد غير متوقع. يُرجى المحاولة مرة أخرى.",
    chooseFile: "اختر ملف",
    noFile: "لم يتم اختيار أي ملف",
    UsernameRequired: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0633\u062a\u062e\u062f\u0645 \u0645\u0637\u0644\u0648\u0628",
    PasswordRequired: "كلمة المرور مطلوبة",
    PasswordMustBeAtLeast8Characters:
      "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل",
    IncludeDeletedRecords: "تضمين السجلات المحذوفة",
    includedeletedrecordstooltip: "تضمين مهام سير العمل والمهام المحذوفة في التقرير",
    selectdurationtooltip: "تحديد النطاق الزمني للتقرير",
    selectduration: "تحديد المدة",
    // "أحتاج تقريرًا عن [الأنشطة] يغطي [المدة]" -- verb leads, so no suffix.
    reportsummaryprefix: "أحتاج تقريرًا عن",
    reportsummarycovering: "يغطي",
    reportsummarysuffix: "",
    selectactivities: "اختر الأنشطة",
    activitiesjoinand: "{first} و{second}",
    activitieslistheader: "الأنشطة ({count})",
    reportrangedates: "من {from} إلى {to}",
    reportrangecycles: "لـ {cycles}",
    requestreporttooltip: "إنشاء تقرير للأنشطة والمدة المحددة",
    downloadreporttooltip: "تنزيل ملف التقرير الذي تم إنشاؤه",

    pleaseFillAllFieldsBeforeSaving: "يرجى ملء جميع الحقول قبل الحفظ",
    ruleCreatedSuccessfully: "تم إنشاء القاعدة بنجاح",
    pleaseSelectFromDateToDate:
      'الرجاء تحديد كل من "من التاريخ" و"إلى التاريخ".',

    exportBtn: "تصدير",
    exportOneFilter: "عامل تصفية واحد",
    exportManyFilters: "{count} عوامل تصفية",
    deleteAllFilteredMessage: "تم تطبيق {filters}. سيتم حذف المهام المطابقة لعوامل التصفية المطبقة فقط.",
    deleteAllUnfilteredMessage: "لم يتم تطبيق أي عامل تصفية. سيتم حذف جميع المهام في هذا النشاط.",
    deleteAllFilteredTooltip: "حذف المهام المطابقة لعوامل التصفية المطبقة فقط",
    deleteAllUnfilteredTooltip: "حذف جميع المهام في هذا النشاط",
    exportNoFiltersWarning:
      "لم يتم تطبيق أي عوامل تصفية، لذا سيتم تصدير كل المهام في التحديد. قد يستغرق إنشاء الملف وقتًا طويلاً في سير عمل كبير.",
    selectProjectForFullExport: "اختر مشروعًا قبل تصدير كل الأنشطة.",
    importBtn: "استيراد",
    addTaskBtn: "إضافة مهمة",
    attachProof: "إرفاق إثبات (PDF/صورة)",
    attachProofNote:
      "ملاحظة: يتم تخزين المستند المُرفَق مع هذا الحساب وسيكون متاحًا للعرض لاحقًا.",
    currentAttachment: "يوجد مستند مرفق حاليًا",
    viewAttachment: "عرض المستند المرفق",
    removeAttachment: "إزالة المرفق",
    maxAttachmentsExceeded: "يمكنك تحميل {count} مرفقات كحد أقصى",
    attachmentTooLarge: "يتجاوز الملف الحد الأقصى المسموح به وهو {size} ميغابايت",
    filesSelected: "ملفات محددة",
    attachmentUnavailable: "المرفق غير متوفر",
    viewLabel: "عرض",
    attachmentSourceRc: "RC",
    attachmentSourceTask: "مهمة",
    attachmentSourceInstalment: "خطة التقسيط",
    activityAnalytics: "تحليلات النشاط",
    analyticsLabel: "التحليلات",
    analyticsStatusLabel: "الحالة",
    chartSelectFiltersHint: "اختر النشاط، الحالة والتواريخ لعرض المخطط",
    chartLoading: "جاري التحميل...",
    taskActions: "تفاصيل المهمة",
    selectedCountLabel: "محدد",
    selectedLocation: "الموقع المحدد",
    drawnArea: "منطقة مرسومة",
    clearSelection: "مسح",
    clickMarkerForLocationDetails:
      "انقر على العلامة في الخريطة لعرض تفاصيل الموقع",
    taskDetailsSection: "تفاصيل المهمة",
    loadingTaskDetails: "جاري تحميل تفاصيل المهمة...",
    clickMarkerLoadTaskDetails: "انقر على العلامة لعرض تفاصيل المهمة",
    taskStatusSection: "حالة المهمة",
    allStatusLabel: "الكل",
    availableAgents: "الوكلاء المتاحون",
    searchFieldAgentsPlaceholder: "ابحث عن الوكلاء الميدانيين...",
    noAgentsMatchSearch: "لا يوجد وكلاء مطابقون لبحثك",
    noAgentsAvailable: "لا يوجد وكلاء متاحون",
    loadingAgentsLabel: "جاري تحميل الوكلاء...",
    statusActiveLabel: "نشطة",
    statusInProgressLabel: "قيد التنفيذ",
    statusCompletedLabel: "مكتملة",
    statusAssignedLabel: "مُعيّنة",
    statusOnHoldLabel: "معلّقة",
    unassignedLabel: "غير معيّن",
    taskIdLabel: "معرّف المهمة",
    assigneeLabel: "المكلّف",
    completedCountSuffix: "مكتمل",
    tasksInDrawnAreaTitle: "مهام في المنطقة المرسومة",
    tasksListTitle: "مهام",
    centerApproxLabel: "المركز (تقريبي)",
    latLongUpperLabel: "خط العرض / الطول",
    agentUpperLabel: "الوكيل",
    activeTasksUpperLabel: "المهام النشطة",
    taskWord: "مهمة",
    tasksWord: "مهام",
    assignTaskCountVerb: "تعيين",
    taskSingular: "مهمة",
    tasksPlural: "مهام",
    onlineLabel: "متصل",
    offlineLabel: "غير متصل",
    showOnlineAgentsTitle: "عرض الوكلاء المتصلين",
    showOfflineAgentsTitle: "عرض الوكلاء غير المتصلين",
    onlyActiveTasksAssignableTitle: "يمكن تعيين المهام النشطة فقط",
    consNameEnglish: "اسم المستهلك (بالإنجليزية)",
    consNameArabic: "اسم المستهلك (بالعربية)",
    meterNoLabel: "رقم العداد",
    consumerTypeLabel: "نوع المستهلك",
    phoneLabel: "الهاتف",
    lastReadTypeLabel: "نوع القراءة الأخيرة",
    lastReadingLabel: "آخر قراءة",
    lastReadingDateLabel: "تاريخ آخر قراءة",
    averageLabel: "المتوسط",

    instalmentPlanNotExisting: "خطة التقسيط غير موجودة لرقم الحساب المحدد",
    remarksError: "حقل الملاحظات مطلوب",
    previewPlanError: "",
    selectActivityAndMap: "تحديد النشاط والخريطة",
    selectActivityLabel: "تحديد النشاط",
    selectMapLabel: "تحديد الخريطة",
    indoorMap: "الخريطة الداخلية",
    drawOnMap: "الرسم على الخريطة",
    calendarLabel: "التقويم",
    activityPanel: "لوحة النشاط",
    fullScreenLabel: "ملء الشاشة",
    detailPanel: "لوحة التفاصيل",
    columnsModalMinThreeRequired: "مطلوب اختيار 3 أعمدة على الأقل.",
    columnsLabel: "الأعمدة",
    toggleColumns: "تبديل الأعمدة",
    columnsTooltip: "اختر الأعمدة التي تريد عرضها في الجدول.",
    columnsModalTitle: "تخصيص الأعمدة",
    columnsModalSubtitle: "اختر الأعمدة الظاهرة ورتّب ترتيب العرض",
    columnsModalShowHide: "إظهار / إخفاء الأعمدة",
    columnsModalSearchPlaceholder: "ابحث في الأعمدة...",
    columnsModalSelectAll: "تحديد الكل",
    columnsModalClearAll: "مسح الكل",
    columnsModalOrderTitle: "ترتيب الأعمدة",
    columnsModalOrderHint: "الأعلى يظهر أولًا في الجدول",
    columnsModalAtLeastOne: "اختر عمودًا واحدًا على الأقل.",
    columnsModalCountOf: "من",
    columnsModalCountVisible: "ظاهر",
    columnsModalApply: "تطبيق التغييرات",
    columnsModalCloseAria: "إغلاق نافذة تخصيص الأعمدة",
    columnsModalMoveUp: "تحريك لأعلى",
    columnsModalMoveDown: "تحريك لأسفل",
    columnsManageTitle: "إدارة الأعمدة",
    columnsResetDefault: "إعادة التعيين إلى الافتراضي",
    columnsModalResetDefault: "إعادة التعيين إلى الافتراضي",
    super_admin: "مسؤول متميز",
    roles: "الأدوار",
    appliedFiltersAria: "عوامل التصفية المطبقة",
    reportEmailsOptional: "رسائل البريد الإلكتروني للتقارير (اختياري)",
    reportEmailsDescription:
      "أضف عنوان بريد إلكتروني واحدًا أو أكثر لاستلام التقارير.",
    addAnotherEmail: "أضف بريدًا إلكترونيًا آخر",
    removeEmail: "إزالة البريد",

    meterBarCode: "الباركود الخاص بالعداد",
    components: "عناصر",
    meterType: "نوع العداد",
    manufacturingYear: "سنة التصنيع",
    meterMake: "الشركة المصنعة للعداد",
    activationDate: "تاريخ التفعيل",
    batchNo: "رقم الدفعة",
    installationStatus: "حالة التثبيت",
    createBy: "تم إنشاؤها بواسطة",
    createdAt: "تم إنشاؤه في",
    simNo: "رقم الشريحة",
    ipAddress: "عنوان الملكية الفكرية",
    iccid: "iccid",
    apn: "apn",
    op: "مرجع سابق",
    balance: "توازن",
    simDetailUpdatedAt: "تم تحديث تفاصيل السيم في",
    transferredFrom: "منقول من",
    transferredTo: "نقل الى",
    DragYourElementsToSecondPageFromLeftPanel:
      ".أسحب العناصر من الصفحة الثانية من بين اللوحات اليمنى",
    Deactive: "غير نشط",
    Yes: "نعم",
    WhatDoYouWantExistingAccounts: "ماذا تريد أن تفعل بالحسابات الموجودة؟",
    updateAlreadyExistingAccountEntries:
      "تحديث إدخالات الحساب الموجودة بالفعل؟",
    createNewAccountEntries: "إنشاء إدخالات حساب جديدة؟",
    customerDetails: "تفاصيل إنشاء القسط",
    created_By: "تم إنشاؤه بواسطة",
    accountNo: "رقم الحساب",
    mapAccountSearchPlaceholder: "ابحث برقم الحساب",
    mapAccountNotFound: "الحساب غير موجود",
    mapAccountLocationUnavailable: "الموقع غير متوفر لهذا الحساب",
    civilId: "معرف العميل",
    phoneNo: "رقم الهاتف",
    comment: "تعليق",
    attachments: "المرفقات",
    employee: "موظف", // employed id added by harshit vachhani
    employeeIdLabel: "معرّف الموظف",
    subContract: "العقد من الباطن", // subContract added by harshit vachhani
    subContractIdLabel: "معرّف المقاول الفرعي",
    // App Update Config
    appUpdateConfig: "إعدادات تحديث التطبيق",
    appUpdateConfigTooltip: "إعدادات تحديث التطبيق، إدارة إعدادات تحديث التطبيق",
    appUpdateConfigTitle: "إعدادات تحديث التطبيق",
    appUpdateConfigDescription: "إدارة إعدادات تحديث التطبيق",
    appUpdatePlatform: "المنصة",
    iosConfigComingSoonTooltip: "إعدادات iOS غير متوفرة بعد",
    appUpdateLatestVersion: "أحدث إصدار",
    appUpdateLatestBuildNumber: "أحدث رقم بناء",
    appUpdateMinBuildNumber: "الحد الأدنى لرقم البناء المدعوم",
    appUpdateTitleLabel: "العنوان",
    appUpdateMessageLabel: "الرسالة",
    appUpdateForceUpdate: "تحديث إجباري",
    appUpdateUrlLabel: "رابط التطبيق",
    appUpdateReleaseNotes: "ملاحظات الإصدار",
    appUpdateReleaseNotesPlaceholder: "ملاحظة واحدة في كل سطر",
    appUpdateFieldRequired: "هذا الحقل مطلوب",
    appUpdateReleaseNotesRequired: "مطلوب ملاحظة إصدار واحدة على الأقل",
    appUpdateNumberInvalid: "يجب أن يكون رقمًا صالحًا",
    appUpdateNumberNegative: "يجب أن يكون رقمًا موجبًا",
    appUpdateUpdatedAt: "تاريخ التحديث",
    editAppUpdateConfigTooltip: "تعديل الإعدادات",
    updateAppUpdateConfigTooltip: "تحديث الإعدادات",
    cancelAppUpdateConfigTooltip: "تجاهل التغييرات",
    savingAppUpdateConfigTooltip: "جارٍ الحفظ...",
    switchPlatformDisabledTooltip: "احفظ التغييرات أو ألغِها قبل تبديل المنصة",
    appUpdateConfigUpdateSuccess: "تم تحديث الإعدادات بنجاح",
    appUpdateConfigLoadError: "فشل تحميل الإعدادات",
    appUpdateConfigUpdateError: "فشل تحديث الإعدادات",
    taskRoadmap: "مسار المهمة",
    taskRoadmapTooltip: "انقر لعرض مسار المهمة",
    roadmapTimeline: "الجدول الزمني",
    roadmapDetails: "تفاصيل المهمة",
    roadmapLoading: "جارٍ تحميل مسار المهمة...",
    roadmapLoadFailed: "فشل تحميل مسار المهمة",
    roadmapNoData: "لا يوجد مسار متاح لهذه المهمة",
    roadmapNoTimeline: "لم يتم تسجيل أي أحداث لهذه المهمة",
    roadmapWorkflow: "سير العمل",
    roadmapAccountNo: "رقم الحساب",
    roadmapArea: "المنطقة",
    roadmapCompletedBy: "أُنجزت بواسطة",
    roadmapCreatedAt: "تاريخ الإنشاء",
    roadmapFinishedAt: "تاريخ الإنهاء",
    roadmapTaskNote: "ملاحظة المهمة",
    roadmapRemarks: "ملاحظات",
    roadmapReading: "القراءة",
    roadmapAssignedTo: "تم التعيين إلى",
    roadmapBy: "بواسطة",
    roadmapLocation: "الموقع",
    roadmapSource: "المصدر",
    roadmapDeleted: "محذوفة",
    roadmapPhotos: "الصور",
    roadmapPhotoField: "الحقل",
    roadmapPhotoLink: "رابط الصورة",
    roadmapCompletionInfo: "معلومات إنجاز المهمة",
    roadmapFieldValue: "القيمة",
    roadmapQueNo: "رقم السؤال",
    // Column Access Management
    columnAccessManagementTitle: "إدارة الوصول إلى الأعمدة",
    columnAccessManagementSubtitle: "تحكم في الأعمدة التي يمكن لكل نوع مستخدم رؤيتها، لكل سير عمل",
    accessManagementBtn: "التحكم في الوصول",
    selectWorkflowLabel: "اختر سير العمل",
    selectUserTypeLabel: "اختر نوع المستخدم",
    selectWorkflowPlaceholder: "اختر سير العمل",
    selectUserTypePlaceholder: "اختر نوع المستخدم",
    currentlyAccessible: "الأعمدة المتاحة حاليًا",
    currentlyAccessibleCountLabel: "{label} - {userType} ({count})",
    manageAccessLabel: "إدارة الوصول",
    manageAccessCountLabel: "{label} - {selected} {of} {total} {selectedLabel}",
    selected: "محدد",
    clear: "مسح",
    noResults: "لا توجد نتائج",
    noWorkflowSelectedTitle: "لم يتم اختيار سير عمل",
    selectWorkflowAndUserTypePrompt: "اختر سير عمل، ثم نوع المستخدم، لعرض وإدارة الوصول إلى الأعمدة.",
    detailsGroupLabel: "أعمدة ديناميكية",
    standardGroupLabel: "أعمدة ثابتة",
    columnAccessExportNote:
      "تنطبق هذه الصلاحيات على الأعمدة الديناميكية فقط. يتبع تصدير Excel صلاحيات الأعمدة الديناميكية، أما الأعمدة الثابتة للنظام فتُدرج دائمًا في الملف المُصدَّر ولا يمكن منحها أو سحبها من هنا.",
    newBadge: "جديد",
    removingBadge: "قيد الإزالة",
    deleteAccessBtn: "حذف الوصول",
    saveChangesBtn: "حفظ التغييرات",
    confirmDeleteColumnAccess: "هل تريد حذف صلاحية الوصول المحفوظة لـ",
    columnAccessSaved: "تم حفظ صلاحية الوصول إلى الأعمدة",
    columnAccessDeleted: "تمت إزالة صلاحية الوصول إلى الأعمدة",
    noColumnAccessTitle: "لا يوجد وصول إلى الأعمدة",
    noColumnAccessMessage: "ليس لديك صلاحية الوصول إلى أي أعمدة لسير العمل هذا. يرجى التواصل مع المسؤول العام.",
    assignedTo: "مسند إلى",
    compareValidationTitle: "التحقق من المقارنة",
    compareValidationSubtitle:
      "قارن هذا الحقل بحقل آخر في سير العمل بدلاً من قيمة ثابتة.",
    compareValidationButton: "التحقق من المقارنة",
    compareValidationCount: "قواعد المقارنة",
    compareValidationFirstField: "الحقل 1 (هذا الحقل)",
    compareValidationSecondField: "الحقل 2",
    compareValidationSelectSecondField: "اختر حقلاً للمقارنة معه",
    compareValidationCondition: "الشرط",
    compareValidationEqual: "يجب أن يكون متساوياً",
    compareValidationNotEqual: "يجب ألا يكون متساوياً",
    compareValidationErrorMessage: "رسالة خطأ",
    compareValidationErrorMessagePlaceholder: "تظهر عند فشل المقارنة",
    compareValidationAdd: "يضيف",
    compareValidationUpdate: "تحديث",
    compareValidationCancel: "يلغي",
    compareValidationAdded: "المقارنات المضافة",
    compareValidationEmpty: "لا توجد قواعد مقارنة بعد.",
    compareValidationNoFields: "أضف حقلاً آخر على الأقل للمقارنة معه.",
    compareValidationEligibleTypes:
      "تعمل المقارنة مع حقول النص والنص الطويل والرقم والبريد الإلكتروني والتاريخ والوقت.",
    compareValidationSelectFieldFirst: "اختر الحقل المراد المقارنة معه.",
    compareValidationDuplicate:
      "تمت مقارنة هذا الحقل بالفعل مع الحقل المحدد.",
    compareValidationSaved: "تم حفظ التحقق من المقارنة.",
    compareValidationRemoved: "تمت إزالة التحقق من المقارنة.",
    compareValidationDeletedField: "حقل محذوف",
    compareValidationDefaultEqualError: "يجب أن يطابق هذا الحقل {field}.",
    compareValidationDefaultNotEqualError:
      "يجب ألا يطابق هذا الحقل {field}.",
    validationTabLabel: "التحقق",
    comparisonTabLabel: "المقارنة",
    addValidationButton: "إضافة تحقق",
    validationEmpty: "لا توجد قواعد تحقق بعد.",
    validationCount: "قواعد التحقق",
    addValidationTooltipDesc:
      "تحقق من قيمة هذا الحقل مقابل رمز تحقق، وحدد رسالة الخطأ التي تظهر عند عدم التطابق.",
    viewValidationTooltipDesc:
      "اعرض أو عدّل أو احذف قواعد التحقق المضافة إلى هذا الحقل.",
    compareValidationTooltipDesc:
      "قارن قيمة هذا الحقل بحقل آخر في سير العمل واشترط أن يكونا متساويين أو غير متساويين.",
  },
  ur: {
    buAccountNumbers: "اکاؤنٹ نمبرز",
    buAccountNo: "اکاؤنٹ نمبر",
    buTypeAccountPlaceholder: "اکاؤنٹ نمبر لکھیں اور اینٹر دبائیں",
    buTypeAndEnterHint: "لکھ کر اینٹر دبائیں، یا اکاؤنٹس کی فہرست پیسٹ کریں۔",
    buDetected: "{n} ملے",
    buAssignmentPriority: "تفویض اور ترجیح",
    buAssignment: "تفویض",
    buCreateTasks: "ٹاسکس بنائیں",
    buUpdatePriority: "ترجیح اپڈیٹ کریں",
    buUpdatePriorityAndAssign: "ترجیح اپڈیٹ کریں اور تفویض کریں",
    buUpdatingPriority: "ترجیح اپڈیٹ ہو رہی ہے...",
    buUpdatePriorityTooltip: "درج کیے گئے اکاؤنٹس کی ترجیح اپڈیٹ کریں",
    buUpdatePriorityAssignTooltip: "ترجیح اپڈیٹ کریں اور منتخب فیلڈ ایجنٹس کو تفویض کریں",
    buCloseDialog: "ڈائیلاگ باکس بند کریں",
    buTotalAccountsHint: "اوپر شامل کیے گئے اکاؤنٹ نمبرز کی کل تعداد۔",
    buCreatingTask: "ٹاسک بنایا جا رہا ہے...",
    buDuplicatesIgnored: "{n} ڈپلیکیٹ اکاؤنٹ نمبر نظرانداز کیے گئے۔",
    buPriorityUpdated: "{n} اکاؤنٹس کی ترجیح اپڈیٹ ہو گئی۔",
    buPriorityUpdateFailed: "ترجیح اپڈیٹ نہیں ہو سکی۔",
    buLookupFailed: "تلاش ناکام ہو گئی۔",
    buUnexpectedError: "ایک غیر متوقع خرابی پیش آ گئی۔",
    buSelectPriority: "براہ کرم ترجیح منتخب کریں۔",
    columnContainsHelp: "ورک فلو کے تمام ٹاسکس میں حروف کے فرق کے بغیر میچ۔",
    selectDateRangeHint: "تاریخ کی حد منتخب کریں (YYYY-MM-DD سے YYYY-MM-DD)",
    dragToReorderColumn: "کالم کی ترتیب بدلنے کے لیے گھسیٹیں",
    dragToResize: "سائز بدلنے کے لیے گھسیٹیں",
    viewFieldAgents: "فیلڈ ایجنٹس دیکھیں",
    noAssigneesOrGroupForUnassign: "تفویض ختم کرنے کے لیے کوئی تفویض شدہ یا گروپ منتخب نہیں کیا گیا۔",
    taskOnHoldSuccess: "ٹاسک روک دیا گیا",
    selectTaskBeforeProceeding: "آگے بڑھنے سے پہلے براہ کرم ایک ٹاسک منتخب کریں!",
    noFieldsMatch: "کوئی فیلڈ مماثل نہیں",
    clearSelectionAria: "انتخاب صاف کریں",
    createTaskSubtitle: "ایک ٹاسک دستی طور پر شامل کریں، ایک ساتھ کئی اپلوڈ کریں، یا شیٹ امپورٹ کریں۔",
    singleTaskUpload: "واحد ٹاسک اپلوڈ",
    bulkTaskUpload: "بلک ٹاسک اپلوڈ",
    selectOnMap: "نقشے پر منتخب کریں",
    categoryName: "زمرے کا نام",
    arabicNameOptional: "عربی نام (اختیاری)",
    enterNewCategory: "نیا زمرہ درج کریں",
    enterArabicNameOptional: "عربی نام درج کریں (اختیاری)",
    selectAZone: "زون منتخب کریں",
    selectPriorityLabel: "ترجیح منتخب کریں",
    activitySelection: "سرگرمی کا انتخاب",
    accessDenied: "آپ کو ان ٹاسکس تک رسائی حاصل نہیں ہے۔",
    back: "واپس",
    createNewAccountsHint: "اس ٹاسک کے ساتھ ایک بالکل نیا اکاؤنٹ رجسٹر کریں",
    enter: "درج کریں",
    fieldAgents: "فیلڈ ایجنٹس",
    high: "زیادہ",
    medium: "درمیانی",
    low: "کم",
    history: "تاریخ",
    listView: "فہرست کا منظر",
    mapView: "نقشے کا منظر",
    loadingTasks: "ٹاسکس لوڈ ہو رہے ہیں...",
    moreActions: "مزید کارروائیاں",
    nofieldagent: "کوئی ایجنٹ دستیاب نہیں",
    noFieldsAvailable: "کوئی فیلڈ دستیاب نہیں",
    nonMandatoryFieldsHint: "اضافی تفصیلات، صرف وہی بھریں جو لاگو ہوں",
    reassignOnlyExisting: "صرف موجودہ کو دوبارہ تفویض کریں",
    sessionExpired: "سیشن ختم ہو گیا۔ براہ کرم دوبارہ لاگ ان کریں۔",
    taskManagement: "ٹاسک مینجمنٹ",
    taskManagementSubtitle: "اپنی ٹیم کے فیلڈ سروس ٹاسکس کو ٹریک، تفویض اور ایکسپورٹ کریں۔",
    taskSelected: "ٹاسک منتخب",
    tasksSelected: "ٹاسکس منتخب",
    tasksLabel: "ٹاسکس",
    updateExistingAccountsHint: "اس ٹاسک کو سسٹم میں موجود اکاؤنٹ ریکارڈز سے منسلک کریں",
    allActivity: "تمام سرگرمیاں",
    page: "صفحہ",
    refreshBtn: "ریفریش",
    accHistoryTabTooltip: "اکاؤنٹ کی ہسٹری دیکھیں",
    exportReportTabTooltip: "رپورٹس کی درخواست کریں اور ڈاؤن لوڈ کریں",
    dragFieldToCanvas: "کسی فیلڈ کو کینوس پر گھسیٹیں",
    searchField: "فیلڈز تلاش کریں...",
    dragElementsFromLeftPanel: "اپنے عناصر کو بائیں پینل سے گھسیٹیں",
    otherFieldSettings: "دیگر فیلڈ کی ترتیبات",
    requiredField: "فیلڈ لازمی ہے",
    validation: "توثیق",
    validationupdated: "توثیق کامیابی سے اپ ڈیٹ ہو گئی",
    workflowEmptyTitle: "یہاں دیکھنے کے لیے ورک فلو بنائیں",
    workflowEmptyDesc: "ٹاسک فارمز کو تیز اور یکساں طور پر ترتیب دینے کے لیے اپنا پہلا ورک فلو ٹیمپلیٹ بنائیں۔",
    workflowEmptyNoProjectTitle: "شروع کرنے کے لیے پروجیکٹ منتخب کریں",
    workflowEmptyNoProjectDesc: "ورک فلو دیکھنے اور منظم کرنے کے لیے براہ کرم پروجیکٹ منتخب کریں۔",
    workflowEmptySearchTitle: "کوئی ورک فلو نہیں ملا",
    wfEnterYourInput: "اپنی ان پٹ درج کریں",
    wfNoRadioOptions: "کوئی ریڈیو آپشن دستیاب نہیں",
    wfAddFieldsForReport: "رپورٹ کے لیے فیلڈز شامل کریں",
    wfSelectMandatoryField: "لازمی فیلڈ منتخب کریں",
    wfEnterPdfName: "PDF کا نام درج کریں...",
    wfType_text: "متن",
    wfType_number: "نمبر",
    wfType_email: "ای میل",
    wfType_date: "تاریخ",
    wfType_time: "وقت",
    wfType_radio: "ریڈیو",
    wfType_checkbox: "چیک باکس",
    wfType_select: "ڈراپ ڈاؤن",
    wfType_textarea: "طویل متن",
    wfType_file: "فائل",
    wfType_multi_image: "متعدد تصاویر",
    wfType_scan: "اسکین",
    wfType_ocr: "او سی آر",
    wfType_gps: "جی پی ایس",
    wfType_signal_quality: "سگنل کی کوالٹی",
    OCR: "او سی آر",
    GPS: "جی پی ایس",
    CaptureSignalQuality: "سگنل کی کوالٹی حاصل کریں",
    editDepartment: "محکمہ میں ترمیم کریں",
    accHistProjects: "پروجیکٹس",
    accHistTasks: "ٹاسکس",
    accHistWorkflowHistory: "ورک فلو ہسٹری",
    accHistNoProjectDetails: "اس پروجیکٹ میں اکاؤنٹ کی تفصیلات موجود نہیں ہیں۔",
    accHistNoteAll: "بطور سپر ایڈمن، اکاؤنٹ ہسٹری تمام ڈیپارٹمنٹس اور پروجیکٹس کے لیے دکھائی جاتی ہے۔",
    accHistNoteScoped: "اکاؤنٹ ہسٹری صرف آپ کو تفویض کیے گئے ڈیپارٹمنٹس، پروجیکٹس اور ایکٹیویٹیز کے لیے دکھائی جاتی ہے۔",
    taskLocationColumn: "مقام",
    taskLocationTooltip: "ٹاسک کا مقام نقشے پر دیکھیں",
    taskLocationTitle: "منتخب ٹاسک کا مقام",
    orgDcrcSubscription: "DCRC سبسکرپشن",
    orgAutoRc: "آٹو RC",
    orgPoleDc: "پول DC",
    orgInstallmentPlan: "قسطوں کا منصوبہ",
    orgMinPaymentPercent: "کم از کم ادائیگی %",
    orgMinOutstandingAmount: "کم از کم واجب الادا رقم",
    orgSvMaxIterations: "SV کی زیادہ سے زیادہ تکرار",
    orgDcrcWorkflowConfig: "DCRC ورک فلو کنفیگریشن (ہر مرحلے کے لیے سرگرمی لازمی ہے)",
    orgDcrcWorkflowConfigPoleDc: "DCRC ورک فلو کنفیگریشن (ہر مرحلے کے لیے سرگرمی لازمی ہے، بشمول POLE_DC)",
    orgLoadingActivities: "سرگرمیاں لوڈ ہو رہی ہیں…",
    orgActivityWorkflow: "سرگرمی (ورک فلو)",
    orgSelectActivity: "سرگرمی منتخب کریں",
    orgDelayDays: "تاخیر (دن)",
    orgEndCycleField: "سائیکل کے اختتام کا فیلڈ",
    orgEndCycleValues: "سائیکل کے اختتام کی قدریں",
    orgSelectActivityFirst: "پہلے سرگرمی منتخب کریں",
    orgLoading: "لوڈ ہو رہا ہے…",
    orgLoadingOptions: "اختیارات لوڈ ہو رہے ہیں…",
    orgNoFieldsInWorkflow: "ورک فلو میں کوئی فیلڈ نہیں",
    orgSelectField: "فیلڈ منتخب کریں",
    orgSelectValues: "قدریں منتخب کریں",
    orgNextStepSuccess: "اگلا مرحلہ (کامیابی)",
    orgNextStepFailure: "اگلا مرحلہ (ناکامی)",
    orgNone: "کوئی نہیں",
    orgField: "فیلڈ",
    orgValues: "قدریں",
    orgNoValuesForField: "اس فیلڈ کے لیے کوئی قدر نہیں",
    orgSelectFieldFirst: "پہلے فیلڈ منتخب کریں",
    orgLoadActivityFirst: "پہلے سرگرمی لوڈ کریں",
    orgShowProject: "پروجیکٹ دکھائیں",
    orgHideProject: "پروجیکٹ چھپائیں",
    orgShowing: "دکھایا جا رہا ہے…",
    orgLoadingProject: "پروجیکٹ لوڈ ہو رہا ہے…",
    orgShowProjectTitle: "پروجیکٹ دکھائیں؟",
    orgHideProjectTitle: "پروجیکٹ چھپائیں؟",
    orgShowProjectDesc: "\"{name}\" کو دوبارہ دکھائیں؟ یہ فہرست میں نظر آئے گا۔",
    orgHideProjectDesc: "\"{name}\" کو فہرست سے چھپائیں؟ آپ اسے بعد میں اسی جگہ سے دوبارہ دکھا سکتے ہیں۔",
    orgProjectVisible: "پروجیکٹ دوبارہ نظر آ رہا ہے",
    orgProjectHidden: "پروجیکٹ چھپا دیا گیا",
    orgFailedShowProject: "پروجیکٹ دکھانے میں ناکامی",
    orgFailedUpdateStatus: "اسٹیٹس اپ ڈیٹ کرنے میں ناکامی",
    orgFailedDeleteOrg: "ادارہ حذف کرنے میں ناکامی",
    orgDeleteOrgSuccess: "ادارہ کامیابی سے حذف ہو گیا",
    orgInvalidEmails: "براہ کرم درست ای میل ایڈریس درج کریں۔",
    orgSelectActivityAllSteps: "براہ کرم تمام DCRC مراحل ({steps}) کے لیے سرگرمی (ورک فلو) منتخب کریں۔",
    completionSubmissionNoteTitle: "ٹاسک کے کامیابی سے مکمل ہونے کے لیے کم از کم ایک اصول متعین کریں۔",
    completionSubmissionRuleRequired: "لازمی فیلڈ: فیلڈ خالی چھوڑنے پر پیغام دکھایا جاتا ہے۔",
    completionSubmissionRuleMismatch: "نمبر میں عدم مطابقت: جمع کرایا گیا نمبر مطلوبہ نمبر سے مختلف ہو تو پیغام دکھایا جاتا ہے۔",
    mapTipMapView: "نقشے کا منظر",
    mapTipListView: "فہرست کا منظر",
    mapTipShowAll: "تمام ٹاسکس دکھائیں",
    mapTipShowOnly: "صرف {status} ٹاسکس دکھائیں",
    mapTipSatellite: "سیٹلائٹ منظر",
    mapTipZoomIn: "زوم اِن",
    mapTipZoomOut: "زوم آؤٹ",
    mapTipExport: "ٹاسک رپورٹ ایکسپورٹ کریں",
    mapTipPrevWeek: "پچھلا ہفتہ",
    mapTipNextWeek: "اگلا ہفتہ",
    mapTipHideDates: "تاریخ نیویگیشن چھپائیں",
    mapTipCloseCalendar: "کیلنڈر پینل بند کریں",
    mapSelectFromDate: "شروع کی تاریخ منتخب کریں",
    mapSelectToDate: "اختتامی تاریخ منتخب کریں",
    powerbidashboard: "پاور بی آئی ڈیش بورڈ",
    failedToFetchTaskStatus: "ٹاسک اسٹیٹس حاصل کرنے میں ناکامی۔ براہ کرم دوبارہ کوشش کریں۔",
    failedToFetchUserCount: "صارفین کی تعداد حاصل کرنے میں ناکامی۔ براہ کرم دوبارہ کوشش کریں۔",
    noDataAvailableForWorkflow: "اس ورک فلو کے لیے ٹاسک اسٹیٹس کا ڈیٹا دستیاب نہیں ہے۔",
    selectOrganizationPrompt: "براہ کرم ایک تنظیم منتخب کریں۔",
    selectWorkflowPrompt: "براہ کرم ایک ورک فلو منتخب کریں۔",
    numberOfUsers: "صارفین کی تعداد",
    numberOfTasks: "ٹاسکس کی تعداد",
    taskPriorityAxis: "ٹاسک کی ترجیح",
    completedTaskAxis: "مکمل ٹاسک",
    taskCount: "ٹاسک کی تعداد",
    priorityCount: "ترجیح کی تعداد",
    totalCompletedTasks: "مکمل ٹاسکس",
    totalTasks: "کل ٹاسکس",
    totalUsers: "کل صارفین",
    userCount: "صارفین کی تعداد",
    unknownUser: "نامعلوم صارف",
    totalEntries: "کل اندراجات",
    numberOfEntries: "اندراجات کی تعداد",
    entryCount: "اندراجات کی تعداد",
    totalWorked: "کل کام کا وقت",
    averageDaily: "یومیہ اوسط",
    tasksCountLabel: "{n} ٹاسکس",
    usersCountLabel: "{n} صارفین",
    dateCannotBeFuture: "{field} مستقبل میں نہیں ہو سکتا۔",
    userFormLeaveBlank: "موجودہ برقرار رکھنے کے لیے خالی چھوڑیں",
    userFormCreateGroup: "گروپ بنائیں",
    userFormNewGroupName: "نئے گروپ کا نام",
    userFormCloseAria: "صارف کا فارم بند کریں",
    userFormSignatureReady: "دستخط کی تصویر تیار ہے",
    userFormChooseSignature: "دستخط منتخب کریں",
    userFormReplaceSignature: "دستخط تبدیل کریں",
    userFormSignatureFormats: "JPG، PNG معاون ہیں",
    userFormUploadSignature: "دستخط اپ لوڈ کریں",
    userFormEditUser: "صارف میں ترمیم کریں",
    userFormTokenMissing: "ٹوکن موجود نہیں ہے",
    userFormPwSpecial: "ایک خاص علامت",
    userFormPwNumber: "ایک عدد",
    userFormPwLower: "ایک چھوٹا حرف",
    userFormPwUpper: "ایک بڑا حرف",
    userFormPwMin: "کم از کم 8 حروف",
    userFormPasswordSpecial: "پاس ورڈ میں کم از کم ایک خاص علامت ہونی چاہیے",
    userFormPasswordNumber: "پاس ورڈ میں کم از کم ایک عدد ہونا چاہیے",
    userFormPasswordLower: "پاس ورڈ میں کم از کم ایک چھوٹا حرف ہونا چاہیے",
    userFormPasswordUpper: "پاس ورڈ میں کم از کم ایک بڑا حرف ہونا چاہیے",
    userFormPasswordMin: "پاس ورڈ کم از کم 8 حروف کا ہونا چاہیے",
    userFormPasswordRequired: "پاس ورڈ ضروری ہے",
    userFormFieldMustBeNumber: "{field} ایک عدد ہونا چاہیے",
    userFormFieldRequired: "{field} ضروری ہے",
    userFormClockInRequired: "کلاک اِن ضروری ہے",
    userFormActivityRequired: "سرگرمی ضروری ہے",
    userFormProjectRequired: "پروجیکٹ ضروری ہے",
    userFormDepartmentRequired: "شعبہ ضروری ہے",
    userFormOrgRequired: "تنظیم ضروری ہے",
    userFormUserTypeRequired: "صارف کی قسم ضروری ہے",
    userFormPhoneRequired: "فون نمبر ضروری ہے",
    userFormEmailRequired: "ای میل ضروری ہے",
    userFormNameRequired: "پورا نام ضروری ہے",
    userFilterNone: "کوئی نہیں",
    userFilterAll: "سب",
    userFilterNoMatches: "کوئی مطابقت نہیں",
    userFilterSearch: "تلاش…",
    userViewAll: "سب دیکھیں",
    userColEmployeeId: "ملازم آئی ڈی",
    userColWorkflows: "ورک فلوز",
    userColRoles: "رولز",
    userListNoProjectTitle: "کوئی پروجیکٹ منتخب نہیں",
    userListNoProjectHint: "صارفین دیکھنے کے لیے صفحے کے اوپر شعبہ اور پروجیکٹ منتخب کریں۔",
    userFilterLimitReached: "آپ ایک وقت میں زیادہ سے زیادہ 15 کالم فلٹرز لگا سکتے ہیں۔ نیا شامل کرنے کے لیے ایک ہٹا دیں۔",
    userContainsHelp: "تمام صارفین میں بڑے اور چھوٹے حروف کا فرق کیے بغیر مماثلت۔",
    timeAgoMonths: "{n} ماہ پہلے",
    timeAgoDays: "{n} دن پہلے",
    timeAgoHours: "{n} گھنٹے پہلے",
    timeAgoMinutes: "{n} منٹ پہلے",
    loginLocation: "مقام",
    noUsersMatchSearch: "آپ کی تلاش سے کوئی صارف مطابقت نہیں رکھتا",
    never: "کبھی نہیں",
    justNow: "ابھی",
    groupMembers: "گروپ کے اراکین",
    groupListInfo: "وہ گروپس منتخب کریں جن تک یہ صارف منتخب شعبے یا شعبوں میں رسائی حاصل کر سکتا ہے۔",
    groupInfo: "فیلڈ ایجنٹ کو منتخب شعبے کے کسی گروپ میں تفویض کریں۔ نیا نام لکھیں اور شامل کرنے کے لیے بنائیں پر کلک کریں۔",
    groupCreated: "گروپ بنا دیا گیا",
    getStartedAddingUser: "اپنا پہلا صارف شامل کر کے شروع کریں۔",
    inventoryAssignmentFileRequired: "Excel فائل منتخب کریں (.xlsx یا .xls)۔",
    inventoryAssignmentInput: "تفویض کا ذریعہ",
    inventoryAssignmentProjectRequired: "اس تفویض کے لیے ایک پروجیکٹ منتخب کریں۔",
    inventoryClearCustody: "تحویل ختم کریں",
    inventoryClearCustodyHint: "ان آئٹمز کی تمام اسٹور اور گروپ تفویضات ختم کریں۔",
    inventoryMeterNumbers: "سیریل نمبر",
    inventoryMeterNumbersHint: "سیریل نمبر (میٹر، موڈیم، سم یا سیل رینج) اسپیس، کوما یا نئی سطر سے الگ کریں۔",
    inventoryMeterNumbersRequired: "ہر منتخب آئٹم کے لیے درست سیریل نمبر درج کریں۔",

    inventoryMissingMeterNumbers: "کچھ منتخب میٹروں کا نمبر موجود نہیں ہے۔",
    inventoryAssignmentSameProject: "ایک ہی پروجیکٹ کے میٹر منتخب کریں۔",
    inventoryAssignmentPending: "تفویض کی درخواست قبول ہو گئی ہے اور کارروائی جاری ہے۔",
    inventoryAssignmentExcel: "Excel سے تفویض کریں",
    inventoryAssignmentExcelHint: "منتخب اسٹور یا گروپ کو میٹر تفویض کرنے کے لیے Excel فائل اپ لوڈ کریں۔ فائل منتخب قطاروں کی جگہ استعمال ہوگی۔",

    inventoryMeterHistoryTitle: "میٹر ہسٹری اور ٹریس ایبیلٹی",
    inventoryMeterHistorySubtitle: "{identifier} کا مکمل لائف سائیکل لاگ",
    inventoryDetailsTitle: "انوینٹری تفصیلات",
    inventoryDetailsSection: "تفصیلات",
    inventoryViewHistory: "ہسٹری دیکھیں →",
    inventoryEditItem: "تفصیلات میں ترمیم",
    inventoryEditStatus: "اسٹیٹس",
    inventoryEditStore: "اسٹور",
    inventoryEditGroup: "گروپ",
    inventoryEditSelectGroup: "گروپ منتخب کریں",
    inventoryEditSave: "تبدیلیاں محفوظ کریں",
    inventoryEditSuccess: "انوینٹری آئٹم کامیابی سے اپ ڈیٹ ہو گیا۔",
    inventoryBackToDetails: "تفصیلات پر واپس",
    inventoryMovementTimeline: "حرکت اور واقعات کی ٹائم لائن",
    inventoryUpdated: "اپ ڈیٹ ہوا",
    inventoryBy: "بذریعہ",
    inventoryNote: "نوٹ",
    inventoryIdentifier: "شناخت",
    inventoryItemType: "آئٹم کی قسم",
    inventoryColItemType: "آئٹم کی قسم",
    inventoryColIdentifier: "شناخت",
    inventoryColStatus: "اسٹیٹس",
    inventoryColComponents: "اجزاء",
    inventoryColGroupAssignment: "گروپ تفویض",
    inventoryColConditionNote: "حالت کا نوٹ",
    inventoryColCreatedBy: "بنانے والا",
    inventoryColCreatedAt: "بنانے کی تاریخ",
    inventoryColUpdatedBy: "اپ ڈیٹ کرنے والا",
    inventoryColUpdatedAt: "اپ ڈیٹ کی تاریخ",
    inventoryColStore: "اسٹور",
    inventoryColSource: "ذریعہ",
    inventoryColLocation: "مقام",
    inventoryColLatitude: "عرض بلد",
    inventoryColLongitude: "طول بلد",
    inventoryColTransferFrom: "منتقلی از",
    inventoryColTransferTo: "منتقلی بنام",
    inventoryTypeNewMeter: "نیا میٹر",
    inventoryTypeOldMeter: "پرانا میٹر",
    inventoryTypeModem: "موڈم",
    inventoryTypeSimCard: "SIM کارڈ",
    inventoryTypeSeal: "سیل",
    inventorySealPrefix: "سیل پری فکس",
    inventorySealFrom: "سیل از",
    inventorySealTo: "سیل تا",
    inventorySealPrefixPlaceholder: "مثلاً SL",
    inventorySealFromPlaceholder: "مثلاً 1001",
    inventorySealToPlaceholder: "مثلاً 2000",
    inventorySealRangeRequired: "سیل کا ابتدائی اور آخری نمبر درج کریں۔",
    inventorySealRangeInvalid: "سیل از اور سیل تا مکمل اعداد ہونے چاہئیں، اور تا، از سے کم نہیں ہو سکتا۔",
    inventorySealRangePreview: "{first} – {last} بنائے گا ({count} سیل)",
    inventorySealRange: "سیل رینج",
    inventorySealCount: "سیل کی تعداد",
    inventorySealNumbers: "سیل نمبرز",
    inventorySealsFitted: "لگائے گئے سیل",
    inventorySealRangeHistoryTitle: "سیل رینج ہسٹری اور ٹریس ایبیلٹی",
    inventorySealTotal: "کل سیل",
    inventorySealFittedCount: "لگائے گئے",
    inventorySealRemaining: "باقی",
    inventorySealRemainingOfTotal: "{total} میں سے {available} باقی",
    inventorySealNoneFitted: "ابھی تک کوئی سیل نہیں لگایا گیا",
    inventorySealColSeal: "سیل",
    inventorySealColMeter: "میٹر",
    inventorySealColFittedBy: "لگانے والا",
    inventorySealColDate: "تاریخ",
    inventoryHistorySealUsedEvent: "سیل {seal} لگایا گیا",
    inventorySealOpenMeterHistory: "اس میٹر کی ہسٹری کھولیں",
    inventorySealBackToRange: "سیل رینج پر واپس جائیں",
    inventorySealNumbersInfoTitle: "اس میٹر پر لگائے گئے سیل",
    inventorySealNumbersInfo: "یہ سیل نمبرز میٹر پر اس وقت لگائے گئے جب فیلڈ ٹاسک کے ذریعے اسے انسٹال کیا گیا۔",
    inventorySealNumbersCellTooltip: "اس انسٹال شدہ میٹر پر {count} سیل لگائے گئے",
    inventorySealRangeFittedInfoTitle: "اس رینج سے استعمال شدہ سیل",
    inventorySealRangeFittedInfo: "اس رینج کے وہ سیل جو انسٹال شدہ میٹرز پر لگ چکے ہیں۔ یہ اب دستیاب نہیں ہیں۔",
    inventoryImportSealColumns: "سیل شیٹس میں From اور To کالم درکار ہیں، Prefix کالم اختیاری ہے (Seal From / Seal To / Seal Prefix بھی چلتے ہیں)۔ سیریل کالم کی ضرورت نہیں۔",
    inventoryImportSealColumnsFound: "شناخت شدہ: {found}",
    inventoryImportSealColumnsMissing: "ابھی نہیں ملے: {missing} (آپ انہیں کالم میپنگ میں منتخب کر سکتے ہیں)",
    inventoryImportDownloadSealTemplate: "سیل ٹیمپلیٹ ڈاؤن لوڈ کریں",
    inventoryStatus: "اسٹیٹس",
    inventoryStoreId: "اسٹور آئی ڈی",
    inventoryAssignedToId: "تفویض (یوزر آئی ڈی)",
    inventoryGroupAssignment: "گروپ اسائنمنٹ",
    inventoryAction: "ایکشن",
    rowsPerPage: "ہر صفحہ قطاریں",
    inventoryApply: "لاگو کریں",
    inventorySelectAll: "سب منتخب کریں",
    inventorySelectNone: "کوئی منتخب نہ کریں",
    inventoryFilterSearchValues: "ویلیوز تلاش کریں...",
    inventoryFilterNoValues: "کوئی ویلیوز نہیں",
    inventoryFilterOk: "ٹھیک ہے",
    inventoryFilterLoadingValues: "ویلیوز لوڈ ہو رہی ہیں...",
    inventoryFilterBlanks: "(خالی)",
    inventoryFilterContainsPlaceholder: "پر مشتمل...",
    inventoryFilterContainsHelp: "حروف کے فرق کے بغیر میچ ہوگا۔",
    inventoryMeterNumber: "میٹر نمبر",
    inventoryRowNumber: "نمبر",
    inventoryMeterType: "میٹر کی قسم",
    inventoryStoreLocation: "مقام",
    inventoryGroup: "گروپ",
    inventoryAssignment: "اسائنمنٹ",
    inventorySimNo: "SIM نمبر",
    inventoryModemNo: "موڈم نمبر",
    inventoryInstallationDate: "تنصیب کی تاریخ",
    inventoryCreatedAt: "تاریخِ تخلیق",
    inventoryComponentType: "کمپوننٹ کی قسم",
    inventoryComponentId: "کمپوننٹ آئی ڈی",
    inventoryCurrentLocation: "موجودہ مقام",
    inventoryAssignedGroup: "تفویض شدہ گروپ",
    inventoryGroupMembers: "گروپ کے اراکین",
    inventoryCurrentAssignment: "موجودہ اسائنمنٹ",
    inventoryMeterBarcode: "میٹر بارکوڈ",
    inventoryMeterSerialNumber: "میٹر سیریل نمبر",
    inventoryMeterMake: "میٹر میک",
    inventoryManufacturingYear: "مینوفیکچرنگ سال",
    inventoryBatchNumber: "بیچ نمبر",
    inventoryActivationDate: "ایکٹیویشن تاریخ",
    inventoryComponents: "کمپوننٹس",
    inventoryApn: "APN",
    inventoryIpAddress: "آئی پی ایڈریس",
    inventoryInstallationStatus: "تنصیب کی حالت",
    inventoryTransferredFrom: "منتقل کیا گیا از",
    inventoryTransferredTo: "منتقل کیا گیا تا",
    inventoryConditionNote: "حالت کا نوٹ",
    inventorySource: "ماخذ",
    inventoryUploadId: "اپ لوڈ آئی ڈی",
    inventoryCreatedBy: "بنایا گیا بذریعہ",
    inventoryUpdatedAt: "اپ ڈیٹ کی تاریخ",
    inventoryBalance: "بیلنس",
    inventoryOrganizationId: "آرگنائزیشن آئی ڈی",
    inventoryProjectId: "پروجیکٹ آئی ڈی",
    inventoryOp: "OP",
    inventorySimDetailUpdatedAt: "SIM تفصیل اپ ڈیٹ وقت",
    inventoryDeleted: "حذف شدہ",
    inventoryDeletedAt: "حذف کی تاریخ",
    inventoryDeletedBy: "حذف کرنے والا",
    inventoryDeleteReason: "حذف کرنے کی وجہ",
    inventoryReplacementSection: "متبادل اور منسلک کمپوننٹس",
    inventoryValueNewMeter: "نیا میٹر",
    inventoryValueOldMeter: "پرانا میٹر",
    inventoryValueModem: "موڈم",
    inventoryValueSimCard: "SIM کارڈ",
    inventoryValueSmartMeter: "اسمارٹ میٹر",
    inventoryStatusAvailable: "دستیاب",
    inventoryStatusTipAvailable: "انوینٹری میں دستیاب اور تفویض کے لیے تیار ہے۔",
    inventoryStatusAssigned: "تفویض شدہ",
    inventoryStatusTipAssigned: "سب کنٹریکٹر کو تفویض کر دیا گیا ہے۔",
    inventoryStatusReassigned: "دوبارہ تفویض شدہ",
    inventoryStatusTipReassigned: "اسی یا کسی دوسرے سب کنٹریکٹر کو دوبارہ تفویض کیا گیا۔",
    inventoryStatusActive: "فعال",
    inventoryStatusInTransit: "منتقلی میں",
    inventoryStatusTipInTransit: "مقامات یا سب کنٹریکٹرز کے درمیان منتقل ہو رہا ہے۔",
    inventoryStatusInstalled: "نصب شدہ",
    inventoryStatusTipInstalled: "صارف کے احاطے میں نصب۔",
    inventoryStatusRemoved: "ہٹا دیا گیا",
    inventoryStatusTipRemoved: "صارف کے احاطے سے ہٹا دیا گیا۔",
    inventoryStatusReturned: "واپس کیا گیا",
    inventoryStatusTipReturned: "اسٹور کو واپس کر دیا گیا۔",
    inventoryStatusDamaged: "خراب",
    inventoryStatusTipDamaged: "خراب اور استعمال کے قابل نہیں۔",
    inventoryStatusQuarantined: "قرنطینہ",
    inventoryStatusTipQuarantined: "جانچ تک الگ رکھا گیا۔",
    inventoryStatusLost: "گم شدہ",
    inventoryStatusTipLost: "گم ہو گیا۔ تفویض یا منتقل نہیں ہو سکتا۔",
    inventoryStatusRetired: "ریٹائرڈ",
    inventoryStatusTipRetired: "استعمال سے ہٹا دیا گیا۔ تفویض یا منتقل نہیں ہو سکتا۔",
    inventoryAssigned: "تفویض شدہ",
    inventoryAvailable: "دستیاب",
    inventoryViewDetailsAria: "انوینٹری تفصیلات دیکھیں",
    inventoryViewHistoryAria: "انوینٹری ہسٹری دیکھیں",
    inventoryClosePanel: "انوینٹری پینل بند کریں",
    noHistoryFound: "ابھی کوئی ہسٹری دستیاب نہیں۔",
    inventoryHistoryFilterAll: "تمام",
    inventoryHistoryFilterTransactions: "ٹرانزیکشنز",
    inventoryHistoryFilterAuditLog: "آڈٹ لاگ",
    inventoryHistoryEventsCount: "{count} واقعات",
    inventoryHistoryNoEventsForFilter: "اس فلٹر کے لیے کوئی واقعہ نہیں۔",
    inventoryHistoryLoadFailed: "انوینٹری ہسٹری لوڈ کرنے میں ناکامی۔",
    inventoryHistoryRecordCreated: "ریکارڈ بن گیا",
    inventoryHistoryReceivedEvent: "انوینٹری میں وصول ہوا",
    inventoryHistoryAuditEvent: "آڈٹ واقعہ",
    inventoryHistoryTagAccount: "اکاؤنٹ",
    inventoryHistoryTagTask: "ٹاسک",
    inventoryHistoryTagReplacement: "متبادل آئی ڈی",
    inventoryHistoryTagReference: "حوالہ",
    inventoryHistoryUnknownUser: "صارف #{id}",
    inventoryImportTitle: "میٹر انوینٹری درآمد کریں",
    inventoryImportSubtitle:
      "میٹر انوینٹری بنانے یا اپ ڈیٹ کرنے کے لیے Excel یا CSV شیٹ اپ لوڈ کریں۔",
    inventoryImportTabNew: "نئی درآمد",
    inventoryImportTabHistory: "اپ لوڈ ہسٹری",
    inventoryImportProgressAria: "انوینٹری درآمد کی پیش رفت",
    inventoryImportStepUpload: "فائل اپ لوڈ کریں",
    inventoryImportStepDestination: "منزل",
    inventoryImportStepReview: "تصدیق اور درآمد",
    inventoryImportUploadDesc: "وہ شیٹ منتخب کریں جس میں انوینٹری کی قطاریں ہیں۔",
    inventoryImportDropTitle: "اپنی Excel یا CSV فائل یہاں ڈراپ کریں",
    inventoryImportDropHint: "یا براؤز کرنے کے لیے کلک کریں (.xlsx، .xls، .csv)",
    inventoryImportChooseAnother: "دوسری فائل منتخب کرنے کے لیے کلک کریں",
    inventoryImportInvalidType: "صرف .xlsx، .xls اور .csv فائلیں درآمد کی جا سکتی ہیں۔",
    inventoryImportDestinationDesc:
      "منتخب کریں کہ قطاریں کہاں جائیں اور انہیں کیسے لاگو کیا جائے۔",
    inventoryImportSelectStore: "اسٹور",
    inventoryImportSelectStorePlaceholder: "اسٹور منتخب کریں",
    inventoryImportStoresEmpty: "اس پروجیکٹ کے لیے کوئی اسٹور دستیاب نہیں۔",
    inventoryImportStoreLoadFailed: "اسٹورز لوڈ نہیں ہو سکے۔",
    inventoryImportItemType: "آئٹم کی قسم",
    inventoryImportItemTypePlaceholder: "آئٹم کی قسم منتخب کریں",
    inventoryImportMode: "درآمد موڈ",
    inventoryImportModeCreate: "نیا بنائیں یا موجودہ اپ ڈیٹ کریں",
    inventoryImportModeCreateHint:
      "نئی قطاریں بنائی جاتی ہیں اور مماثل قطاریں اپ ڈیٹ ہوتی ہیں۔",
    inventoryImportModeUpdate: "صرف موجودہ اپ ڈیٹ کریں",
    inventoryImportModeUpdateHint:
      "صرف موجودہ قطاریں اپ ڈیٹ ہوں گی، کوئی نئی شامل نہیں ہوگی۔",
    inventoryImportSelectFileFirst: "جاری رکھنے کے لیے فائل منتخب کریں۔",
    inventoryImportSelectStoreFirst: "جاری رکھنے کے لیے اسٹور منتخب کریں۔",
    inventoryImportValidating: "آپ کی شیٹ کی تصدیق ہو رہی ہے...",
    inventoryImportValidationDesc: "ہر قطار چیک کی گئی۔ ابھی کچھ محفوظ نہیں ہوا۔",
    inventoryImportValidationPassed: "تصدیق کامیاب",
    inventoryImportValidationFailed: "تصدیق میں مسائل ملے",
    inventoryImportValidationError: "شیٹ کی تصدیق نہیں ہو سکی۔",
    inventoryImportRevalidate: "دوبارہ تصدیق کریں",
    inventoryImportSummary: "خلاصہ",
    inventoryImportTotalRows: "کل قطاریں",
    inventoryImportValidRows: "درست قطاریں",
    inventoryImportInvalidRows: "غلط قطاریں",
    inventoryImportCreatedRows: "بنائی گئیں",
    inventoryImportUpdatedRows: "اپ ڈیٹ ہوئیں",
    inventoryImportSkippedRows: "چھوڑی گئیں",
    inventoryImportErrorsTitle: "قطاروں کے مسائل",
    inventoryImportRow: "قطار",
    inventoryImportMoreIssues: "{count} مزید مسائل ظاہر نہیں کیے گئے۔",
    inventoryImportConfirm: "درآمد کریں",
    inventoryImportUploading: "درآمد ہو رہی ہے...",
    inventoryImportSuccess: "انوینٹری شیٹ کامیابی سے درآمد ہو گئی۔",
    inventoryImportFailed: "انوینٹری درآمد ناکام ہو گئی۔",
    inventoryImportHistoryEmpty: "ابھی کوئی اپ لوڈ نہیں۔",
    inventoryImportHistoryFile: "فائل",
    inventoryImportHistoryStore: "اسٹور",
    inventoryImportHistoryMode: "موڈ",
    inventoryImportHistoryStatus: "حالت",
    inventoryImportHistoryTotal: "کل",
    inventoryImportHistorySuccess: "کامیاب",
    inventoryImportHistoryFailed: "ناکام",
    inventoryImportHistoryUploadedBy: "اپ لوڈ کرنے والا",
    inventoryImportHistoryUploadedAt: "اپ لوڈ کی تاریخ",
    inventoryImportHistoryLoadFailed: "اپ لوڈ ہسٹری لوڈ نہیں ہو سکی۔",
    inventoryImportRunning: "درآمد پس منظر میں چل رہی ہے...",
    inventoryImportValidationRunning: "تصدیق پس منظر میں چل رہی ہے...",
    inventoryImportBackgroundNote:
      "آپ کام جاری رکھ سکتے ہیں — یہ عمل پس منظر میں چلتا رہے گا اور اپ لوڈ ہسٹری میں موجود رہے گا۔",
    inventoryImportStatusLabel: "حالت",
    inventoryImportStatusQueued: "قطار میں",
    inventoryImportStatusInProgress: "جاری ہے",
    inventoryImportStatusCompleted: "مکمل",
    inventoryImportStatusFailedLabel: "ناکام",
    inventoryImportPollFailed: "اپ لوڈ کی حالت پڑھی نہیں جا سکی۔",
    inventoryImportUploadIdLabel: "اپ لوڈ",
    inventoryImportRejectedTitle: "وہ قطاریں جو اپ لوڈ نہیں ہوئیں",
    inventoryImportRejectedTruncated: "پہلی {count} مسترد قطاریں دکھائی جا رہی ہیں۔",
    inventoryImportLoadAllRejected: "تمام مسترد قطاریں لوڈ کریں",
    inventoryImportDownloadFailureLog: "فیلیئر لاگ ڈاؤن لوڈ کریں",
    inventoryImportDownloadNotUploaded: "اپ لوڈ نہ ہونے والی قطاریں ڈاؤن لوڈ کریں (Excel)",
    inventoryImportNotUploadedExportEmpty: "ڈاؤن لوڈ کے لیے کوئی مسترد قطار نہیں ہے۔",
    inventoryImportNotUploadedExportPartial:
      "صرف وہی قطاریں ڈاؤن لوڈ ہو سکیں جو پہلے سے لوڈ تھیں۔",
    inventoryImportNotUploadedExportFailed: "مسترد قطاریں ڈاؤن لوڈ نہیں ہو سکیں۔",
    inventoryImportReason: "وجہ",
    inventoryImportNotUploadedCount: "اپ لوڈ نہیں ہوئیں",
    inventoryImportShowValidationRuns: "تصدیقی رنز دکھائیں",
    inventoryImportShowValidationRunsInfo:
      "تصدیقی رن وہ آزمائشی جانچ ہے جو اپ لوڈ وزرڈ پہلے کرتا ہے: یہ بتاتا ہے کہ کیا بنے گا، اپ ڈیٹ ہوگا یا مسترد ہوگا، مگر کچھ محفوظ نہیں کرتا۔",
    inventoryImportUploadSheet: "شیٹ اپ لوڈ کریں",
    inventoryNoAccessTooltip: "آپ کو اس عمل کی اجازت نہیں ہے",
    inventoryNoCreateAccessTooltip: "آپ کو انوینٹری بنانے کی اجازت نہیں ہے",
    inventoryNoUpdateAccessTooltip: "آپ کو انوینٹری اپ ڈیٹ کرنے کی اجازت نہیں ہے",
    inventoryImportTooltip: "انوینٹری بنانے یا اپ ڈیٹ کرنے کے لیے شیٹ اپ لوڈ کریں",
    inventoryTransferTooltip: "منتخب آئٹمز کو اسٹور یا گروپ میں منتقل کریں",
    inventoryAddTooltip: "انوینٹری دستی یا بلک میں شامل کریں",
    inventoryCreateStoreTooltip: "نیا اسٹور بنائیں",
    inventorySuperAdminOnlyTooltip: "صرف سپر ایڈمن اسٹور بنا سکتا ہے",
    inventoryFiltersTooltip: "کالم فلٹرز دکھائیں یا چھپائیں",
    inventoryResetTooltip: "تمام لاگو فلٹرز صاف کریں",
    inventoryImportHistoryHeading: "اپ لوڈ ہسٹری",
    inventoryImportHistorySubtitle: "میٹر انوینٹری میں اپ لوڈ کی گئی تمام شیٹس، تازہ ترین پہلے۔",
    inventoryExport: "ایکسپورٹ",
    inventoryExportTooltip: "تمام انوینٹری آئٹمز Excel میں ایکسپورٹ کریں",
    inventoryExportFilteredTooltip: "ان فلٹرز کے مطابق آئٹمز ایکسپورٹ کریں: {columns}",
    inventoryExportStarted: "انوینٹری ایکسپورٹ شروع ہو گئی۔",
    inventoryExportStartFailed: "انوینٹری ایکسپورٹ شروع نہیں ہو سکی۔",
    inventoryExportHistoryLoadFailed: "ایکسپورٹ ہسٹری لوڈ نہیں ہو سکی۔",
    inventoryExportHistoryEmpty: "ابھی تک کوئی ایکسپورٹ نہیں",
    inventoryExportNoRecordsTooltip: "منتخب فلٹرز سے کوئی انوینٹری آئٹم میل نہیں کھاتا، اس لیے ایکسپورٹ کے لیے کوئی ڈیٹا موجود نہیں۔",
    inventoryExportPreparing: "تیاری ہو رہی ہے…",
    inventoryExportProgress: "{completed} / {total} آئٹمز، {remaining} باقی",
    inventoryExportRetry: "دوبارہ کوشش کریں",
    inventoryExportRetryTooltip: "اسی پروجیکٹ اور فلٹرز کے ساتھ یہ ایکسپورٹ دوبارہ شروع کریں",
    inventoryExportRetrying: "ایکسپورٹ دوبارہ شروع ہو رہی ہے…",
    inventoryExportView: "ایکسپورٹ دیکھیں",
    inventoryExportTitle: "انوینٹری ایکسپورٹ کریں",
    inventoryExportDescription: "یہ رپورٹ منتخب پروجیکٹ کی انوینٹری ایکسپورٹ کرتی ہے۔",
    inventoryDashboard: "انوینٹری ڈیش بورڈ",
    inventoryDashboardSubtitle: "انوینٹری میں ہر آئٹم کی حالت، اور ہر گروپ کے پاس کیا ہے۔",
    inventoryDashboardStatusTitle: "حالت کے لحاظ سے آئٹمز",
    inventoryDashboardTotal: "کل آئٹمز",
    inventoryDashboardGroupTitle: "گروپس کو تفویض کردہ آئٹمز",
    inventoryDashboardGroupSubtitle: "ہر گروپ کو تفویض کردہ کل آئٹمز، حالت کے لحاظ سے تقسیم۔",
    inventoryDashboardGroup: "گروپ",
    inventoryDashboardGroupTotal: "کل تفویض کردہ",
    inventoryDashboardBreakdown: "تفصیل",
    inventoryDashboardNoGroups: "ابھی تک کسی گروپ کو کوئی آئٹم تفویض نہیں کیا گیا۔",
    inventoryDashboardLoadFailed: "انوینٹری ڈیش بورڈ لوڈ نہیں ہو سکا۔",
    inventoryDashboardAllItemTypes: "تمام آئٹم اقسام",
    inventoryDashboardSelectOrganization: "اس کی انوینٹری دیکھنے کے لیے ہیڈر میں ایک تنظیم منتخب کریں۔",
    inventoryDashboardOther: "دیگر حالتیں",
    inventoryDashboardGroups: "گروپس",
    inventoryDashboardItems: "آئٹمز",
    inventoryDashboardNoItems: "انوینٹری میں ابھی کوئی آئٹم نہیں ہے۔",
    inventoryDashboardDonutHint: "ہر حصہ تمام آئٹمز میں اس حالت کا تناسب ہے",
    inventoryDashboardStatusBarHint: "بار کی لمبائی آئٹمز کی تعداد ہے",
    inventoryDashboardGroupBarHint: "بار کی لمبائی گروپ کے آئٹمز کی تعداد ہے",
    inventoryDashboardTableHint: "ہر گروپ کے درست اعداد",
    inventoryDashboardShowAllGroups: "تمام {count} گروپس دکھائیں",
    inventoryDashboardShowTopGroups: "سرفہرست {count} گروپس دکھائیں",
    inventoryDashboardStoreTitle: "اسٹور کے لحاظ سے آئٹمز",
    inventoryDashboardStoreSubtitle: "ہر اسٹور میں موجود آئٹمز، حالت کے لحاظ سے تقسیم۔",
    inventoryDashboardStores: "اسٹورز",
    inventoryDashboardItemsInStores: "اسٹورز میں آئٹمز",
    inventoryDashboardNeedsAttention: "خراب / قرنطینہ / گم شدہ",
    inventoryDashboardNoStores: "اس انتخاب کے لیے کوئی اسٹور نہیں ملا۔",
    inventoryDashboardStoreInactive: "غیر فعال",
    inventoryDashboardIncoming: "آنے والے ٹرانزٹ میں",
    inventoryDashboardOutgoing: "جانے والے ٹرانزٹ میں",
    inventoryDashboardItemsWithoutStore: "{count} آئٹمز کسی اسٹور میں نہیں ہیں۔",
    inventoryDashboardStoreBarHint: "بار کی لمبائی اسٹور کے آئٹمز کی تعداد ہے",
    inventoryDashboardStoreTableHint: "ہر اسٹور کے درست اعداد",
    inventoryDashboardShowAllStores: "تمام {count} اسٹورز دکھائیں",
    inventoryDashboardShowTopStores: "سرفہرست {count} اسٹورز دکھائیں",
    inventoryExportRecent: "حالیہ ایکسپورٹس",
    inventoryExportNote: "ایکسپورٹس پس منظر میں تیار ہوتی ہیں۔ فائل تیار ہونے پر یہاں نظر آئے گی، اور آپ کو نوٹیفکیشن بھی ملے گا۔",
    inventoryImportValidationRunBadge: "صرف تصدیق",
    inventoryImportFailedRows: "ناکام",
    inventoryAddTitle: "انوینٹری شامل کریں",
    inventoryAddSubtitle: "ایک انوینٹری آئٹم دستی طور پر بنائیں یا ایک ساتھ کئی شامل کریں۔",
    inventoryAddTabManual: "دستی اندراج",
    inventoryAddTabBulk: "بلک اندراج",
    inventoryAddTabImport: "ایکسل اپ لوڈ",
    inventoryUpdateActionLabel: "جب میٹر پہلے سے موجود ہو",
    inventoryUpdateActionHint:
      "تفصیلات اپ ڈیٹ کرنے سے اسٹاک منتقل نہیں ہوتا — تحویل بدلنے کے لیے واپسی کا آپشن منتخب کریں۔",
    inventoryUpdateActionDetails: "موجودہ میٹر کی تفصیلات اپ ڈیٹ کریں",
    inventoryUpdateActionDetailsHint:
      "میٹر کی تفصیلات اپ ڈیٹ کریں اور اس کا موجودہ اسٹور اور تحویل برقرار رکھیں۔",
    inventoryUpdateActionReturn: "موجودہ میٹر منتخب اسٹور میں واپس کریں",
    inventoryUpdateActionReturnHint:
      "میٹر کو منتخب اسٹور میں واپس منتقل کریں۔ گم شدہ یا ریٹائرڈ میٹر واپس نہیں کیے جا سکتے۔",
    inventoryGroupDisabledReturnTooltip: "میٹر کو اسٹور میں واپس کرتے وقت گروپ تفویض دستیاب نہیں ہے۔",
    inventoryUploadFieldModemSerial: "موڈیم سیریل نمبر",
    inventoryUploadFieldSimSerial: "سم سیریل نمبر",
    inventoryImportNoHeaders: "شیٹ میں میپ کرنے کے لیے ہیڈر قطار نہیں ہے۔ پہلی قطار میں کالم کے نام شامل کریں۔",
    inventoryImportHeadersReadFailed: "شیٹ نہیں پڑھی جا سکی۔ فائل چیک کریں اور دوبارہ کوشش کریں۔",
    inventoryImportColumnsFound: "کالم",
    inventoryImportMapTitle: "شیٹ کالم میپ کریں",
    inventoryImportUnmappedCount: "{count} شیٹ کالم میپ نہیں ہوئے",
    inventoryImportMainColumns: "میپ کرنے کے لیے مرکزی کالم",
    inventoryImportMapHint: "اگلے مرحلے میں آپ اپنی شیٹ کے کالم ان فیلڈز سے ملائیں گے۔",
    inventoryImportMapAndImport: "کالم میپ کریں اور امپورٹ کریں",
    inventoryImportSerialDetected: "کالم \"{header}\" سے خودکار طور پر شناخت ہو گئی — میپنگ کی ضرورت نہیں۔",
    inventoryImportSerialNotFound: "اس شیٹ میں کوئی پہچانا ہوا سیریل کالم نہیں ملا — اگلے مرحلے میں اسے میپ کریں۔",
    inventoryImportSerialAccepted: "پہچانے جانے والے ہیڈرز: {names}",
    inventoryImportMapConflict: "کالم '{a}' اور '{b}' دونوں '{target}' پر میپ ہیں۔ صرف ایک کو میپ کریں۔",
    inventoryImportKeepColumnName: "\"{header}\" کے نام سے رکھیں",
    inventoryImportColumnsMappedCount: "{total} میں سے {mapped} انوینٹری فیلڈز سے میپ ہیں",
    inventoryImportOtherColumnsHint:
      "آپ کی شیٹ کے باقی تمام کالم نیچے درج ہیں۔ ہر کالم کے لیے انوینٹری فیلڈ منتخب کریں، یا اسے اس کے اپنے نام سے رکھیں۔",
    inventoryImportExcelColumn: "ایکسل کالم",
    inventoryImportInventoryField: "انوینٹری فیلڈ",
    inventoryAddSectionDestination: "منزل اور موڈ",
    inventoryAddSectionDetails: "آئٹم کی تفصیلات",
    inventoryAddSectionMetadata: "اضافی تفصیلات",
    inventoryAddSectionItems: "آئٹمز",
    inventoryAddIdentifierPlaceholder: "مثلاً MTR-000123",
    inventoryAddStatus: "حالت",
    inventoryAddMode: "محفوظ کرنے کا موڈ",
    inventoryAddModeCreateOnly: "صرف نیا بنائیں",
    inventoryAddModeCreateOnlyHint: "اگر شناخت کنندہ پہلے سے موجود ہو تو ناکام ہو جائے گا۔",
    inventoryAddModeUpdateOnly: "صرف اپ ڈیٹ کریں",
    inventoryAddModeUpdateOnlyHint: "صرف پہلے سے موجود شناخت کنندہ اپ ڈیٹ ہوں گے۔",
    inventoryAddModeCreateOrUpdate: "بنائیں یا اپ ڈیٹ کریں",
    inventoryAddModeCreateOrUpdateHint:
      "نئے شناخت کنندہ بنائے جاتے ہیں اور موجودہ اپ ڈیٹ ہوتے ہیں۔",
    inventoryAddGroupAssignment: "گروپ تفویض",
    inventoryAddConditionNote: "حالت کا نوٹ",
    inventoryAddNote: "نوٹ",
    inventoryAddMeterMake: "میٹر میک",
    inventoryAddMeterType: "میٹر کی قسم",
    inventoryAddComponents: "اجزاء",
    inventoryAddManufacturingYear: "سالِ تیاری",
    inventoryAddSelectYear: "سال منتخب کریں",
    inventoryAddBatchNo: "بیچ نمبر",
    inventoryAddOrganizationName: "تنظیم",
    inventoryAddSimNo: "سم نمبر",
    inventoryAddIccid: "آئی سی سی آئی ڈی (ICCID)",
    inventoryAddModemMake: "موڈیم میک",
    inventoryAddBulkHint:
      "ہر قطار اوپر منتخب کردہ اسٹور، آئٹم کی قسم اور موڈ استعمال کرے گی، الا یہ کہ قطار میں تبدیل کیا جائے۔",
    inventoryAddAddRow: "قطار شامل کریں",
    inventoryAddRemoveRow: "قطار ہٹائیں",
    inventoryAddRowLabel: "قطار",
    inventoryAddIdentifierRequired: "میٹر نمبر ضروری ہے۔",
    inventoryAddStoreRequired: "اسٹور منتخب کریں۔",
    inventoryAddItemsRequired: "کم از کم ایک آئٹم شناخت کنندہ کے ساتھ شامل کریں۔",
    inventoryAddDuplicateIdentifier: "اس بیچ میں مکرر شناخت کنندہ: {values}",
    inventoryAddSuccess: "انوینٹری آئٹم محفوظ ہو گیا۔",
    inventoryAddBulkSuccess: "انوینٹری آئٹمز محفوظ ہو گئے۔",
    inventoryAddFailed: "انوینٹری محفوظ نہیں ہو سکی۔",
    inventoryAddSave: "محفوظ کریں",
    inventoryAddSaving: "محفوظ ہو رہا ہے...",
    inventoryAddResultsTitle: "نتائج",
    inventoryTransferTitle: "انوینٹری منتقل کریں",
    inventoryTransferSubtitle:
      "منتخب انوینٹری آئٹمز کو دوسرے اسٹور میں منتقل کریں یا کسی سب کنٹریکٹر گروپ کے حوالے کریں۔",
    inventoryTransferSelectedCount: "{count} آئٹم منتخب",
    inventoryTransferNoSelection: "منتقلی کے لیے کم از کم ایک انوینٹری آئٹم منتخب کریں۔",
    inventoryTransferSelectedItems: "منتخب آئٹمز",
    inventoryTransferTargetTitle: "منتقلی کہاں",
    inventoryTransferTargetStore: "دوسرا اسٹور",
    inventoryTransferTargetStoreHint: "آئٹمز کو کسی دوسرے اسٹور مقام پر منتقل کریں۔",
    inventoryTransferTargetGroup: "سب کنٹریکٹر (گروپ)",
    inventoryTransferTargetGroupHint:
      "آئٹمز کسی فیلڈ گروپ کے حوالے کریں؛ اس کے ممبران صرف حوالے کے لیے دکھائے گئے ہیں۔",
    inventoryTransferSearchGroup: "گروپ یا ممبر تلاش کریں...",
    inventoryTransferNoGroups: "کوئی گروپ نہیں ملا",
    inventoryTransferSelectGroupFirst: "جاری رکھنے کے لیے گروپ منتخب کریں۔",
    inventoryAssignmentInput: "تفویض کا ذریعہ",
    inventoryMeterNumbers: "سیریل نمبر",
    inventoryAssignmentExcel: "Excel سے تفویض کریں",
    inventoryMeterNumbersHint: "سیریل نمبر (میٹر، موڈیم، سم یا سیل رینج) اسپیس، کوما یا نئی سطر سے الگ کریں۔",
    inventoryMeterNumbersRequired: "ہر منتخب آئٹم کے لیے درست سیریل نمبر درج کریں۔",
    inventoryAssignmentFileRequired: "Excel فائل منتخب کریں (.xlsx یا .xls)۔",
    inventoryAssignmentProjectRequired: "اس تفویض کے لیے ایک پروجیکٹ منتخب کریں۔",
    inventoryClearCustody: "تحویل ختم کریں",
    inventoryClearCustodyHint: "ان آئٹمز کی تمام اسٹور اور گروپ تفویضات ختم کریں۔",
    inventoryReassign: "دوبارہ تفویض",
    inventoryDeleteUnavailable: "حذف API کی ترتیب درکار ہے۔",
    inventoryTransferSameSourceStore: "گروپ کو تفویض کرنے سے پہلے ایک ہی اسٹور کے میٹر منتخب کریں۔",
    inventoryTransferSameSourceOrg: "گروپ کو تفویض کرنے سے پہلے ایک ہی تنظیم کے میٹر منتخب کریں۔",
    inventoryTransferOrgMismatch: "آئٹم '{item}' کسی دوسری تنظیم سے تعلق رکھتا ہے۔",
    inventoryTransferAssignmentResult: "{assigned} تفویض ہوئے، {failed} ناکام ہوئے۔",
    inventoryMeterTransferSummary: "{success} کامیاب، {skipped} چھوڑ دیے گئے۔",
    inventorySkippedMetersDownloaded: "چھوڑے گئے سیریل نمبر ڈاؤن لوڈ ہو گئے ہیں۔",
    inventoryTransferSelectStoreFirst: "جاری رکھنے کے لیے اسٹور منتخب کریں۔",
    inventoryTransferNote: "نوٹ",
    inventoryTransferNotePlaceholder: "اس منتقلی کے لیے اختیاری نوٹ",
    inventoryTransferConfirm: "منتقل کریں",
    inventoryTransferring: "منتقل ہو رہا ہے...",
    inventoryTransferInProgressHint: "اس میں کچھ وقت لگ سکتا ہے۔ مکمل ہونے تک براہ کرم یہ ونڈو کھلی رکھیں۔",
    inventoryTransferSuccess: "انوینٹری کامیابی سے منتقل ہو گئی۔",
    inventoryTransferFailed: "انوینٹری کی منتقلی مکمل نہیں ہو سکی۔",
    inventoryTransferCurrentStore: "موجودہ اسٹور",
    inventoryTransferNewStore: "نیا اسٹور",
    inventoryTransferUnassignedStore: "کوئی اسٹور تفویض نہیں",
    inventoryTransferCurrentStoreUnknown: "منتخب آئٹمز کے لیے دستیاب",
    inventoryTransferGroupLoadFailed: "گروپس لوڈ نہیں ہو سکے۔",
    inventorySampleComponentId: "INV-MTR-20451",
    inventorySampleLocation: "Site 102",
    inventorySampleGroup: "Group A",
    inventorySampleAssignment: "Field Team 04",
    inventorySampleBarcode: "23239722299",
    inventorySampleSerial: "SN-2026-88231",
    inventorySampleMake: "L&T",
    inventorySampleYear: "2026",
    inventorySampleBatch: "BATCH-2026-14",
    inventorySampleActivationDate: "25 Sep 2026",
    inventorySampleInstallationDate: "2026-09-25",
    inventorySampleOldMeterId: "INV-MTR-10021",
    inventorySampleModemId: "INV-MOD-00421",
    inventorySampleSimId: "INV-SIM-00891",
    notAvailable: "—",
    transferMeter: "انوینٹری منتقل کریں",
    addInventory: "انوینٹری شامل کریں",
    accountreportcenter: "اکاؤنٹ اور رپورٹس سینٹر",
    accountreportcentersub: "اکاؤنٹ ہسٹری ٹریک کریں اور رپورٹ ایکسپورٹس کا انتظام کریں۔",
    PDF: "PDF",
    viewdetails: "تفصیل دیکھیں",
    addnewvehicale: "اپنی اثاثوں کی فہرست میں ایک نئی گاڑی شامل کریں۔",
    cancelandstay: "منسوخ کریں اور صفحہ پر رہیں",
    confirmandlogout: "تصدیق کریں اور لاگ آؤٹ کریں۔",
    welcome: "خوش آمدید",
    welcomeback: "دوبارہ خوش آمدید",
    editandudateasset: " اثاثوں کی تفصیلات میں ترمیم اور اپ ڈیٹ کریں۔ ",
    assigntheselected: "منتخب اثاثے فیلڈ سٹاف کو تفویض کریں۔",
    updatetherule: "اصول کو اپ ڈیٹ کریں۔",
    submitherule: " قاعدہ جمع کروائیں۔",
    addassignmentrule: " تفویض کا اصول شامل کریں۔",
    savetherule: "اصول کو بچائیں۔",
    addcompletionrule: " تکمیل کا اصول شامل کریں۔",
    addcustomrule: " حسب ضرورت اصول شامل کریں۔",
    assignallactiverules: "تمام فعال قواعد تفویض کریں۔",
    addnewspecialassingmentrule: "نیا خصوصی تفویض اصول شامل کریں۔",
    updatetherulewitjselectedpara:
      " منتخب پیرامیٹرز کے ساتھ اصول کو اپ ڈیٹ کریں۔",
    createneweulwwithselected: " منتخب پیرامیٹرز کے ساتھ نیا اصول بنائیں",
    cancelandclose: " ڈائیلاگ باکس کو منسوخ اور بند کریں۔",
    addnewdashboardtooltip:
      " ایک نیا ڈیش بورڈ شامل کریں (آپ ورک فلو کی بنیاد پر ڈیش بورڈ بنا سکتے ہیں)",
    processthenextstep: " اگلے مرحلے پر عمل کریں۔",
    deletethedashboard: " ڈیش بورڈ کو حذف کریں۔",
    createdashboardtooltip: " ڈیش بورڈ بنائیں ",
    canceltheselectedchart: "منتخب کردہ چارٹ بنائیں",
    applytheselecteddaterange: "منتخب کردہ تاریخ کی حد کا فلٹر لگائیں۔",
    downloadfilterdate: " فلٹر شدہ تاریخ کے ساتھ ڈاؤن لوڈ کریں۔",
    proceedwiththeaction: "کارروائی کے ساتھ آگے بڑھیں۔",
    addnewproject: " نیا پروجیکٹ شامل کریں۔",
    addnewdepartment: " نیا شعبہ شامل کریں۔",
    addneworgnization: "نئی تنظیم شامل کریں۔",
    updateorgnizations: " تنظیموں کو اپ ڈیٹ کریں۔",
    savethechangesmadetomarkers:
      " مارکر کے رنگوں میں کی گئی تبدیلیوں کو محفوظ کریں۔",
    updatethechangesmade: " مارکر کے رنگوں میں کی گئی تبدیلیوں کو اپ ڈیٹ کریں۔",
    cancelanddiscardchanges: " تبدیلیاں منسوخ اور رد کریں۔",
    requestthereport: " رپورٹ طلب کریں۔",
    savetheprotectedaccount: " محفوظ اکاؤنٹ کو محفوظ کریں۔",
    submitthereportrequest: " رپورٹ کی درخواست جمع کروائیں۔",
    cancelandgoback: " منسوخ کریں اور واپس جائیں۔",
    exportthexcelfilebasedon: "فلٹر کی بنیاد پر ایکسل فائل کو ایکسپورٹ کریں۔",
    createaprotectedaccountwithpermanent:
      "مستقل تحفظ کے ساتھ یا مخصوص مدت کے لیے ایک محفوظ اکاؤنٹ بنائیں",
    downloadthereportfortheselecte:
      " منتخب تاریخ کی حد کے لیے رپورٹ ڈاؤن لوڈ کریں۔",
    uploadtheinventorysheet: " انوینٹری ایکسل شیٹ اپ لوڈ کریں۔",
    downloadincentoryreport: "انوینٹری رپورٹ ڈاؤن لوڈ کریں۔",
    applythesleectedfilters: "منتخب کردہ فلٹرز لگائیں۔",
    uploadtheselectedexcelfile: "منتخب ایکسل فائل اپ لوڈ کریں۔",
    createinstallmentplan: "قسط کا منصوبہ بنائیں",
    generatepreviewfiter: "(پہلے پیش نظارہ بنائیں)",
    emiamount: "(EMI کی رقم بقایا رقم سے میل نہیں کھاتی)",
    finisheditinisntall: "(تدوین کی قسط ختم کریں) ",
    savechangesbeforesubmiting: " (جمع کرانے سے پہلے تبدیلیاں محفوظ کریں)",
    totalemaiamount: "(کل EMI رقم منفی نہیں ہو سکتی)",
    userscancreateup: "(صارفین صرف 6 قسطیں بنا سکتے ہیں)",
    accountTwoActivePlans: "اس اکاؤنٹ کے پہلے سے ہی 2 فعال قسط پلان موجود ہیں۔ آپ مزید پلان نہیں بنا سکتے۔",
    maxTwoActivePlans: " (فی اکاؤنٹ زیادہ سے زیادہ 2 فعال پلان کی اجازت ہے)",
    maxInstalmentsExceeded: "قسطوں کی تعداد اس سے زیادہ نہیں ہو سکتی",
    instalmentsGreaterThanZero: "قسطوں کی تعداد صفر سے زیادہ ہونی چاہیے",
    printpreviewtable: "پیش نظارہ ٹیبل پرنٹ کریں۔",
    generatepreview: "پیش نظارہ بنائیں",
    clearpreviewdata: " پیش نظارہ ڈیٹا صاف کریں۔",
    submitforRccreation: " RC تخلیق کے لیے جمع کروائیں۔",
    savethechagesmadeto: " ادائیگی کی رقم میں کی گئی تبدیلیوں کو محفوظ کریں۔",
    editthepaymentamount: "ادائیگی کی رقم میں ترمیم کریں۔",
    submitspecialRc: " خصوصی RC جمع کروائیں۔",
    printinstallmentdetails: "قسط کی تفصیلات پرنٹ کریں۔",
    proceedwithdeleaction: "حذف کرنے کی کارروائی کے ساتھ آگے بڑھیں۔",
    proceedwithrecallaction: "واپس بلانے کی کارروائی کے ساتھ آگے بڑھیں۔",
    deletetheselectedtask: " منتخب کردہ کام کو حذف کریں۔",
    unassignntheseledtask: " منتخب کردہ کاموں کو غیر تفویض کریں۔",
    reassigntheselectedtask: " منتخب کردہ کاموں کو دوبارہ تفویض کریں۔",
    assigntheselectedtask: " منتخب کردہ کام تفویض کریں۔",
    multiselecte: "ملٹی سلیکٹ",
    addemailenablrnotifi:
      "ای میلز شامل کریں، اطلاعات کو فعال کریں، اور دیگر ترتیبات کو ترتیب دیں۔",
    donwloadthetaskrecordin:
      "منتخب کردہ سرگرمی یا تمام سرگرمیوں کی بنیاد پر ایکسل میں ٹاسک ریکارڈ ڈاؤن لوڈ کریں۔",
    createtaskbulk:
      "ایک نیا ٹاسک بنائیں، تخلیق کریں اور تفویض کریں، یا بلک ٹاسک اپ لوڈ کریں۔",
    uploadthetasksheet: "ٹاسک شیٹ اپ لوڈ کریں۔",
    assingtaskbasedonselectedrules: "منتخب قواعد کی بنیاد پر کام تفویض کریں۔",
    reassigningprocess: "دوبارہ تفویض کرنا جاری ہے۔",
    reassingselectedtasktochosen:
      "منتخب کردہ کاموں کو منتخب فیلڈ ایجنٹوں کو دوبارہ تفویض کریں۔",
    assingtaskbasedonselectedrule: "منتخب قواعد کی بنیاد پر کام تفویض کریں۔",
    reassinginginprocess: "دوبارہ تفویض کرنا جاری ہے۔",
    reassignselectedtasktochosenfield:
      "منتخب کردہ کاموں کو منتخب فیلڈ ایجنٹوں کو دوبارہ تفویض کریں۔",
    unassignselectedassingeesfromtask:
      "منتخب کردہ تفویض کردہ افراد کو کاموں سے غیر تفویض کریں۔",
    savetheupdateddatacompleted:
      "مکمل شدہ کاموں کے لیے اپ ڈیٹ کردہ ڈیٹا کو محفوظ کریں۔",
    gobacktheprivious: "محفوظ کیے بغیر پچھلی اسکرین پر واپس جائیں۔",
    resetthecompletiondata: "کام کی تکمیل کے ڈیٹا کو دوبارہ ترتیب دیں۔",
    closewithoutsavingchnages: "تبدیلیاں محفوظ کیے بغیر بند کریں۔",
    savechangesmadetothefield: "فیلڈ میں کی گئی تبدیلیوں کو محفوظ کریں۔",
    viewworkflowguidlines: "ورک فلو کے رہنما خطوط دیکھیں",
    createnewworkflows: "ایک نیا ورک فلو بنائیں",
    selectorgtocreateaworkflow: "ورک فلو بنانے کے لیے ایک تنظیم منتخب کریں۔",
    scheduleemail: "ای میل شیڈول کریں۔",
    exporttheexcelfilebasedonfilters:
      "فلٹرز کی بنیاد پر ایکسل فائل کو ایکسپورٹ کریں۔",
    exportpdfbasedonfilters:
      "فلٹرز کی بنیاد پر پی ڈی ایف فائل کو ایکسپورٹ کریں۔",
    downloadpdfbasedonfilters: "فلٹرز کی بنیاد پر پی ڈی ایف ڈاؤن لوڈ کریں۔",
    savechangesforprofile: "پروفائل کے لیے تبدیلیاں محفوظ کریں۔",
    requestonewreport: "ایک نئی رپورٹ کی درخواست کریں۔",
    createamanualtask: "ایک دستی کام بنائیں",
    createandassingtasktofield: "فیلڈ ایجنٹ کو کام بنائیں اور تفویض کریں۔",
    closethedialogbox: "ڈائیلاگ باکس بند کریں۔",
    gobacktomapmandotoryfield: "لازمی فیلڈز کے نقشے پر واپس جائیں۔",
    submitmappeddataandstartupload:
      "میپ شدہ ڈیٹا جمع کرائیں اور اپ لوڈ شروع کریں۔",
    procestomapnonmdaotry: "غیر لازمی فیلڈز کا نقشہ بنانے کے لیے آگے بڑھیں۔",
    gobacktotaskpriority: "کام کی ترجیحی انتخاب پر واپس جائیں۔",
    proceestomapmadatory: "لازمی فیلڈز کا نقشہ بنانے کے لیے آگے بڑھیں۔",
    gobackprivousscren: "محفوظ کیے بغیر پچھلی اسکرین پر واپس جائیں۔",
    addmultipleaccount:
      "متعدد اکاؤنٹ نمبرز شامل کریں اور فیلڈ ایجنٹس کو کام تفویض کریں۔",
    selectatleast: "تفویض کرنے کے لیے کم از کم ایک فیلڈ ایجنٹ منتخب کریں۔",
    assingmentinprocess: "اسائنمنٹ جاری ہے۔",
    assingselectedtasktochosen:
      "منتخب کردہ کاموں کو منتخب فیلڈ ایجنٹوں کو تفویض کریں۔",
    recallassingedtask: "صارفین سے تفویض کردہ کاموں کو یاد کریں۔",
    deleterecordfrom: "صارفین سے تفویض کردہ کاموں کو یاد کریں۔",
    donwloastheuplodedexcel: "اپ لوڈ کردہ ایکسل فائل ڈاؤن لوڈ کریں۔",
    uploasthexcelfile: "منتخب سرگرمی کے لیے ایکسل فائل اپ لوڈ کریں۔",
    savethechanges: "تبدیلیاں محفوظ کریں۔",
    diacardchanges: "تبدیلیوں کو مسترد کریں۔",
    proceedtomapnonmdfield: "غیر لازمی فیلڈز کا نقشہ بنانے کے لیے آگے بڑھیں۔",
    submitthemapedcol: "میپ شدہ کالم جمع کریں اور ڈیٹا اپ لوڈ کریں۔",
    uploadtheslectedfile: "منتخب فائل کو اپ لوڈ کریں۔",
    uploadtheaccountexcel:
      "اکاؤنٹس ایکسل شیٹ کو ماسٹر ڈیٹا بیس میں اپ لوڈ کریں۔",
    clearalldata: "تمام ڈیٹا صاف کریں۔",
    fetchtheaccounthistory:
      "درج کردہ اکاؤنٹ نمبر کے لیے اکاؤنٹ کی تاریخ حاصل کریں۔",
    donwlaodthetaskreportinpdfformat:
      "ٹاسک رپورٹ کو پی ڈی ایف فارمیٹ میں ڈاؤن لوڈ کریں۔",
    editandupdateuserdetail: "صارف کی تفصیلات میں ترمیم اور اپ ڈیٹ کریں۔",
    saveandcreateuser: "محفوظ کریں اور صارف بنائیں",
    donotsavechangesgoback: "تبدیلیاں محفوظ نہ کریں اور واپس جائیں۔",
    addauserassingroles: "صارف کو شامل کریں اور کردار یا مراعات تفویض کریں۔",
    previewcurrentworkflowlayout:
      "موجودہ ورک فلو لے آؤٹ اور فیلڈز کا جائزہ لیں۔",
    submitworkflow: "ورک فلو جمع کروائیں۔",
    pleaseselectatleastonefild:
      "براہ کرم کم از کم ایک فیلڈ بطور رپورٹ منتخب کریں۔",
    plzmakesuretosetauique:
      "براہ کرم کلوننگ سے پہلے ایک منفرد ورک فلو کا نام سیٹ کرنا یقینی بنائیں",
    updatetheworkflowiwth: "تازہ ترین تبدیلیوں کے ساتھ ورک فلو کو اپ ڈیٹ کریں۔",
    addnewvalidation: "ایک نئی توثیق شامل کریں۔",
    closewithoutsavingchanges: "تبدیلیاں محفوظ کیے بغیر بند کریں۔",
    viewwxistinfcalidation: "موجودہ توثیق دیکھیں",
    savechangesmadetovalidation: "توثیق میں کی گئی تبدیلیوں کو محفوظ کریں۔",
    discarchangesandexit: "تبدیلیاں رد کریں اور باہر نکلیں۔",
    savetheupdateddata: "مکمل شدہ کاموں کے لیے اپ ڈیٹ کردہ ڈیٹا کو محفوظ کریں۔",
    addselectefield: "رپورٹ میں منتخب فیلڈز شامل کریں۔",
    gotonextpage: "اگلے صفحے پر جائیں۔",
    gotopreviouspage: "پچھلے صفحے پر جائیں۔",
    refeshreportlist: "رپورٹ کی فہرست کو تازہ کریں۔",
    reportsGenerationNote: "رپورٹ تیار ہونے میں چند منٹ لگ سکتے ہیں۔ اگر آپ کی رپورٹ ابھی تیار نہیں ہے تو براہ کرم کچھ وقت دیں اور دوبارہ چیک کرنے کے لیے ریفریش بٹن پر کلک کریں۔ رپورٹیں تیار ہونے کے 6 گھنٹے بعد ختم ہو جائیں گی۔",
    gobackpreviouspage: "پچھلے صفحے پر واپس جائیں۔",
    requestreporbasedonfilter: "فلٹرز پر مبنی رپورٹ کی درخواست کریں۔",
    filteredReports: "فلٹر شدہ رپورٹس",

    failedtoloadruledata:
      "اصول کا ڈیٹا لوڈ کرنے میں ناکام۔ براہ کرم help@blufield.net پر رابطہ کریں۔",
    pleaseSelectLeastAssetBeforeAssigning:
      "براہ کرم تفویض کرنے سے پہلے کم از کم ایک اثاثہ منتخب کریں۔",
    plzselectfieldagent: "براہ کرم فیلڈ ایجنٹ کو منتخب کریں۔",
    assetsucassigned: "اثاثے کامیابی کے ساتھ تفویض کیے گئے۔",
    assetsfailedassigned: "اثاثے تفویض کرنے میں ناکام",
    logout: "کامیابی سے لاگ آؤٹ ہو گیا۔",
    rulecreated: "اصول کامیابی کے ساتھ بنایا گیا۔",
    unexpectederroroccured: "",
    plzselworkflow: "براہ کرم معیار شامل کرنے سے پہلے ایک ورک فلو منتخب کریں۔",
    ruledeleted: "اصول کامیابی کے ساتھ حذف ہو گیا۔",
    failedelrule: "اصول کو حذف کرنے میں ناکام۔",
    PleaseSelectWorkflowBeforeAddingRule:
      "براہ کرم کوئی اصول شامل کرنے سے پہلے ایک ورک فلو منتخب کریں۔",
    plzfillallfield: "براہ کرم جمع کرانے کے لیے تمام لازمی فیلڈز کو پُر کریں۔",
    failtoloadasign:
      "اسائنمنٹ رولز لوڈ کرنے میں ناکام۔ براہ کرم help@blufield.net سے رابطہ کریں۔",
    failedtoassign:
      "تمام اصول تفویض کرنے میں ناکام۔ براہ کرم help@blufield.net پر رابطہ کریں۔",
    OnClickTheOldAssignmentRuleDisabled:
      "کلک کرنے پر، اسائنمنٹ کا سابقہ ​​اصول غیر فعال ہو جائے گا۔",
    invalideruleid: "غلط اصول ID۔",
    plzselfield: "براہ کرم ایک فیلڈ ایجنٹ منتخب کریں۔",
    nopermission:
      "آپ کے پاس یہ صفحہ دیکھنے کے لیے ضروری اجازتیں نہیں ہیں۔ براہ کرم help@blufield.net پر رابطہ کریں۔ ",
    nocreatetaskaccess: "آپ کے پاس ٹاسک بنانے کی رسائی نہیں ہے۔",
    plzselectorg: "براہ کرم ایک تنظیم منتخب کریں۔",
    somthingwentwrong: "",
    excelisdownloading: "ایکسل فائل ڈاؤن لوڈ ہو رہی ہے…",
    norecordfound: "کوئی ریکارڈ نہیں ملا۔",
    anerroroccurred: "",
    orgaddedsuc: "تنظیم کامیابی کے ساتھ شامل ہو گئی۔",
    errorcreatingorg:
      "تنظیم بنانے میں خرابی۔ براہ کرم help@blufield.net سے رابطہ کریں۔",
    failstofetchorg: "تنظیم کا ڈیٹا حاصل کرنے میں ناکام۔",
    orgupdated: "تنظیم کا ڈیٹا حاصل کرنے میں ناکام۔",
    allfieldarerequired: "تمام فیلڈز درکار ہیں۔",
    reportreqsuc: "رپورٹ کامیابی کے ساتھ طلب کر لی گئی۔",
    errorequestreport: "رپورٹ کی درخواست کرنے میں خرابی۔",
    addremark: "ایک تبصرہ شامل کریں!",
    protectedAcccreated: "محفوظ اکاؤنٹ بنایا گیا",
    protectedAccUpdated: "محفوظ اکاؤنٹ اپ ڈیٹ ہو گیا",
    errorcreatingprotacc: "محفوظ اکاؤنٹ بنانے میں خرابی۔",
    skippedAccountsDownloaded: "اکاؤنٹ چھوڑ دیے گئے۔ تفصیلات ڈاؤن لوڈ ہو گئی ہیں۔",
    partialProtectionSummary:
      "{created} اکاؤنٹ محفوظ ہو گئے، {skipped} چھوڑ دیے گئے۔ تفصیلات ڈاؤن لوڈ ہو گئی ہیں۔",
    updatedBy: "اپ ڈیٹ کنندہ",
    previousRemarks: "سابقہ نوٹس",
    pleaseSelectOrganizationCreatingAccount:
      "اکاؤنٹ بنانے سے پہلے براہ کرم ایک تنظیم منتخب کریں۔",
    pleaseSelectProjectIdFirst: "براہ کرم پہلے ایک پروجیکٹ منتخب کریں۔",
    norecordareavailbles: "کوئی ریکارڈ دستیاب نہیں ہے۔",
    downloadlinkmissing: "ڈاؤن لوڈ کا لنک غائب ہے۔",
    invalidresponse: "غلط جوابی شکل۔",
    failedFetchReports: "رپورٹس حاصل کرنے میں ناکام۔",
    reportgeneratedsuccc: "رپورٹ کامیابی کے ساتھ تیار ہو گئی!",
    pleaseSelectRecordProceed:
      "براہ کرم آگے بڑھنے کے لیے ایک ریکارڈ منتخب کریں!",
    errorOccurredWhileDeletingRecord:
      "ریکارڈ کو حذف کرتے وقت ایک خرابی پیش آگئی۔",
    failedtofetchmeter: "میٹر کی انوینٹری کی تفصیلات حاصل کرنے میں ناکام۔",
    userStatusupdatesuc: "صارف کی حیثیت کامیابی کے ساتھ اپ ڈیٹ ہو گئی۔",
    failedtoupdateuserstatus: "صارف کی حیثیت کو اپ ڈیٹ کرنے میں ناکام۔",
    fileuploadedsucc: "فائل کامیابی کے ساتھ اپ لوڈ ہو گئی۔",
    failedtouploadfiles:
      "فائل اپ لوڈ کرنے میں ناکام۔ براہ کرم help@blufield.net سے رابطہ کریں۔",
    pleasegeneratepreview: "براہ کرم قسط بنانے سے پہلے پیش نظارہ تیار کریں۔",
    failedtogeneratepdf:
      "پی ڈی ایف بنانے میں ناکام۔ براہ کرم دوبارہ کوشش کریں یا help@blufield.net پر ہم سے رابطہ کریں۔",
    installmentupdated: "قسط کا منصوبہ کامیابی کے ساتھ اپ ڈیٹ ہو گیا!",
    installmentplancretsuc: "قسط کا منصوبہ کامیابی کے ساتھ بنایا گیا!",
    errorgeneratingpdf: "پی ڈی ایف بنانے یا قسط کا منصوبہ جمع کرانے میں خرابی!",
    failedtoconnectserver: "",
    youcannotpaythefullamount:
      "آپ پوری رقم ایک قسط میں ادا نہیں کر سکتے۔ براہ کرم اسے تمام قسطوں میں تقسیم کریں۔",
    eachinstallmentmusthave: "ہر قسط میں کم از کم کم از کم رقم ہونی چاہیے۔",
    changesavedsuc: "تبدیلیاں کامیابی سے محفوظ ہو گئیں!",
    plzwentervalidacc: "براہ کرم ایک درست اکاؤنٹ نمبر درج کریں۔",
    fieldagentassinged: "فیلڈ ایجنٹ کو تفویض کیا گیا۔",
    NoasssingData: "تفویض کرنے والا کوئی ڈیٹا دستیاب نہیں ہے۔",
    assigneeCompleted: "مکمل",
    assigneeCompletedBy: "مکمل کرنے والا",
    unAssignTaskSuccessMeg:
      "آپ کی درخواست موصول ہو گئی ہے اور اس پر پس منظر میں کارروائی ہو رہی ہے۔ اس کے مکمل ہونے کے بعد آپ کو مطلع کر دیا جائے گا۔",
    pleaseselect: "پہلے ایک ورک فلو منتخب کریں۔",
    plzenteracommentbeforedel:
      "براہ کرم کام کو حذف کرنے سے پہلے ایک تبصرہ درج کریں۔",
    taskdelsuccessfully: "ٹاسک کامیابی سے حذف ہو گیا۔",
    erroccureduringtask: "",
    failedtoassignbyarea: "علاقے کے لحاظ سے کام تفویض کرنے میں ناکام۔",
    plzselectactivity: "براہ کرم ایک سرگرمی منتخب کریں۔",
    noassigneselectedfor:
      "تفویض ختم کرنے کے لیے کوئی تفویض منتخب نہیں کیا گیا۔",
    delteallrecord: "تمام ریکارڈز حذف کر دیے گئے ہیں۔",
    taskprioriyupdated: "کام کی ترجیح کو اپ ڈیٹ کر دیا گیا۔",
    pdfnotavailable: "PDF دستیاب نہیں ہے۔",
    datafetchedsuccessfully: "ڈیٹا کامیابی سے حاصل کیا گیا۔",
    anerroroccuredtaskhistory: "",
    taskupdatedcussfully: "ٹاسک کامیابی کے ساتھ اپ ڈیٹ ہو گیا۔",
    erroruploadingfileplztry:
      "فائل اپ لوڈ کرنے میں خرابی۔ براہ کرم دوبارہ کوشش کریں یا help@blufield.net پر ہم سے رابطہ کریں۔ ",
    orgismissingnotdrag: "تنظیم کی شناخت غائب ہے، گھسیٹ نہیں سکتی!",
    nochangwsmadetothe: "فیلڈ کی قسم میں کوئی تبدیلی نہیں کی گئی۔",
    selectOrgWarning: "پہلے تنظیم کا انتخاب کریں۔",
    pleaseselectdayreport: "براہ کرم رپورٹ کے لیے دن کا انتخاب کریں۔",
    reportprocesucc: "رپورٹ پر کامیابی کے ساتھ کارروائی ہوئی!",
    nofileselc: "کوئی فائل منتخب نہیں کی گئی۔",
    filesizeexceeds: "فائل کا سائز 5MB سے زیادہ ہے۔",
    invalidfiletypeplimg: "غلط فائل کی قسم۔ براہ کرم ایک تصویر اپ لوڈ کریں۔",
    invalidfiletypedouc: "غلط فائل کی قسم۔ براہ کرم ایک دستاویز اپ لوڈ کریں۔",
    unsupportedfile: "غیر تعاون یافتہ فائل کی قسم۔",
    plzfillallfieldbeforeadd:
      "براہ کرم اثاثہ شامل کرنے سے پہلے تمام فیلڈز کو پُر کریں۔",
    assetaddedscucceffuly: "اثاثہ کامیابی کے ساتھ شامل کر دیا گیا۔",
    fillFieldbeforeAddVehical:
      "گاڑی شامل کرنے سے پہلے براہ کرم تمام فیلڈ پُر کریں۔",
    assetupdatedsuc: "اثاثہ کامیابی سے اپ ڈیٹ ہو گیا۔",
    vehicalupdatedsuc: "گاڑی کامیابی کے ساتھ اپ ڈیٹ ہو گئی۔",
    emailidorpass: "ای میل یا پاس ورڈ غلط ہے۔",
    accessdenied: "رسائی سے انکار!",
    otpverifiedsuc: "OTP کی کامیابی سے تصدیق ہو گئی۔",
    failedtoverifyotp: "OTP کی توثیق کرنے میں ناکام۔",
    noworkflowinorg: "اس تنظیم کے لیے کوئی ورک فلو دستیاب نہیں ہے۔",
    plzuploadpdffileonly: "براہ کرم صرف پی ڈی ایف یا ویڈیو فائلیں اپ لوڈ کریں۔",
    guidlineuplodsucc: "گائیڈ لائن کامیابی سے اپ لوڈ ہو گئی۔",
    invalidfiletype:
      "غلط فائل کی قسم۔ براہ کرم ایک JPG، PNG، یا GIF اپ لوڈ کریں۔",
    emailnotavailble:
      "ای میل دستیاب نہیں ہے۔ براہ کرم یقینی بنائیں کہ آپ کا پروفائل لوڈ ہے۔",
    youcanotmodify:
      "آپ موجودہ پاس ورڈ میں ترمیم نہیں کر سکتے جب تک کہ پہلے صاف نہ کر دیا جائے۔",
    youcanowenter: "اب آپ نیا پاس ورڈ درج کر سکتے ہیں۔",
    passowrdmust:
      "پاس ورڈ کم از کم 8 حروف کا ہونا چاہیے، اس میں ایک بڑے حروف، چھوٹے حروف، نمبر، اور خصوصی حرف شامل ہوں",
    profileupdated: "پروفائل اپ ڈیٹ کر دیا گیا۔",
    failedtofetchemails: "ای میلز حاصل کرنے میں ناکام",
    enteremailfirst:
      "پہلے اپنا ای میل درج کریں، پھر آپ ای میل اطلاعات کو فعال کر سکتے ہیں۔",
    statusupdatedsucc: "حالت کامیابی کے ساتھ اپ ڈیٹ ہو گئی۔",
    failedtoupdatednotifcation: "اطلاع کی ترتیب کو اپ ڈیٹ کرنے میں ناکام",
    errorfiledownloaded: "خرابی: فائل ڈاؤن لوڈ ہو گئی۔",
    fileuploadedaborteddue: "فائل اپ لوڈ ایک خرابی کی وجہ سے روک دی گئی۔",
    plxselectanoption: "براہ کرم ایک آپشن منتخب کریں۔",
    pleasefillallmandtoryfield:
      "آگے بڑھنے کے لیے براہ کرم تمام لازمی فیلڈز پُر کریں۔",
    uploadcanceled: "اپ لوڈ منسوخ کر دیا گیا۔",
    nodatavailvle: "کوئی ڈیٹا دستیاب نہیں ہے۔",
    nofieldavailable: "کوئی فیلڈز دستیاب نہیں ہیں۔",
    categoriyaddedsucc: "زمرہ کامیابی کے ساتھ شامل کیا گیا۔",
    plzselectdeltype: "براہ کرم حذف کرنے کی قسم منتخب کریں۔",
    failedtodelfile: "فائل کو حذف کرنے میں ناکام۔",
    uploadedtasksheet: "اپ لوڈ کردہ ٹاسک شیٹ کی فہرست ٹیبل میں دکھائی گئی ہے!",
    nomoredatatoload: "لوڈ کرنے کے لیے مزید ڈیٹا نہیں ہے۔",
    taskdetailupdatedsuc: "ٹاسک کی تفصیلات کامیابی کے ساتھ اپ ڈیٹ ہو گئیں!",
    norecordavbforthisacc:
      "اس اکاؤنٹ نمبر کے لیے کوئی ریکارڈ دستیاب نہیں، براہ کرم دوسرا اکاؤنٹ نمبر آزمائیں۔",
    userupdatedsuc: "صارف کامیابی کے ساتھ اپ ڈیٹ ہو گیا۔",
    usercreatedSuc: "صارف کامیابی کے ساتھ بنایا گیا۔",
    failedtofetchusers: "صارفین کو لانے میں ناکام۔",
    nofieldabuplodtasksheet:
      "کوئی فیلڈ دستیاب نہیں، اضافی فیلڈز حاصل کرنے کے لیے پہلے ٹاسک شیٹ اپ لوڈ کریں۔",
    nomoreuniqueversion: "مزید منفرد ورژن دستیاب نہیں ہیں۔",
    nomoreversionavailble: "مزید ورژن دستیاب نہیں ہیں۔",
    createworkflowdiagram: "ورک فلو بنائیں۔",
    updatepdfnamefirst: "پہلے پی ڈی ایف کا نام اپ ڈیٹ کریں۔ ",
    pdfnameupdate: "PDF نام کامیابی کے ساتھ اپ ڈیٹ ہو گیا۔",
    updatereportname: "پہلے رپورٹ کا نام اپ ڈیٹ کریں۔",
    excelnameupdate: "ایکسل کا نام کامیابی سے اپ ڈیٹ ہو گیا۔ ",
    inputvlueadded: "ان پٹ ویلیو شامل!",
    warningthis:
      "انتباہ: یہ اختیار پہلے سے ہی ورک فلو میں شامل ہے۔ ہٹانے پر پابندی ہے۔",
    linkedWorkflowConditionConflict:
      'اس اختیار کے ساتھ پہلے ہی ورک فلو منسلک ہے۔ "{option}" کے لیے والد کے اختیار کی شرط شامل کرنے سے پہلے منسلک ورک فلو ہٹائیں۔',
    conditionLinkedWorkflowConflict:
      'اس اختیار کے لیے والد کے اختیار کی شرط پہلے ہی موجود ہے۔ "{option}" سے ورک فلو منسلک کرنے سے پہلے یہ شرط ہٹائیں۔',
    linkedWorkflowConditionSaveConflict:
      'فیلڈ "{field}" کے اختیار "{option}" کے ساتھ پہلے ہی ورک فلو اور والد کے اختیار کی شرط موجود ہے۔ محفوظ کرنے سے پہلے ایک کو ہٹائیں۔',
    fieldremoved: "فیلڈ ہٹا دیا گیا۔",
    fieldcloned: "فیلڈ کلون",
    clonedsuc: "کامیابی کے ساتھ کلون کیا گیا۔",
    pleaseentername: "براہ کرم کلون شدہ ورک فلو کے لیے ایک نام درج کریں۔.",
    inputfield: "ان پٹ فیلڈ خالی نہیں ہو سکتی!",
    warningalready:
      "انتباہ: یہ اختیار پہلے سے ہی ورک فلو میں شامل ہے۔ ہٹانے پر پابندی ہے۔ آپ صرف اس اختیار کے نام میں ترمیم کر سکتے ہیں۔",
    validationremoved:
      "توثیق ہٹا دی گئی۔ حذف کرنے کے لیے ورک فلو کو اپ ڈیٹ کریں۔",
    validationnotapplicable:
      "اس فیلڈ کی قسم کے لیے توثیق کا اطلاق نہیں ہوتا ہے۔",
    updatetheworkflow: "ان اضافی فیلڈز کو بچانے کے لیے ورک فلو کو اپ ڈیٹ کریں۔",
    failedtoupdatefield:
      "فیلڈز کو اپ ڈیٹ کرنے میں ناکام۔ براہ کرم دوبارہ کوشش کریں۔",
    pleaseSelectLeastActivity: "براہ کرم کم از کم ایک سرگرمی منتخب کریں۔",
    failedSubmitReportRequest: "رپورٹ کی درخواست جمع کرانے میں ناکام۔",
    urlnotprovided: "جواب میں URL فراہم نہیں کیا گیا۔",
    failedtoaddasset: "اثاثہ شامل کرنے میں ناکام ",
    vehicleaddedsuc: "گاڑی کامیابی کے ساتھ شامل کر دی گئی۔",
    failToAddVehical: "گاڑی شامل کرنے میں ناکام۔",
    ruleupdatedsuc: "اصول کامیابی کے ساتھ اپ ڈیٹ ہو گیا!",
    filesdeleted: "فائل حذف کر دی گئی۔",
    plzselectatleatone:
      "براہ کرم تفویض کرنے کے لیے کم از کم ایک کام منتخب کریں۔",
    plzselectedforilfagrntoasing:
      "براہ کرم کام تفویض کرنے کے لیے فیلڈ ایجنٹ کا انتخاب کریں۔",
    invalidworkflow: "غلط ورک فلو۔ براہ کرم دوبارہ کوشش کریں۔",
    softdeletedsucc: "نرم حذف کامیاب!",
    softdelfailed: "نرم حذف کرنے میں ناکام!",
    erroduringsoftdel: "نرم حذف کے دوران خرابی!",
    permamatdelsuc: "مستقل حذف کامیاب!",
    permantdelfailed: "مستقل حذف کرنے میں ناکام!",
    errorduringperdel: "مستقل حذف کے دوران خرابی!",
    taskrecallcompletesuc: "ٹاسک واپسی کامیابی کے ساتھ مکمل ہو گیا!",
    taskrecallfailed: "ٹاسک یاد کرنے میں ناکام!",
    erroduringtaskrecall: "ٹاسک یاد کرنے کے دوران خرابی!",
    attachmentismand: "منسلکہ لازمی ہے!",
    onlypdfimgallowed: "صرف پی ڈی ایف اور تصویری فائلوں کی اجازت ہے۔",
    workflowmodule:
      "ورک فلو ماڈیول موبائل آلات پر دستیاب نہیں ہے۔ جاری رکھنے کے لیے براہ کرم ڈیسک ٹاپ یا ٹیبلیٹ استعمال کریں۔",
    Attachment: "اٹیچمنٹ ",
    viewattachment: "اٹیچمنٹ دیکھیں",
    selectedtasknotassinged: "منتخب کردہ کام تفویض نہیں کیے گئے۔ ",
    completedTaskReassignNotAllowed: "صرف ناکام مکمل شدہ کاموں کو دوبارہ تفویض کیا جا سکتا ہے۔",
    completedTasksCannotBeOnHold: "مکمل شدہ ٹاسکس کو آن ہولڈ نہیں کیا جا سکتا۔",
    taskAlreadyOnHold: "ٹاسک پہلے سے آن ہولڈ ہے۔",
    pendingTasksCannotBeOnHold: "پینڈنگ ٹاسکس کو آن ہولڈ نہیں کیا جا سکتا۔",
    taskAssignNotAllowed: "صرف فعال، پینڈنگ یا آن ہولڈ ٹاسکس تفویض کیے جا سکتے ہیں۔",
    taskReassignNotAllowed: "صرف تفویض شدہ، جاری، پینڈنگ یا آن ہولڈ ٹاسکس دوبارہ تفویض کیے جا سکتے ہیں۔",
    taskUnassignNotAllowed: "صرف تفویض شدہ، پینڈنگ یا آن ہولڈ ٹاسکس کی تفویض ختم کی جا سکتی ہے۔",
    Inactive: "غیر فعال ",
    aresurewantodeleterule: "کیا آپ واقعی اصول کو حذف کرنا چاہتے ہیں؟",
    Assigning: "تفویض کرنا ",
    Saving: "محفوظ کرنا",
    Requesting: "درخواست کر رہا ہے۔ ",
    enterextendeddate: "توسیعی تاریخ درج کریں۔",
    targetoutstandingamtbyextdate:
      "توسیعی تاریخ کے لحاظ سے بقایا رقم کا ہدف بنائیں",
    Comments: "تبصرے ",

    aresurewanttodeleterecord: "کیا آپ واقعی ریکارڈ کو حذف کرنا چاہتے ہیں؟",
    downladreport: "رپورٹ ڈاؤن لوڈ کریں۔",
    transferto: "کو منتقل کیا گیا۔",
    nometerdetailfound: "بار کوڈ کے لیے میٹر کی کوئی تفصیلات نہیں ملی",
    loadingmeterdetail: "میٹر کی تفصیل لوڈ ہو رہی ہے۔",
    Print: "پرنٹ ",
    ucantaddmorethan6: `آپ 6 سے زیادہ قسطیں شامل نہیں کر سکتے`,
    Proceed: "آگے بڑھیں۔ ",
    taskdetails: "ٹاسک کی تفصیلات",
    viewexistingfile: "موجودہ فائل دیکھیں",
    nofileuploaded: "کوئی فائل اپ لوڈ نہیں ہوئی۔",
    nooptionavailable: "کوئی اختیارات دستیاب نہیں ہیں۔",

    fetchingaccdetails: "اکاؤنٹ کی تفصیلات حاصل کی جا رہی ہیں۔",
    workflowid: "ورک فلو ID",
    pdflink: "پی ڈی ایف لنک",
    selectefieldpreiview: "پیش نظارہ کے لیے منتخب فیلڈز",
    fieldname: "فیلڈ کا نام",
    fieldtype: "فیلڈ کی قسم",
    selectfield: "فیلڈ منتخب کریں۔",
    selectinputtype: "ان پٹ کی قسم منتخب کریں۔",
    updateinputype: "ان پٹ کی قسم کو اپ ڈیٹ کریں۔",
    uploadnewphoto: "نئی تصویر اپ لوڈ کریں۔",
    Open: "کھولیں۔ ",
    uploadnewdoc: "نئی دستاویز اپ لوڈ کریں۔",
    viewpdf: "پی ڈی ایف دیکھیں",
    dragandroptoupload: "اپ لوڈ کرنے کے لیے گھسیٹیں اور چھوڑیں۔",
    aresurewantodeletefile: "کیا واقعی فائل کو حذف کرنا چاہتے ہیں؟",
    generatereport: "رپورٹ بنائیں ",
    Reject: "رد کرنا ",
    Approve: "منظور کرو ",
    loadingmorenotification: "مزید اطلاعات لوڈ ہو رہی ہیں۔",
    nomorenotification: "لوڈ کرنے کے لیے مزید اطلاعات نہیں ہیں۔",
    Pending: "زیر التواء ",
    Task: "کام ",
    Mandatory: "لازمی ",
    Fields: "فیلڈز ",
    Other: "دیگر ",
    Back: "پیچھے ",
    thisactivitydoesnothavefield: "اس سرگرمی میں فیلڈز نہیں ہیں۔",
    subcategory: "ذیلی زمرہ",
    selectsubcategory: "ذیلی زمرہ منتخب کریں۔",
    addcategory: "زمرہ + شامل کریں۔",
    deletetask: "ٹاسکس کو حذف کریں۔",
    deleteTaskTitle: "ٹاسک حذف کریں",
    dosoftdeletions: "نرم حذف کریں۔",
    depermanatdeletions: "مستقل حذف کریں۔",
    permanentdeletedisabled: "یہ آپشن فی الحال غیر فعال ہے۔",
    confirmdeletion: "حذف کرنے کی تصدیق کریں۔",
    areusurewanttoallassinged:
      "کیا آپ واقعی تمام تفویض کردہ، پیش رفت اور آن ہولڈ کاموں کو فعال بنانا چاہتے ہیں؟",
    selectlocationmap: "نقشے پر مقام منتخب کریں۔",
    Loading: "لوڈ ہو رہا ہے۔",
    nowuserfound: "کوئی صارف نہیں ملا",
    userActivity: "صارف کی سرگرمی",
    loginHistoryTitle: "لاگ ان کی تاریخ",
    viewLoginHistory: "لاگ ان کی تاریخ دیکھیں",
    loadingLoginHistory: "لاگ ان کی تاریخ لوڈ ہو رہی ہے...",
    noLoginActivityYet: "ابھی تک لاگ ان کی کوئی سرگرمی نہیں",
    loginHistoryWillAppearWhenSignIn: "جب یہ صارف لاگ ان کرے گا تو لاگ ان کی تاریخ یہاں ظاہر ہو گی۔",
    mostRecentLogin: "حالیہ ترین لاگ ان",
    loginTime: "لاگ ان کا وقت",
    systemId: "سسٹم آئی ڈی",
    map: "نقشہ",
    openInMap: "نقشے میں کھولیں",
    open: "کھولیں",
    locationUnavailable: "مقام دستیاب نہیں",
    failedToFetchLoginHistory: "لاگ ان کی تاریخ حاصل کرنے میں ناکامی۔",
    notAvailable: "N/A",
    addfield: "فیلڈز شامل کریں۔",
    updatefield: "فیلڈز کو اپ ڈیٹ کریں۔",
    enterworkflowname: "ورک فلو کا نام درج کریں۔",
    Elements: "عناصر ",

    Report: "رپورٹ ",
    editinputvalues: "ان پٹ ویلیوز میں ترمیم کریں۔",
    addedvalidation: "توثیق شامل کر دی گئی۔",

    deletefield: "فیلڈ کو حذف کریں۔",
    deletevalidation: "توثیق کو حذف کریں۔",
    validationcode: "توثیق کوڈ",
    novalidationavailable: "کوئی توثیق دستیاب نہیں ہے۔",
    rusurewanttodeleteworkflow:
      "کیا آپ واقعی اس ورک فلو کو حذف کرنا چاہتے ہیں؟",
    noversionavb: "کوئی ورژن دستیاب نہیں ہے۔",
    noreportdataavb: "کوئی رپورٹ ڈیٹا دستیاب نہیں ہے۔",
    goback: "واپس جائیں →",

    aresurewantodeleteemail: "کیا آپ واقعی اس ای میل کو حذف کرنا چاہتے ہیں؟",
    nofieldagentfound: "کوئی فیلڈ ایجنٹ نہیں ملا",
    Selected: "منتخب",
    updatedon: "کو اپ ڈیٹ کیا گیا۔",
    tariff: "ٹیرف",
    Office: "دفتر",
    cancelupload: "اپ لوڈ منسوخ کریں۔",
    Recall: "یاد کرنا ",
    notaskavbtounasign: "غیر تفویض کرنے کے لیے کوئی ٹاسک دستیاب نہیں ہے۔",
    unassigntask: " ٹاسک کو غیر تفویض کریں۔",
    selectassigntounassign:
      "منتخب کردہ کاموں سے غیر تفویض کرنے کے لیے تفویض کردہ افراد کو منتخب کریں۔",
    allassign: "تمام تفویض کردہ",

    confirmaction: "کارروائی کی تصدیق کریں۔",
    areusure: "کیا آپ واقعی اس کام کو حذف کرنا چاہتے ہیں؟ یہ عمل نہیں ہو سکتا",
    totalcount: "کل شمار",
    Processing: "پروسیسنگ",
    currenOs: "موجودہ OS ",
    updatedat: "پر اپ ڈیٹ کیا گیا۔",
    curros: "موجودہ بقایا",
    lastupdateddate: "آخری تازہ کاری کی تاریخ",
    lastupdatedtime: "آخری تازہ کاری کا وقت",
    assingename: "تفویض کرنے والے کا نام",
    finisheddate: "ختم ہونے والی تاریخ",
    fnishedtime: "ختم ہونے کا وقت",
    uploadeddate: "اپ لوڈ کی تاریخ",
    uploadedtime: "اپ لوڈ کا وقت",
    uploadedLabel: "اپ لوڈ شدہ",
    finishedLabel: "مکمل شدہ",
    Unsuccessful: "ناکام ",
    Success: "کامیابی ",
    fileprocessingcancle: "فائل پروسیسنگ منسوخ کر دی گئی۔",
    pleaseenteraccnumber: "براہ کرم اکاؤنٹ نمبر درج کریں۔ ",
    projmissingplzelc: "پروجیکٹ غائب ہے۔ براہ کرم ایک پروجیکٹ منتخب کریں۔",
    addleastonelementto:
      "اگلے صفحہ پر جانے سے پہلے موجودہ صفحہ میں کم از کم ایک عنصر شامل کریں۔",
    checkuremailotp: "OTP کے لیے اپنا ای میل چیک کریں",
    taskcreatedsuc: "کام کامیابی کے ساتھ بنائے گئے۔",
    taskunassingedsucc: "کام کامیابی کے ساتھ غیر تفویض کیا گیا!",
    norecordareavailable: "کوئی ریکارڈ دستیاب نہیں ہے۔",
    failedtouploadfile: "فائل اپ لوڈ کرنے میں ناکام",
    failtoupdaterule: "اصول کو اپ ڈیٹ کرنے میں ناکام",
    startdateerror: "آغاز کی تاریخ اختتامی تاریخ کے بعد نہیں ہو سکتی",
    anerror: "",
    errorsubmiting: "فارم جمع کرانے میں خرابی۔",
    ruleupdated: "اصول کامیابی کے ساتھ اپ ڈیٹ ہو گیا۔",
    failupdaterule: "اصول کو اپ ڈیٹ کرنے میں ناکام",
    plzselectworkflow: "براہ کرم اصول شامل کرنے سے پہلے ورک فلو کو منتخب کریں۔",

    basicinfo: "بنیادی معلومات",
    changeprofile: "پروفائل تبدیل کریں۔",
    updateRule: "اپڈیٹ رول",
    newRule: " نیا اصول",
    assignedAll: "تمام تفویض",
    notAssignedAll: "سب کو تفویض نہیں کیا گیا۔",
    LoadingGeo: "جیو کوڈز لوڈ ہو رہے ہیں۔",
    selectgeocode: "جیو کوڈ منتخب کریں۔",
    All: "تمام",
    loadingtyoecodes: "ٹائپ کوڈز لوڈ ہو رہے ہیں۔",
    selecttypecodes: "قسم کا کوڈ منتخب کریں۔",
    selectamount: "رقم کی حد منتخب کریں۔",
    ok: "ٹھیک ہے",
    gobacktopreviousstep: "پچھلے مرحلے پر واپس جائیں",
    continuetonextstep: "اگلے مرحلے پر جائیں",
    selectsheettoupload: "جو شیٹ درآمد کرنا ہے اسے منتخب کریں یا یہاں چھوڑیں",
    uploadlimitexceeded: "اپ لوڈ کی حد سے تجاوز ہو گیا",
    sheetrecordlimitmsg:
      "اس شیٹ میں {count} ریکارڈ ہیں۔ ایک وقت میں زیادہ سے زیادہ {limit} ریکارڈ اپ لوڈ کیے جا سکتے ہیں۔ براہ کرم فائل کو تقسیم کر کے دوبارہ اپ لوڈ کریں۔",
    fileuploadedtitle: "فائل اپ لوڈ ہو گئی",
    largedataprocessingmsg:
      "آپ کی فائل کامیابی سے اپ لوڈ ہو گئی ہے۔ اگر اس میں ریکارڈز کی تعداد زیادہ ہے تو پروسیسنگ میں کچھ وقت لگ سکتا ہے۔ براہ کرم کچھ دیر انتظار کریں اور نیچے دی گئی فہرست میں اسٹیٹس چیک کریں۔",
    invalidfiletitle: "غیر درست فائل",
    unabletoreadsheet:
      "ہم اس فائل کو نہیں پڑھ سکے۔ براہ کرم یقینی بنائیں کہ یہ ایک درست CSV یا Excel شیٹ ہے اور دوبارہ کوشش کریں۔",
    importtaskusingsheet: "شیٹ / CSV کے ذریعے ٹاسک درآمد کریں",
    mapyourfilecolumns: "اپنی فائل کے کالمز میپ کریں اور ٹاسک اپ لوڈ کریں",
    importprogress: "درآمد کی پیش رفت",
    columnmappingsteps: "کالم میپنگ کے مراحل",
    uploadfilelabel: "فائل اپ لوڈ کریں",
    uploadtasksheetdesc:
      "جو ٹاسک شیٹ درآمد کرنا ہے اسے اپ لوڈ کریں (.csv یا .xlsx)۔ اگلے مرحلے میں ہم اس کے کالمز میپ کریں گے۔",
    draganddroptasksheet: "اپنی ٹاسک شیٹ یہاں گھسیٹ کر چھوڑیں",
    orclicktobrowse: "یا براؤز کرنے کے لیے کلک کریں · CSV یا Excel",
    clicktochooseanotherfile: "دوسری فائل منتخب کرنے کے لیے کلک کریں",
    selectavalue: "ایک قیمت منتخب کریں",
    selecttaskpriority: "درآمد شدہ ٹاسک کے لیے ڈیفالٹ ترجیح منتخب کریں",
    existingaccountsquestion: "موجودہ اکاؤنٹس کے ساتھ آپ کیا کرنا چاہتے ہیں؟",
    updateexistingaccountentries: "پہلے سے موجود اکاؤنٹ اندراجات اپ ڈیٹ کریں؟",
    createnewaccountentries: "نئے اکاؤنٹ اندراجات بنائیں؟",
    mandatoryfield: "لازمی فیلڈ",
    primarykeyvalue: "پرائمری کی / ویلیو",
    pleaseselectanactivity: "براہ کرم ایک سرگرمی منتخب کریں",
    findAField: "فیلڈ تلاش کریں...",
    wfFieldGroupBasic: "بنیادی فیلڈز",
    wfFieldGroupSelection: "انتخابی فیلڈز",
    wfFieldGroupMedia: "میڈیا اور خصوصی فیلڈز",
    uploadandreviewtasksheets: "درآمد شدہ ٹاسک شیٹس اپ لوڈ کریں اور جائزہ لیں۔",
    cycle: "سائیکل",
    daterange: "تاریخ کی حد",
    reportscope: "رپورٹ کا دائرہ",
    selectcycle: "سائیکل منتخب کریں",
    selectcycleoptional: "سائیکل (اختیاری)",
    nocyclesavailable: "ابھی تک کوئی سائیکل اپ لوڈ نہیں ہوا",
    pleaseselectacycle: "براہ کرم ایک سائیکل منتخب کریں",
    pleaseselectonecycle: "ڈیٹا رپورٹ کے لیے صرف ایک سائیکل منتخب کریں",
    performancereport: "کارکردگی رپورٹ",
    cycleperformancereport: "سائیکل کارکردگی رپورٹ",
    performancereportready: "سائیکل کارکردگی رپورٹس تیار ہو گئیں۔",
    performancereporttooltip: "منتخب سرگرمی اور سائیکلوں کے لیے کارکردگی رپورٹس بنائیں",
    performancereportrequirements: "کارکردگی رپورٹ بنانے کے لیے اس سرگرمی کا ایک سائیکل منتخب کریں",
    cyclesingleactivityonly: "سائیکل رپورٹس ایک وقت میں ایک سرگرمی کا احاطہ کرتی ہیں۔ سائیکل اسکوپ استعمال کرنے کے لیے ایک سرگرمی منتخب کریں۔",
    cycleselectactivityfirst: "سائیکل اسکوپ استعمال کرنے کے لیے ایک سرگرمی منتخب کریں",
    gobacklabel: "واپس جائیں",
    inProgress: "جاری ہے",
    uploadedCount: "اپ لوڈ شدہ تعداد",
    movedCount: "منتقل شدہ تعداد",
    updatedCount: "اپ ڈیٹ شدہ تعداد",
    notUploadedCount: "اپ لوڈ نہ ہونے والی تعداد",
    notUploadedLog: "اپ لوڈ نہ ہونے والا لاگ",
    movedLog: "منتقل شدہ لاگ",
    downloadnotuploadedlog: "اپ لوڈ نہ ہونے والا لاگ ڈاؤن لوڈ کریں",
    downloadnotmovedlog: "منتقل نہ ہونے والا لاگ ڈاؤن لوڈ کریں",
    failedtorecalltask: "ٹاسک واپس بلانے میں ناکامی۔",
    previousPage: "پچھلا صفحہ",
    nextPage: "اگلا صفحہ",
    previousyear: "پچھلا سال",
    nextyear: "اگلا سال",
    addRule: " قاعدہ شامل کریں۔",
    addproject: "پروجیکٹ شامل کریں۔",
    departmentname: "محکمہ کا نام۔",
    projectname: "  پروجیکٹ کا نام",
    adddepartment: "محکمہ شامل کریں۔",
    seeData: "ڈیٹا دیکھیں",
    enterrecipt: "وصول کنندگان کو کوما سے الگ کرکے درج کریں۔",
    enterbcc: "کوما سے الگ کرکے Bcc درج کریں۔",
    entercc: "کوما سے الگ کرکے Cc درج کریں۔",
    assignbyrule: "قواعد کے مطابق تفویض کریں۔",
    searchfieldAgent: "فیلڈ ایجنٹوں کو تلاش کریں۔",
    selectAll: "سب منتخب کریں",
    deselectAll: "سب غیر منتخب کریں",
    selectAllAgentsTooltip: "تمام نظر آنے والے فیلڈ ایجنٹس منتخب کریں",
    deselectAllAgentsTooltip: "تمام نظر آنے والے فیلڈ ایجنٹس غیر منتخب کریں",
    loadingtask: "کام کی تفصیلات لوڈ ہو رہی ہیں۔",
    fieldagentAvgwork: "فیلڈ ایجنٹ کا اوسط کام کا وقت",
    selectDash: "ڈیش بورڈ کو منتخب کریں۔",
    selecttask: "ٹاسک اسٹیٹس کو منتخب کریں۔",
    selectStatus: "اسٹیٹس کو منتخب کریں۔",
    SelectDateTime: "تاریخ اور وقت کی حد منتخب کریں۔",
    startdatetime: "آغاز کی تاریخ اور وقت",
    enddatetime: "اختتامی تاریخ اور وقت",
    selectDateRange: "تاریخ کی حد منتخب کریں۔",
    fieldAgentCLock: "فیلڈ ایجنٹ کلاک ان/آؤٹ",
    selectusertpye: "صارف کی قسم منتخب کریں۔",
    isClockin: "ClockIn ہے۔",
    selectvehicle: "گاڑی منتخب کریں۔",
    vehicalid: "گاڑی کی شناخت",
    OrganizationId: "تنظیم کی شناخت",
    inuse: "استعمال میں",
    id: "ID",
    selectAsset: "اثاثہ منتخب کریں۔",
    showLatLog: "لیٹ/لمبی غائب کام دکھائیں۔",
    hidelatlog: "مقام (لیٹ/لانگ) کے بغیر ٹاسکس دکھائیں",
    createdatetime: "تاریخکا وقت بنایا گیا۔",
    taskCategory: "ٹاسک کیٹیگری",
    mobileno: "موبائل نمبر",
    discardMessage:
      "کیا آپ واقعی چھوڑنا چاہتے ہیں؟ یہ عمل آپ کو محفوظ یا رد کر دے گا۔",
    viewinstallmentmsg: "قسط کے منصوبے دیکھنے کے لیے اکاؤنٹ نمبر درج کریں۔",
    optionalSelectedfield: "اختیاری انتخابی فیلڈز",
    emailnotification: "ای میل اطلاعات",
    recievemeial:
      "ٹاسک اپ ڈیٹس اور یاد دہانیوں کے لیے ای میل اطلاعات موصول کریں۔",
    taskmangement: "ٹاسک مینجمنٹ",
    autoAssign: "خودکار تفویض",
    autoAssignTask: "خود کار طریقے سے کام تفویض کریں۔",
    autoasigntaskto: "دستیاب ٹیم کے اراکین کو خودکار طور پر کام تفویض کریں۔ ",
    failedToLoadAutoAssign: "خودکار تفویض کی حالت لوڈ کرنے میں ناکامی۔",
    failedToUpdateAutoAssign: "خودکار تفویض کی حالت اپ ڈیٹ کرنے میں ناکامی۔",
    protectioninWorkflow: "ورک فلو میں تحفظ",
    preventtaskprotected: "ایک بار جب کام جاری ہیں ان میں تبدیلیوں کو روکیں۔",
    othersetting: "دیگر ترتیبات",
    choselang: "درخواست کے لیے پہلے سے طے شدہ زبان کا انتخاب کریں۔",
    addmeail: "ای میل شامل کریں۔",
    email: "ای میل",
    notchartYet: "اس چارٹ کے لیے ابھی تک کوئی ڈیٹا دستیاب نہیں ہے۔",
    chartWaitingForResponses: "جوابات موصول ہوتے ہی یہ چارٹ خودکار طور پر اپ ڈیٹ ہو جائے گا۔",
    priorityLevel: "ترجیحی سطح",
    entername: "نام درج کریں۔",
    Activities: "سرگرمیاں",
    basicField: " بنیادی فیلڈز",
    recent: "حالیہ",
    selectionfield: "انتخاب کا میدان",
    mediafield: "میڈیا اور خصوصی فیلڈز",
    items: "چیزیں",
    Enable: "فعال کریں۔",
    disable: "غیر فعال",
    comapletedDate: " مکمل ہونے کی تاریخ",
    taskId: "ٹاسک آئی ڈی",
    noproject: "لکوئی پروجیکٹ نہیں۔",
    nodepartment: " کوئی محکمہ نہیں۔",
    noactivity: " لکوئی سرگرمی نہیں۔",
    splaignrule: "خصوصی تفویض کا اصول  ",
    specialAssignmentRuleSubheading: "جیو لوکیشن، قسم، یا رقم کی حد کے مطابق ٹاسکس روٹ کریں۔",
    urgentTaskAssignment: "فوری ٹاسک تفویض",
    urgentTaskAssignmentTooltip: "منتخب فیلڈ ایجنٹس کو فوری ٹاسکس تفویض کریں",
    urgentTaskAssignmentSubtitle: "فوری ٹاسک تفویض کے لیے ورک فلو، ایریا کوڈز اور فیلڈ ایجنٹس منتخب کریں۔",
    urgentAreaCodes: "ایریا کوڈز",
    urgentSelectAreaCodes: "ایریا کوڈز منتخب کریں",
    urgentFieldAgents: "فیلڈ ایجنٹس",
    urgentSelectFieldAgents: "فیلڈ ایجنٹس منتخب کریں",
    urgentSelectWorkflowRequired: "براہ کرم کم از کم ایک ورک فلو منتخب کریں",
    urgentSelectAreaCodeRequired: "براہ کرم کم از کم ایک ایریا کوڈ منتخب کریں",
    urgentSelectAgentRequired: "براہ کرم کم از کم ایک فیلڈ ایجنٹ منتخب کریں",
    urgentWorkflowHelp: "ان ورک فلوز کے فوری ٹاسکس تفویض کیے جائیں گے۔",
    urgentAreaCodeHelp: "صرف ان ایریا کوڈز میں موجود ٹاسکس شامل ہوں گے۔",
    urgentAgentHelp: "یہ ایجنٹس ہر مماثل کھلے ٹاسک میں شامل کیے جائیں گے۔",
    urgentSummary: "تفویض کا خلاصہ",
    urgentStepsComplete: "مراحل مکمل",
    urgentAssignNow: "فوری ٹاسکس تفویض کریں",
    urgentAssigning: "تفویض ہو رہا ہے...",
    urgentPleaseWait: "فوری ٹاسکس تفویض ہو رہے ہیں، براہ کرم انتظار کریں...",
    urgentNoPermission: "آپ کو فوری ٹاسکس تفویض کرنے کی اجازت نہیں ہے",
    urgentAssignSuccess: "فوری تفویض پس منظر میں پروسیس ہو رہی ہے، مکمل ہونے پر آپ کو اطلاع دی جائے گی۔",
    urgentAssignFailed: "فوری ٹاسکس تفویض کرنے میں ناکامی",
    urgentConfirmTitle: "فوری تفویض کی تصدیق کریں",
    urgentConfirmMessage: "منتخب سرگرمیوں اور علاقوں کے تمام کھلے ٹاسکس میں {count} ایجنٹ شامل کریں؟ موجودہ تفویض کردہ افراد برقرار رہیں گے۔",
    urgentConfirmBack: "واپس",
    urgentConfirm: "ہاں، تفویض کریں",
    urgentHowItWorks: "یہ کیسے کام کرتا ہے",
    urgentHelpKeepAssignees: "موجودہ تفویض کردہ افراد برقرار رہتے ہیں؛ ایجنٹس ان کے علاوہ شامل کیے جاتے ہیں۔",
    urgentHelpSkipCompleted: "مکمل اور ختم شدہ ٹاسکس چھوڑ دیے جاتے ہیں۔",
    urgentHelpOneTime: "یہ ایک بار کا عمل ہے: نئے اپ لوڈز خود بخود ان ایجنٹس کو نہیں جائیں گے۔",
    urgentHelpInProgress: "جاری ٹاسکس میں بھی ایجنٹس شامل کیے جاتے ہیں، اور ٹاسک لسٹ انہیں موجودہ تفویض شدگان کے ساتھ دکھاتی ہے۔",
    searchByAssignTo: "تفویض کردہ کے ذریعے تلاش کریں...",
    myprofile: " میرا پروفائل ",
    sidebarNotifications: "اطلاعات",
    sidebarSettings: "سیٹنگز",
    sidebarUnreadCount: "{count} غیر پڑھے ہوئے",
    barChart: " بار چارٹ ",
    Piechart: "پائی چارٹ",
    Radarchart: "ریڈار چارٹ",
    Linechart: "لائن چارٹ",
    Areachart: "ایریا چارٹ",
    OrganizationLogo: "تنظیم کا لوگو",
    OrganizationName: "تنظیم کا نام",

    Organizations: "تنظیمیں",
    ReportType: "رپورٹ کی قسم",
    ForInstallmentPlan: "قسط کے منصوبے کے لیے",
    WorkflowNames: "ورک فلو کے نام",
    ReportLink: "رپورٹ کا لنک",
    RequestedAt: "پر درخواست کی۔",
    Noguidelines: "کوئی رہنما خطوط دستیاب نہیں ہیں۔",
    Deleteworkflowmsg:
      "کیا آپ واقعی چھوڑنا چاہتے ہیں؟ یہ عمل آپ کے بنائے گئے ورک فلو ڈھانچے کو حذف کر دے گا۔",
    MandatoryFields: "لازمی فیلڈ",
    NonMandatoryFields: "غیر لازمی فیلڈز",
    BulkUpload: "بلک اپ لوڈ",
    CreateandAssigne: "بنائیں اور تفویض کریں۔",
    AssetName: "اثاثہ کا نام",
    UserId: "یوزر آئی ڈی",
    FieldStaffList: "فیلڈ سٹاف کی فہرست",
    SUBMISSION: "جمع کروانا",
    NOT_COMPLETED: "مکمل نہیں ہوا۔",
    HideCriteria: "معیار چھپائیں۔",
    NewCriteria: "نیا معیار شامل کریں۔",
    ActivityQuestions: "سرگرمی کے سوالات کو منتخب کریں۔",
    FieldQuestion: "فیلڈ سوال منتخب کریں۔",
    Select: "منتخب کریں۔",
    AddChart: "چارٹ شامل کریں۔",
    DeleteDash: "کیا آپ واقعی اس ڈیش بورڈ کو حذف کرنا چاہتے ہیں؟",
    DeleteGraph: "کیا آپ واقعی اس گراف میٹرک کو حذف کرنا چاہتے ہیں؟",
    CreateDash: "ایکٹیویٹی ڈیش بورڈ بنائیں",
    Role: "کردار",
    Activity: "سرگرمی",
    selectWorkflow: "ورک فلو منتخب کریں",
    sarWorkflow: "ورک فلو",
    allWorkflows: "تمام ورک فلوز",
    sarWorkflowRequired: "براہ کرم ورک فلو منتخب کریں",
    sarWorkflowChangeHint: "ورک فلو تبدیل کرنے سے پرانے ورک فلو میں اس اصول کے تفویض کردہ کام غیر تفویض ہو جائیں گے اور نئے ورک فلو میں مماثل کام تفویض ہو جائیں گے۔",
    ActivityName: "سرگرمی کا نام",
    SelectChart: "چارٹ منتخب کریں۔",

    // --- گورنریٹ کے لحاظ سے ٹاسکس کارڈ ---
    tasksByGovernorate: "گورنریٹ کے لحاظ سے ٹاسکس",
    governorate: "گورنریٹ",
    notSpecified: "غیر متعین",
    selectFieldAgent: "فیلڈ ایجنٹ منتخب کریں",
    selectView: "منظر منتخب کریں",
    barChartView: "بار چارٹ",
    barChartViewHint: "بار کی لمبائی ٹاسک کی تعداد ظاہر کرتی ہے",
    shareView: "تناسب",
    shareViewHint: "ہر بار پوری چوڑائی میں، تاکہ اسٹیٹس کا تناسب موازنہ ہو سکے",
    tableView: "ٹیبل",
    tableViewHint: "تمام چھ اسٹیٹس کے درست اعداد",
    statusAssigned: "تفویض شدہ",
    statusInProgress: "جاری ہے",
    statusOnHold: "روکا گیا",
    statusPending: "زیر التوا",
    statusCompleted: "مکمل",
    statusFinished: "ختم شدہ",
    total: "کل",
    doneLabel: "مکمل شدہ",
    openLabel: "کھلے",
    blockedLabel: "رکے ہوئے",
    totalAcrossGovernorates: "ان تمام گورنریٹس کے ٹاسکس جہاں ٹاسک موجود ہیں",
    completedPlusFinished: "مکمل + ختم شدہ",
    assignedPlusInProgress: "تفویض شدہ + جاری",
    onHoldPlusPending: "روکے گئے + زیر التوا",
    selectWorkflowToSeeData: "ڈیٹا دیکھنے کے لیے ورک فلو منتخب کریں۔",
    workflowPickerHint: "صفحے کے اوپر موجود فہرست سے ورک فلو منتخب کریں۔",
    noFieldAgentsForWorkflow: "اس ورک فلو میں کوئی فیلڈ ایجنٹ نہیں ہے۔",
    noFieldAgentsHint: "کوریج دیکھنے کے لیے اس ورک فلو میں فیلڈ ایجنٹ تفویض کریں۔",
    selectFieldAgentToSeeData: "فیلڈ ایجنٹ منتخب کریں",
    selectFieldAgentHint: "ان کے ٹاسکس گورنریٹ اور اسٹیٹس کے لحاظ سے تقسیم کیے جائیں گے۔",
    loadingData: "لوڈ ہو رہا ہے...",
    somethingWentWrong: "گورنریٹ کا ڈیٹا لوڈ نہیں ہو سکا۔",
    tryAgainHint: "دوبارہ فیلڈ ایجنٹ منتخب کر کے کوشش کریں۔",
    noTasksForAgent: "اس فیلڈ ایجنٹ کے لیے کوئی ٹاسک نہیں",
    noTasksForAgentHint: "اس ورک فلو میں انہیں ابھی تک کچھ تفویض نہیں کیا گیا۔",
    allStatusesHidden: "تمام اسٹیٹس چھپے ہوئے ہیں - دوبارہ دکھانے کے لیے نیچے کسی پر کلک کریں۔",
    governorateWithNoTask: "گورنریٹ جس میں کوئی ٹاسک نہیں",
    governoratesWithNoTask: "گورنریٹس جن میں کوئی ٹاسک نہیں",
    ViewChart: "چارٹ دیکھیں",
    RangeFilter: "تاریخ کی حد کا فلٹر",
    selecrOrg: "براہ کرم ایک تنظیم منتخب کریں۔",
    Page: "صفحہ",
    FieldId: "فیلڈ ایجنٹ کی شناخت",
    FieldAgentName: "فیلڈ ایجنٹ کا نام",
    Action: "ایکشن",
    RemarkReq: "کسٹمر سپورٹ شامل کریں۔",
    adCustSupport: "کسٹمر سپورٹ شامل کریں۔",
    Clone: "کلون",
    SpecialRc: "خاص RC",
    InteractiveRc: "انٹرایکٹو RC",
    Viewinstallment: "قسط دیکھیں",
    createInstallment: "قسط کا منصوبہ بنائیں",
    CustomerId: "کسٹمر آئی ڈی",
    NoOfinstallment: "قسطوں کی تعداد",
    advancepayamt: "پیشگی ادائیگی کی رقم",
    advDate: "پیشگی تاریخ",
    custDetail: "کسٹمر کی تفصیلات",
    instalDetail: "قسط کی تفصیلات",
    firstInstDate: "پہلی قسط کی تاریخ",
    clrPreview: "پیش نظارہ صاف کریں۔",
    prevPlan: "پیش نظارہ پلان",
    submitRc: "کے لیے جمع کروائیں۔ RC",
    AfterAdv: "پیشگی کے بعد بقایا",
    currentOut: "موجودہ بقایا",

    Amount: "رقم ",
    Notes: "نوٹس ",
    Latitude: "عرض بلد ",
    Longitude: "طول البلد ",
    selectFieldAget: "فیلڈ ایجنٹ کو منتخب کریں۔",
    planId: "پلان آئی ڈی",
    planActive: "فعال منصوبہ",
    planCreated: "منصوبہ بنایا",
    outstaningAmt: "بقایا رقم",
    Advamt: "ایڈوانس رقم",
    AdvDate: "پیشگی ادائیگی کی تاریخ",
    firstInsDate: "پہلی قسط کی تاریخ",
    noOfInst: "قسطوں کی تعداد",
    activeInst: "فعال قسطیں",
    DetailId: "تفصیلی شناخت ",
    PaymentId: "ادائیگی کی شناخت",
    PayAmt: "ادائیگی کی رقم",
    payDate: "ادائیگی کی تاریخ",
    dueDate: "واجب الادا تاریخ",
    paymentStatusUpdatedAt: "ادائیگی کی حالت اپڈیٹ ہونے کی تاریخ",
    outstandingForInstalmentPlan: "بقایا رقم",
    Status: "حیثیت ",
    PayPrev: "ادائیگی کا پیش نظارہ",
    OutAfteAdv: "پیشگی کے بعد بقایا",
    CurrentOut: "موجودہ بقایا",
    NoinstAvlble: "کوئی قسط دستیاب نہیں۔",
    title: "Blufield یوٹیلیٹیز ٹاسک مینجمنٹ سلوشنز",
    userEmail: "صارف نام/ای میل پتہ",
    password: "پاس ورڈ ",
    remember: "مجھے یاد رکھنا",
    forgetpass: "پاس ورڈ بھول جائیں۔",
    Login: "لاگ ان ",

    pressEnter: "متعدد اکاؤنٹ نمبرز شامل کرنے کے لیے Enter دبائیں۔",
    typeEnter: "ایک نمبر ٹائپ کریں اور انٹر دبائیں۔",
    protectedAccountLimitReached: "آپ فی درخواست زیادہ سے زیادہ {limit} اکاؤنٹس شامل کر سکتے ہیں۔",
    protectedAccountCount: "زیادہ سے زیادہ {limit} میں سے {count} اکاؤنٹس شامل کیے گئے ہیں",

    payDetail: "ادائیگی کی تفصیلات",
    cretDate: "تخلیق کی تاریخ",
    inactiveplane: "غیر فعال قسطوں کے منصوبے",
    instplanDetail: "قسط کے منصوبے کی تفصیلات",
    loogoutMsg: "کیا آپ واقعی لاگ آؤٹ کرنا چاہتے ہیں؟",
    Logout: "لاگ آؤٹ",
    support: "کسٹمر سپورٹ",
    supportSubtitle: "RC درخواستیں، قسطوں کے منصوبے اور اکاؤنٹ اپ ڈیٹس کا نظم کریں۔",
    interactiveRcTabTooltip: "انٹرایکٹو RC درخواست جمع کروائیں",
    createInstallmentTabTooltip: "اکاؤنٹ کے لیے نیا قسط کا منصوبہ بنائیں",
    viewInstallmentTabTooltip: "موجودہ قسطوں کے منصوبے دیکھیں",
    specialRcTabTooltip: "خصوصی/استثنائی RC درخواست جمع کروائیں",
    interactiveRcSubtitle: "انٹرایکٹو RC درخواست جمع کروائیں۔",
    createInstallmentSubtitle: "کسٹمر اکاؤنٹ کے لیے نیا قسط کا منصوبہ ترتیب دیں۔",
    viewInstallmentSubtitle: "قسط کا منصوبہ دیکھنے کے لیے اکاؤنٹ تلاش کریں۔",
    specialRcSubtitle: "خصوصی یا استثنائی RC درخواست جمع کروائیں۔",
    viewInstallmentEmptySub: "قسط کا منصوبہ دیکھنے کے لیے اوپر اکاؤنٹ نمبر تلاش کریں۔",
    noMatchingCustomerRecord: "کوئی مماثل کسٹمر ریکارڈ نہیں ملا۔",
    noInactiveInstallmentPlans: "کوئی غیر فعال قسط کا منصوبہ نہیں۔",
    noActiveInstallments: "کوئی فعال قسط نہیں۔",
    supporttooltip: "سپورٹ سسٹم  RC",
    installment: " قسط کا منصوبہ",
    downloadPdf: "پی ڈی ایف ڈاؤن لوڈ کریں۔",
    noDatavb: "کوئی ڈیٹا دستیاب نہیں ہے۔",
    noFilteredData: "منتخب کردہ فلٹرز سے کوئی ٹاسک میل نہیں کھاتا۔ اپنے فلٹرز کو تبدیل یا صاف کرنے کی کوشش کریں۔",
    viewValidation: "توثیق دیکھیں",
    refresh: "ٹیبل ریفریش کریں۔",
    discard: "رد کر دیں۔",
    Confirm: "تصدیق کریں۔",
    datefilterforchart: " مکمل کام کے لیے تاریخ کا فلٹر   ",
    updatetaskdetail: "ٹاسک کی تفصیلات کو اپ ڈیٹ کریں۔  ",
    completedTaskCount: "مکمل ٹاسک کاؤنٹ  ",
    taskpriority: "کام کی ترجیح  ",
    taskstatus: "ٹاسک اسٹیٹس ",
    usercount: "صارف شمار",
    listvbiew: "ٹاسک لسٹ ویو  ",
    previous: "پچھلا",
    next: "اگلا",
    date: "تاریخ",
    from: "سے",
    to: "کو",
    apply: "لگائیں",
    unassignn: "إلغاء التعيين",
    dashboard: "لوحة القيادة",
    dashboardtolltip: "لوحة القيادة، عرض وإدارة نظرة عامة على لوحة القيادة",
    usertooltip: "المستخدمون، إدارة حسابات المستخدمين والأدوار",
    setting: "الإعدادات",
    asset: "إدارة الأصول",
    assettooltip: "الأصول، عرض وإدارة الأصول الخاصة بك",
    config: "التكوين",
    configtooltip:
      "التكوين، إدارة قواعد التعيين، القواعد المخصصة وقواعد الإتمام",
    task: "إدارة المهام",
    tasktooltip: "إدارة المهام، إدارة مهامك وتعييناتك، والحذف",
    acchistory: "تاريخ الحساب",
    accReportsCenter: "اکاؤنٹس اور رپورٹس سینٹر",
    historytooltip: "اکاؤنٹ کی تاریخ، مکمل ٹاسکس کی تاریخ دیکھیں",
    accReportsCentertooltip:
      "اکاؤنٹ اور رپورٹس سینٹر، اکاؤنٹ کی تاریخ دیکھیں اور رپورٹس ایکسپورٹ کریں",
    callCenter: "کال سینٹر",
    callCentertooltip:
      "کال سینٹر، ان باکس، ٹکٹس، مہمات اور ایجنٹ ورک سپیس منظم کریں",
    workflowe: "سير العمل",
    workflowtooltip: "سير العمل، إدارة سير العمل الخاص بك، الإرشادات",
    workflowManagementSubtitle: "ورک فلو ٹیمپلیٹس بنائیں اور ان کا نظم کریں جو ٹاسک فارمز کو ترتیب دینے کے لیے استعمال ہوتے ہیں۔",
    workflows: "ورک فلوز",
    searchWorkflow: "ورک فلو کا نام تلاش کریں...",
    sortBy: "ترتیب دیں",
    sortNameAsc: "نام (A-Z)",
    sortNameDesc: "نام (Z-A)",
    sortUpdatedNewest: "آخری اپ ڈیٹ (تازہ ترین)",
    sortUpdatedOldest: "آخری اپ ڈیٹ (پرانا ترین)",
    noWorkflowsMatchSearch: "آپ کی تلاش سے کوئی ورک فلو مماثل نہیں",
    workflowSettings: "ورک فلو کی ترتیبات",
    secondsUnit: "سیکنڈ",
    pageWiseOff: "پیج وائز آف",
    timerLabel: "ٹائمر",
    addPage: "صفحہ شامل کریں",
    duplicatePage: "صفحہ کاپی کریں",
    deletePage: "صفحہ حذف کریں",
    versionHistory: "ورژن ہسٹری",
    confirmDeletePageText: "یہ صفحہ اور اس کے تمام فیلڈز مستقل طور پر حذف ہو جائیں گے۔ اسے واپس نہیں لایا جا سکتا۔",
    workflowNeedsAtLeastOnePage: "ورک فلو میں کم از کم ایک صفحہ ہونا ضروری ہے",
    pageAdded: "صفحہ شامل ہو گیا",
    pageDuplicated: "صفحہ کاپی ہو گیا",
    pageDeleted: "صفحہ حذف ہو گیا",
    moveToPage: "صفحہ پر منتقل کریں",
    fieldMoved: "فیلڈ منتقل ہو گئی",
    worklog: "سجل العمل",
    worklogtooltip:
      "سجل العمل، عرض وإدارة سجلات العمل الخاصة بك، تصدير تقرير Excel، تصدير PDF",
    worklogSubtitle: "جدولة تقرير بريد إلكتروني متكرر أو تصدير سجل العمل بصيغة PDF.",
    security: "الأمان",
    securitytooltip: "الأمان، إدارة إعدادات الأمان",

    reportooltip: "التقارير، طلب تقرير، التحقق من حالة التقارير",
    roleManagement: "رول کی بنیاد پر انتظام",
    roleManagementSubtitle: "اپنی تنظیم کے لیے مخصوص اجازتوں کے ساتھ رولز بنائیں اور منظم کریں۔",
    roleManagementtooltip: "رول اور اجازتیں منظم کریں",
    createRole: "رول بنائیں",
    updateRole: "رول اپ ڈیٹ کریں",
    deleteRole: "رول حذف کریں",
    roleName: "رول کا نام",
    confirmDeleteRole: "کیا آپ واقعی اس رول کو حذف کرنا چاہتے ہیں؟",
    noRolesFound: "کوئی رول نہیں ملا",
    permissions: "اجازتیں",
    permissionModalSubtitle: "منتخب کریں کہ یہ کردار کیا دیکھ سکتا ہے، بنا سکتا ہے، اپ ڈیٹ کر سکتا ہے یا حذف کر سکتا ہے۔",
    granted: "دی گئی",
    changesApplyOnceSaved: "محفوظ کرنے پر تبدیلیاں لاگو ہوں گی۔",
    noScreensAvailable: "کوئی اسکرین دستیاب نہیں",
    permGroupAccess: "رسائی اور کردار",
    permGroupOperations: "آپریشنز",
    permGroupAssets: "اثاثے",
    permGroupInsights: "بصیرت",
    permGroupSystem: "سسٹم اور اکاؤنٹ",
    permGroupOther: "دیگر",
    org: "تنظیم",
    organizationPageTitle: "المنظمة",
    recordName: "نام",
    recordType: "نوع",
    logo: "لوگو",
    orgHierarchyHint: "محکمے اور پروجیکٹس دیکھنے کے لیے تنظیم کو پھیلائیں ",
    organizationPageHierarchyHint: "محکمے اور پروجیکٹس دیکھنے کے لیے تنظیم کو پھیلائیں ",
    organizationPageSearchPlaceholder: "تنظیم تلاش کریں...",
    orgtooltip: "المنظمة، إدارة المنظمة",
    deleteOrganizationTitle: "تنظیم حذف کریں؟",
    deleteOrganizationCascadeMessage:
      "کیا آپ واقعی اس تنظیم کو حذف کرنا چاہتے ہیں؟ اس سے منسلک تمام منحصر ڈیٹا بھی حذف ہو جائے گا۔",
    stock: "إدارة المخزون",
    stocktoooltip: "إدارة المخزون، تحديث تفاصيل المخزون، تنزيل التقرير",
    addUser: "صارف شامل کریں",
    searchusername: "البحث بواسطة اسم المستخدم...",
    searchAllFields: "البحث بواسطة اسم المستخدم أو البريد الإلكتروني أو الهاتف...",
    searchByEmail: "البحث بواسطة البريد الإلكتروني...",
    searchByPhone: "البحث بواسطة رقم الهاتف...",
    searchareacode: "البحث بواسطة رمز المنطقة...",
    userType: "صارف کی قسم",
    user: "صارف",
    edit: "تعديل",
    editOrganizationTooltip: "تنظیم میں ترمیم کریں",
    deleteOrganizationTooltip: "تنظیم حذف کریں",
    userlist: "صارفین کا انتظام",
    userManagementSubtitle: "صارفین کو شامل، ترمیم اور اپنی تنظیم میں ان کی رسائی کا انتظام کریں۔",
    userdetail: "تفاصيل المستخدم",
    previllage: "الامتيازات",
    cancle: "منسوخ کریں",
    updateuser: "تحديث المستخدم",
    add: "إضافة مستخدم",
    username: "صارف کا نام",

    selectOrg: "تنظیم منتخب کریں",
    areCode: "رمز المنطقة",
    addeditActivity: "إضافة/تعديل النشاط",
    addnewlabel: "إضافة/تعديل التكوين",
    addEdituser: "صارف کو شامل/ترمیم کریں۔",
    canasset: "يمكن الوصول إلى إدارة الأصول",
    uservisibility: "رؤية المستخدم",
    modifyguidline: "تعديل الإرشادات",
    createDashboar: "إنشاء لوحة القيادة",
    addeditleader: "إضافة/تعديل لوحة القيادة",
    canTaskManage: "يمكن الوصول إلى إدارة المهام",
    canAddEditProtectedAccount: "يمكن إضافة/تعديل الحساب المحمي",
    canAddEditInventory: "يمكن إضافة/تعديل إدارة المخزون",
    general: "عام",
    save: "تبدیلیاں محفوظ کریں",
    langSetting: "إعدادات اللغة ",
    colormode: "وضع اللون ",
    light: "فاتح",
    dark: "داكن",
    highcontrast: "تباين عالي",
    lang: "اللغة",
    toursetting: "إعدادات الجولة",
    stoptour: "إيقاف الجولة",
    starttour: "بدء الجولة",
    custommarker: "علامة مخصصة",
    all: "الكل",
    none: "کوئی نہیں",
    assigned: "مخصص",
    active: "فعال ",
    progress: "قيد التقدم",
    completed: "مكتمل",
    onhold: "معلق",
    //ASSET
    vehical: "مركبة",
    Inventory: "المخزون",
    exportreport: "تصدير التقرير",
    addVehical: "إضافة مركبة جديدة",
    addAsset: "إضافة أصل جديد",
    search: "بحث",
    vehicalType: "نوع المركبة",
    vehicalAssign: "مخصص المركبة",
    searchbyId: "البحث بواسطة المعرف...",
    assetType: "نوع الأصل",
    assetAssign: "مخصص الأصل",
    addnewasset: "إضافة أصل جديد",
    assetId: "اثاثہ کی شناخت",
    agentAssigned: "ایجنٹ تفویض",
    assetStatus: "اثاثہ کی حیثیت",
    updateAsset: "تحديث الأصل",
    Update: "تحديث",
    updateVehical: "تحديث المركبة",
    //CONFIGURATION
    complitionrule: "قواعد الإتمام",
    completionRuleSubheading: "کسی حیثیت کے منتخب ہونے پر ٹاسک کے رویے کو کنٹرول کریں۔",
    searchStatusOrExpression: "حیثیت یا ایکسپریشن کے ذریعے تلاش کریں...",
    editRule: "قاعدہ میں ترمیم کریں",
    deleteRule: "قاعدہ حذف کریں",
    completionRuleColumn: "تکمیل کا قاعدہ",
    ruleLabel: "اصول",
    step: "مرحلہ",
    statusStepDescription: "وہ ٹاسک حیثیت منتخب کریں جو اس قاعدے کو فعال کرے گی۔",
    ruleActive: "قاعدہ فعال",
    ruleActiveDescription: "فعال ہونے پر، اس قاعدے کا جائزہ لیا جاتا ہے۔ غیر فعال قواعد محفوظ رہتے ہیں لیکن نظر انداز کر دیے جاتے ہیں۔",
    taskMovement: "ٹاسک کی منتقلی",
    taskMovementDescription: "فعال ہونے پر، یہ قاعدہ پورا ہوتے ہی ٹاسک خودکار طور پر دوسرے ورک فلو میں منتقل ہو جاتا ہے۔",
    destinationTask: "منزل ٹاسک",
    completionRuleDescPrefix: "وہ شرط متعین کریں جسے",
    completionRuleDescSuffix: "ہونے پر ٹاسک مکمل کیا جا سکتا ہے۔",
    expressionEditor: "ایکسپریشن ایڈیٹر",
    fullscreen: "فل اسکرین",
    exitFullscreen: "فل اسکرین سے باہر نکلیں",
    criteriaPlaceholder: 'مثال: submission["field_id"] == option-1',
    whatThisScreenDoes: "یہ اسکرین کیا کرتی ہے",
    completionRuleInfo: "ہر قاعدہ ایک شرط سیٹ کرتا ہے: وہ حیثیت جس پر یہ نظر رکھتا ہے، آیا یہ فعال ہے، آیا ٹاسک خودکار طور پر منتقل ہونا چاہیے، اور وہ درست ایکسپریشن جو پورا ہونا ضروری ہے۔ ترمیم کے لیے کسی قاعدے پر یا نیا قاعدہ شامل کریں پر کلک کریں۔",
    assignmentRuleInfo: "ہر قاعدہ کسی مخصوص فیلڈ ایجنٹ یا گروپ کے ساتھ ایک شرط کا تعبیر ملاتا ہے۔ آٹو اسائن نئے ٹاسکس آنے پر انہیں خودکار طور پر لاگو کرتا ہے۔",
    specialAssignmentRuleInfo: "اسے استعمال کریں جب روٹنگ کو ایک سادہ تفویض قاعدے سے زیادہ مخصوص ہونے کی ضرورت ہو -- مثلاً کچھ جغرافیائی کوڈز، قسم کے کوڈز، یا رقم کی حدود کو کسی مخصوص صارف یا گروپ کو بھیجنا۔",
    customVariableInfo: "ایک ایکسپریشن ایک بار متعین کریں اور اسے اس ورک فلو کے لیے تکمیل، تفویض، اور خصوصی تفویض کے قواعد میں استعمال کریں۔",
    customVariableSubheading: "آپ کے ورک فلو قواعد کے لیے دوبارہ قابل استعمال ایکسپریشنز۔",
    completionRuleTabTooltip: "ٹاسک کی حیثیت بدلنے پر کیا ہوتا ہے اسے کنٹرول کریں",
    assignmentRuleTabTooltip: "معیار کے مطابق ٹاسک کسی صارف یا گروپ کو تفویض کریں",
    specialAssignmentRuleTabTooltip: "مخصوص ٹاسکس کو ایک مخصوص فرد کو بھیجیں",
    customVariableTabTooltip: "اپنے قواعد کے لیے دوبارہ قابل استعمال ایکسپریشنز",
    assignment: "قواعد التعيين",
    assignmentRuleSubheading: "طے کریں کہ معیار کے مطابق ٹاسک کس صارف یا گروپ کو تفویض کیا جائے۔",
    searchByNameTargetCriteria: "نام، ہدف، یا معیار کے ذریعے تلاش کریں...",
    searchByCriteria: "معیار کے ذریعے تلاش کریں...",
    editCriteria: "معیار میں ترمیم کریں",
    assignmentCriteriaPlaceholder: "مثال: 'Area Code' == 123, 456",
    customerule: "المتغيرات المخصصة",
    rulename: "اسم القاعدة",
    assignTo: "التعيين إلى",
    activedeactive: "نشط / غير نشط",
    criteria: "المعايير",
    submit: "جمع کرائیں",
    update: "اپ ڈیٹ کریں۔",
    norule: "لا توجد قواعد لتحميلها",
    noSearchResults: "کوئی نتیجہ نہیں ملا",
    tryAdjustingSearch: "جو آپ تلاش کر رہے ہیں اسے تلاش کرنے کے لیے اپنی تلاش کی اصطلاحات کو ایڈجسٹ کرنے کی کوشش کریں۔",
    clearSearch: "تلاش صاف کریں",
    getStartedAddingRule: "اپنا پہلا اصول شامل کر کے شروعات کریں۔",
    getStartedAddingCustomVariable: "اپنا پہلا حسب ضرورت متغیر شامل کر کے شروعات کریں۔",
    icon: "أيقونة",
    createrule: "إنشاء قاعدة جديدة",
    addNewRule: "نیا اصول شامل کریں۔",
    //TASKMANAGE
    multiSelect: "تحديد متعدد",
    smartAssign: "التعيين الذكي",
    FieldStaff: "فیلڈ سٹاف",
    Location: "مقام",
    MapStatus: "نقشہ کی حیثیت",
    fieldAgent: "وكيل ميداني",
    selectFieldAgent: "فیلڈ ایجنٹ منتخب کریں",
    createNewTask: "إنشاء مهمة جديدة",
    importCSV: "رفع المهمة",
    mapview: "عرض الخريطة",
    createTask: "إنشاء مهمة جديدة",
    download: "تنزيل",
    downloadAll: "سب ڈاؤن لوڈ کریں",
    downloadSelected: "منتخب کردہ ڈاؤن لوڈ کریں",
    downloadAllPdfsTooltip: "تمام PDF فائلیں ڈاؤن لوڈ کریں",
    downloadSelectedPdfsTooltip: "منتخب کردہ PDF فائلیں ڈاؤن لوڈ کریں",
    downloadingAllPdfs: "تمام PDF فائلیں ڈاؤن لوڈ ہو رہی ہیں...",
    downloadingSelectedPdfs: "{count} PDF فائل(ز) ڈاؤن لوڈ ہو رہی ہیں...",
    // Bulk PDF export (BLF-2171)
    bulkExportTitle: "بلک PDF ایکسپورٹ",
    bulkExportSubtitle: "پس منظر میں تیار ہو کر ایک ZIP فائل کے طور پر ملے گی۔",
    bulkExportIdLabel: "ایکسپورٹ آئی ڈی",
    bulkExportActivityLabel: "سرگرمی",
    bulkExportClose: "بند کریں",
    bulkExportActionColumn: "کارروائی",
    bulkExportStart: "ایکسپورٹ شروع کریں",
    bulkExportStartTooltip: "PDF فائلیں پس منظر میں تیار کریں",
    bulkExportRetry: "دوبارہ کوشش کریں",
    bulkExportIdleHelp:
      "PDF فائلیں پس منظر میں زپ کی جاتی ہیں، اس دوران آپ کام جاری رکھ سکتے ہیں۔ ZIP تیار ہونے پر ہم آپ کو مطلع کریں گے۔",
    bulkExportRequesting: "آپ کا ایکسپورٹ قطار میں شامل کیا جا رہا ہے...",
    bulkExportQueuedHeading: "قطار میں — شروع ہونے کا انتظار ہے",
    bulkExportQueuedHelp: "آپ کا ایکسپورٹ قطار میں ہے اور جلد شروع ہو جائے گا۔",
    bulkExportInProgressHeading: "PDF فائلیں تیار ہو رہی ہیں",
    bulkExportProcessedOfTotal: "{total} میں سے {processed} PDF",
    bulkExportKeepRunningHint:
      "آپ یہ ونڈو بند کر سکتے ہیں — ایکسپورٹ جاری رہے گا اور ZIP ایکسپورٹ ہسٹری میں موجود رہے گی۔",
    bulkExportRunInBackground: "پس منظر میں چلائیں",
    bulkExportRunInBackgroundTooltip: "یہ ونڈو بند کریں، ایکسپورٹ جاری رہے گا",
    bulkExportCompletedHeading: "آپ کی ZIP تیار ہے",
    bulkExportCompletedHelp: "اسے نیچے سے یا ایکسپورٹ ہسٹری سے ڈاؤن لوڈ کریں۔",
    bulkExportDownloadZip: "ZIP ڈاؤن لوڈ کریں",
    bulkExportDownloadZipTooltip: "تیار شدہ ZIP ڈاؤن لوڈ کریں",
    bulkExportTotalLabel: "کل",
    bulkExportSuccessLabel: "کامیاب",
    bulkExportFailedLabel: "ناکام",
    bulkExportNoFile: "یہ ایکسپورٹ بغیر فائل مکمل ہوا۔ براہ کرم دوبارہ کوشش کریں۔",
    bulkExportNoFileShort: "کوئی فائل نہیں",
    bulkExportFailedHeading: "ایکسپورٹ ناکام",
    bulkExportFailedHelp: "ایکسپورٹ مکمل نہیں ہو سکا۔ براہ کرم دوبارہ کوشش کریں۔",
    bulkExportErrorHeading: "ایکسپورٹ سروس تک رسائی نہیں ہو سکی",
    bulkExportErrorHelp:
      "پیش رفت کی اپ ڈیٹس رک گئی ہیں۔ ایکسپورٹ ممکنہ طور پر جاری ہے — ایکسپورٹ ہسٹری دیکھیں۔",
    bulkExportLimitHeading: "ایکسپورٹ شروع نہیں ہو سکا",
    bulkExportLimitFallback:
      "یہ ایکسپورٹ شروع نہیں ہو سکا۔ براہ کرم انتخاب کم کریں اور دوبارہ کوشش کریں۔",
    bulkExportEmptyHeading: "اس انتخاب سے کچھ مطابقت نہیں رکھتا",
    bulkExportEmptyHelp: "کوئی اور تاریخ کی حد، سرگرمی یا اکاؤنٹس منتخب کر کے دیکھیں۔",
    bulkExportFailedAccountsTitle: "{count} اکاؤنٹ ایکسپورٹ نہیں ہو سکے",
    bulkExportFailedAccountsColumn: "ناکام اکاؤنٹس",
    bulkExportFailedAccountsCount: "{count} ناکام",
    bulkExportNoFailedAccounts: "کوئی نہیں",
    bulkExportDownloadFailedExcel: "Excel ڈاؤن لوڈ کریں",
    bulkExportDownloadFailedExcelTooltip: "ناکام اکاؤنٹ نمبر Excel میں ڈاؤن لوڈ کریں",
    bulkExportRequestError: "ایکسپورٹ شروع نہیں ہو سکا۔ براہ کرم دوبارہ کوشش کریں۔",
    bulkExportDismiss: "ہٹائیں",
    bulkExportShowAccounts: "اکاؤنٹس دکھائیں",
    bulkExportHideAccounts: "اکاؤنٹس چھپائیں",
    bulkExportCopyAccounts: "اکاؤنٹ نمبر کاپی کریں",
    bulkExportCopied: "کاپی ہو گیا",
    bulkExportSelectedAccounts: "{count} منتخب",
    bulkExportAllAccountsInRange: "تاریخ کی حد کے تمام اکاؤنٹس",
    bulkExportMatchedLabel: "مطابقت رکھنے والی PDF",
    bulkExportStatusPending: "قطار میں",
    bulkExportStatusInProgress: "جاری ہے",
    bulkExportStatusCompleted: "مکمل",
    bulkExportStatusFailed: "ناکام",
    bulkExportHistoryTitle: "ایکسپورٹ ہسٹری",
    bulkExportHistorySubtitle: "آپ کے درخواست کردہ تمام بلک PDF ایکسپورٹ، نئے پہلے۔",
    bulkExportShowingRange: "{total} میں سے {start}-{end} دکھائے جا رہے ہیں",
    bulkExportHistoryTooltip: "پچھلے بلک PDF ایکسپورٹ دیکھیں",
    bulkExportHistoryLoadError: "ایکسپورٹ ہسٹری لوڈ نہیں ہو سکی۔",
    bulkExportAllActivities: "تمام سرگرمیاں",
    bulkExportRefresh: "ریفریش",
    bulkExportRefreshTooltip: "ایکسپورٹ ہسٹری دوبارہ لوڈ کریں",
    bulkExportBackToPdf: "ایکسپورٹ PDF پر واپس جائیں",
    bulkExportRequestedAt: "درخواست",
    bulkExportCompletedAt: "مکمل",
    bulkExportFileSize: "سائز",
    bulkExportNoHistory: "ابھی کوئی ایکسپورٹ نہیں",
    bulkExportNoHistoryHelp: "آپ کے درخواست کردہ بلک PDF ایکسپورٹ یہاں دکھائی دیں گے۔",
    bulkExportTrack: "ٹریک کریں",
    bulkExportTrackTooltip: "اس ایکسپورٹ کی پیش رفت دیکھیں",
    bulkExportToggleDetails: "ایکسپورٹ کی تفصیلات دکھائیں",
    bulkExportViewExport: "ایکسپورٹ دیکھیں",
    bulkExportCheckSelectionTitle: "اپنا انتخاب دیکھیں",
    bulkExportSingleActivityWarning: "PDF ایکسپورٹ کرنے سے پہلے ایک سرگرمی منتخب کریں۔",
    bulkExportDateRangeWarning: "PDF ایکسپورٹ کرنے سے پہلے تاریخ کی حد منتخب کریں۔",
    bulkExportRadioFilterNotice:
      "ریڈیو آپشن فلٹر بلک ایکسپورٹ پر لاگو نہیں ہوتا — اس تاریخ کی حد کے تمام مکمل ٹاسک شامل ہوں گے۔ صرف مخصوص قطاریں ایکسپورٹ کرنے کے لیے انہیں منتخب کریں۔",
    bulkExportTableFilterNotice:
      "کالم اور صارف نام کے فلٹر صرف اس صفحے کے ٹیبل کو محدود کرتے ہیں، ایکسپورٹ کو نہیں۔ صرف مخصوص قطاریں ایکسپورٹ کرنے کے لیے انہیں منتخب کریں۔",
    selectRadioOption: "ریڈیو آپشن منتخب کریں",
    deleteAllRecord: "حذف جميع السجلات",
    assign: "تعيين",
    reassign: "إعادة تعيين",
    alert: "إرسال تنبيه",
    delete: "حذف",
    priority: "الأولوية",
    Cycle: "دورة",
    status: "الحالة",
    searchbycode: "البحث بواسطة رمز المنطقة..",
    selectAssign: "اختيار المعين",
    downloadtask: "تنزيل تقرير المهمة",
    seectallactivty: "تحديد جميع الأنشطة",
    selectpartcular: "اختيار نشاط معين",
    recentReports: "حالیہ رپورٹس",
    noteLabel: "نوٹ:",
    reportGeneratingNote: "رپورٹس تیار ہونے میں چند منٹ لگ سکتے ہیں۔ اگر آپ کی رپورٹ ابھی تیار نہیں ہے تو تھوڑی دیر انتظار کریں اور دوبارہ چیک کرنے کے لیے ریفریش بٹن پر کلک کریں۔",
    viewAllReports: "تمام رپورٹس دیکھیں",
    reportRequestQueued:
      "رپورٹ تیار ہو رہی ہے۔ تیار ہونے پر یہ حالیہ رپورٹس میں ظاہر ہوگی۔",
    selectMsg: "يرجى تحديد نشاط للمتابعة.",
    createnewtask: "إنشاء مهمة جديدة",
    cancel: "منسوخ کریں",
    create: "بنائیں",
    bulkReAssign: "بلک دوبارہ تفویض",
    bulkPriorityUpdate: "بلک ترجیح اپڈیٹ",
    bulkUpload: "بلک اپ لوڈ",
    reassignTasks: "ٹاسک دوبارہ تفویض کریں",
    newAccounts: "نئے اکاؤنٹس",
    existingAccounts: "موجودہ اکاؤنٹس",
    noNewAccounts: "کوئی نیا اکاؤنٹ نہیں",
    noExistingAccounts: "کوئی موجودہ اکاؤنٹ نہیں",
    assignees: "تفویض کردہ",
    noAssignees: "کوئی تفویض کردہ نہیں",
    DragDetail: "اسحب وأفلت ملف CSV الذي يحتوي على جميع تفاصيل المهام",
    sizeMsg: "الحد الأقصى لحجم الملف: 15 ميجابايت",
    import: "استيراد CSV",
    uploadfile: "رفع ورقة المهام",
    uploadby: "تم الرفع بواسطة",
    uploaddate: "تاريخ الرفع",
    uploadtime: "وقت الرفع (24 ساعة)",
    taskdetail: "تفاصيل المهمة",
    taskhistory: "تاريخ المهمة",
    nohistory: "لا توجد تاريخ للمهمة.",
    more: "جاري تحميل المزيد من تاريخ المهام...",
    enteraccno: "اکاؤنٹ نمبر درج کریں",
    reset: "ری سیٹ",
    resetAllAppliedFiltersTooltip: "تمام لاگو فلٹرز صاف کریں",
    filtersToggleTooltip: "جدول کے ہیڈر سے فلٹرز لگائیں",
    protectedAccountsTitle: "محفوظ اکاؤنٹس",
    protectionJobsTitle: "تحفظ کی تاریخ",
    protectionJobsSubtitle: "اکاؤنٹ کے تحفظ کی درخواستیں ٹریک کریں اور چھوڑے گئے اکاؤنٹس ڈاؤن لوڈ کریں۔",
    protectionJobsTooltip: "تحفظ کی درخواستوں کی حالت اور تاریخ دیکھیں",
    protectionJobsBack: "محفوظ اکاؤنٹس پر واپس جائیں",
    protectionJobsRefresh: "ریفریش",
    protectionJobsAutoRefresh: "تحفظ جاری ہے اور اس میں کچھ وقت لگ سکتا ہے۔ ٹیبل خود بخود اپڈیٹ ہوتا ہے، یا ریفریش پر کلک کریں۔",
    protectionJobsEmpty: "ابھی تک کوئی تحفظ کا کام نہیں",
    protectionJobsEmptyHint: "محفوظ اکاؤنٹس بنانے کے بعد کام یہاں نظر آئیں گے۔",
    protectionJobsLoadFailed: "تحفظ کے کام لوڈ نہیں ہو سکے۔",
    protectionJobCreated: "بنایا گیا",
    protectionJobFinished: "مکمل ہوا",
    protectionJobStatusQUEUED: "قطار میں",
    protectionJobStatusIN_PROGRESS: "جاری ہے",
    protectionJobStatusCOMPLETED: "مکمل",
    protectionJobStatusFAILED: "ناکام",
    protectionJobColStatus: "حالت",
    protectionJobColSrNo: "نمبر شمار",
    protectionJobColSkippedFile: "چھوڑے گئے اکاؤنٹس",
    protectionJobColActions: "کارروائیاں",
    protectionJobAddMasterDb: "ماسٹر ڈیٹا بیس میں شامل کریں",
    protectionJobAddProtection: "تحفظ شامل کریں",
    protectionJobMasterDbTooltip: "ماسٹر ڈیٹا بیس میں نہیں ہیں۔ پہلے شامل کریں۔",
    masterDbModalTitle: "ماسٹر ڈیٹا بیس میں اکاؤنٹس شامل کریں",
    masterDbModalSubtitle: "یہ اکاؤنٹس چھوڑ دیے گئے کیونکہ وہ ماسٹر ڈیٹا بیس میں نہیں ہیں۔ انہیں پہلے شامل کریں تاکہ انہیں محفوظ کیا جا سکے۔",
    masterDbAccountsLabel: "اکاؤنٹس ({count})",
    masterDbNote: "{count} چھوڑے گئے اکاؤنٹس ماسٹر ڈیٹا بیس میں نہیں ہیں۔ انہیں ڈیفالٹ مقام ({lat}, {lon}) پر شامل کیا جائے گا۔",
    masterDbProtectionTitle: "تحفظ کی تفصیلات",
    masterDbProtectionHint: "صرف شامل کریں اور محفوظ کریں کے لیے درکار ہیں۔",
    masterDbNoAccounts: "کم از کم ایک اکاؤنٹ منتخب کریں۔",
    masterDbProtectNotice: "اکاؤنٹس ماسٹر ڈیٹا بیس میں شامل ہوتے ہی دوبارہ محفوظ کر دیے جائیں گے۔",
    masterDbFieldsLoadFailed: "ماسٹر ڈیٹا بیس کے فیلڈز لوڈ نہیں ہو سکے۔ یہ ونڈو بند کر کے دوبارہ کوشش کریں۔",
    masterDbSubmitAdd: "ماسٹر ڈیٹا بیس میں شامل کریں",
    masterDbSubmitAddAndProtect: "شامل کریں اور محفوظ کریں",
    masterDbSubmitAddTooltip: "صرف ماسٹر ڈیٹا بیس میں شامل کریں",
    masterDbSubmitAddAndProtectTooltip: "ماسٹر ڈیٹا بیس میں شامل کریں اور محفوظ کریں",
    masterDbAddedSuccess: "ماسٹر ڈیٹا بیس میں کامیابی سے شامل ہو گیا۔",
    masterDbAddedAndProtected: "اکاؤنٹس ماسٹر ڈیٹا بیس میں شامل ہو گئے۔ تحفظ کی درخواست پس منظر میں چلتی ہے اور اس کی پیش رفت یہاں نظر آتی ہے۔",
    masterDbAddedProtectFailed: "اکاؤنٹس ماسٹر ڈیٹا بیس میں شامل ہو گئے لیکن تحفظ کی درخواست ناکام رہی۔ انہیں محفوظ اکاؤنٹ بنائیں سے محفوظ کریں۔",
    masterDbAddFailed: "اکاؤنٹس ماسٹر ڈیٹا بیس میں شامل نہیں ہو سکے۔",
    protectionJobMasterDbAddedTooltip: "اکاؤنٹس پہلے ہی ماسٹر ڈیٹا بیس میں شامل ہیں۔ انہیں محفوظ کریں۔",
    protectionJobMasterDbDoneTooltip: "تمام اکاؤنٹس پہلے ہی ماسٹر ڈیٹا بیس میں شامل اور محفوظ ہیں۔",
    masterDbProtectModalTitle: "اکاؤنٹس محفوظ کریں",
    masterDbProtectModalSubtitle: "یہ اکاؤنٹس پہلے ہی ماسٹر ڈیٹا بیس میں شامل ہیں۔ صرف تحفظ شامل کیا جا سکتا ہے۔",
    masterDbAlreadyAddedNote: "{count} اکاؤنٹس پہلے ہی ماسٹر ڈیٹا بیس میں شامل ہیں۔ اب صرف تحفظ شامل کیا جا سکتا ہے۔",
    masterDbSubmitProtect: "محفوظ کریں",
    masterDbSubmitProtectTooltip: "ان اکاؤنٹس کو محفوظ کریں",
    masterDbProtectStarted: "تحفظ کی درخواست پس منظر میں چل رہی ہے؛ اس کی پیش رفت یہاں دکھائی گئی ہے۔",
    masterDbProtectFailed: "تحفظ کی درخواست ناکام ہو گئی۔",
    protectionJobTotal: "کل",
    protectionJobProtected: "محفوظ",
    protectionJobSkipped: "چھوڑے گئے",
    protectionJobDownloadSkipped: "چھوڑے گئے اکاؤنٹس ڈاؤن لوڈ کریں",
    protectionJobDownloadSkippedTooltip: "چھوڑے گئے اکاؤنٹس کی ایکسل ڈاؤن لوڈ کریں",
    protectionJobFinishedSummary: "تحفظ مکمل: {protected} محفوظ، {skipped} چھوڑے گئے۔",
    protectionJobFailedToast: "تحفظ کی درخواست ناکام ہو گئی۔",
    protectionJobFailedTitle: "تحفظ کی درخواست ناکام ہو گئی",
    protectionRequestReceived: "تحفظ کی درخواست موصول ہو گئی۔ یہ پس منظر میں چلتی ہے، اس لیے اس کی پیش رفت یہاں دیکھیں۔",
    protectedAccountsSubtitle: "خودکار رائٹ آف اور بندش سے اکاؤنٹس کی حفاظت کرتا ہے۔",
    fromDateTooltip: "رپورٹ کی شروع کی تاریخ منتخب کریں",
    toDateTooltip: "رپورٹ کی آخری تاریخ منتخب کریں",
    exportProtectedAccountsReport: "محفوظ اکاؤنٹس کی رپورٹ ایکسپورٹ کریں",
    createProtectedAccountTooltip: "محفوظ اکاؤنٹ بنائیں",
    searchProtectedAccounts: "محفوظ اکاؤنٹس تلاش کریں",
    editProtectedAccountTooltip: "محفوظ اکاؤنٹ میں ترمیم کریں",
    deleteProtectedAccountTooltip: "محفوظ اکاؤنٹ حذف کریں",
    totalUsersTooltip: "مماثل صارفین کی کل تعداد",
    searchScopeTooltip: "وہ فیلڈ منتخب کریں جس میں تلاش کرنی ہے",
    toggleDensity: "کثافت تبدیل کریں",
    stockManagementSubtitle: "اپنے میٹر انوینٹری اسٹاک کو دیکھیں، ٹریک کریں اور اس کا نظم کریں۔",
    totalItemsTooltip: "موجودہ فلٹرز سے مماثل ریکارڈز کی کل تعداد۔",
    exportDateRangeTooltip: "ایکسپورٹ رپورٹ کے لیے تاریخ کی حد منتخب کریں",
    protectedAccountsEmptyHint: "ابھی تک کوئی اکاؤنٹ محفوظ نہیں ہے۔ خودکار رائٹ آف اور بندش سے بچانے کے لیے ایک بنائیں۔",
    dateRange: "تاریخ کی حد",
    dateRangeTooltip: "ایکٹیویشن تاریخ کی حد کے مطابق فلٹر کریں",
    searchTooltip: "منتخب فیلڈ کے ذریعے تلاش کریں۔ تلاش کے لیے Enter دبائیں۔",
    clear: "صاف کریں",
    clearFilters: "فلٹرز صاف کریں",
    selected: "منتخب شدہ",
    noRecordsMatchSearch: "آپ کی تلاش سے مماثل کوئی ریکارڈ نہیں ملا",
    tryAdjustingFilters: "جو آپ تلاش کر رہے ہیں اسے تلاش کرنے کے لیے اپنے فلٹرز یا تلاش کی اصطلاحات کو ایڈجسٹ کرنے کی کوشش کریں۔",
    noDataFound: "کوئی ڈیٹا نہیں ملا",
    getStartedUploadingSheet: "اپنی انوینٹری شیٹ اپ لوڈ کر کے شروع کریں۔",
    inventoryLoadError: "انوینٹری لوڈ نہیں ہو سکی۔ براہ کرم دوبارہ کوشش کریں۔",
    uploadinventorysheetlabel: "انوینٹری شیٹ اپ لوڈ کریں (XLSX/XLS)",
    onlyexcelallowed: "صرف .xlsx اور .xls فائلوں کی اجازت ہے۔",
    exportCsvTooltip: "موجودہ صفحہ کو CSV فائل کے طور پر ایکسپورٹ کریں۔",
    minVisibleColumnsTooltip: "کم از کم 2 کالم مرئی رہنے چاہئیں",
    submitting: "جاري الإرسال..",
    accDetail: "تفاصيل الحساب",
    accnumber: "رقم الحساب",
    searchByAccountNumber: "البحث برقم الحساب",
    activityFilterTooltip: "التصفية حسب النشاط أو سير العمل",
    workflowInputTooltip: "التصفية حسب معايير إضافية",
    area: "المنطقة",
    areacode: "رمز المنطقة",
    latitude: "خط العرض",
    longitude: "خط الطول",
    importdb: "استيراد قاعدة البيانات الرئيسية",
    exportData: "تصدير التقرير",
    downloading: "جاري التنزيل...",
    viewGuideline: "عرض الإرشادات",
    createWorkflow: "إنشاء سير عمل جديد",
    guidline: "الإرشادات",
    guidelinesSubtitle: "اپ لوڈ کریں اور ہر سرگرمی کے لیے پی ڈی ایف یا ویڈیو رہنما خطوط کا نظم کریں۔",
    guidelinesLabel: "رہنما خطوط",
    selectOrgForGuidelines: "رہنما خطوط دیکھنے کے لیے ایک تنظیم منتخب کریں۔",
    dropzoneHint: "صرف پی ڈی ایف یا ویڈیو فائلیں",
    noworkflow: "لا توجد سير عمل متاحة",
    Scheduleemail: "جدولة تقرير عبر البريد الإلكتروني",
    export: "تصدير التقرير",
    pdf: "تصدير PDF",
    todo: "قيد التنفيذ",
    loading: "جاري تحميل المزيد من سجل العمل...",
    nomore: "لا توجد المزيد من سجلات العمل لتحميلها",
    name: "حساب محمي",
    createacc: "إنشاء حساب جديد",
    editacc: "تعديل الحساب المحمي",
    createproacc: "إنشاء حساب محمي",
    permanent: "حماية دائمة",
    protectionValid: "تحفظ درست ہے۔",
    createdBy: "کی طرف سے پیدا کیا",
    accProtection: "حماية الحساب لجميع الأنشطة",
    accno: "رقم الحساب",
    remark: "ملاحظات",
    enterremark: "أدخل ملاحظاتك هنا",
    updatemeterDEtail: "تحديث تفاصيل العداد",
    downloadsheet: "تنزيل الورقة",
    uploadinventory: "رفع ورقة المخزون",
    reportType: "نوع التقرير",

    form: "طلب تقرير",
    uploadSheet: "شیٹ اپ لوڈ کریں",
    createStore: "اسٹور بنائیں",
    storeManagement: "اسٹور مینجمنٹ",
    storeManagementTooltip: "اسٹورز اور انوینٹری کے مقامات کا انتظام کریں",
    selectStoreLocation: "نقشے پر مقام منتخب کریں یا نیچے اس کے کوآرڈینیٹس درج کریں۔",
    selectStoreAddress: "نقشے پر مقام منتخب کریں یا نیچے پتہ تلاش کریں۔",
    storeLocationMethod: "مقام کا طریقہ",
    storeAddress: "پتہ",
    storeGovernorate: "گورنریٹ",
    storeWilayat: "ولایت",
    storeCity: "شہر / علاقہ",
    storeArea: "محلہ / علاقہ",
    storeStreet: "سڑک کا نام",
    storeBuilding: "عمارت کا نام / نمبر",
    storeUnit: "یونٹ / منزل (اختیاری)",
    storePostalCode: "پوسٹل کوڈ (اختیاری)",
    storeCountry: "ملک",
    storeCoordinates: "کوآرڈینیٹس",
    storeAddressPlaceholder: "عمان کا پتہ درج کریں",
    storeAddressSearchPlaceholder: "جگہ تلاش کریں",
    omanCountry: "عمان",
    searchStoreAddress: "پتہ تلاش کریں",
    searchingStoreAddress: "تلاش جاری ہے...",
    storeAddressResults: "عمان کے پتوں کے نتائج",
    storeAddressSearchFailed: "پتے تلاش نہیں ہو سکے۔ دوبارہ کوشش کریں۔",
    noOmanAddressesFound: "کوئی مماثل پتہ نہیں ملا۔",
    storeLatitude: "عرض بلد",
    storeLongitude: "طول بلد",
    storeMapView: "نقشے کا منظر",
    storeDefaultView: "ڈیفالٹ",
    storeSatelliteView: "سیٹلائٹ",
    storeZoomIn: "زوم اِن",
    storeZoomOut: "زوم آؤٹ",
    createStoreDescription: "اپنے انوینٹری اسٹاک کے مقامات بنائیں اور منظم کریں۔",
    existingStores: "موجودہ اسٹورز",
    existingStoresDescription: "اسٹور کی تفصیلات تلاش کریں، فلٹر کریں اور اپ ڈیٹ کریں۔",
    searchStores: "اسٹورز یا مقامات تلاش کریں...",
    filterStoresByStatus: "حالت کے لحاظ سے اسٹورز فلٹر کریں",
    allStatuses: "تمام حالتیں",
    storeName: "اسٹور کا نام",
    storeLocation: "مقام",
    storeStatus: "حالت",
    storeAction: "عمل",
    storeActive: "فعال",
    storeInactive: "غیر فعال",
    updateStore: "اپ ڈیٹ",
    updateStoreTitle: "اسٹور اپ ڈیٹ کریں",
    viewStore: "دیکھیں",
    storeDetails: "اسٹور کی تفصیلات",
    storeCreatedSuccess: "اسٹور کامیابی سے بن گیا۔",
    storeUpdatedSuccess: "اسٹور کامیابی سے اپ ڈیٹ ہو گیا۔",
    storeDeletedSuccess: "اسٹور کامیابی سے حذف ہو گیا۔",
    deleteStore: "حذف کریں",
    failedToLoadStores: "اسٹورز لوڈ کرنے میں ناکامی۔",
    noStoresYet: "ابھی کوئی اسٹور دستیاب نہیں۔",
    noMatchingStores: "کوئی اسٹور آپ کے فلٹر سے مطابقت نہیں رکھتا۔",
    storesCount: "اسٹورز",
    storeNameRequired: "اسٹور کا نام درکار ہے۔",
    storeNameMaxLength: "اسٹور کا نام 255 حروف سے زیادہ نہیں ہونا چاہیے۔",
    storeNameNote: "نوٹ: زیادہ سے زیادہ 255 حروف کی اجازت ہے۔",
    storeAddressRequired: "براہ کرم پتہ درج کریں یا مقام تلاش کریں۔",
    storeAddressNotFound: "اس پتے کے لیے کوآرڈینیٹس نہیں مل سکے۔ برائے مہربانی پتہ درست کریں یا نقشے پر منتخب کریں۔",
    storeCoordinatesRequired: "درست کوآرڈینیٹس (عرض بلد اور طول بلد) درکار ہیں۔",
    autoDetectedCoordinates: "کوآرڈینیٹس خود بخود حاصل کر لیے گئے",
    detectingCoordinates: "کوآرڈینیٹس کا پتہ لگایا جا رہا ہے...",
    fetchingAddressFromMap: "نقشے سے پتہ حاصل کیا جا رہا ہے...",
    addressFilledFromMap: "نقشے سے پتہ پُر کر دیا گیا ہے",
    startDate: "تاريخ البدء",
    endDate: "تاريخ الانتهاء",
    request: "طلب",

    orglist: "قائمة المنظمات",
    createOrg: "إنشاء منظمة",
    noOrg: "لا توجد بيانات للمنظمة.",
    rows: "فی صفحہ قطاریں",
    showing: "دکھا رہے ہیں",
    of: "از",
    allFields: "تمام فیلڈز",
    group: "گروپ",
    assignedGroups: "تفویض کردہ گروپس",
    agentGroup: "ایجنٹ گروپ",
    lastLogin: "آخری لاگ ان",
    loginCount: "لاگ ان",
    users: "صارفین",
    filters: "فلٹرز",
    columns: "کالمز",
    orgname: "اسم المنظمة",
    img: "رفع الشعار",

    creating: "جاري الإنشاء...",
    updateOrg: "تحديث المنظمة",

    Updating: "جاري التحديث...",
    nolog: "لا يوجد شعار",
    number: "لنہیں",
    geoCodes: "منتخب جیو کوڈز",
    geoCodeLabel: "جیو کوڈ",
    typeCodes: "منتخب قسم کے کوڈز",
    amountRange: "منتخب کردہ رقم کی حد",
    assignAll: "سب کو تفویض کریں۔",
    default: "طے شدہ",
    assingTask: "کام تفویض کریں۔",
    //dashbord
    userdashboard: "لوحة القيادة للمستخدم",
    activitydashboard: "لوحة القيادة للنشاط",
    admin: "مسؤول",
    supervisor: "نگران",
    office_user: "آفس صارفین",
    field_agent: "فیلڈ ایجنٹس",
    dashboardName: "اسم لوحة القيادة",
    dashboardManagement: "ڈیش بورڈ کا انتظام",
    addnewDashboard: "إضافة لوحة قيادة جديدة",
    chartMessage: "حدد لوحة القيادة لعرض الرسوم البيانية",
    noChartsTitle: "ابھی تک کوئی چارٹ نہیں",
    noChartsSubtitle: "اس ڈیش بورڈ کا ڈیٹا دیکھنے کے لیے اپنا پہلا چارٹ شامل کریں۔",
    addChartCardSubtitle: "اس ڈیش بورڈ میں ایک اور چارٹ شامل کریں",
    deletDashbord: "حذف لوحة القيادة",
    //notifucation
    notification: "إشعار",
    allnotification: "جميع الإشعارات",
    profile: "الملف الشخصي",
    select: "اختيار النشاط",
    selecteOrgName: "اختيار اسم المنظمة",
    selectsubactivty: "اختيار النشاط الفرعي",

    emailreport: "جدولة تقرير عبر البريد الإلكتروني",
    selectactivity: "اختيار النشاط:",
    recipients: "المستلمون",
    bcc: "نسخة مخفية",
    cc: "نسخة",
    sendreport: "إرسال التقرير المجدول",
    senddashboard: "إرسال لوحة القيادة:",
    shedulesend: "جدولة الإرسال:",
    daily: "يومي",
    weekly: "أسبوعي",
    monthly: "شهري",

    send: "إرسال",
    sendScheduleReportTooltip: "یہ شیڈول شدہ ای میل رپورٹ بھیجیں",
    updateScheduleReportTooltip: "یہ شیڈول شدہ ای میل رپورٹ اپ ڈیٹ کریں",
    reportbtn: "طلب تقرير",
    report: "التقارير",
    reportsSubtitle: "اپنی تنظیم کے لیے رپورٹس کی درخواست کریں، ٹریک کریں اور ڈاؤن لوڈ کریں۔",
    dateRange: "تاریخ کی حد",
    dateRangeTooltip: "تاریخ کی حد کے مطابق رپورٹس فلٹر کریں",
    reportTypeTooltip: "رپورٹ کی قسم کے مطابق رپورٹس فلٹر کریں",
    userTypeTooltip: "صارف کی قسم کے مطابق رپورٹس فلٹر کریں",
    statusTooltip: "اسٹیٹس کے مطابق رپورٹس فلٹر کریں",

    stockmanag: "إدارة المخزون",
    fromdate: "من تاريخ",
    todate: "إلى تاريخ",
    metercode: "رمز بار العداد",
    location: "إلى الموقع",
    filter: "تطبيق الفلاتر",
    filtersLabel: "فلٹرز",
    columnFiltersLabel: "کالم فلٹرز",
    maxFiltersReachedTitle: "فلٹر کی حد مکمل ہو گئی",
    maxFiltersReachedMsg:
      "آپ ایک وقت میں زیادہ سے زیادہ {limit} فلٹرز لاگو کر سکتے ہیں۔ نیا فلٹر شامل کرنے سے پہلے کوئی ایک لاگو فلٹر ہٹا دیں۔",
    filterByColumn: "فلٹر بذریعہ",
    addbtn: "إضافة",
    visitTime: "وزٹ ٹائم",
    visitDate: " وزٹ کی تاریخ ",
    nopdfavb: "کوئی PDF دستیاب نہیں ہے۔ ",
    noPdfEntriesHelp: "تاریخ کی حد، سرگرمی، یا اکاؤنٹ نمبر فلٹرز کو ایڈجسٹ کرنے کی کوشش کریں۔",
    pdfReportsSubtitle: "وزٹ PDF رپورٹس تلاش کریں، فلٹر کریں، اور ایک مخصوص مدت کے لیے ڈاؤن لوڈ کریں۔",

    // login
    loginEnterEmailPassword:
      "اپنے اکاؤنٹ تک رسائی کے لیے اپنا ای میل اور پاس ورڈ درج کریں",
    loginManageTeamOperations: "اپنی ٹیم اور آپریشنز کو آسانی سے منظم کریں",
    loginDashboardAccess:
      "ڈیش بورڈ تک رسائی کے لیے لاگ ان کریں اور ہر چیز کو ایک جگہ سے منظم کریں",
    Utilities: "افادیت اور",
    TasksManagementSolutions: "ٹاسک مینجمنٹ کے حل",
    UsernameEmailAddress: "صارف نام / ای میل ایڈریس",
    loginEmailPlaceholder: "اپنا صارف نام یا ای میل درج کریں",
    loginPasswordPlaceholder: "اپنا پاس ورڈ درج کریں",
    loginNoAccountText: "کیا آپ کا اکاؤنٹ نہیں ہے؟",
    loginContactAdminText: "اپنے ایڈمنسٹریٹر سے رابطہ کریں",
    loginPoweredByText: "بذریعہ Outbox",
    loginMadeWithLoveText: "سلطنتِ عمان میں انجینیئر کیا گیا",
    loginOtpTitle: "اپنی شناخت کی تصدیق کریں",
    loginOtpDescription:
      "ہم نے SMS کے ذریعے 6 ہندسوں کا کوڈ {phone} پر بھیجا ہے۔ جاری رکھنے کے لیے اسے نیچے درج کریں۔",
    loginOtpDidntGetCode: "کوڈ نہیں ملا؟",
    loginOtpVerify: "تصدیق کریں اور جاری رکھیں",
    loginOtpVerifying: "تصدیق ہو رہی ہے...",
    loginOtpResend: "کوڈ دوبارہ بھیجیں",
    loginOtpResendIn: "دوبارہ بھیجنے کا وقت",
    loginOtpResendSuccess: "نیا تصدیقی کوڈ بھیج دیا گیا ہے۔",
    loginOtpIncomplete: "براہ کرم مکمل تصدیقی کوڈ درج کریں۔",
    loginOtpBack: "لاگ ان پر واپس جائیں",
    loginOtpSecureTitle: "Blufield تک محفوظ رسائی",
    loginOtpSecureDescription:
      "آپ کا تصدیقی کوڈ آپ کے فیلڈ آپریشنز کو محفوظ رکھنے میں مدد کرتا ہے۔",
    loginOtpDigitLabel: "تصدیقی ہندسہ",
    loginOtpRegisteredNumber: "آپ کا رجسٹرڈ نمبر",
    loginHeroSlide1Title: "ماہر ٹیکنیشنز",
    loginHeroSlide1Description:
      "اپنی فیلڈ ٹیم کو معائنے، رپورٹنگ اور مرمت کے لیے موبائل فرسٹ ٹولز فراہم کریں۔",
    loginHeroSlide1Stat1Label: "ٹیکنیشنز",
    loginHeroSlide1Stat2Label: "اطمینان",
    loginHeroSlide2Title: "حفاظت اور تعمیل",
    loginHeroSlide2Description:
      "مربوط دستاویزات اور رپورٹنگ کے ذریعے حفاظتی پروٹوکولز اور تعمیلی معیارات یقینی بنائیں۔",
    loginHeroSlide2Stat1Label: "مطابق",
    loginHeroSlide2Stat2Label: "واقعات",
    loginHeroSlide3Title: "پاور گرڈ انفراسٹرکچر",
    loginHeroSlide3Description:
      "جدید شیڈولنگ اور وسائل کی تقسیم کے ساتھ اہم انفراسٹرکچر کی نگرانی اور دیکھ بھال کریں۔",
    loginHeroSlide3Stat1Label: "افادیت کی شرح",
    loginHeroSlide3Stat2Label: "ٹیمیں",
    loginHeroSlide4Title: "فیلڈ آپریشنز مینجمنٹ",
    loginHeroSlide4Description:
      "ریئل ٹائم ٹریکنگ اور جامع فیلڈ مینجمنٹ کے ساتھ اپنے برقی مرمتی آپریشنز کو بہتر بنائیں۔",
    loginHeroSlide4Stat1Label: "فعال کام",
    loginHeroSlide4Stat2Label: "سپورٹ",
    RememberMe: "مجھے یاد رکھنا",
    ForgotPassword: "اپنا پاس ورڈ بھول گئے؟",
    assetBarCode: "اثاثہ رسپانس کوڈ (بارکوڈ)",
    assetBarCodeMain: "اثاثہ رسپانس کوڈ",
    assetBarCodeParen: "بارکوڈ",
    dragAndDropDocuments: "دستاویزات کو گھسیٹیں اور چھوڑیں۔",
    viewDocuments: "دستاویز دیکھیں",
    uploadedDocument: "اپ لوڈ کردہ دستاویز",
    maxFileSize5MB: "زیادہ سے زیادہ فائل کا سائز: 5MB",
    browse: "براؤز کریں۔",
    description: "تفصیل",
    kilometer: "کلومیٹر",
    noAccountDetialsAvailable: "اکاؤنٹ کی کوئی تفصیلات دستیاب نہیں ہیں۔",
    enterAccSubmitViewDetails:
      "تفصیلات دیکھنے کے لیے اکاؤنٹ نمبر درج کریں اور سبمٹ کریں۔",
    uploading: "اپ لوڈ ہو رہا ہے۔",
    upload: "اپ لوڈ کریں۔",
    addOrganization: "تنظیم شامل کریں۔",
    addDepartment: "محکمہ شامل کریں۔",
    uploadOrganizationLogo: "تنظیم کا لوگو اپ لوڈ کریں۔",
    successMessage:
      "براہ مہربانی انتظار کریں! فائل اپ لوڈ ہو رہی ہے۔ اس میں کچھ وقت لگ سکتا ہے، اور کامیابی سے اپ لوڈ ہونے کے بعد، آپ کو کامیابی کا پیغام موصول ہوگا۔",
    fullName: "پورا نام",
    fullNameInfo: "صارف کا پورا نام درج کریں (جیسا کہ دکھایا جانا ہے)۔",
    userEmailInfo: "اس صارف کے لیے درست ای میل ایڈریس درج کریں۔",
    phoneInfo: "+968 ملک کوڈ کے ساتھ رابطہ نمبر درج کریں۔",
    userTypeInfo: "صارف کی قسم منتخب کریں: ایڈمن، آفس یوزر، یا فیلڈ ایجنٹ۔",
    orgInfo: "وہ تنظیم منتخب کریں جس سے یہ صارف متعلق ہے۔",
    rolesInfo: "اجازت دینے کے لیے صارف کے رولز منتخب کریں۔",
    departmentInfo: "وہ شعبے منتخب کریں جن تک اس صارف کی رسائی ہونی چاہیے۔",
    projectInfo: "وہ پروجیکٹس منتخب کریں جن تک اس صارف کی رسائی ہونی چاہیے۔",
    clockInInfo:
      "کلاک اِن/آؤٹ فعال کریں اور پروجیکٹ منتخب کریں (صرف فیلڈ ایجنٹ کے لیے)۔",
    activityInfo:
      "وہ ورک فلو/سرگرمیاں منتخب کریں جن تک فیلڈ ایجنٹ کی رسائی ہو۔",
    employeeIdInfo: "فیلڈ ایجنٹس کے لیے ایمپلائی آئی ڈی ضروری ہے۔",
    subContractInfo: "فیلڈ ایجنٹ کے لیے سب کانٹریکٹ کی تفصیل درج کریں۔",
    passwordInfo:
      "نئے صارف کے لیے پاس ورڈ ضروری ہے۔ ترمیم کرتے وقت موجودہ پاس ورڈ برقرار رکھنے کے لیے خالی چھوڑ دیں۔",
    signatureInfo: "دستاویزات کے لیے واضح دستخط کی تصویر اپ لوڈ کریں۔",
    department: "محکمہ",
    project: "پروجیکٹ",
    profileImage: "پروفائل امیج",
    vehicleId: "گاڑی کی شناخت",
    vehicleKM: "گاڑی (KM)",
    vehicleAssinged: "گاڑی تفویض کی گئی۔",
    editPrivileges: "مراعات میں ترمیم کریں۔",
    source: "ماخذ",
    thecustomcodewarningmessage:
      "حسب ضرورت مارکر رنگ شامل نہیں کیا گیا، نیچے سے منتخب کریں!!",
    selectWorkflowFirst: "پہلے ورک فلو کو منتخب کریں۔",
    makerColor: "مارکر رنگ کامیابی سے محفوظ ہو گئے!",
    failedtoSaveMakerColor: "مارکر کا رنگ محفوظ کرنے میں ناکام!",
    permanentProtection: "مستقل تحفظ کی آخری تاریخ نہیں ہوگی۔",
    noRecordAvailable: "کوئی ریکارڈ دستیاب نہیں۔",
    reportGenerating: "رپورٹ تیار ہو رہی ہے...",
    reportFailed: "ناکام",
    reportGenerationFailed: "رپورٹ تیار کرنے میں ناکامی",
    reportFailedTooltip: "خرابی کی تفصیلات دیکھنے کے لیے کلک کریں",
    reportNoRecords: "کوئی ریکارڈ نہیں ملا",
    reportNoRecordsTooltip: "منتخب فلٹرز کے لیے کوئی ریکارڈ نہیں ملا",
    mediumPriority: "درمیانی ترجیح",
    highPriority: "اعلیٰ ترجیح",
    lowPriority: "کم ترجیح",

    accountProtection: "اکاؤنٹ کا تحفظ",
    clockIn: "گھڑی میں",
    clockOut: "گھڑی باہر",
    isPageWise: "صفحہ وار",
    isReviewEnabled: "جائزہ فعال",
    isShowDistance: "کوآرڈینیٹس کا فاصلہ دکھائیں",
    isShowDistanceTooltip:
      "فعال ہونے پر، رپورٹ اور PDF ایکسپورٹ میں اپ لوڈ کردہ ٹاسک کوآرڈینیٹس اور فیلڈ جمع کرانے کے وقت ریکارڈ کیے گئے کوآرڈینیٹس کے درمیان فاصلہ دکھایا جائے گا۔",
    safetyComplianceRequired: "حفاظتی چیک لسٹ درکار ہے",
    safetyComplianceRequiredTooltip:
      "فعال ہونے پر، اس ورک فلو کے تحت ایک حفاظتی تعمیل کا ذیلی ورک فلو بنایا جاتا ہے۔ اس میں بارکوڈ، OCR، GPS اور سگنل کوالٹی فیلڈز دستیاب نہیں ہیں۔",
    safetyChecklistName: "حفاظتی چیک لسٹ کا نام",
    enterSafetyChecklistName: "حفاظتی چیک لسٹ کا نام درج کریں",
    safetyChecklistNeedsField:
      "حفاظتی چیک لسٹ میں کم از کم ایک فیلڈ شامل کریں",
    mainWorkflowTab: "مرکزی ورک فلو",
    safetyChecklistTab: "حفاظتی چیک لسٹ",
    safetyPaletteRestricted:
      "بارکوڈ، OCR، GPS اور سگنل کوالٹی حفاظتی چیک لسٹ میں دستیاب نہیں ہیں۔",
    fieldNotAllowedInSafetyChecklist:
      "یہ فیلڈ حفاظتی چیک لسٹ میں استعمال نہیں کی جا سکتی۔",
    createSafetyChecklist: "حفاظتی چیک لسٹ بنائیں",
    createSafetyChecklistTooltip: "اس ورک فلو کے تحت حفاظتی چیک لسٹ بنائیں",
    updateSafetyChecklist: "حفاظتی چیک لسٹ اپ ڈیٹ کریں",
    updateSafetyChecklistTooltip: "صرف حفاظتی چیک لسٹ کی تبدیلیاں محفوظ کریں",
    deleteSafetyChecklist: "حفاظتی چیک لسٹ حذف کریں",
    deleteSafetyChecklistTooltip:
      "حذف کرنے سے پہلے حفاظتی تعمیل بند کریں اور ورک فلو محفوظ کریں",
    confirmDeleteSafetyChecklist:
      "یہ حفاظتی چیک لسٹ اور اس کی تمام فیلڈز مستقل طور پر حذف ہو جائیں گی۔ پہلے حفاظتی تعمیل بند کریں اور ورک فلو محفوظ کریں۔",
    safetyChecklistCreated: "حفاظتی چیک لسٹ بن گئی",
    createSafetyChecklistFirst:
      "پہلے حفاظتی چیک لسٹ بنائیں، پھر حفاظتی تعمیل فعال کریں",
    safetyChecklistSavedWithWorkflow: "ورک فلو کے ساتھ محفوظ ہوتی ہے",
    savedLabel: "محفوظ",
    notCreatedLabel: "نہیں بنائی گئی",
    companyStamp: "کمپنی مہر",
    companyStampDescription:
      "فیلڈ ایجنٹ دستاویزات کے لیے کمپنی مہر کی صاف تصویر اپ لوڈ کریں۔",
    uploadCompanyStamp: "کمپنی مہر اپ لوڈ کریں",
    changeCompanyStamp: "کمپنی مہر تبدیل کریں",
    companyStampSupported: "JPG، PNG، SVG  سپورٹڈ",
    companyStampMaxSize: "زیادہ سے زیادہ فائل سائز: 5MB",
    chooseCompanyStamp: "مہر منتخب کریں",
    editCompanyStamp: "تبدیل کریں",
    removeCompanyStamp: "ہٹا دیں",
    companyStampInvalidType:
      "براہ کرم JPG، PNG یا SVG تصویر اپ لوڈ کریں۔",
    userAssign: "صارف تفویض کریں",
    groupAssign: "گروپ تفویض کریں",
    searchGroup: "گروپس تلاش کریں",
    nogroupfound: "کوئی گروپ نہیں ملا",
    nomembers: "کوئی رکن نہیں",
    selectGroup: "گروپ منتخب کریں",
    selectgrouptoassign: "تفویض کے لیے گروپ منتخب کریں۔",
    selectgrouptounassign: "غیر تفویض کے لیے گروپ منتخب کریں۔",
    memberNoWorkflowAccess: "اس ورک فلو تک رسائی نہیں",
    groupNotInProject: "منتخب کردہ پروجیکٹ کا حصہ نہیں ہے",
    groupNotInProjectTooltip: "یہ گروپ منتخب کردہ پروجیکٹ سے وابستہ نہیں ہے",
    groupDisabledNoMembers: "اس گروپ میں کوئی رکن نہیں ہے",
    assignWorkflowAccessNote:
      "ٹاسک صرف انہی گروپ اراکین کو تفویض کیا جائے گا جنہیں اس ورک فلو تک رسائی حاصل ہے۔",
    showAsFilter: "فلٹر کے طور پر دکھائیں",
    allowGallery: "گیلری کی اجازت دیں",
    allowGalleryTooltip:
      "فیلڈ ایجنٹس کو صرف کیمرہ استعمال کرنے کے بجائے گیلری سے تصاویر منتخب کرنے کی اجازت دیں۔",
    photoDimensions: "تصویر کے طول و عرض",
    photoDimensionsTooltip:
      "اختیاری طور پر کھینچی گئی تصاویر کو مخصوص چوڑائی، اونچائی اور/یا ایسپیکٹ ریشو سے مماثل بنانے کی شرط رکھیں۔",
    widthPx: "چوڑائی (پکسل)",
    heightPx: "اونچائی (پکسل)",
    aspectRatio: "ایسپیکٹ ریشو (اختیاری)",
    aspectRatioSelect: "ایسپیکٹ ریشو منتخب کریں",
    customAspectRatio: "حسب ضرورت",
    configuredDimensions: "مقرر کردہ طول و عرض",
    linkedWorkflow: "منسلک ورک فلو",
    linkedWorkflowTooltip:
      "ہر آپشن کے ساتھ منسلک کرنے کے لیے ورک فلو منتخب کریں۔ یہ لنک صرف رپورٹ / PDF آؤٹ پٹ پر اثر ڈالتا ہے۔",
    linkedWorkflowSelect: "ورک فلو منتخب کریں",
    linkedWorkflowNoOptions:
      "ورک فلو منسلک کرنے کے لیے کم از کم ایک آپشن شامل کریں۔",
    linkedWorkflowNoWorkflows:
      "اس پروجیکٹ میں کوئی دوسرا فعال ورک فلو دستیاب نہیں ہے۔",
    linkedWorkflowLoading: "ورک فلو لوڈ ہو رہے ہیں...",
    linkedWorkflowAdvancedRules:
      "اس پینل سے باہر مقرر کردہ قواعد (محفوظ کرنے پر برقرار رہیں گے)",
    linkedWorkflowLinkedTo: "منسلک ورک فلو",
    linkedWorkflowLoadFailed: "یہ منسلک ورک فلو لوڈ نہیں ہو سکا۔",
    linkedWorkflowNoFields:
      "اس ورک فلو میں پیش نظارہ کے لیے کوئی فیلڈ موجود نہیں ہے۔",
    linkedWorkflowDepthLimit:
      "پیش نظارہ میں نیسٹڈ منسلک ورک فلوز کو مزید نہیں پھیلایا جاتا۔",
    English: "انگریزی",
    Urdu: "اردو",
    Arabic: "عربی",
    History: "تاریخ",
    Heading: "سرخی",
    Name: "نام",
    Email: "ای میل",
    Phone: "فون",
    Address: "پتہ",
    DatePicker: "تاریخ چننے والا",
    TakePhoto: "تصویر لیں",
    MultipleImages: "متعدد تصاویر",
    Signature: "دستخط",
    RadioButton: "ریڈیو بٹن",
    Checkbox: "چیک باکس",
    Dropdown: "ڈراپ ڈاؤن",
    Number: "نمبر",
    Time: "وقت",
    LongText: "لمبا متن",
    Barcode: "بارکوڈ",
    wfElTooltipHeading: "سرخی شامل کرنے کے لیے استعمال کریں۔",
    wfElTooltipName: "فیلڈ کے لیے نام درج کریں۔",
    wfElTooltipEmail: "درست ای میل پتہ درج کریں۔",
    wfElTooltipPhone: "فون نمبر درج کریں۔",
    wfElTooltipAddress: "پتہ درج کریں۔",
    wfElTooltipDate: "کیلنڈر سے تاریخ منتخب کریں۔",
    wfElTooltipPhoto: "تصویر اپ لوڈ کریں۔",
    wfElTooltipMultiImage: "متعدد تصاویر اپ لوڈ کریں۔",
    wfElTooltipSignature: "دستخط شامل کریں۔",
    wfElTooltipRadio: "متعدد میں سے ایک آپشن منتخب کریں۔",
    wfElTooltipCheckbox: "متعلقہ صورت میں متعدد آپشن منتخب کریں۔",
    wfElTooltipDropdown: "ڈراپ ڈاؤن فہرست سے آپشن منتخب کریں۔",
    wfElTooltipNumber: "عددی قدر درج کریں۔",
    wfElTooltipTime: "مخصوص وقت منتخب کریں۔",
    wfElTooltipLongText: "تفصیلی متن یا تفاسیر درج کریں۔",
    wfElTooltipBarcode: "ان پٹ کے لیے بارکوڈ اسکین کریں۔",
    wfElTooltipOcr: "بصری حروف کی شناخت (OCR)۔",
    wfElTooltipGps: "گلوبل پوزیشننگ سسٹم۔",
    wfElTooltipSignalQuality: "ڈیوائس کے نیٹ ورک سگنل کے معیار کو خودکار طور پر حاصل کرتا ہے۔",
    workflowModalPreviewOptionsEmpty:
      "اپنے فارم بلڈر میں اختیارات شامل کریں تاکہ وہ یہاں نظر آئیں۔",
    NotificationSound: "اطلاع کی آواز",
    TestSound: "ٹیسٹ ساؤنڈ",
    Configurations: "کنفیگریشنز",
    TermsAndConditions: "شرائط و ضوابط",
    DragDropTermsConditionFile: "شرائط و ضوابط کی فائل کو گھسیٹ کر چھوڑیں۔",
    PrivacyAcceptance: "رازداری کی قبولیت",
    DragDropPrivacyAcceptanceFile:
      "رازداری کی قبولیت فائل کو گھسیٹیں اور چھوڑیں۔",
    TermsandConditionPdf: "شرائط و ضوابط.pdf",
    view: "دیکھیں",
    NoReportDataavailble: "کوئی رپورٹ ڈیٹا دستیاب نہیں ہے۔",
    getStartedRequestingReport: "اپنی پہلی رپورٹ کی درخواست کر کے شروع کریں۔",
    noRecordsMatchSearch: "آپ کی تلاش سے مماثل کوئی ریکارڈ نہیں ملا",
    tryAdjustingFilters: "جو آپ تلاش کر رہے ہیں اسے تلاش کرنے کے لیے اپنے فلٹرز یا تلاش کی اصطلاحات کو ایڈجسٹ کرنے کی کوشش کریں۔",
    clearFilters: "فلٹرز صاف کریں",
    UnexpectedResponseFormat: "غیر متوقع جوابی شکل۔ براہ کرم دوبارہ کوشش کریں۔",
    chooseFile: "فائل کا انتخاب کریں۔",
    noFile: "کوئی فائل منتخب نہیں کی گئی۔",
    UsernameRequired: "\u0635\u0627\u0631\u0641 \u0646\u0627\u0645 \u062f\u0631\u06a9\u0627\u0631 \u06c1\u06d2\u06d4",
    PasswordRequired: "پاس ورڈ درکار ہے۔",
    PasswordMustBeAtLeast8Characters: "پاس ورڈ کم از کم 8 حروف کا ہونا چاہیے۔",
    IncludeDeletedRecords: "حذف شدہ ریکارڈز شامل کریں۔",
    includedeletedrecordstooltip: "رپورٹ میں حذف شدہ ورک فلوز اور ٹاسکس شامل کریں۔",
    selectdurationtooltip: "رپورٹ کے لیے تاریخ کی حد منتخب کریں۔",
    selectduration: "مدت منتخب کریں",
    /* Urdu is verb-final: "مجھے [سرگرمیاں] کے لیے [مدت] کی رپورٹ چاہیے".
       The verb lives in the suffix, after the range -- which is exactly why
       this line could not be translated word by word. */
    reportsummaryprefix: "مجھے",
    reportsummarycovering: "کے لیے",
    reportsummarysuffix: "کی رپورٹ چاہیے",
    selectactivities: "سرگرمیاں منتخب کریں",
    activitiesjoinand: "{first} اور {second}",
    activitieslistheader: "سرگرمیاں ({count})",
    reportrangedates: "{from} سے {to} تک",
    reportrangecycles: "{cycles} کے لیے",
    requestreporttooltip: "منتخب کردہ سرگرمیوں اور مدت کے لیے رپورٹ تیار کریں۔",
    downloadreporttooltip: "تیار شدہ رپورٹ فائل ڈاؤن لوڈ کریں۔",

    pleaseFillAllFieldsBeforeSaving:
      "براہ کرم محفوظ کرنے سے پہلے تمام فیلڈ پُر کریں۔",
    ruleCreatedSuccessfully: "اصول کامیابی کے ساتھ بنایا گیا۔",
    pleaseSelectFromDateToDate:
      "براہ کرم تاریخ سے اور تاریخ تک دونوں کو منتخب کریں۔",

    instalmentPlanNotExisting:
      "دیئے گئے اکاؤنٹ نمبر کے لیے قسط کا منصوبہ موجود نہیں ہے۔",
    remarksError: "ریمارکس فیلڈ درکار ہے۔",
    previewPlanError: "",
    selectActivityAndMap: "سرگرمی اور نقشہ منتخب کریں",
    selectActivityLabel: "سرگرمی منتخب کریں",
    selectMapLabel: "نقشہ منتخب کریں",
    indoorMap: "انڈور نقشہ",
    drawOnMap: "نقشے پر ڈرا کریں",
    calendarLabel: "کیلنڈر",
    activityPanel: "سرگرمی پینل",
    fullScreenLabel: "فل اسکرین",
    detailPanel: "تفصیل پینل",
    columnsLabel: "کالم",
    toggleColumns: "کالم ٹوگل کریں",
    columnsTooltip: "وہ کالم منتخب کریں جو جدول میں دکھانے ہیں۔",
    columnsModalTitle: "کالم حسبِ ضرورت بنائیں",
    columnsModalSubtitle: "نمایاں کالم منتخب کریں اور ترتیب سیٹ کریں",
    columnsModalShowHide: "کالم دکھائیں / چھپائیں",
    columnsModalSearchPlaceholder: "کالم تلاش کریں...",
    columnsModalSelectAll: "سب منتخب کریں",
    columnsModalClearAll: "سب صاف کریں",
    columnsModalOrderTitle: "کالم ترتیب",
    columnsModalOrderHint: "اوپر والا کالم جدول میں پہلے دکھے گا",
    columnsModalAtLeastOne: "کم از کم ایک کالم منتخب کریں۔",
    columnsModalCountOf: "میں سے",
    columnsModalCountVisible: "نمایاں",
    columnsModalApply: "تبدیلیاں لاگو کریں",
    columnsModalCloseAria: "کالم حسبِ ضرورت ونڈو بند کریں",
    columnsModalMoveUp: "اوپر لے جائیں",
    columnsModalMoveDown: "نیچے لے جائیں",
    columnsManageTitle: "کالمز کا انتظام کریں",
    columnsResetDefault: "طے شدہ پر ری سیٹ کریں",
    columnsModalResetDefault: "طے شدہ پر ری سیٹ کریں",
    super_admin: "سپر ایڈمن",
    roles: "کردار",
    appliedFiltersAria: "لاگو کردہ فلٹرز",
    reportEmailsOptional: "رپورٹ ای میلز (اختیاری)",
    reportEmailsDescription:
      "رپورٹس وصول کرنے کے لیے ایک یا زیادہ ای میل پتے شامل کریں۔",
    addAnotherEmail: "ایک اور ای میل شامل کریں",
    removeEmail: "ای میل ہٹائیں",

    meterBarCode: "میٹر بار کوڈ",
    components: "اجزاء",
    meterType: "میٹر کی قسم",
    manufacturingYear: "مینوفیکچرنگ سال",
    meterMake: "میٹر بنائیں",
    activationDate: "ایکٹیویشن کی تاریخ",
    batchNo: "بیچ نمبر",
    installationStatus: "تنصیب کی حیثیت",
    createBy: "کی طرف سے پیدا کیا",
    createdAt: "پر پیدا کیا",
    simNo: "سم نمبر",
    ipAddress: "آئی پی ایڈریس",
    iccid: "iccid",
    apn: "apn",
    op: "op",
    balance: "توازن",
    simDetailUpdatedAt: "سم کی تفصیلات کو اپ ڈیٹ کیا گیا۔",
    transferredFrom: "سے منتقل",
    transferredTo: "کو منتقل کر دیا گیا۔",
    DragYourElementsToSecondPageFromLeftPanel:
      "اپنے عناصر کو بائیں پینل سے دوسرے صفحہ پر گھسیٹیں۔",
    Deactive: "غیر فعال",
    Yes: "جی ہاں",
    No: "نہیں",
    WhatDoYouWantExistingAccounts:
      "آپ موجودہ اکاؤنٹس کے ساتھ کیا کرنا چاہتے ہیں؟",
    updateAlreadyExistingAccountEntries:
      "پہلے سے موجود اکاؤنٹ اندراجات کو اپ ڈیٹ کریں؟",
    createNewAccountEntries: "نئے اکاؤنٹ اندراجات بنائیں؟",
    customerDetails: "قسط کی تخلیق کی تفصیل",
    created_By: "کی طرف سے پیدا کیا",
    accountNo: "اکاؤنٹ نمبر",
    mapAccountSearchPlaceholder: "اکاؤنٹ نمبر تلاش کریں",
    mapAccountNotFound: "اکاؤنٹ نہیں ملا",
    mapAccountLocationUnavailable: "اس اکاؤنٹ کا مقام دستیاب نہیں ہے",
    civilId: "کسٹمر آئی ڈی",
    phoneNo: "فون نمبر",
    comment: "تبصرہ",
    attachments: "منسلکات",

    // Urdu overrides for map task UI, dates, and stock (later entries win over mixed duplicates above)
    fromdate: "تاریخ سے",
    todate: "تاریخ تک",
    protectionValid: "تحفظ کی میعاد تک",
    stockmanag: "اسٹاک کا انتظام",
    metercode: "میٹر کا بارکوڈ",
    meterBarCode: "میٹر کا بارکوڈ",
    meterMake: "میٹر بنانے والی کمپنی",
    nopdfavb: "PDF دستیاب نہیں ہے۔",
    assign: "تفویض کریں",
    reassign: "دوبارہ تفویض کریں",
    unassignn: "غیر تفویض کریں",
    delete: "حذف کریں",
    exportBtn: "ایکسپورٹ",
    exportOneFilter: "1 فلٹر",
    exportManyFilters: "{count} فلٹرز",
    deleteAllFilteredMessage: "{filters} لاگو ہیں۔ صرف لاگو فلٹرز سے مطابقت رکھنے والے ٹاسک حذف کیے جائیں گے۔",
    deleteAllUnfilteredMessage: "کوئی فلٹر لاگو نہیں ہے۔ اس ایکٹیویٹی کے تمام ٹاسک حذف کر دیے جائیں گے۔",
    deleteAllFilteredTooltip: "صرف لاگو فلٹرز سے مطابقت رکھنے والے ٹاسک حذف کریں",
    deleteAllUnfilteredTooltip: "اس ایکٹیویٹی کے تمام ٹاسک حذف کریں",
    exportNoFiltersWarning:
      "کوئی فلٹر لاگو نہیں ہے، اس لیے انتخاب کے تمام ٹاسک ایکسپورٹ ہوں گے۔ بڑے ورک فلو میں فائل بننے میں کافی وقت لگ سکتا ہے۔",
    selectProjectForFullExport: "تمام سرگرمیاں ایکسپورٹ کرنے سے پہلے پروجیکٹ منتخب کریں۔",
    importBtn: "امپورٹ",
    addTaskBtn: "ٹاسک شامل کریں",
    attachProof: "ثبوت منسلک کریں (PDF/تصویر)",
    attachProofNote:
      "نوٹ: اپ لوڈ کردہ دستاویز اس اکاؤنٹ کے ساتھ محفوظ کی جاتی ہے اور بعد میں دیکھنے کے لیے دستیاب ہوگی۔",
    currentAttachment: "موجودہ دستاویز منسلک ہے",
    viewAttachment: "منسلک دستاویز دیکھیں",
    removeAttachment: "منسلکہ ہٹائیں",
    maxAttachmentsExceeded: "آپ زیادہ سے زیادہ {count} منسلکات اپ لوڈ کر سکتے ہیں",
    attachmentTooLarge: "فائل زیادہ سے زیادہ اجازت شدہ {size} MB سائز سے بڑی ہے",
    filesSelected: "فائلیں منتخب",
    attachmentUnavailable: "منسلکہ دستیاب نہیں ہے",
    viewLabel: "دیکھیں",
    attachmentSourceRc: "RC",
    attachmentSourceTask: "ٹاسک",
    attachmentSourceInstalment: "قسط کا منصوبہ",
    exportData: "ایکسپورٹ",
    importdb: "ماسٹر ڈیٹابیس امپورٹ",
    activityAnalytics: "سرگرمی تجزیات",
    analyticsLabel: "تجزیات",
    analyticsStatusLabel: "حیثیت",
    chartSelectFiltersHint:
      "چارٹ دیکھنے کے لیے سرگرمی، حیثیت اور تاریخیں منتخب کریں",
    chartLoading: "لوڈ ہو رہا ہے...",
    taskActions: "ٹاسک کی تفصیلات",
    selectedCountLabel: "منتخب",
    selectedLocation: "منتخب مقام",
    drawnArea: "کھینچا ہوا علاقہ",
    clearSelection: "صاف کریں",
    clickMarkerForLocationDetails:
      "مقام کی تفصیلات دیکھنے کے لیے نقشے پر نشان پر کلک کریں",
    taskDetailsSection: "ٹاسک کی تفصیلات",
    loadingTaskDetails: "ٹاسک کی تفصیلات لوڈ ہو رہی ہیں...",
    clickMarkerLoadTaskDetails:
      "ٹاسک کی تفصیلات لوڈ کرنے کے لیے نشان پر کلک کریں۔",
    taskStatusSection: "ٹاسک کی حیثیت",
    allStatusLabel: "تمام",
    availableAgents: "دستیاب ایجنٹس",
    searchFieldAgentsPlaceholder: "فیلڈ ایجنٹس تلاش کریں...",
    noAgentsMatchSearch: "آپ کی تلاش سے کوئی ایجنٹ میل نہیں کھاتا",
    noAgentsAvailable: "کوئی ایجنٹ دستیاب نہیں",
    loadingAgentsLabel: "ایجنٹس لوڈ ہو رہے ہیں...",
    statusActiveLabel: "فعال",
    statusInProgressLabel: "جاری",
    statusCompletedLabel: "مکمل",
    statusAssignedLabel: "تفویض شدہ",
    statusOnHoldLabel: "موقوف",
    unassignedLabel: "غیر تفویض",
    taskIdLabel: "ٹاسک آئی ڈی",
    assigneeLabel: "تفویض شدہ فرد",
    completedCountSuffix: "مکمل",
    tasksInDrawnAreaTitle: "کھینچے گئے علاقے میں ٹاسکس",
    tasksListTitle: "ٹاسکس",
    centerApproxLabel: "مرکز (تقریبی)",
    latLongUpperLabel: "عرض بلد / طول بلد",
    agentUpperLabel: "ایجنٹ",
    activeTasksUpperLabel: "فعال ٹاسکس",
    taskWord: "ٹاسک",
    tasksWord: "ٹاسکس",
    assignTaskCountVerb: "تفویض",
    taskSingular: "ٹاسک",
    tasksPlural: "ٹاسکس",
    onlineLabel: "آن لائن",
    offlineLabel: "آف لائن",
    showOnlineAgentsTitle: "آن لائن ایجنٹس دکھائیں",
    showOfflineAgentsTitle: "آف لائن ایجنٹس دکھائیں",
    onlyActiveTasksAssignableTitle: "صرف فعال ٹاسکس تفویض کیے جا سکتے ہیں",
    consNameEnglish: "صارف کا نام (انگریزی)",
    consNameArabic: "صارف کا نام (عربی)",
    meterNoLabel: "میٹر نمبر",
    consumerTypeLabel: "صارف کی قسم",
    phoneLabel: "فون",
    lastReadTypeLabel: "آخری ریڈنگ کی قسم",
    lastReadingLabel: "آخری ریڈنگ",
    lastReadingDateLabel: "آخری ریڈنگ کی تاریخ",
    averageLabel: "اوسط",
    remark: "نوٹس",
    enterremark: "یہاں اپنے نوٹس درج کریں",
    areacode: "علاقہ کوڈ",
    area: "علاقہ",
    latitude: "عرض البلد",
    longitude: "طول البلد",
    pleaseSelectFromDateToDate:
      'براہ کرم "تاریخ سے" اور "تاریخ تک" دونوں منتخب کریں۔',
    all: "سب",
    allFieldAgents: "تمام فیلڈ ایجنٹس",

    employee: "ملازم", // employed id added by harshit vachhani
    employeeIdLabel: "ملازم آئی ڈی",
    subContract: "ذیلی معاہدہ", // subContract added by harshit vachhani
    subContractIdLabel: "سب کانٹریکٹ آئی ڈی",
    // App Update Config
    appUpdateConfig: "ایپ اپ ڈیٹ کنفیگ",
    appUpdateConfigTooltip: "ایپ اپ ڈیٹ کنفیگ، ایپ اپ ڈیٹ کنفیگ کا نظم کریں",
    appUpdateConfigTitle: "ایپ اپ ڈیٹ کنفیگ",
    appUpdateConfigDescription: "ایپ اپ ڈیٹ کنفیگ کا نظم کریں",
    appUpdatePlatform: "پلیٹ فارم",
    iosConfigComingSoonTooltip: "iOS کنفیگریشن ابھی دستیاب نہیں",
    appUpdateLatestVersion: "تازہ ترین ورژن",
    appUpdateLatestBuildNumber: "تازہ ترین بلڈ نمبر",
    appUpdateMinBuildNumber: "کم از کم معاون بلڈ نمبر",
    appUpdateTitleLabel: "عنوان",
    appUpdateMessageLabel: "پیغام",
    appUpdateForceUpdate: "زبردستی اپ ڈیٹ",
    appUpdateUrlLabel: "ایپ یو آر ایل",
    appUpdateReleaseNotes: "ریلیز نوٹس",
    appUpdateReleaseNotesPlaceholder: "ہر لائن میں ایک نوٹ",
    appUpdateFieldRequired: "یہ فیلڈ ضروری ہے",
    appUpdateReleaseNotesRequired: "کم از کم ایک ریلیز نوٹ ضروری ہے",
    appUpdateNumberInvalid: "درست نمبر ہونا چاہیے",
    appUpdateNumberNegative: "مثبت نمبر ہونا چاہیے",
    appUpdateUpdatedAt: "اپ ڈیٹ کی تاریخ",
    editAppUpdateConfigTooltip: "کنفیگریشن میں ترمیم کریں",
    updateAppUpdateConfigTooltip: "کنفیگریشن اپ ڈیٹ کریں",
    cancelAppUpdateConfigTooltip: "تبدیلیاں مسترد کریں",
    savingAppUpdateConfigTooltip: "محفوظ ہو رہا ہے...",
    switchPlatformDisabledTooltip:
      "پلیٹ فارم تبدیل کرنے سے پہلے تبدیلیاں محفوظ یا منسوخ کریں",
    appUpdateConfigUpdateSuccess: "کنفیگریشن کامیابی سے اپ ڈیٹ ہو گئی",
    appUpdateConfigLoadError: "کنفیگریشن لوڈ کرنے میں ناکام",
    appUpdateConfigUpdateError: "کنفیگریشن اپ ڈیٹ کرنے میں ناکام",
    taskRoadmap: "ٹاسک روڈ میپ",
    taskRoadmapTooltip: "ٹاسک روڈ میپ دیکھنے کے لیے کلک کریں",
    roadmapTimeline: "ٹائم لائن",
    roadmapDetails: "ٹاسک کی تفصیلات",
    roadmapLoading: "ٹاسک روڈ میپ لوڈ ہو رہا ہے...",
    roadmapLoadFailed: "ٹاسک روڈ میپ لوڈ کرنے میں ناکام",
    roadmapNoData: "اس ٹاسک کے لیے کوئی روڈ میپ دستیاب نہیں",
    roadmapNoTimeline: "اس ٹاسک کے لیے کوئی ایونٹ ریکارڈ نہیں ہوا",
    roadmapWorkflow: "ورک فلو",
    roadmapAccountNo: "اکاؤنٹ نمبر",
    roadmapArea: "علاقہ",
    roadmapCompletedBy: "مکمل کرنے والا",
    roadmapCreatedAt: "تخلیق کی تاریخ",
    roadmapFinishedAt: "تکمیل کی تاریخ",
    roadmapTaskNote: "ٹاسک نوٹ",
    roadmapRemarks: "ریمارکس",
    roadmapReading: "ریڈنگ",
    roadmapAssignedTo: "تفویض کردہ",
    roadmapBy: "بذریعہ",
    roadmapLocation: "مقام",
    roadmapSource: "ماخذ",
    roadmapDeleted: "حذف شدہ",
    roadmapPhotos: "تصاویر",
    roadmapPhotoField: "فیلڈ",
    roadmapPhotoLink: "تصویر کا لنک",
    roadmapCompletionInfo: "ٹاسک تکمیل کی معلومات",
    roadmapFieldValue: "ویلیو",
    roadmapQueNo: "سوال نمبر",
    // Column Access Management
    columnAccessManagementTitle: "کالم رسائی کا انتظام",
    columnAccessManagementSubtitle: "کنٹرول کریں کہ ہر یوزر ٹائپ ہر ورک فلو میں کون سے کالم دیکھ سکتا ہے",
    accessManagementBtn: "رسائی کنٹرول",
    selectWorkflowLabel: "ورک فلو منتخب کریں",
    selectUserTypeLabel: "یوزر ٹائپ منتخب کریں",
    selectWorkflowPlaceholder: "ورک فلو منتخب کریں",
    selectUserTypePlaceholder: "یوزر ٹائپ منتخب کریں",
    currentlyAccessible: "فی الحال قابل رسائی",
    currentlyAccessibleCountLabel: "{label} - {userType} ({count})",
    manageAccessLabel: "رسائی کا نظم کریں",
    manageAccessCountLabel: "{label} - {selected} {of} {total} {selectedLabel}",
    selected: "منتخب",
    clear: "صاف کریں",
    noResults: "کوئی نتیجہ نہیں ملا",
    noWorkflowSelectedTitle: "کوئی ورک فلو منتخب نہیں",
    selectWorkflowAndUserTypePrompt: "کالم رسائی دیکھنے اور منظم کرنے کے لیے پہلے ورک فلو اور پھر یوزر ٹائپ منتخب کریں۔",
    detailsGroupLabel: "ڈائنامک کالمز",
    standardGroupLabel: "اسٹیٹک کالمز",
    columnAccessExportNote:
      "یہ رسائی صرف ڈائنامک کالمز پر لاگو ہوتی ہے۔ ایکسل ایکسپورٹ ڈائنامک کالم رسائی کے مطابق چلتا ہے، لیکن اسٹیٹک سسٹم کالمز ہمیشہ ایکسپورٹ فائل میں شامل ہوتے ہیں اور انہیں یہاں سے دیا یا ہٹایا نہیں جا سکتا۔",
    newBadge: "نیا",
    removingBadge: "ہٹایا جا رہا ہے",
    deleteAccessBtn: "رسائی حذف کریں",
    saveChangesBtn: "تبدیلیاں محفوظ کریں",
    confirmDeleteColumnAccess: "کیا آپ محفوظ شدہ کالم رسائی حذف کرنا چاہتے ہیں برائے",
    columnAccessSaved: "کالم رسائی محفوظ ہو گئی",
    columnAccessDeleted: "کالم رسائی ہٹا دی گئی",
    noColumnAccessTitle: "کالم تک کوئی رسائی نہیں",
    noColumnAccessMessage: "آپ کو اس ورک فلو کے کسی بھی کالم تک رسائی حاصل نہیں ہے۔ براہ کرم اپنے سپر ایڈمن سے رابطہ کریں۔",
    assignedTo: "تفویض کردہ",
    compareValidationTitle: "موازنہ کی توثیق",
    compareValidationSubtitle:
      "اس فیلڈ کا موازنہ کسی مقررہ قدر کے بجائے ورک فلو کی دوسری فیلڈ سے کریں۔",
    compareValidationButton: "موازنہ کی توثیق",
    compareValidationCount: "موازنہ کے قواعد",
    compareValidationFirstField: "فیلڈ 1 (یہ فیلڈ)",
    compareValidationSecondField: "فیلڈ 2",
    compareValidationSelectSecondField:
      "موازنہ کے لیے ایک فیلڈ منتخب کریں",
    compareValidationCondition: "شرط",
    compareValidationEqual: "برابر ہونا چاہیے",
    compareValidationNotEqual: "برابر نہیں ہونا چاہیے",
    compareValidationErrorMessage: "خرابی کا پیغام",
    compareValidationErrorMessagePlaceholder:
      "موازنہ ناکام ہونے پر دکھایا جائے گا",
    compareValidationAdd: "شامل کریں",
    compareValidationUpdate: "اپ ڈیٹ کریں",
    compareValidationCancel: "منسوخ کریں",
    compareValidationAdded: "شامل کردہ موازنے",
    compareValidationEmpty: "ابھی تک موازنہ کا کوئی قاعدہ نہیں ہے۔",
    compareValidationNoFields:
      "موازنہ کے لیے کینوس پر کم از کم ایک اور فیلڈ شامل کریں۔",
    compareValidationEligibleTypes:
      "موازنہ ٹیکسٹ، لانگ ٹیکسٹ، نمبر، ای میل، تاریخ اور وقت کی فیلڈز کے ساتھ کام کرتا ہے۔",
    compareValidationSelectFieldFirst:
      "موازنہ کے لیے فیلڈ منتخب کریں۔",
    compareValidationDuplicate:
      "اس فیلڈ کا منتخب کردہ فیلڈ سے پہلے ہی موازنہ کیا جا چکا ہے۔",
    compareValidationSaved: "موازنہ کی توثیق محفوظ ہو گئی۔",
    compareValidationRemoved: "موازنہ کی توثیق ہٹا دی گئی۔",
    compareValidationDeletedField: "حذف شدہ فیلڈ",
    compareValidationDefaultEqualError:
      "اس فیلڈ کا {field} سے مطابقت رکھنا ضروری ہے۔",
    compareValidationDefaultNotEqualError:
      "اس فیلڈ کا {field} سے مطابقت رکھنا نہیں چاہیے۔",
    validationTabLabel: "توثیق",
    comparisonTabLabel: "موازنہ",
    addValidationButton: "توثیق شامل کریں",
    validationEmpty: "ابھی تک توثیق کا کوئی قاعدہ نہیں ہے۔",
    validationCount: "توثیقی قواعد",
    addValidationTooltipDesc:
      "اس فیلڈ کی اپنی قدر کو توثیقی کوڈ کے مقابل چیک کریں، اور مطابقت نہ ہونے پر دکھایا جانے والا خرابی کا پیغام مقرر کریں۔",
    viewValidationTooltipDesc:
      "اس فیلڈ میں پہلے شامل کیے گئے توثیقی قواعد دیکھیں، تبدیل کریں یا حذف کریں۔",
    compareValidationTooltipDesc:
      "اس فیلڈ کی قدر کا ورک فلو کی دوسری فیلڈ سے موازنہ کریں اور دونوں کے برابر یا غیر برابر ہونے کی شرط رکھیں۔",
  },
};

export default translations;
